var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import React, { useState, useRef, useEffect, isValidElement, createElement, memo, Component, createContext, useReducer } from "react";
import { css, cx, keyframes } from "@emotion/css";
import ReactDOM from "react-dom";
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs$1(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
function getAugmentedNamespace(n2) {
  if (n2.__esModule)
    return n2;
  var f = n2.default;
  if (typeof f == "function") {
    var a = function a2() {
      if (this instanceof a2) {
        return Reflect.construct(f, arguments, this.constructor);
      }
      return f.apply(this, arguments);
    };
    a.prototype = f.prototype;
  } else
    a = {};
  Object.defineProperty(a, "__esModule", { value: true });
  Object.keys(n2).forEach(function(k2) {
    var d = Object.getOwnPropertyDescriptor(n2, k2);
    Object.defineProperty(a, k2, d.get ? d : {
      enumerable: true,
      get: function() {
        return n2[k2];
      }
    });
  });
  return a;
}
var runtime = { exports: {} };
(function(module) {
  var runtime2 = function(exports) {
    var Op = Object.prototype;
    var hasOwn2 = Op.hasOwnProperty;
    var defineProperty2 = Object.defineProperty || function(obj, key, desc) {
      obj[key] = desc.value;
    };
    var undefined$12;
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define2(obj, key, value) {
      Object.defineProperty(obj, key, {
        value,
        enumerable: true,
        configurable: true,
        writable: true
      });
      return obj[key];
    }
    try {
      define2({}, "");
    } catch (err) {
      define2 = function(obj, key, value) {
        return obj[key] = value;
      };
    }
    function wrap(innerFn, outerFn, self2, tryLocsList) {
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
      var generator = Object.create(protoGenerator.prototype);
      var context = new Context(tryLocsList || []);
      defineProperty2(generator, "_invoke", { value: makeInvokeMethod(innerFn, self2, context) });
      return generator;
    }
    exports.wrap = wrap;
    function tryCatch(fn, obj, arg) {
      try {
        return { type: "normal", arg: fn.call(obj, arg) };
      } catch (err) {
        return { type: "throw", arg: err };
      }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    var ContinueSentinel = {};
    function Generator() {
    }
    function GeneratorFunction() {
    }
    function GeneratorFunctionPrototype() {
    }
    var IteratorPrototype = {};
    define2(IteratorPrototype, iteratorSymbol, function() {
      return this;
    });
    var getProto2 = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto2 && getProto2(getProto2(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn2.call(NativeIteratorPrototype, iteratorSymbol)) {
      IteratorPrototype = NativeIteratorPrototype;
    }
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty2(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: true });
    defineProperty2(
      GeneratorFunctionPrototype,
      "constructor",
      { value: GeneratorFunction, configurable: true }
    );
    GeneratorFunction.displayName = define2(
      GeneratorFunctionPrototype,
      toStringTagSymbol,
      "GeneratorFunction"
    );
    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function(method) {
        define2(prototype, method, function(arg) {
          return this._invoke(method, arg);
        });
      });
    }
    exports.isGeneratorFunction = function(genFun) {
      var ctor = typeof genFun === "function" && genFun.constructor;
      return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
      // do is to check its .name property.
      (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
      } else {
        genFun.__proto__ = GeneratorFunctionPrototype;
        define2(genFun, toStringTagSymbol, "GeneratorFunction");
      }
      genFun.prototype = Object.create(Gp);
      return genFun;
    };
    exports.awrap = function(arg) {
      return { __await: arg };
    };
    function AsyncIterator(generator, PromiseImpl) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);
        if (record.type === "throw") {
          reject(record.arg);
        } else {
          var result = record.arg;
          var value = result.value;
          if (value && typeof value === "object" && hasOwn2.call(value, "__await")) {
            return PromiseImpl.resolve(value.__await).then(function(value2) {
              invoke("next", value2, resolve, reject);
            }, function(err) {
              invoke("throw", err, resolve, reject);
            });
          }
          return PromiseImpl.resolve(value).then(function(unwrapped) {
            result.value = unwrapped;
            resolve(result);
          }, function(error) {
            return invoke("throw", error, resolve, reject);
          });
        }
      }
      var previousPromise;
      function enqueue(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function(resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
      }
      defineProperty2(this, "_invoke", { value: enqueue });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define2(AsyncIterator.prototype, asyncIteratorSymbol, function() {
      return this;
    });
    exports.AsyncIterator = AsyncIterator;
    exports.async = function(innerFn, outerFn, self2, tryLocsList, PromiseImpl) {
      if (PromiseImpl === void 0)
        PromiseImpl = Promise;
      var iter = new AsyncIterator(
        wrap(innerFn, outerFn, self2, tryLocsList),
        PromiseImpl
      );
      return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
        return result.done ? result.value : iter.next();
      });
    };
    function makeInvokeMethod(innerFn, self2, context) {
      var state = GenStateSuspendedStart;
      return function invoke(method, arg) {
        if (state === GenStateExecuting) {
          throw new Error("Generator is already running");
        }
        if (state === GenStateCompleted) {
          if (method === "throw") {
            throw arg;
          }
          return doneResult();
        }
        context.method = method;
        context.arg = arg;
        while (true) {
          var delegate = context.delegate;
          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);
            if (delegateResult) {
              if (delegateResult === ContinueSentinel)
                continue;
              return delegateResult;
            }
          }
          if (context.method === "next") {
            context.sent = context._sent = context.arg;
          } else if (context.method === "throw") {
            if (state === GenStateSuspendedStart) {
              state = GenStateCompleted;
              throw context.arg;
            }
            context.dispatchException(context.arg);
          } else if (context.method === "return") {
            context.abrupt("return", context.arg);
          }
          state = GenStateExecuting;
          var record = tryCatch(innerFn, self2, context);
          if (record.type === "normal") {
            state = context.done ? GenStateCompleted : GenStateSuspendedYield;
            if (record.arg === ContinueSentinel) {
              continue;
            }
            return {
              value: record.arg,
              done: context.done
            };
          } else if (record.type === "throw") {
            state = GenStateCompleted;
            context.method = "throw";
            context.arg = record.arg;
          }
        }
      };
    }
    function maybeInvokeDelegate(delegate, context) {
      var methodName = context.method;
      var method = delegate.iterator[methodName];
      if (method === undefined$12) {
        context.delegate = null;
        if (methodName === "throw" && delegate.iterator["return"]) {
          context.method = "return";
          context.arg = undefined$12;
          maybeInvokeDelegate(delegate, context);
          if (context.method === "throw") {
            return ContinueSentinel;
          }
        }
        if (methodName !== "return") {
          context.method = "throw";
          context.arg = new TypeError(
            "The iterator does not provide a '" + methodName + "' method"
          );
        }
        return ContinueSentinel;
      }
      var record = tryCatch(method, delegate.iterator, context.arg);
      if (record.type === "throw") {
        context.method = "throw";
        context.arg = record.arg;
        context.delegate = null;
        return ContinueSentinel;
      }
      var info = record.arg;
      if (!info) {
        context.method = "throw";
        context.arg = new TypeError("iterator result is not an object");
        context.delegate = null;
        return ContinueSentinel;
      }
      if (info.done) {
        context[delegate.resultName] = info.value;
        context.next = delegate.nextLoc;
        if (context.method !== "return") {
          context.method = "next";
          context.arg = undefined$12;
        }
      } else {
        return info;
      }
      context.delegate = null;
      return ContinueSentinel;
    }
    defineIteratorMethods(Gp);
    define2(Gp, toStringTagSymbol, "Generator");
    define2(Gp, iteratorSymbol, function() {
      return this;
    });
    define2(Gp, "toString", function() {
      return "[object Generator]";
    });
    function pushTryEntry(locs) {
      var entry = { tryLoc: locs[0] };
      if (1 in locs) {
        entry.catchLoc = locs[1];
      }
      if (2 in locs) {
        entry.finallyLoc = locs[2];
        entry.afterLoc = locs[3];
      }
      this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal";
      delete record.arg;
      entry.completion = record;
    }
    function Context(tryLocsList) {
      this.tryEntries = [{ tryLoc: "root" }];
      tryLocsList.forEach(pushTryEntry, this);
      this.reset(true);
    }
    exports.keys = function(val) {
      var object = Object(val);
      var keys2 = [];
      for (var key in object) {
        keys2.push(key);
      }
      keys2.reverse();
      return function next() {
        while (keys2.length) {
          var key2 = keys2.pop();
          if (key2 in object) {
            next.value = key2;
            next.done = false;
            return next;
          }
        }
        next.done = true;
        return next;
      };
    };
    function values(iterable) {
      if (iterable != null) {
        var iteratorMethod = iterable[iteratorSymbol];
        if (iteratorMethod) {
          return iteratorMethod.call(iterable);
        }
        if (typeof iterable.next === "function") {
          return iterable;
        }
        if (!isNaN(iterable.length)) {
          var i2 = -1, next = function next2() {
            while (++i2 < iterable.length) {
              if (hasOwn2.call(iterable, i2)) {
                next2.value = iterable[i2];
                next2.done = false;
                return next2;
              }
            }
            next2.value = undefined$12;
            next2.done = true;
            return next2;
          };
          return next.next = next;
        }
      }
      throw new TypeError(typeof iterable + " is not iterable");
    }
    exports.values = values;
    function doneResult() {
      return { value: undefined$12, done: true };
    }
    Context.prototype = {
      constructor: Context,
      reset: function(skipTempReset) {
        this.prev = 0;
        this.next = 0;
        this.sent = this._sent = undefined$12;
        this.done = false;
        this.delegate = null;
        this.method = "next";
        this.arg = undefined$12;
        this.tryEntries.forEach(resetTryEntry);
        if (!skipTempReset) {
          for (var name in this) {
            if (name.charAt(0) === "t" && hasOwn2.call(this, name) && !isNaN(+name.slice(1))) {
              this[name] = undefined$12;
            }
          }
        }
      },
      stop: function() {
        this.done = true;
        var rootEntry = this.tryEntries[0];
        var rootRecord = rootEntry.completion;
        if (rootRecord.type === "throw") {
          throw rootRecord.arg;
        }
        return this.rval;
      },
      dispatchException: function(exception) {
        if (this.done) {
          throw exception;
        }
        var context = this;
        function handle(loc, caught) {
          record.type = "throw";
          record.arg = exception;
          context.next = loc;
          if (caught) {
            context.method = "next";
            context.arg = undefined$12;
          }
          return !!caught;
        }
        for (var i2 = this.tryEntries.length - 1; i2 >= 0; --i2) {
          var entry = this.tryEntries[i2];
          var record = entry.completion;
          if (entry.tryLoc === "root") {
            return handle("end");
          }
          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn2.call(entry, "catchLoc");
            var hasFinally = hasOwn2.call(entry, "finallyLoc");
            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              } else if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              }
            } else if (hasFinally) {
              if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else {
              throw new Error("try statement without catch or finally");
            }
          }
        }
      },
      abrupt: function(type2, arg) {
        for (var i2 = this.tryEntries.length - 1; i2 >= 0; --i2) {
          var entry = this.tryEntries[i2];
          if (entry.tryLoc <= this.prev && hasOwn2.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }
        if (finallyEntry && (type2 === "break" || type2 === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
          finallyEntry = null;
        }
        var record = finallyEntry ? finallyEntry.completion : {};
        record.type = type2;
        record.arg = arg;
        if (finallyEntry) {
          this.method = "next";
          this.next = finallyEntry.finallyLoc;
          return ContinueSentinel;
        }
        return this.complete(record);
      },
      complete: function(record, afterLoc) {
        if (record.type === "throw") {
          throw record.arg;
        }
        if (record.type === "break" || record.type === "continue") {
          this.next = record.arg;
        } else if (record.type === "return") {
          this.rval = this.arg = record.arg;
          this.method = "return";
          this.next = "end";
        } else if (record.type === "normal" && afterLoc) {
          this.next = afterLoc;
        }
        return ContinueSentinel;
      },
      finish: function(finallyLoc) {
        for (var i2 = this.tryEntries.length - 1; i2 >= 0; --i2) {
          var entry = this.tryEntries[i2];
          if (entry.finallyLoc === finallyLoc) {
            this.complete(entry.completion, entry.afterLoc);
            resetTryEntry(entry);
            return ContinueSentinel;
          }
        }
      },
      "catch": function(tryLoc) {
        for (var i2 = this.tryEntries.length - 1; i2 >= 0; --i2) {
          var entry = this.tryEntries[i2];
          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;
            if (record.type === "throw") {
              var thrown = record.arg;
              resetTryEntry(entry);
            }
            return thrown;
          }
        }
        throw new Error("illegal catch attempt");
      },
      delegateYield: function(iterable, resultName, nextLoc) {
        this.delegate = {
          iterator: values(iterable),
          resultName,
          nextLoc
        };
        if (this.method === "next") {
          this.arg = undefined$12;
        }
        return ContinueSentinel;
      }
    };
    return exports;
  }(
    // If this script is executing as a CommonJS module, use module.exports
    // as the regeneratorRuntime namespace. Otherwise create a new empty
    // object. Either way, the resulting object will be used to initialize
    // the regeneratorRuntime variable at the top of this file.
    module.exports
  );
  try {
    regeneratorRuntime = runtime2;
  } catch (accidentalStrictMode) {
    if (typeof globalThis === "object") {
      globalThis.regeneratorRuntime = runtime2;
    } else {
      Function("r", "regeneratorRuntime = r")(runtime2);
    }
  }
})(runtime);
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var browser = { exports: {} };
var process = browser.exports = {};
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
  throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
  throw new Error("clearTimeout has not been defined");
}
(function() {
  try {
    if (typeof setTimeout === "function") {
      cachedSetTimeout = setTimeout;
    } else {
      cachedSetTimeout = defaultSetTimout;
    }
  } catch (e) {
    cachedSetTimeout = defaultSetTimout;
  }
  try {
    if (typeof clearTimeout === "function") {
      cachedClearTimeout = clearTimeout;
    } else {
      cachedClearTimeout = defaultClearTimeout;
    }
  } catch (e) {
    cachedClearTimeout = defaultClearTimeout;
  }
})();
function runTimeout(fun) {
  if (cachedSetTimeout === setTimeout) {
    return setTimeout(fun, 0);
  }
  if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
    cachedSetTimeout = setTimeout;
    return setTimeout(fun, 0);
  }
  try {
    return cachedSetTimeout(fun, 0);
  } catch (e) {
    try {
      return cachedSetTimeout.call(null, fun, 0);
    } catch (e2) {
      return cachedSetTimeout.call(this, fun, 0);
    }
  }
}
function runClearTimeout(marker) {
  if (cachedClearTimeout === clearTimeout) {
    return clearTimeout(marker);
  }
  if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
    cachedClearTimeout = clearTimeout;
    return clearTimeout(marker);
  }
  try {
    return cachedClearTimeout(marker);
  } catch (e) {
    try {
      return cachedClearTimeout.call(null, marker);
    } catch (e2) {
      return cachedClearTimeout.call(this, marker);
    }
  }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
  if (!draining || !currentQueue) {
    return;
  }
  draining = false;
  if (currentQueue.length) {
    queue = currentQueue.concat(queue);
  } else {
    queueIndex = -1;
  }
  if (queue.length) {
    drainQueue();
  }
}
function drainQueue() {
  if (draining) {
    return;
  }
  var timeout2 = runTimeout(cleanUpNextTick);
  draining = true;
  var len = queue.length;
  while (len) {
    currentQueue = queue;
    queue = [];
    while (++queueIndex < len) {
      if (currentQueue) {
        currentQueue[queueIndex].run();
      }
    }
    queueIndex = -1;
    len = queue.length;
  }
  currentQueue = null;
  draining = false;
  runClearTimeout(timeout2);
}
process.nextTick = function(fun) {
  var args = new Array(arguments.length - 1);
  if (arguments.length > 1) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      args[i2 - 1] = arguments[i2];
    }
  }
  queue.push(new Item(fun, args));
  if (queue.length === 1 && !draining) {
    runTimeout(drainQueue);
  }
};
function Item(fun, array) {
  this.fun = fun;
  this.array = array;
}
Item.prototype.run = function() {
  this.fun.apply(null, this.array);
};
process.title = "browser";
process.browser = true;
process.env = {};
process.argv = [];
process.version = "";
process.versions = {};
function noop$1() {
}
process.on = noop$1;
process.addListener = noop$1;
process.once = noop$1;
process.off = noop$1;
process.removeListener = noop$1;
process.removeAllListeners = noop$1;
process.emit = noop$1;
process.prependListener = noop$1;
process.prependOnceListener = noop$1;
process.listeners = function(name) {
  return [];
};
process.binding = function(name) {
  throw new Error("process.binding is not supported");
};
process.cwd = function() {
  return "/";
};
process.chdir = function(dir) {
  throw new Error("process.chdir is not supported");
};
process.umask = function() {
  return 0;
};
var browserExports = browser.exports;
const process$1 = /* @__PURE__ */ getDefaultExportFromCjs(browserExports);
var propTypes = { exports: {} };
var reactIs = { exports: {} };
var reactIs_production_min = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min)
    return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b = "function" === typeof Symbol && Symbol.for, c2 = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h2 = b ? Symbol.for("react.provider") : 60109, k2 = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m2 = b ? Symbol.for("react.concurrent_mode") : 60111, n2 = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r2 = b ? Symbol.for("react.memo") : 60115, t2 = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
  function z(a) {
    if ("object" === typeof a && null !== a) {
      var u = a.$$typeof;
      switch (u) {
        case c2:
          switch (a = a.type, a) {
            case l:
            case m2:
            case e:
            case g:
            case f:
            case p:
              return a;
            default:
              switch (a = a && a.$$typeof, a) {
                case k2:
                case n2:
                case t2:
                case r2:
                case h2:
                  return a;
                default:
                  return u;
              }
          }
        case d:
          return u;
      }
    }
  }
  function A(a) {
    return z(a) === m2;
  }
  reactIs_production_min.AsyncMode = l;
  reactIs_production_min.ConcurrentMode = m2;
  reactIs_production_min.ContextConsumer = k2;
  reactIs_production_min.ContextProvider = h2;
  reactIs_production_min.Element = c2;
  reactIs_production_min.ForwardRef = n2;
  reactIs_production_min.Fragment = e;
  reactIs_production_min.Lazy = t2;
  reactIs_production_min.Memo = r2;
  reactIs_production_min.Portal = d;
  reactIs_production_min.Profiler = g;
  reactIs_production_min.StrictMode = f;
  reactIs_production_min.Suspense = p;
  reactIs_production_min.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
  };
  reactIs_production_min.isConcurrentMode = A;
  reactIs_production_min.isContextConsumer = function(a) {
    return z(a) === k2;
  };
  reactIs_production_min.isContextProvider = function(a) {
    return z(a) === h2;
  };
  reactIs_production_min.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c2;
  };
  reactIs_production_min.isForwardRef = function(a) {
    return z(a) === n2;
  };
  reactIs_production_min.isFragment = function(a) {
    return z(a) === e;
  };
  reactIs_production_min.isLazy = function(a) {
    return z(a) === t2;
  };
  reactIs_production_min.isMemo = function(a) {
    return z(a) === r2;
  };
  reactIs_production_min.isPortal = function(a) {
    return z(a) === d;
  };
  reactIs_production_min.isProfiler = function(a) {
    return z(a) === g;
  };
  reactIs_production_min.isStrictMode = function(a) {
    return z(a) === f;
  };
  reactIs_production_min.isSuspense = function(a) {
    return z(a) === p;
  };
  reactIs_production_min.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m2 || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t2 || a.$$typeof === r2 || a.$$typeof === h2 || a.$$typeof === k2 || a.$$typeof === n2 || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
  };
  reactIs_production_min.typeOf = z;
  return reactIs_production_min;
}
var reactIs_development = {};
var hasRequiredReactIs_development;
function requireReactIs_development() {
  if (hasRequiredReactIs_development)
    return reactIs_development;
  hasRequiredReactIs_development = 1;
  if (process$1.env.NODE_ENV !== "production") {
    (function() {
      var hasSymbol = typeof Symbol === "function" && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
      function isValidElementType(type2) {
        return typeof type2 === "string" || typeof type2 === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type2 === REACT_FRAGMENT_TYPE || type2 === REACT_CONCURRENT_MODE_TYPE || type2 === REACT_PROFILER_TYPE || type2 === REACT_STRICT_MODE_TYPE || type2 === REACT_SUSPENSE_TYPE || type2 === REACT_SUSPENSE_LIST_TYPE || typeof type2 === "object" && type2 !== null && (type2.$$typeof === REACT_LAZY_TYPE || type2.$$typeof === REACT_MEMO_TYPE || type2.$$typeof === REACT_PROVIDER_TYPE || type2.$$typeof === REACT_CONTEXT_TYPE || type2.$$typeof === REACT_FORWARD_REF_TYPE || type2.$$typeof === REACT_FUNDAMENTAL_TYPE || type2.$$typeof === REACT_RESPONDER_TYPE || type2.$$typeof === REACT_SCOPE_TYPE || type2.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === "object" && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type2 = object.type;
              switch (type2) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type2;
                default:
                  var $$typeofType = type2 && type2.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return void 0;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element2 = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement2(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development.AsyncMode = AsyncMode;
      reactIs_development.ConcurrentMode = ConcurrentMode;
      reactIs_development.ContextConsumer = ContextConsumer;
      reactIs_development.ContextProvider = ContextProvider;
      reactIs_development.Element = Element2;
      reactIs_development.ForwardRef = ForwardRef;
      reactIs_development.Fragment = Fragment;
      reactIs_development.Lazy = Lazy;
      reactIs_development.Memo = Memo;
      reactIs_development.Portal = Portal;
      reactIs_development.Profiler = Profiler;
      reactIs_development.StrictMode = StrictMode;
      reactIs_development.Suspense = Suspense;
      reactIs_development.isAsyncMode = isAsyncMode;
      reactIs_development.isConcurrentMode = isConcurrentMode;
      reactIs_development.isContextConsumer = isContextConsumer;
      reactIs_development.isContextProvider = isContextProvider;
      reactIs_development.isElement = isElement2;
      reactIs_development.isForwardRef = isForwardRef;
      reactIs_development.isFragment = isFragment;
      reactIs_development.isLazy = isLazy;
      reactIs_development.isMemo = isMemo;
      reactIs_development.isPortal = isPortal;
      reactIs_development.isProfiler = isProfiler;
      reactIs_development.isStrictMode = isStrictMode;
      reactIs_development.isSuspense = isSuspense;
      reactIs_development.isValidElementType = isValidElementType;
      reactIs_development.typeOf = typeOf;
    })();
  }
  return reactIs_development;
}
var hasRequiredReactIs;
function requireReactIs() {
  if (hasRequiredReactIs)
    return reactIs.exports;
  hasRequiredReactIs = 1;
  if (process$1.env.NODE_ENV === "production") {
    reactIs.exports = requireReactIs_production_min();
  } else {
    reactIs.exports = requireReactIs_development();
  }
  return reactIs.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign;
var hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign)
    return objectAssign;
  hasRequiredObjectAssign = 1;
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty2 = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;
  function toObject(val) {
    if (val === null || val === void 0) {
      throw new TypeError("Object.assign cannot be called with null or undefined");
    }
    return Object(val);
  }
  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }
      var test1 = new String("abc");
      test1[5] = "de";
      if (Object.getOwnPropertyNames(test1)[0] === "5") {
        return false;
      }
      var test2 = {};
      for (var i2 = 0; i2 < 10; i2++) {
        test2["_" + String.fromCharCode(i2)] = i2;
      }
      var order2 = Object.getOwnPropertyNames(test2).map(function(n2) {
        return test2[n2];
      });
      if (order2.join("") !== "0123456789") {
        return false;
      }
      var test3 = {};
      "abcdefghijklmnopqrst".split("").forEach(function(letter) {
        test3[letter] = letter;
      });
      if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
        return false;
      }
      return true;
    } catch (err) {
      return false;
    }
  }
  objectAssign = shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for (var s2 = 1; s2 < arguments.length; s2++) {
      from = Object(arguments[s2]);
      for (var key in from) {
        if (hasOwnProperty2.call(from, key)) {
          to[key] = from[key];
        }
      }
      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);
        for (var i2 = 0; i2 < symbols.length; i2++) {
          if (propIsEnumerable.call(from, symbols[i2])) {
            to[symbols[i2]] = from[symbols[i2]];
          }
        }
      }
    }
    return to;
  };
  return objectAssign;
}
var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret)
    return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  ReactPropTypesSecret_1 = ReactPropTypesSecret;
  return ReactPropTypesSecret_1;
}
var has$4;
var hasRequiredHas;
function requireHas() {
  if (hasRequiredHas)
    return has$4;
  hasRequiredHas = 1;
  has$4 = Function.call.bind(Object.prototype.hasOwnProperty);
  return has$4;
}
var checkPropTypes_1;
var hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes)
    return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var printWarning = function() {
  };
  if (process$1.env.NODE_ENV !== "production") {
    var ReactPropTypesSecret = requireReactPropTypesSecret();
    var loggedTypeFailures = {};
    var has2 = requireHas();
    printWarning = function(text) {
      var message2 = "Warning: " + text;
      if (typeof console !== "undefined") {
        console.error(message2);
      }
      try {
        throw new Error(message2);
      } catch (x) {
      }
    };
  }
  function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    if (process$1.env.NODE_ENV !== "production") {
      for (var typeSpecName in typeSpecs) {
        if (has2(typeSpecs, typeSpecName)) {
          var error;
          try {
            if (typeof typeSpecs[typeSpecName] !== "function") {
              var err = Error(
                (componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              err.name = "Invariant Violation";
              throw err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
          } catch (ex) {
            error = ex;
          }
          if (error && !(error instanceof Error)) {
            printWarning(
              (componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
            );
          }
          if (error instanceof Error && !(error.message in loggedTypeFailures)) {
            loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : "";
            printWarning(
              "Failed " + location + " type: " + error.message + (stack != null ? stack : "")
            );
          }
        }
      }
    }
  }
  checkPropTypes.resetWarningCache = function() {
    if (process$1.env.NODE_ENV !== "production") {
      loggedTypeFailures = {};
    }
  };
  checkPropTypes_1 = checkPropTypes;
  return checkPropTypes_1;
}
var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers)
    return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var ReactIs = requireReactIs();
  var assign2 = requireObjectAssign();
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  var has2 = requireHas();
  var checkPropTypes = requireCheckPropTypes();
  var printWarning = function() {
  };
  if (process$1.env.NODE_ENV !== "production") {
    printWarning = function(text) {
      var message2 = "Warning: " + text;
      if (typeof console !== "undefined") {
        console.error(message2);
      }
      try {
        throw new Error(message2);
      } catch (x) {
      }
    };
  }
  function emptyFunctionThatReturnsNull() {
    return null;
  }
  factoryWithTypeCheckers = function(isValidElement2, throwOnDirectAccess) {
    var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === "function") {
        return iteratorFn;
      }
    }
    var ANONYMOUS = "<<anonymous>>";
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker("array"),
      bigint: createPrimitiveTypeChecker("bigint"),
      bool: createPrimitiveTypeChecker("boolean"),
      func: createPrimitiveTypeChecker("function"),
      number: createPrimitiveTypeChecker("number"),
      object: createPrimitiveTypeChecker("object"),
      string: createPrimitiveTypeChecker("string"),
      symbol: createPrimitiveTypeChecker("symbol"),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker
    };
    function is(x, y) {
      if (x === y) {
        return x !== 0 || 1 / x === 1 / y;
      } else {
        return x !== x && y !== y;
      }
    }
    function PropTypeError(message2, data) {
      this.message = message2;
      this.data = data && typeof data === "object" ? data : {};
      this.stack = "";
    }
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
      if (process$1.env.NODE_ENV !== "production") {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;
        if (secret !== ReactPropTypesSecret) {
          if (throwOnDirectAccess) {
            var err = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            err.name = "Invariant Violation";
            throw err;
          } else if (process$1.env.NODE_ENV !== "production" && typeof console !== "undefined") {
            var cacheKey = componentName + ":" + propName;
            if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3) {
              printWarning(
                "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
              );
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
            }
            return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
          }
          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }
      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          var preciseType = getPreciseType(propValue);
          return new PropTypeError(
            "Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
            { expectedType }
          );
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
        }
        var propValue = props[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
        }
        for (var i2 = 0; i2 < propValue.length; i2++) {
          var error = typeChecker(propValue, i2, componentName, location, propFullName + "[" + i2 + "]", ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!isValidElement2(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!ReactIs.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (process$1.env.NODE_ENV !== "production") {
          if (arguments.length > 1) {
            printWarning(
              "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
            );
          } else {
            printWarning("Invalid argument supplied to oneOf, expected an array.");
          }
        }
        return emptyFunctionThatReturnsNull;
      }
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        for (var i2 = 0; i2 < expectedValues.length; i2++) {
          if (is(propValue, expectedValues[i2])) {
            return null;
          }
        }
        var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
          var type2 = getPreciseType(value);
          if (type2 === "symbol") {
            return String(value);
          }
          return value;
        });
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
        }
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
        }
        for (var key in propValue) {
          if (has2(propValue, key)) {
            var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        process$1.env.NODE_ENV !== "production" ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
        return emptyFunctionThatReturnsNull;
      }
      for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
        var checker = arrayOfTypeCheckers[i2];
        if (typeof checker !== "function") {
          printWarning(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i2 + "."
          );
          return emptyFunctionThatReturnsNull;
        }
      }
      function validate(props, propName, componentName, location, propFullName) {
        var expectedTypes = [];
        for (var i3 = 0; i3 < arrayOfTypeCheckers.length; i3++) {
          var checker2 = arrayOfTypeCheckers[i3];
          var checkerResult = checker2(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
          if (checkerResult == null) {
            return null;
          }
          if (checkerResult.data && has2(checkerResult.data, "expectedType")) {
            expectedTypes.push(checkerResult.data.expectedType);
          }
        }
        var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode(props[propName])) {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type2) {
      return new PropTypeError(
        (componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type2 + "`."
      );
    }
    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        var allKeys = assign2({}, props[propName], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (has2(shapeTypes, key) && typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          if (!checker) {
            return new PropTypeError(
              "Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
            );
          }
          var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
      switch (typeof propValue) {
        case "number":
        case "string":
        case "undefined":
          return true;
        case "boolean":
          return !propValue;
        case "object":
          if (Array.isArray(propValue)) {
            return propValue.every(isNode);
          }
          if (propValue === null || isValidElement2(propValue)) {
            return true;
          }
          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode(step.value)) {
                  return false;
                }
              }
            } else {
              while (!(step = iterator.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }
          return true;
        default:
          return false;
      }
    }
    function isSymbol2(propType, propValue) {
      if (propType === "symbol") {
        return true;
      }
      if (!propValue) {
        return false;
      }
      if (propValue["@@toStringTag"] === "Symbol") {
        return true;
      }
      if (typeof Symbol === "function" && propValue instanceof Symbol) {
        return true;
      }
      return false;
    }
    function getPropType(propValue) {
      var propType = typeof propValue;
      if (Array.isArray(propValue)) {
        return "array";
      }
      if (propValue instanceof RegExp) {
        return "object";
      }
      if (isSymbol2(propType, propValue)) {
        return "symbol";
      }
      return propType;
    }
    function getPreciseType(propValue) {
      if (typeof propValue === "undefined" || propValue === null) {
        return "" + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === "object") {
        if (propValue instanceof Date) {
          return "date";
        } else if (propValue instanceof RegExp) {
          return "regexp";
        }
      }
      return propType;
    }
    function getPostfixForTypeWarning(value) {
      var type2 = getPreciseType(value);
      switch (type2) {
        case "array":
        case "object":
          return "an " + type2;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + type2;
        default:
          return type2;
      }
    }
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = checkPropTypes;
    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithTypeCheckers;
}
var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims)
    return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  function emptyFunction() {
  }
  function emptyFunctionWithReset() {
  }
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  factoryWithThrowingShims = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        return;
      }
      var err = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      err.name = "Invariant Violation";
      throw err;
    }
    shim.isRequired = shim;
    function getShim() {
      return shim;
    }
    var ReactPropTypes = {
      array: shim,
      bigint: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithThrowingShims;
}
if (process$1.env.NODE_ENV !== "production") {
  var ReactIs = requireReactIs();
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  propTypes.exports = requireFactoryWithThrowingShims()();
}
var propTypesExports = propTypes.exports;
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs$1(propTypesExports);
const colors = {
  // Base colours
  white: "#FFF",
  black: "#000",
  jumbo: "#7C7C80",
  catskillWhite: "#EEF3F6",
  porcelain: "#F3F4F5",
  athensGray: "#F9FAFB",
  // THEMES
  // Primary
  cornflowerBlue: "#5EA5EE",
  havelockBlue: "#5698DC",
  hawkesBlue: "#E4F0FC",
  mariner: "#2E71C1",
  // Secondary
  amethyst: "#BA69C8",
  wisteria: "#A55AB2",
  whiteLilac: "#F8F0F9",
  affair: "#974CA3",
  // Success
  jungleGreen: "#34B96F",
  eucalyptus: "#2FA765",
  harp: "#E1F1E7",
  seaGreen: "#229053",
  // Warning
  sandyBrown: "#F28F5D",
  burntSienna: "#E88857",
  provincialPink: "#FDF3EE",
  redDamask: "#D77644",
  // Error
  mandy: "#e25c59",
  chestnutRose: "#D05552",
  linen: "#FCEEEE",
  mojo: "#C24441",
  // Legacy
  scooter: "#40aadb",
  pelorous: "#3A99C4",
  whiteIce: "#D9EEF8",
  jellyBean: "#257FA8",
  // Light
  mystic: "#E4EBEF",
  geyser: "#DAE0E4",
  grayChateau: "#A6ACAF",
  scorpion: "#5C5C5C",
  // Dark
  oxfordBlue: "#343951",
  blueZodiac: "#0B1236",
  mischka: "#D3D5DF",
  blackPearl: "#060A22",
  // Tertiary
  froly: "#F96E8D",
  cranberry: "#E55D7B",
  wispPink: "#FCE6EA",
  cabaret: "#D54F6D",
  // Info
  shakespeare: "#41BFCB",
  bostonBlue: "#30A4AF",
  iceberg: "#D8F2F4",
  easternBlue: "#238F99"
};
const primaryTheme = {
  base: colors.cornflowerBlue,
  medium: colors.havelockBlue,
  light: colors.hawkesBlue,
  dark: colors.mariner
};
const secondaryTheme = {
  base: colors.amethyst,
  medium: colors.wisteria,
  light: colors.whiteLilac,
  dark: colors.affair
};
const successTheme = {
  base: colors.jungleGreen,
  medium: colors.eucalyptus,
  light: colors.harp,
  dark: colors.seaGreen
};
const warningTheme = {
  base: colors.sandyBrown,
  medium: colors.burntSienna,
  light: colors.provincialPink,
  dark: colors.redDamask
};
const errorTheme = {
  base: colors.mandy,
  medium: colors.chestnutRose,
  light: colors.linen,
  dark: colors.mojo
};
const legacyTheme = {
  base: colors.scooter,
  medium: colors.pelorous,
  light: colors.whiteIce,
  dark: colors.jellyBean
};
const lightTheme = {
  base: colors.grayChateau,
  medium: colors.geyser,
  light: colors.mystic,
  dark: colors.scorpion
};
const darkTheme = {
  base: colors.oxfordBlue,
  medium: colors.blueZodiac,
  light: colors.mischka,
  dark: colors.blackPearl
};
const tertiaryTheme = {
  base: colors.froly,
  medium: colors.cranberry,
  light: colors.wispPink,
  dark: colors.cabaret
};
const infoTheme = {
  base: colors.shakespeare,
  medium: colors.bostonBlue,
  light: colors.iceberg,
  dark: colors.easternBlue
};
const getThemeColors = (theme) => {
  switch (theme) {
    case "secondary":
      return secondaryTheme;
    case "success":
      return successTheme;
    case "warning":
      return warningTheme;
    case "error":
      return errorTheme;
    case "legacy":
      return legacyTheme;
    case "light":
      return lightTheme;
    case "dark":
      return darkTheme;
    case "tertiary":
      return tertiaryTheme;
    case "info":
      return infoTheme;
    default:
      return primaryTheme;
  }
};
const getSkeletonColors = (theme) => {
  switch (theme) {
    case "dark":
      return colors.geyser;
    default:
      return colors.mystic;
  }
};
const borderRadius = {
  extraLarge: 100,
  medium: 4,
  default: 3,
  small: 2
};
const spacing = {
  extraLarge: 40,
  large: 24,
  medium: 18,
  default: 12,
  small: 6,
  extraSmall: 3
};
const fontSize = {
  extraLarge: 30,
  large: 24,
  medium: 18,
  default: 16,
  small: 14,
  extraSmall: 12
};
const fontWeight = {
  thin: 100,
  extraLight: 200,
  light: 300,
  regular: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
  extraBold: 800,
  black: 900
};
const fontFamily = {
  heading: '"proxima-nova", Helvetica, Arial, sans-serif',
  body: '"proxima-nova", Helvetica, Arial, sans-serif'
};
const lineHeight = {
  default: 1.2
};
const zIndex = {
  level1: 100,
  level2: 200,
  level3: 300,
  level4: 400,
  level5: 500,
  level6: 600,
  level7: 700,
  level8: 800,
  level9: 900,
  level10: 1e3
};
const breakpoint = {
  phone: 640,
  // Need to use 821 because of rails. Change back to tablet: 800 when we remove sass
  tablet: 821,
  desktop: 1128
};
const size = {
  navbar: 50,
  attachmentHeightSmall: 30,
  attachmentHeightDefault: 35
};
const styles$1R = {
  label: css({
    display: "inline-block",
    fontFamily: fontFamily.body,
    fontSize: fontSize.default,
    fontWeight: fontWeight.regular,
    lineHeight: 1.2,
    color: colors.blackPearl,
    marginBottom: spacing.small
  })
};
const FormLabel = ({ htmlFor, label, optional, className, id, forwardRef, onClick }) => /* @__PURE__ */ React.createElement("label", { ref: forwardRef, htmlFor, className: cx(styles$1R.label, className), onClick, id }, label, Boolean(optional) && /* @__PURE__ */ React.createElement(React.Fragment, null, " (optional)"));
FormLabel.propTypes = {
  htmlFor: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  optional: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  forwardRef: PropTypes.any,
  onClick: PropTypes.func
};
const AccessibleFormLabel = ({ formFieldId, label, labelClassName, readOnly, optional, children }) => {
  const [formFieldRef, setFormFieldRef] = useState(null);
  const labelRef = useRef();
  useEffect(() => {
    const { current: labelCurrent } = labelRef;
    const focusOnSelect = () => {
      if (!readOnly)
        formFieldRef.focus();
    };
    labelCurrent.addEventListener("click", focusOnSelect);
    return () => labelCurrent.removeEventListener("click", focusOnSelect);
  });
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(FormLabel, { forwardRef: labelRef, className: labelClassName, id: `${formFieldId}-label`, label, optional }), React.Children.map(
    children,
    (child) => React.cloneElement(child, {
      id: formFieldId,
      ariaLabelledby: `${formFieldId}-label`,
      setInnerRef: setFormFieldRef
    })
  ));
};
AccessibleFormLabel.propTypes = {
  formFieldId: PropTypes.string,
  label: PropTypes.string,
  labelClassName: PropTypes.string,
  readOnly: PropTypes.bool,
  optional: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
const hexToRgba = (colorValue, opacity = 1) => {
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  const fullHexColour = colorValue.replace(shorthandRegex, (m2, r2, g, b) => r2 + r2 + g + g + b + b);
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHexColour);
  const rgb = result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : { r: 0, g: 0, b: 0 };
  return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${opacity})`;
};
const scrollGradient = {
  backgroundImage: `linear-gradient(${colors.white}, ${hexToRgba(colors.white, 0)}),
    linear-gradient(to top, ${colors.white}, ${hexToRgba(colors.white, 0)}),
    linear-gradient(${hexToRgba(colors.grayChateau, 0.15)}, ${hexToRgba(colors.grayChateau, 0)}),
    linear-gradient(to top, ${hexToRgba(colors.grayChateau, 0.15)}, ${hexToRgba(colors.grayChateau, 0)})`,
  backgroundPosition: "0 0, 0 100%, 0 0, 0 100%",
  backgroundSize: "100% 50px, 100% 50px, 100% 20px, 100% 20px",
  backgroundRepeat: "no-repeat",
  backgroundColor: colors.white,
  backgroundAttachment: "local, local, scroll, scroll"
};
const accessiblyHidden = {
  border: 0,
  clip: "rect(0 0 0 0)",
  clipPath: "polygon(0 0, 0 0, 0 0)",
  height: 1,
  margin: -1,
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  width: 1,
  whiteSpace: "nowrap"
};
const styles$1Q = {
  accessiblyHidden: css(accessiblyHidden)
};
const AccessibleText = ({ displayText, accessibleText, className }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", { className, "aria-hidden": true }, displayText), /* @__PURE__ */ React.createElement("span", { className: styles$1Q.accessiblyHidden }, accessibleText));
AccessibleText.propTypes = {
  displayText: PropTypes.node.isRequired,
  accessibleText: PropTypes.string.isRequired,
  className: PropTypes.string
};
const styles$1P = {
  wrapper: css({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",
    userSelect: "none"
  })
};
const wrapperSize$6 = (size2) => css({
  width: size2,
  height: size2
});
const iconSize$8 = (size2) => css({
  maxWidth: size2,
  maxHeight: size2
});
const AccessibleIcon = ({ icon, title, size: size2 = fontSize.medium, color = colors.scorpion, className, ariaHidden = true }) => {
  const [iconObject, setIconObject] = useState({ type: null, icon: null });
  const ariaHiddenValue = !title && "true" || ariaHidden.toString();
  useEffect(() => {
    if (!icon)
      return;
    if (typeof icon === "string") {
      console.warn("AccessibleIcon", `Passing in strings to the icon prop is deprecated. You passed in "${icon}"`);
      return;
    }
    if (icon == null ? void 0 : icon.paths) {
      setIconObject({ type: "object", icon });
      return;
    }
    if (isValidElement(createElement(icon))) {
      setIconObject({ type: "zenicon" });
      return;
    }
    console.warn("AccessibleIcon", "icon prop should be an string, object with paths or a React component");
  }, [icon]);
  return Boolean(icon && iconObject.type) && /* @__PURE__ */ React.createElement("span", { className: cx(styles$1P.wrapper, className, wrapperSize$6(size2)) }, iconObject.type === "zenicon" ? /* @__PURE__ */ React.createElement(React.Fragment, null, createElement(icon, {
    title,
    color,
    fontSize: size2,
    "aria-hidden": ariaHiddenValue
  })) : /* @__PURE__ */ React.createElement(
    "svg",
    {
      className: iconSize$8(size2),
      fill: color,
      width: 1024,
      height: 1024,
      viewBox: "0 0 1024 1024",
      preserveAspectRatio: "xMidYMid meet",
      role: "img",
      "aria-hidden": ariaHiddenValue
    },
    Boolean(title) && /* @__PURE__ */ React.createElement("title", null, title),
    /* @__PURE__ */ React.createElement("path", { d: iconObject.icon.paths.join(" ") })
  ));
};
AccessibleIcon.propTypes = {
  title: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  className: PropTypes.string,
  ariaHidden: PropTypes.bool,
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.shape({})]).isRequired
};
const specialKeyPressed = (ev) => ev.metaKey || ev.altKey || ev.ctrlKey || ev.shiftKey;
const dimension = 30;
const styles$1O = {
  actionsMenu: css({
    display: "inline-block",
    position: "relative"
  }),
  button: css({
    background: "none",
    border: "none",
    borderRadius: borderRadius.default,
    height: dimension,
    width: dimension,
    padding: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }),
  menu: css({
    position: "absolute",
    right: spacing.small,
    top: `calc(100% - ${spacing.small}px)`,
    borderStyle: "solid",
    borderRadius: borderRadius.small,
    overflow: "hidden",
    borderWidth: "1px",
    borderColor: colors.mystic,
    boxShadow: `1px 1px 10px 0px ${hexToRgba(colors.black, 0.1)}`,
    zIndex: zIndex.level1
  })
};
const iconTheme$9 = (theme) => {
  const themed = getThemeColors(theme);
  return theme === "light" ? colors.jumbo : themed.base;
};
const hoverTheme$1 = (theme) => {
  const themed = getThemeColors(theme);
  return css({
    "&:hover, &:focus, &[aria-expanded=true]": {
      backgroundColor: themed.light
    },
    "&:focus": {
      outlineColor: themed.base
    }
  });
};
const ActionsMenu$1 = ({ icon, className, children, theme = "primary", label = "further actions", onToggle = () => {
} }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isHovering, setIsHovering] = useState(false);
  const [isFocussed, setIsFocussed] = useState(false);
  const node2 = useRef();
  const displayIconColor = isHovering || isOpen || isFocussed;
  const handleButtonClick = () => {
    onToggle(!isOpen);
    setIsOpen(!isOpen);
  };
  const handleMenuItemClick = () => {
    setIsOpen(false);
    setIsHovering(false);
  };
  useEffect(() => {
    const handleClosingClick = (e) => {
      if (node2.current.contains(e.target))
        return;
      onToggle(false);
      setIsOpen(false);
    };
    if (isOpen) {
      document.addEventListener("mousedown", handleClosingClick);
    } else {
      document.removeEventListener("mousedown", handleClosingClick);
    }
    return () => {
      document.removeEventListener("mousedown", handleClosingClick);
    };
  }, [isOpen, onToggle]);
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cx(styles$1O.actionsMenu, className),
      ref: node2,
      onMouseEnter: () => setIsHovering(true),
      onMouseLeave: () => setIsHovering(false)
    },
    /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        onClick: handleButtonClick,
        "aria-haspopup": "true",
        "aria-expanded": isOpen,
        className: cx(styles$1O.button, hoverTheme$1(theme)),
        "aria-label": label,
        onFocus: () => setIsFocussed(true),
        onBlur: () => setIsFocussed(false)
      },
      /* @__PURE__ */ React.createElement(AccessibleIcon, { icon, size: 18, color: displayIconColor ? iconTheme$9(theme) : colors.jumbo })
    ),
    Boolean(isOpen) && /* @__PURE__ */ React.createElement(
      "div",
      {
        role: "menu",
        tabIndex: 0,
        className: styles$1O.menu,
        "aria-label": `${label} menu`,
        onKeyDown: (ev) => {
          if (ev.code === 13 && !specialKeyPressed(ev))
            setIsOpen(false);
        },
        onClick: handleMenuItemClick
      },
      React.Children.map(children, (child) => {
        if (!child)
          return null;
        const item = React.cloneElement(child, {
          theme
        });
        return item;
      })
    )
  );
};
ActionsMenu$1.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "light", "dark", "tertiary", "info"]),
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.shape({})]).isRequired,
  className: PropTypes.string,
  label: PropTypes.string,
  onToggle: PropTypes.func
};
const styles$1N = {
  button: css({
    background: "none",
    backgroundColor: colors.white,
    border: "none",
    color: colors.jumbo,
    fontFamily: fontFamily.body,
    fontWeight: fontWeight.normal,
    fontSize: fontSize.default,
    padding: spacing.default,
    textAlign: "left",
    whiteSpace: "nowrap",
    width: "100%",
    cursor: "pointer",
    margin: 0,
    "&:hover, &:focus": {
      outline: "none"
    }
  })
};
const buttonTheme$2 = (theme) => {
  const themed = getThemeColors(theme);
  const base = theme === "light" ? colors.jumbo : themed.base;
  return css({
    "&:hover, &:focus": {
      backgroundColor: themed.light,
      color: base
    }
  });
};
const Button$1 = ({ onClick, children, theme = "primary" }) => /* @__PURE__ */ React.createElement("button", { type: "button", onClick, className: cx(styles$1N.button, buttonTheme$2(theme)), role: "menuitem" }, children);
Button$1.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "light", "dark", "tertiary", "info"])
};
const PinataLink = ({ to, children, as: AsProp, ...props }) => createElement(AsProp, { to, ...props }, children);
PinataLink.propTypes = {
  to: PropTypes.string,
  as: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({})]),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};
const linkTheme$3 = (theme) => {
  const themed = getThemeColors(theme);
  if (theme === "light") {
    return css({
      color: colors.jumbo,
      "&:active": {
        color: themed.dark
      }
    });
  }
  return css({
    color: themed.base,
    "&:active": {
      color: themed.dark
    }
  });
};
const styles$1M = {
  link: css({
    fontFamily: fontFamily.body,
    fontSize: "inherit",
    fontWeight: "inherit",
    cursor: "pointer",
    userSelect: "none",
    textDecoration: "none",
    "&:focus": {
      outline: "none",
      textDecoration: "underline"
    },
    "&:hover": {
      textDecoration: "underline"
    },
    "&:active": {
      textDecoration: "underline"
    }
  }),
  disabled: css({
    pointerEvents: "none",
    cursor: "default",
    opacity: 0.3
  })
};
const Hyperlink = ({ theme, disabled, className, label, href, onClick, target, download, external, rel, as }) => {
  const Component2 = href && !external ? PinataLink : "a";
  const componentProps = {
    ...href ? {
      ...external ? {
        href,
        rel
      } : {
        to: href,
        as
      },
      target,
      download,
      onClick
    } : {
      onClick,
      onKeyDown: (ev) => {
        if (ev.which === 13 && !specialKeyPressed(ev) && onClick)
          onClick(ev);
      },
      tabIndex: disabled ? "-1" : "0"
    }
  };
  return /* @__PURE__ */ React.createElement(
    Component2,
    {
      className: cx(styles$1M.link, className, linkTheme$3(theme), disabled && styles$1M.disabled),
      ...componentProps
    },
    label
  );
};
Hyperlink.propTypes = {
  label: PropTypes.string.isRequired,
  href: PropTypes.string,
  onClick: PropTypes.func,
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "light", "dark", "tertiary", "info"]),
  target: PropTypes.oneOf(["_self", "_blank", "_parent", "_top"]),
  download: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  external: PropTypes.bool,
  rel: PropTypes.string,
  as: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({})])
};
Hyperlink.defaultProps = {
  theme: "primary",
  external: false
};
const styles$1L = {
  link: css({
    backgroundColor: colors.white,
    boxSizing: "border-box",
    display: "inline-block",
    color: colors.jumbo,
    fontFamily: fontFamily.body,
    fontWeight: fontWeight.normal,
    padding: spacing.default,
    fontSize: fontSize.default,
    textAlign: "left",
    whiteSpace: "nowrap",
    width: "100%",
    "&:link, &:visited": {
      color: colors.jumbo
    },
    "&:hover, &:focus": {
      textDecoration: "none"
    }
  })
};
const linkTheme$2 = (theme) => {
  const themed = getThemeColors(theme);
  const base = theme === "light" ? colors.jumbo : themed.base;
  return css({
    "&:hover, &:focus": {
      backgroundColor: themed.light,
      color: base
    }
  });
};
const Link = ({ label, href, onClick, external, rel, target, theme = "primary", asLink }) => /* @__PURE__ */ React.createElement("div", { role: "menuitem" }, /* @__PURE__ */ React.createElement(
  Hyperlink,
  {
    label,
    href,
    onClick,
    external,
    rel,
    target,
    className: cx(styles$1L.link, linkTheme$2(theme)),
    as: asLink
  }
));
Link.propTypes = {
  label: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  external: PropTypes.bool,
  rel: PropTypes.string,
  target: PropTypes.string,
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "light", "dark", "tertiary", "info"]),
  asLink: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({})])
};
const ActionsMenu = ActionsMenu$1;
ActionsMenu.Button = Button$1;
ActionsMenu.Link = Link;
var H = { exports: {} }, j = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Re;
function ir() {
  return Re || (Re = 1, process$1.env.NODE_ENV !== "production" && function() {
    var N = React, P = Symbol.for("react.element"), V = Symbol.for("react.portal"), y = Symbol.for("react.fragment"), D = Symbol.for("react.strict_mode"), F = Symbol.for("react.profiler"), S = Symbol.for("react.provider"), h2 = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), R = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), g = Symbol.for("react.memo"), _ = Symbol.for("react.lazy"), A = Symbol.for("react.offscreen"), X = Symbol.iterator, Ce = "@@iterator";
    function Pe(e) {
      if (e === null || typeof e != "object")
        return null;
      var r2 = X && e[X] || e[Ce];
      return typeof r2 == "function" ? r2 : null;
    }
    var T = N.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function c2(e) {
      {
        for (var r2 = arguments.length, t2 = new Array(r2 > 1 ? r2 - 1 : 0), n2 = 1; n2 < r2; n2++)
          t2[n2 - 1] = arguments[n2];
        Se("error", e, t2);
      }
    }
    function Se(e, r2, t2) {
      {
        var n2 = T.ReactDebugCurrentFrame, i2 = n2.getStackAddendum();
        i2 !== "" && (r2 += "%s", t2 = t2.concat([i2]));
        var u = t2.map(function(o) {
          return String(o);
        });
        u.unshift("Warning: " + r2), Function.prototype.apply.call(console[e], console, u);
      }
    }
    var we = false, xe = false, je = false, ke = false, De = false, Z;
    Z = Symbol.for("react.module.reference");
    function Fe(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === y || e === F || De || e === D || e === R || e === d || ke || e === A || we || xe || je || typeof e == "object" && e !== null && (e.$$typeof === _ || e.$$typeof === g || e.$$typeof === S || e.$$typeof === h2 || e.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === Z || e.getModuleId !== void 0));
    }
    function Ae(e, r2, t2) {
      var n2 = e.displayName;
      if (n2)
        return n2;
      var i2 = r2.displayName || r2.name || "";
      return i2 !== "" ? t2 + "(" + i2 + ")" : t2;
    }
    function Q(e) {
      return e.displayName || "Context";
    }
    function E(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && c2("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case y:
          return "Fragment";
        case V:
          return "Portal";
        case F:
          return "Profiler";
        case D:
          return "StrictMode";
        case R:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case h2:
            var r2 = e;
            return Q(r2) + ".Consumer";
          case S:
            var t2 = e;
            return Q(t2._context) + ".Provider";
          case l:
            return Ae(e, e.render, "ForwardRef");
          case g:
            var n2 = e.displayName || null;
            return n2 !== null ? n2 : E(e.type) || "Memo";
          case _: {
            var i2 = e, u = i2._payload, o = i2._init;
            try {
              return E(o(u));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var m2 = Object.assign, w = 0, ee, re, te, ne, ae, oe, ie;
    function ue() {
    }
    ue.__reactDisabledLog = true;
    function Ie() {
      {
        if (w === 0) {
          ee = console.log, re = console.info, te = console.warn, ne = console.error, ae = console.group, oe = console.groupCollapsed, ie = console.groupEnd;
          var e = {
            configurable: true,
            enumerable: true,
            value: ue,
            writable: true
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        w++;
      }
    }
    function $e() {
      {
        if (w--, w === 0) {
          var e = {
            configurable: true,
            enumerable: true,
            writable: true
          };
          Object.defineProperties(console, {
            log: m2({}, e, {
              value: ee
            }),
            info: m2({}, e, {
              value: re
            }),
            warn: m2({}, e, {
              value: te
            }),
            error: m2({}, e, {
              value: ne
            }),
            group: m2({}, e, {
              value: ae
            }),
            groupCollapsed: m2({}, e, {
              value: oe
            }),
            groupEnd: m2({}, e, {
              value: ie
            })
          });
        }
        w < 0 && c2("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var M = T.ReactCurrentDispatcher, U;
    function I(e, r2, t2) {
      {
        if (U === void 0)
          try {
            throw Error();
          } catch (i2) {
            var n2 = i2.stack.trim().match(/\n( *(at )?)/);
            U = n2 && n2[1] || "";
          }
        return `
` + U + e;
      }
    }
    var B = false, $;
    {
      var We = typeof WeakMap == "function" ? WeakMap : Map;
      $ = new We();
    }
    function se(e, r2) {
      if (!e || B)
        return "";
      {
        var t2 = $.get(e);
        if (t2 !== void 0)
          return t2;
      }
      var n2;
      B = true;
      var i2 = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var u;
      u = M.current, M.current = null, Ie();
      try {
        if (r2) {
          var o = function() {
            throw Error();
          };
          if (Object.defineProperty(o.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(o, []);
            } catch (b) {
              n2 = b;
            }
            Reflect.construct(e, [], o);
          } else {
            try {
              o.call();
            } catch (b) {
              n2 = b;
            }
            e.call(o.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (b) {
            n2 = b;
          }
          e();
        }
      } catch (b) {
        if (b && n2 && typeof b.stack == "string") {
          for (var a = b.stack.split(`
`), v = n2.stack.split(`
`), s2 = a.length - 1, f = v.length - 1; s2 >= 1 && f >= 0 && a[s2] !== v[f]; )
            f--;
          for (; s2 >= 1 && f >= 0; s2--, f--)
            if (a[s2] !== v[f]) {
              if (s2 !== 1 || f !== 1)
                do
                  if (s2--, f--, f < 0 || a[s2] !== v[f]) {
                    var p = `
` + a[s2].replace(" at new ", " at ");
                    return e.displayName && p.includes("<anonymous>") && (p = p.replace("<anonymous>", e.displayName)), typeof e == "function" && $.set(e, p), p;
                  }
                while (s2 >= 1 && f >= 0);
              break;
            }
        }
      } finally {
        B = false, M.current = u, $e(), Error.prepareStackTrace = i2;
      }
      var C = e ? e.displayName || e.name : "", ye = C ? I(C) : "";
      return typeof e == "function" && $.set(e, ye), ye;
    }
    function Ye(e, r2, t2) {
      return se(e, false);
    }
    function Le(e) {
      var r2 = e.prototype;
      return !!(r2 && r2.isReactComponent);
    }
    function W(e, r2, t2) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return se(e, Le(e));
      if (typeof e == "string")
        return I(e);
      switch (e) {
        case R:
          return I("Suspense");
        case d:
          return I("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case l:
            return Ye(e.render);
          case g:
            return W(e.type, r2, t2);
          case _: {
            var n2 = e, i2 = n2._payload, u = n2._init;
            try {
              return W(u(i2), r2, t2);
            } catch {
            }
          }
        }
      return "";
    }
    var Y = Object.prototype.hasOwnProperty, fe = {}, le = T.ReactDebugCurrentFrame;
    function L(e) {
      if (e) {
        var r2 = e._owner, t2 = W(e.type, e._source, r2 ? r2.type : null);
        le.setExtraStackFrame(t2);
      } else
        le.setExtraStackFrame(null);
    }
    function Ne(e, r2, t2, n2, i2) {
      {
        var u = Function.call.bind(Y);
        for (var o in e)
          if (u(e, o)) {
            var a = void 0;
            try {
              if (typeof e[o] != "function") {
                var v = Error((n2 || "React class") + ": " + t2 + " type `" + o + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[o] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw v.name = "Invariant Violation", v;
              }
              a = e[o](r2, o, n2, t2, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (s2) {
              a = s2;
            }
            a && !(a instanceof Error) && (L(i2), c2("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", n2 || "React class", t2, o, typeof a), L(null)), a instanceof Error && !(a.message in fe) && (fe[a.message] = true, L(i2), c2("Failed %s type: %s", t2, a.message), L(null));
          }
      }
    }
    var Ve = Array.isArray;
    function q(e) {
      return Ve(e);
    }
    function Me(e) {
      {
        var r2 = typeof Symbol == "function" && Symbol.toStringTag, t2 = r2 && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return t2;
      }
    }
    function Ue(e) {
      try {
        return ce(e), false;
      } catch {
        return true;
      }
    }
    function ce(e) {
      return "" + e;
    }
    function ve(e) {
      if (Ue(e))
        return c2("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Me(e)), ce(e);
    }
    var x = T.ReactCurrentOwner, Be = {
      key: true,
      ref: true,
      __self: true,
      __source: true
    }, de, pe, J;
    J = {};
    function qe(e) {
      if (Y.call(e, "ref")) {
        var r2 = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (r2 && r2.isReactWarning)
          return false;
      }
      return e.ref !== void 0;
    }
    function Je(e) {
      if (Y.call(e, "key")) {
        var r2 = Object.getOwnPropertyDescriptor(e, "key").get;
        if (r2 && r2.isReactWarning)
          return false;
      }
      return e.key !== void 0;
    }
    function Ge(e, r2) {
      if (typeof e.ref == "string" && x.current && r2 && x.current.stateNode !== r2) {
        var t2 = E(x.current.type);
        J[t2] || (c2('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', E(x.current.type), e.ref), J[t2] = true);
      }
    }
    function ze(e, r2) {
      {
        var t2 = function() {
          de || (de = true, c2("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r2));
        };
        t2.isReactWarning = true, Object.defineProperty(e, "key", {
          get: t2,
          configurable: true
        });
      }
    }
    function Ke(e, r2) {
      {
        var t2 = function() {
          pe || (pe = true, c2("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r2));
        };
        t2.isReactWarning = true, Object.defineProperty(e, "ref", {
          get: t2,
          configurable: true
        });
      }
    }
    var He = function(e, r2, t2, n2, i2, u, o) {
      var a = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: P,
        // Built-in properties that belong on the element
        type: e,
        key: r2,
        ref: t2,
        props: o,
        // Record the component responsible for creating this element.
        _owner: u
      };
      return a._store = {}, Object.defineProperty(a._store, "validated", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      }), Object.defineProperty(a, "_self", {
        configurable: false,
        enumerable: false,
        writable: false,
        value: n2
      }), Object.defineProperty(a, "_source", {
        configurable: false,
        enumerable: false,
        writable: false,
        value: i2
      }), Object.freeze && (Object.freeze(a.props), Object.freeze(a)), a;
    };
    function Xe(e, r2, t2, n2, i2) {
      {
        var u, o = {}, a = null, v = null;
        t2 !== void 0 && (ve(t2), a = "" + t2), Je(r2) && (ve(r2.key), a = "" + r2.key), qe(r2) && (v = r2.ref, Ge(r2, i2));
        for (u in r2)
          Y.call(r2, u) && !Be.hasOwnProperty(u) && (o[u] = r2[u]);
        if (e && e.defaultProps) {
          var s2 = e.defaultProps;
          for (u in s2)
            o[u] === void 0 && (o[u] = s2[u]);
        }
        if (a || v) {
          var f = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          a && ze(o, f), v && Ke(o, f);
        }
        return He(e, a, v, i2, n2, x.current, o);
      }
    }
    var G = T.ReactCurrentOwner, ge = T.ReactDebugCurrentFrame;
    function O(e) {
      if (e) {
        var r2 = e._owner, t2 = W(e.type, e._source, r2 ? r2.type : null);
        ge.setExtraStackFrame(t2);
      } else
        ge.setExtraStackFrame(null);
    }
    var z;
    z = false;
    function K(e) {
      return typeof e == "object" && e !== null && e.$$typeof === P;
    }
    function Ee() {
      {
        if (G.current) {
          var e = E(G.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function Ze(e) {
      {
        if (e !== void 0) {
          var r2 = e.fileName.replace(/^.*[\\\/]/, ""), t2 = e.lineNumber;
          return `

Check your code at ` + r2 + ":" + t2 + ".";
        }
        return "";
      }
    }
    var be = {};
    function Qe(e) {
      {
        var r2 = Ee();
        if (!r2) {
          var t2 = typeof e == "string" ? e : e.displayName || e.name;
          t2 && (r2 = `

Check the top-level render call using <` + t2 + ">.");
        }
        return r2;
      }
    }
    function he(e, r2) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = true;
        var t2 = Qe(r2);
        if (be[t2])
          return;
        be[t2] = true;
        var n2 = "";
        e && e._owner && e._owner !== G.current && (n2 = " It was passed a child from " + E(e._owner.type) + "."), O(e), c2('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', t2, n2), O(null);
      }
    }
    function _e(e, r2) {
      {
        if (typeof e != "object")
          return;
        if (q(e))
          for (var t2 = 0; t2 < e.length; t2++) {
            var n2 = e[t2];
            K(n2) && he(n2, r2);
          }
        else if (K(e))
          e._store && (e._store.validated = true);
        else if (e) {
          var i2 = Pe(e);
          if (typeof i2 == "function" && i2 !== e.entries)
            for (var u = i2.call(e), o; !(o = u.next()).done; )
              K(o.value) && he(o.value, r2);
        }
      }
    }
    function er(e) {
      {
        var r2 = e.type;
        if (r2 == null || typeof r2 == "string")
          return;
        var t2;
        if (typeof r2 == "function")
          t2 = r2.propTypes;
        else if (typeof r2 == "object" && (r2.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        r2.$$typeof === g))
          t2 = r2.propTypes;
        else
          return;
        if (t2) {
          var n2 = E(r2);
          Ne(t2, e.props, "prop", n2, e);
        } else if (r2.PropTypes !== void 0 && !z) {
          z = true;
          var i2 = E(r2);
          c2("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", i2 || "Unknown");
        }
        typeof r2.getDefaultProps == "function" && !r2.getDefaultProps.isReactClassApproved && c2("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function rr(e) {
      {
        for (var r2 = Object.keys(e.props), t2 = 0; t2 < r2.length; t2++) {
          var n2 = r2[t2];
          if (n2 !== "children" && n2 !== "key") {
            O(e), c2("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", n2), O(null);
            break;
          }
        }
        e.ref !== null && (O(e), c2("Invalid attribute `ref` supplied to `React.Fragment`."), O(null));
      }
    }
    function me(e, r2, t2, n2, i2, u) {
      {
        var o = Fe(e);
        if (!o) {
          var a = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (a += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var v = Ze(i2);
          v ? a += v : a += Ee();
          var s2;
          e === null ? s2 = "null" : q(e) ? s2 = "array" : e !== void 0 && e.$$typeof === P ? (s2 = "<" + (E(e.type) || "Unknown") + " />", a = " Did you accidentally export a JSX literal instead of a component?") : s2 = typeof e, c2("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", s2, a);
        }
        var f = Xe(e, r2, t2, i2, u);
        if (f == null)
          return f;
        if (o) {
          var p = r2.children;
          if (p !== void 0)
            if (n2)
              if (q(p)) {
                for (var C = 0; C < p.length; C++)
                  _e(p[C], e);
                Object.freeze && Object.freeze(p);
              } else
                c2("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              _e(p, e);
        }
        return e === y ? rr(f) : er(f), f;
      }
    }
    function tr(e, r2, t2) {
      return me(e, r2, t2, true);
    }
    function nr(e, r2, t2) {
      return me(e, r2, t2, false);
    }
    var ar = nr, or = tr;
    j.Fragment = y, j.jsx = ar, j.jsxs = or;
  }()), j;
}
var k = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Te;
function ur() {
  if (Te)
    return k;
  Te = 1;
  var N = React, P = Symbol.for("react.element"), V = Symbol.for("react.fragment"), y = Object.prototype.hasOwnProperty, D = N.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, F = { key: true, ref: true, __self: true, __source: true };
  function S(h2, l, R) {
    var d, g = {}, _ = null, A = null;
    R !== void 0 && (_ = "" + R), l.key !== void 0 && (_ = "" + l.key), l.ref !== void 0 && (A = l.ref);
    for (d in l)
      y.call(l, d) && !F.hasOwnProperty(d) && (g[d] = l[d]);
    if (h2 && h2.defaultProps)
      for (d in l = h2.defaultProps, l)
        g[d] === void 0 && (g[d] = l[d]);
    return { $$typeof: P, type: h2, key: _, ref: A, props: g, _owner: D.current };
  }
  return k.Fragment = V, k.jsx = S, k.jsxs = S, k;
}
process$1.env.NODE_ENV === "production" ? H.exports = ur() : H.exports = ir();
var fr = H.exports;
const s$8 = ({
  title: l,
  titleId: o,
  ...r2
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...r2,
    children: [
      l ? /* @__PURE__ */ fr.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M746.667 853.446h-448c-23.552 0-42.667-19.115-42.667-42.667s19.115-42.667 42.667-42.667h448c23.552 0 42.667 19.115 42.667 42.667s-19.115 42.667-42.667 42.667m23.082-315.208L549.376 715.945c-7.659 6.4-17.28 9.6-26.667 9.6-9.6 0-18.987-3.2-26.88-9.6L275.456 538.238c-18.347-14.72-21.099-41.6-6.4-59.947 14.72-18.347 41.6-21.333 59.968-6.4l151.019 121.813v-359.04c0-23.467 19.008-42.667 42.667-42.667 23.488 0 42.667 19.2 42.667 42.667v359.04l150.827-121.813c18.368-14.933 45.227-11.947 60.181 6.4 14.699 18.347 11.712 45.227-6.635 59.947z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), m$g = memo(s$8);
const r$5 = ({
  title: e,
  titleId: o,
  ...s2
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...s2,
    children: [
      e ? /* @__PURE__ */ fr.jsx("title", { id: o, children: e }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M776.851 695.153c16.64 16.619 16.64 43.733 0 60.373-8.32 8.32-19.179 12.587-30.08 12.587-10.88 0-21.952-4.267-30.293-12.587L522.771 561.819l-193.92 193.707c-8.32 8.32-19.179 12.587-30.08 12.587-10.88 0-21.952-4.267-30.293-12.587-16.64-16.64-16.64-43.755 0-60.373l193.941-193.707-193.941-193.92c-16.64-16.64-16.64-43.733 0-60.373s43.733-16.64 60.373 0l193.92 193.92 193.707-193.92c16.64-16.64 43.733-16.64 60.373 0s16.64 43.733 0 60.373l-193.707 193.92z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), t$7 = memo(r$5);
const styles$1K = {
  wrapper: css({
    boxSizing: "border-box",
    display: "inline-flex",
    alignItems: "center",
    borderRadius: borderRadius.default,
    fontSize: fontSize.small,
    fontFamily: fontFamily.body,
    lineHeight: 1,
    fontWeight: fontWeight.semiBold,
    maxWidth: "100%",
    "& > * + *": {
      marginLeft: spacing.small
    }
  }),
  icon: css({
    background: "none",
    border: "none",
    padding: 0,
    margin: 0,
    lineHeight: 1,
    textDecoration: "none",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }),
  link: css({
    cursor: "pointer",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    textDecoration: "none",
    color: "inherit"
  }),
  label: css({
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
  }),
  accessiblyHidden: css(accessiblyHidden)
};
const wrapperTheme$e = (theme) => {
  const themed = getThemeColors(theme);
  if (theme === "light") {
    return css({
      backgroundColor: themed.light,
      color: colors.jumbo,
      "&:hover": {
        backgroundColor: themed.medium,
        color: colors.jumbo
      }
    });
  }
  return css({
    backgroundColor: themed.light,
    color: themed.base,
    "&:hover": {
      backgroundColor: themed.base,
      color: colors.white,
      "& svg path": {
        fill: colors.white
      }
    }
  });
};
const wrapperSize$5 = (sizeWord) => {
  switch (sizeWord) {
    case "small":
      return css({
        height: size.attachmentHeightSmall,
        paddingLeft: spacing.default,
        paddingRight: spacing.small
      });
    default:
      return css({
        height: size.attachmentHeightDefault,
        paddingLeft: spacing.default,
        paddingRight: spacing.small
      });
  }
};
const labelSize = (sizeWord) => {
  switch (sizeWord) {
    case "small":
      return css({
        marginRight: spacing.small
      });
    default:
      return css({
        marginRight: spacing.default
      });
  }
};
const iconColor$6 = (theme) => {
  if (theme === "light")
    return colors.jumbo;
  const themed = getThemeColors(theme);
  return themed.base;
};
const iconSize$7 = (sizeWord) => {
  switch (sizeWord) {
    case "small":
      return 16;
    default:
      return 18;
  }
};
const Attachment = ({ name, url, theme, size: size2, onClear, className, onDownload }) => /* @__PURE__ */ React.createElement("div", { className: cx(styles$1K.wrapper, className, wrapperTheme$e(theme), wrapperSize$5(size2)) }, url && !onClear ? /* @__PURE__ */ React.createElement("a", { href: url, download: name, onClick: onDownload, rel: "noopener noreferrer", target: "_blank", className: styles$1K.link }, /* @__PURE__ */ React.createElement("span", { className: cx(styles$1K.label, labelSize(size2)) }, name), /* @__PURE__ */ React.createElement("span", { className: styles$1K.icon }, /* @__PURE__ */ React.createElement(AccessibleIcon, { icon: m$g, size: iconSize$7(size2), color: iconColor$6(theme) }), /* @__PURE__ */ React.createElement("span", { className: styles$1K.accessiblyHidden }, "Download"))) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", { className: cx(styles$1K.label, labelSize(size2)) }, name), Boolean(url) && /* @__PURE__ */ React.createElement("a", { href: url, download: name, rel: "noopener noreferrer", target: "_blank", className: styles$1K.icon }, /* @__PURE__ */ React.createElement(AccessibleIcon, { icon: m$g, size: iconSize$7(size2), color: iconColor$6(theme) }), /* @__PURE__ */ React.createElement("span", { className: styles$1K.accessiblyHidden }, "Download")), Boolean(onClear) && /* @__PURE__ */ React.createElement("button", { type: "button", onClick: onClear, className: styles$1K.icon }, /* @__PURE__ */ React.createElement(AccessibleIcon, { icon: t$7, size: iconSize$7(size2), color: iconColor$6(theme) }), /* @__PURE__ */ React.createElement("span", { className: styles$1K.accessiblyHidden }, "Clear"))));
Attachment.propTypes = {
  name: PropTypes.string.isRequired,
  url: PropTypes.string,
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "light", "dark", "tertiary", "info"]),
  size: PropTypes.oneOf(["", "default", "small"]),
  onClear: PropTypes.func,
  onDownload: PropTypes.func,
  className: PropTypes.string
};
Attachment.defaultProps = {
  theme: "primary",
  size: "default"
};
const i$9 = ({
  title: l,
  titleId: o,
  ...c2
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...c2,
    children: [
      l ? /* @__PURE__ */ fr.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M860.623 813.135c0-.405.171-.768.171-1.173v-.064h-.235c-.896-19.456-2.197-38.891-5.099-58.133-2.987-19.84-7.509-39.595-15.275-58.005-6.869-16.32-16.405-31.253-28.501-43.733-13.269-13.632-29.099-24.085-45.781-32.341-21.355-10.603-44.117-17.877-66.987-23.829-14.123-3.669-28.373-6.805-42.688-9.621a1145.441 1145.441 0 0 0-23.851-4.395c-8.448-1.472-18.155-1.643-25.899-5.781-8.064-4.309-13.973-13.333-10.987-23.04 2.603-8.427 9.835-14.507 15.851-20.181 5.013-4.736 9.792-9.771 14.336-15.04 24.107-27.947 41.259-62.187 52.224-98.069 19.733-5.248 34.987-24.896 35.989-51.925.789-21.547-7.723-38.144-20.885-47.253.021-1.835.192-3.627.192-5.461 0-143.68-83.072-214.912-180.309-214.912h-.512c-96.917 0-180.309 71.232-180.309 214.912 0 1.835.149 3.627.171 5.461-13.163 9.109-21.653 25.707-20.864 47.253 1.003 27.029 16.256 46.677 35.989 51.925 10.965 35.883 28.096 70.123 52.224 98.069a195.04 195.04 0 0 0 14.336 15.04c6.016 5.675 13.227 11.755 15.829 20.181 2.987 9.707-2.923 18.731-10.987 23.04-7.723 4.139-17.429 4.309-25.877 5.781a1140.829 1140.829 0 0 0-23.872 4.395c-14.293 2.816-28.544 5.952-42.688 9.621-22.869 5.952-45.611 13.227-66.987 23.829-16.661 8.256-32.512 18.709-45.76 32.341-12.117 12.48-21.653 27.413-28.523 43.733-7.744 18.411-12.267 38.165-15.253 58.005-2.901 19.243-4.224 38.677-5.099 58.133h-.235c0 .021-.021.043-.021.064 0 .405.171.768.192 1.173-.043 1.024-.149 2.048-.192 3.093h.661c6.891 60.949 159.595 109.739 347.52 109.739 187.904 0 340.629-48.789 347.52-109.739h.64c-.043-1.045-.128-2.069-.171-3.093z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), h$1 = memo(i$9);
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function asciiWords$1(string2) {
  return string2.match(reAsciiWord) || [];
}
var _asciiWords = asciiWords$1;
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function hasUnicodeWord$1(string2) {
  return reHasUnicodeWord.test(string2);
}
var _hasUnicodeWord = hasUnicodeWord$1;
var freeGlobal$1 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal$1;
var freeGlobal = _freeGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root$9 = freeGlobal || freeSelf || Function("return this")();
var _root = root$9;
var root$8 = _root;
var Symbol$6 = root$8.Symbol;
var _Symbol = Symbol$6;
function arrayMap$3(array, iteratee) {
  var index = -1, length = array == null ? 0 : array.length, result = Array(length);
  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}
var _arrayMap = arrayMap$3;
var isArray$f = Array.isArray;
var isArray_1 = isArray$f;
var Symbol$5 = _Symbol;
var objectProto$b = Object.prototype;
var hasOwnProperty$8 = objectProto$b.hasOwnProperty;
var nativeObjectToString$1 = objectProto$b.toString;
var symToStringTag$1 = Symbol$5 ? Symbol$5.toStringTag : void 0;
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$8.call(value, symToStringTag$1), tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = void 0;
    var unmasked = true;
  } catch (e) {
  }
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}
var _getRawTag = getRawTag$1;
var objectProto$a = Object.prototype;
var nativeObjectToString = objectProto$a.toString;
function objectToString$2(value) {
  return nativeObjectToString.call(value);
}
var _objectToString = objectToString$2;
var Symbol$4 = _Symbol, getRawTag = _getRawTag, objectToString$1 = _objectToString;
var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
var symToStringTag = Symbol$4 ? Symbol$4.toStringTag : void 0;
function baseGetTag$5(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString$1(value);
}
var _baseGetTag = baseGetTag$5;
function isObjectLike$6(value) {
  return value != null && typeof value == "object";
}
var isObjectLike_1 = isObjectLike$6;
var baseGetTag$4 = _baseGetTag, isObjectLike$5 = isObjectLike_1;
var symbolTag$1 = "[object Symbol]";
function isSymbol$6(value) {
  return typeof value == "symbol" || isObjectLike$5(value) && baseGetTag$4(value) == symbolTag$1;
}
var isSymbol_1 = isSymbol$6;
var Symbol$3 = _Symbol, arrayMap$2 = _arrayMap, isArray$e = isArray_1, isSymbol$5 = isSymbol_1;
var INFINITY$1 = 1 / 0;
var symbolProto$1 = Symbol$3 ? Symbol$3.prototype : void 0, symbolToString = symbolProto$1 ? symbolProto$1.toString : void 0;
function baseToString$1(value) {
  if (typeof value == "string") {
    return value;
  }
  if (isArray$e(value)) {
    return arrayMap$2(value, baseToString$1) + "";
  }
  if (isSymbol$5(value)) {
    return symbolToString ? symbolToString.call(value) : "";
  }
  var result = value + "";
  return result == "0" && 1 / value == -INFINITY$1 ? "-0" : result;
}
var _baseToString = baseToString$1;
var baseToString = _baseToString;
function toString$3(value) {
  return value == null ? "" : baseToString(value);
}
var toString_1 = toString$3;
var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
var rsApos = "['’]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [rsDingbat, rsRegional, rsSurrPair].join("|") + ")" + rsSeq;
var reUnicodeWord = RegExp([
  rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
  rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")",
  rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
  rsUpper + "+" + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join("|"), "g");
function unicodeWords$1(string2) {
  return string2.match(reUnicodeWord) || [];
}
var _unicodeWords = unicodeWords$1;
var asciiWords = _asciiWords, hasUnicodeWord = _hasUnicodeWord, toString$2 = toString_1, unicodeWords = _unicodeWords;
function words(string2, pattern, guard) {
  string2 = toString$2(string2);
  pattern = guard ? void 0 : pattern;
  if (pattern === void 0) {
    return hasUnicodeWord(string2) ? unicodeWords(string2) : asciiWords(string2);
  }
  return string2.match(pattern) || [];
}
var words_1 = words;
const words$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(words_1);
class LazyImage extends Component {
  constructor() {
    super(...arguments);
    // eslint-disable-next-line react/state-in-constructor
    __publicField(this, "state", {
      image: null
    });
  }
  componentDidMount() {
    this.mounted = true;
    this.loadImage();
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  async loadImage() {
    const response = await this.props.loader();
    const loadedImage = response.default || response;
    if (this.mounted)
      this.setState({ image: loadedImage });
  }
  render() {
    if (!this.state.image)
      return null;
    return /* @__PURE__ */ React.createElement("img", { className: this.props.className, src: this.state.image, alt: this.props.alt, width: this.props.width });
  }
}
LazyImage.propTypes = {
  loader: PropTypes.func.isRequired,
  alt: PropTypes.string,
  width: PropTypes.number,
  className: PropTypes.string
};
LazyImage.defaultProps = {
  alt: ""
};
const styles$1J = {
  wrapper: css({
    margin: 0,
    boxSizing: "border-box",
    borderRadius: borderRadius.small,
    overflow: "hidden",
    "& img": {
      width: "100%",
      height: "100%",
      objectFit: "cover"
    }
  }),
  rounded: css({
    borderRadius: "50%",
    overflow: "hidden"
  }),
  padded: css({
    "& img": {
      objectFit: "contain"
    }
  }),
  fallbackInitials: css({
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    fontWeight: fontWeight.semiBold,
    fontFamily: fontFamily.body
  }),
  fallbackIcon: css({
    objectFit: "contain",
    minWidth: "100%",
    minHeight: "100%",
    "& svg": {
      width: "100%",
      height: "100%"
    }
  })
};
const wrapperSize$4 = (size2, padded) => {
  switch (size2) {
    case "extraSmall":
      return css({
        width: 22,
        minWidth: 22,
        height: 22,
        minHeight: 22,
        ...padded && {
          padding: spacing.extraSmall
        }
      });
    case "small":
      return css({
        width: 30,
        minWidth: 30,
        height: 30,
        minHeight: 30,
        ...padded && {
          padding: spacing.extraSmall
        }
      });
    case "medium":
      return css({
        width: 60,
        minWidth: 60,
        height: 60,
        minHeight: 60,
        ...padded && {
          padding: spacing.default
        }
      });
    case "large":
      return css({
        width: 90,
        minWidth: 90,
        height: 90,
        minHeight: 90,
        ...padded && {
          padding: spacing.small
        }
      });
    case "extraLarge":
      return css({
        width: 125,
        minWidth: 125,
        height: 125,
        minHeight: 125,
        ...padded && {
          padding: spacing.medium
        }
      });
    case "extraExtraLarge":
      return css({
        width: 150,
        minWidth: 150,
        height: 150,
        minHeight: 150,
        ...padded && {
          padding: spacing.medium
        }
      });
    default:
      return css({
        width: 45,
        minWidth: 45,
        height: 45,
        minHeight: 45,
        ...padded && {
          padding: spacing.small
        }
      });
  }
};
const wrapperTheme$d = (theme, modifier) => {
  const themed = getThemeColors(theme);
  return css({
    backgroundColor: modifier === "dark" ? themed.base : themed.light
  });
};
const wrapperColor = (color) => css({
  backgroundColor: color
});
const imageRender = (loaded) => css({
  ...loaded ? {
    visibility: "visible"
  } : {
    visibility: "hidden"
  }
});
const initialsTheme = (theme) => {
  const themed = getThemeColors(theme);
  return css({
    color: colors.white,
    backgroundColor: themed.base
  });
};
const initialsSize = (size2) => {
  switch (size2) {
    case "extraSmall":
      return css({
        fontSize: fontSize.extraSmall
      });
    case "small":
      return css({
        fontSize: fontSize.small
      });
    case "medium":
      return css({
        fontSize: fontSize.medium
      });
    case "large":
    case "extraLarge":
    case "extraExtraLarge":
      return css({
        fontSize: fontSize.large
      });
    default:
      return css({
        fontSize: fontSize.default
      });
  }
};
const iconTheme$8 = (theme, modifier) => {
  const themed = getThemeColors(theme);
  return modifier === "dark" ? colors.white : themed.base;
};
const iconSize$6 = (size2) => {
  switch (size2) {
    case "extraSmall":
      return css({
        padding: spacing.extraSmall
      });
    case "small":
      return css({
        padding: spacing.extraSmall
      });
    case "medium":
      return css({
        padding: spacing.default
      });
    case "large":
      return css({
        padding: spacing.medium
      });
    case "extraLarge":
      return css({
        padding: spacing.large
      });
    case "extraExtraLarge":
      return css({
        padding: spacing.large
      });
    default:
      return css({
        padding: spacing.small
      });
  }
};
const getNameInitials = (name) => {
  if (!name)
    return "";
  const names = words$1(name.toUpperCase());
  if (names.length === 0)
    return "";
  const firstname = names[0][0];
  if (names.length === 1)
    return firstname;
  const surname = names[names.length - 1][0];
  return `${firstname}${surname}`;
};
class Avatar extends Component {
  constructor() {
    super(...arguments);
    // eslint-disable-next-line react/state-in-constructor
    __publicField(this, "state", {
      loaded: false,
      errored: false
    });
  }
  render() {
    const { loaded, errored } = this.state;
    const { name, loader, url, padded, size: size2, theme, themeModifier, backgroundColor, ...props } = this.props;
    let content;
    if (loader) {
      content = /* @__PURE__ */ React.createElement(LazyImage, { loader, alt: name });
    } else if (url && !errored) {
      content = /* @__PURE__ */ React.createElement(
        "img",
        {
          src: url,
          alt: name,
          className: imageRender(loaded),
          onLoad: () => this.setState({ loaded: true, errored: false }),
          onError: () => this.setState({ loaded: true, errored: true })
        }
      );
    } else if (props.fallback === "initials" && name) {
      content = /* @__PURE__ */ React.createElement("span", { className: cx(styles$1J.fallbackInitials, initialsTheme(theme), initialsSize(size2)) }, getNameInitials(name));
    } else {
      content = /* @__PURE__ */ React.createElement(
        AccessibleIcon,
        {
          icon: h$1,
          color: iconTheme$8(theme, themeModifier),
          className: cx(styles$1J.fallbackIcon, !padded && iconSize$6(size2))
        }
      );
    }
    return /* @__PURE__ */ React.createElement(
      "figure",
      {
        className: cx(
          styles$1J.wrapper,
          wrapperSize$4(size2, padded),
          wrapperTheme$d(theme, themeModifier),
          loaded && !errored && wrapperColor(backgroundColor),
          props.round && styles$1J.rounded,
          padded && styles$1J.padded,
          props.className
        )
      },
      content
    );
  }
}
Avatar.propTypes = {
  url: PropTypes.string,
  backgroundColor: PropTypes.string,
  loader: PropTypes.func,
  name: PropTypes.string,
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "light", "dark", "tertiary", "info"]),
  themeModifier: PropTypes.oneOf(["", "light", "dark"]),
  size: PropTypes.oneOf(["", "default", "extraSmall", "small", "medium", "large", "extraLarge", "extraExtraLarge"]),
  fallback: PropTypes.oneOf(["", "icon", "initials"]),
  round: PropTypes.bool,
  padded: PropTypes.bool,
  className: PropTypes.string
};
Avatar.defaultProps = {
  theme: "primary",
  themeModifier: "light",
  size: "default",
  fallback: "icon"
};
const styles$1I = {
  badge: css({
    flexGrow: 0,
    flexShrink: 0,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%"
  })
};
const badgeTheme$1 = (theme) => {
  const themed = getThemeColors(theme);
  return css({
    backgroundColor: themed.light
  });
};
const badgeSize$1 = (size2) => {
  switch (size2) {
    case "extraSmall":
      return css({
        width: 16,
        height: 16
      });
    case "small":
      return css({
        width: 20,
        height: 20
      });
    case "medium":
      return css({
        width: 30,
        height: 30
      });
    default:
      return css({
        width: 24,
        height: 24
      });
  }
};
const iconTheme$7 = (theme) => {
  const themed = getThemeColors(theme);
  return themed.base;
};
const iconSize$5 = (size2) => {
  switch (size2) {
    case "extraSmall":
      return 10;
    case "small":
      return 14;
    case "medium":
      return 16;
    default:
      return 14;
  }
};
const Badge = ({ className, theme, size: size2, icon }) => /* @__PURE__ */ React.createElement("span", { className: cx(styles$1I.badge, className, badgeTheme$1(theme), badgeSize$1(size2)) }, /* @__PURE__ */ React.createElement(AccessibleIcon, { icon, size: iconSize$5(size2), color: iconTheme$7(theme) }));
Badge.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.shape({})]),
  size: PropTypes.oneOf(["", "default", "extraSmall", "small", "medium"]),
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "light", "dark", "tertiary", "info", "legacy"])
};
Badge.defaultProps = {
  size: "default",
  theme: "primary"
};
const styles$1H = {
  button: css({
    appearance: "none",
    borderRadius: "50%",
    border: "none",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:focus": {
      outline: "none"
    },
    "&[disabled]": {
      opacity: 0.3,
      pointerEvents: "none"
    }
  })
};
const badgeButtonSize = (size2) => {
  switch (size2) {
    case "extraSmall":
      return css({
        width: 16,
        height: 16
      });
    case "small":
      return css({
        width: 20,
        height: 20
      });
    case "medium":
      return css({
        width: 30,
        height: 30
      });
    default:
      return css({
        width: 24,
        height: 24
      });
  }
};
const iconSize$4 = (size2) => {
  switch (size2) {
    case "extraSmall":
      return 10;
    case "small":
      return 12;
    case "medium":
      return 16;
    default:
      return 14;
  }
};
const buttonTheme$1 = (theme) => {
  const themed = getThemeColors(theme);
  return css({
    backgroundColor: themed.light,
    "&:hover": {
      backgroundColor: themed.base,
      "& svg": {
        color: colors.white
      }
    },
    "&:focus": {
      boxShadow: `0 0 2px 2px ${hexToRgba(themed.base, 0.3)}`,
      backgroundColor: themed.base,
      "& svg": {
        color: colors.white
      }
    }
  });
};
const iconTheme$6 = (theme) => {
  const themed = getThemeColors(theme);
  return themed.base;
};
const BadgeButton = ({ theme, size: size2, onClick, icon, className, disabled, ariaLabel, innerRef }) => /* @__PURE__ */ React.createElement(
  "button",
  {
    className: cx(styles$1H.button, className, badgeButtonSize(size2), buttonTheme$1(theme)),
    type: "button",
    onClick,
    ref: innerRef,
    disabled,
    "aria-label": ariaLabel
  },
  /* @__PURE__ */ React.createElement(AccessibleIcon, { icon, size: iconSize$4(size2), color: iconTheme$6(theme) })
);
BadgeButton.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.shape({})]),
  size: PropTypes.oneOf(["", "default", "extraSmall", "small", "medium"]),
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "light", "dark", "tertiary", "info", "legacy"]),
  onClick: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  ariaLabel: PropTypes.string,
  innerRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({
      current: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.elementType])
    })
  ])
};
BadgeButton.defaultProps = {
  size: "default",
  theme: "primary"
};
const sideBarWidth = (size2) => {
  switch (size2) {
    case "small":
      return {
        minWidth: 200,
        maxWidth: 250
      };
    case "large":
      return {
        minWidth: 300,
        maxWidth: 350
      };
    case "extraLarge":
      return {
        minWidth: 350,
        maxWidth: 400
      };
    default:
      return {
        minWidth: 250,
        maxWidth: 300
      };
  }
};
const body = (size2) => {
  const { minWidth, maxWidth } = sideBarWidth(size2);
  return css({
    display: "grid",
    gridGap: spacing.medium,
    margin: spacing.medium,
    gridTemplateColumns: `1fr minmax(${minWidth}px, ${maxWidth}px)`,
    gridTemplateAreas: "'body sidebar'"
  });
};
const BodyWithSidebar = ({ children, size: size2 }) => /* @__PURE__ */ React.createElement("div", { className: body(size2) }, children);
BodyWithSidebar.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  size: PropTypes.string
};
const shorthandHelper = (values, unit = "px") => {
  if (!values.length) {
    return "0px";
  }
  const isNumber2 = (value) => Number(value) === 0 || Number(value);
  return values.map((value) => `${value}${isNumber2(value) ? unit : ""}`).join(" ");
};
const mediaQueryHelper = (breakpoint2, direction = "min-width") => {
  let adjustedBreakpoint = breakpoint2;
  if (direction === "max-width")
    adjustedBreakpoint -= 1;
  return `@media screen and (${direction}: ${adjustedBreakpoint}px)`;
};
const matchesMediaQuery = (breakpoint2) => window.matchMedia(`(min-width: ${breakpoint2}px)`).matches;
const styles$1G = {
  button: css({
    boxSizing: "border-box",
    cursor: "pointer",
    borderRadius: borderRadius.default,
    border: "1px solid transparent",
    color: colors.white,
    fontFamily: fontFamily.body,
    fontWeight: fontWeight.regular,
    fontSize: fontSize.default,
    lineHeight: 1.4,
    whiteSpace: "nowrap",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    "&:active": {
      boxShadow: `inset 0 1px 3px ${hexToRgba(colors.black, 0.1)}`
    },
    "&:focus": {
      outline: "none"
    },
    "&[disabled]": {
      opacity: 0.3,
      pointerEvents: "none"
    }
  })
};
const buttonVariant = (variant, theme) => {
  const themed = getThemeColors(theme);
  if (theme === "light") {
    switch (variant) {
      case "outlined":
        return css({
          color: colors.jumbo,
          borderColor: themed.light,
          backgroundColor: "transparent",
          "&:hover": {
            backgroundColor: hexToRgba(themed.light, 0.3),
            boxShadow: `0 2px 4px ${hexToRgba(colors.black, 0.1)}`
          },
          "&:focus": {
            boxShadow: `0 0 4px 2px ${hexToRgba(themed.medium, 0.5)}`
          },
          "&:active": {
            backgroundColor: hexToRgba(themed.light, 0.6)
          }
        });
      case "dashed":
        return css({
          color: colors.jumbo,
          borderColor: themed.light,
          borderStyle: "dashed",
          backgroundColor: "transparent",
          "&:hover": {
            backgroundColor: hexToRgba(themed.light, 0.3),
            boxShadow: `0 2px 4px ${hexToRgba(colors.black, 0.1)}`
          },
          "&:focus": {
            boxShadow: `0 0 4px 2px ${hexToRgba(themed.medium, 0.5)}`
          },
          "&:active": {
            backgroundColor: hexToRgba(themed.light, 0.6)
          }
        });
      default:
        return css({
          color: colors.jumbo,
          backgroundColor: themed.light,
          "&:hover": {
            backgroundColor: hexToRgba(themed.medium, 0.8),
            boxShadow: `0 2px 4px ${hexToRgba(colors.black, 0.15)}`
          },
          "&:focus": {
            boxShadow: `0 0 4px 2px ${hexToRgba(themed.base, 0.5)}`
          },
          "&:active": {
            backgroundColor: themed.medium
          }
        });
    }
  }
  switch (variant) {
    case "outlined":
      return css({
        color: themed.base,
        borderColor: themed.base,
        backgroundColor: "transparent",
        "&:hover": {
          backgroundColor: hexToRgba(themed.light, 0.8),
          boxShadow: `0 2px 4px ${hexToRgba(colors.black, 0.1)}`
        },
        "&:focus": {
          boxShadow: `0 0 4px 2px ${hexToRgba(themed.medium, 0.2)}`
        },
        "&:active": {
          backgroundColor: hexToRgba(themed.base, 0.25)
        }
      });
    case "dashed":
      return css({
        color: themed.base,
        borderColor: themed.base,
        borderStyle: "dashed",
        backgroundColor: "transparent",
        "&:hover": {
          backgroundColor: hexToRgba(themed.light, 0.8),
          boxShadow: `0 2px 4px ${hexToRgba(colors.black, 0.1)}`
        },
        "&:focus": {
          boxShadow: `0 0 4px 2px ${hexToRgba(themed.medium, 0.2)}`
        },
        "&:active": {
          backgroundColor: hexToRgba(themed.base, 0.25)
        }
      });
    default:
      return css({
        backgroundColor: themed.base,
        "&:hover": {
          backgroundColor: themed.medium,
          boxShadow: `0 2px 4px ${hexToRgba(colors.black, 0.1)}`
        },
        "&:focus": {
          boxShadow: `0 0 4px 2px ${hexToRgba(themed.medium, 0.5)}`
        },
        "&:active": {
          backgroundColor: themed.dark
        }
      });
  }
};
const buttonSize = (size2) => {
  switch (size2) {
    case "small":
      return css({
        height: 30,
        fontSize: fontSize.small,
        padding: shorthandHelper([spacing.small, spacing.default])
      });
    case "medium":
      return css({
        height: 40,
        lineHeight: 1,
        padding: shorthandHelper([spacing.small, spacing.medium])
      });
    default:
      return css({
        height: 35,
        padding: shorthandHelper([spacing.small, spacing.default])
      });
  }
};
const Button = ({ className = null, size: size2 = "", theme = "", variant = "default", label, ...props }) => /* @__PURE__ */ React.createElement("button", { className: cx(styles$1G.button, className, buttonSize(size2), buttonVariant(variant, theme)), ...props }, label);
Button.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  type: PropTypes.string,
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "light", "dark", "tertiary", "info"]),
  size: PropTypes.oneOf(["", "default", "small", "medium"]),
  variant: PropTypes.oneOf(["", "default", "outlined", "dashed"]),
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string
};
Button.defaultProps = {
  type: "button",
  theme: "primary",
  size: "default"
};
const styles$1F = {
  button: css({
    // Override default button styling
    border: "none",
    background: "none",
    outline: "none",
    padding: 0,
    fontFamily: fontFamily.body,
    fontSize: "inherit",
    fontWeight: "inherit",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline"
    },
    "&:focus": {
      textDecoration: "underline"
    },
    "&:active": {
      textDecoration: "underline"
    }
  }),
  disabled: css({
    textDecoration: "none",
    pointerEvents: "none",
    cursor: "default",
    opacity: 0.3
  })
};
const ButtonLink = ({ className, theme, label, ...props }) => /* @__PURE__ */ React.createElement(
  "button",
  {
    type: "button",
    className: cx(styles$1F.button, linkTheme$3(theme), props.disabled && styles$1F.disabled, className),
    ...props
  },
  label
);
ButtonLink.propTypes = {
  label: PropTypes.string.isRequired,
  type: PropTypes.string,
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "light", "dark", "tertiary", "info"]),
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string
};
ButtonLink.defaultProps = {
  type: "button",
  theme: "primary"
};
const beat = keyframes({
  "30%": { opacity: 0.3 },
  "60%": { opacity: 0.5 },
  "100%": { opacity: 1 }
});
const styles$1E = {
  wrapper: css({
    display: "inline-flex",
    "& > * + *": {
      marginLeft: spacing.extraSmall
    }
  }),
  spinner: css({
    display: "inline-flex",
    width: spacing.small,
    height: spacing.small,
    borderRadius: "50%",
    animation: `${beat} 0.75s infinite`,
    "&:nth-child(2)": {
      animationDelay: "0.25s"
    },
    "&:nth-child(3)": {
      animationDelay: "0.5s"
    }
  })
};
const spinnerTheme = (theme, style) => {
  if (style === "white") {
    return css({
      backgroundColor: colors.white
    });
  }
  const themed = getThemeColors(theme);
  return css({
    backgroundColor: themed.base
  });
};
const Spinner = ({ theme, variant = "colored", className }) => /* @__PURE__ */ React.createElement("div", { className: cx(styles$1E.wrapper, className) }, /* @__PURE__ */ React.createElement("span", { className: cx(styles$1E.spinner, spinnerTheme(theme, variant)) }), /* @__PURE__ */ React.createElement("span", { className: cx(styles$1E.spinner, spinnerTheme(theme, variant)) }), /* @__PURE__ */ React.createElement("span", { className: cx(styles$1E.spinner, spinnerTheme(theme, variant)) }));
Spinner.propTypes = {
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "light", "dark", "tertiary", "info"]),
  variant: PropTypes.oneOf(["", "colored", "white"]),
  className: PropTypes.string
};
Spinner.defaultProps = {
  theme: "primary"
};
const styles$1D = {
  button: css({
    boxSizing: "border-box",
    cursor: "default",
    borderRadius: borderRadius.default,
    border: "1px solid transparent",
    color: colors.white,
    fontFamily: fontFamily.body,
    fontWeight: fontWeight.regular,
    fontSize: fontSize.default,
    lineHeight: 1.4,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    "&:focus": {
      outline: "none"
    }
  }),
  spinner: css({
    marginRight: spacing.small
  })
};
const buttonLoaderVariant = (variant, theme) => {
  const themed = getThemeColors(theme);
  if (theme === "light") {
    switch (variant) {
      case "outlined":
        return css({
          backgroundColor: "transparent",
          color: colors.jumbo,
          borderColor: themed.light
        });
      case "dashed":
        return css({
          backgroundColor: "transparent",
          color: colors.jumbo,
          borderColor: themed.light,
          borderStyle: "dashed"
        });
      default:
        return css({
          color: colors.jumbo,
          backgroundColor: themed.light
        });
    }
  }
  switch (variant) {
    case "outlined":
      return css({
        backgroundColor: "transparent",
        color: themed.base,
        borderColor: themed.base
      });
    case "dashed":
      return css({
        backgroundColor: "transparent",
        color: themed.base,
        borderColor: themed.base,
        borderStyle: "dashed"
      });
    default:
      return css({
        backgroundColor: themed.base
      });
  }
};
const buttonLoaderSize = (size2) => {
  switch (size2) {
    case "small":
      return css({
        height: 30,
        fontSize: fontSize.small,
        padding: shorthandHelper([spacing.small, spacing.default])
      });
    case "medium":
      return css({
        height: 40,
        lineHeight: 1,
        padding: shorthandHelper([spacing.small, spacing.medium])
      });
    default:
      return css({
        height: 35,
        padding: shorthandHelper([spacing.small, spacing.default])
      });
  }
};
const spinnerVariant$1 = (variant) => {
  switch (variant) {
    case "outlined":
    case "dashed":
      return "colored";
    default:
      return "white";
  }
};
const ButtonLoader = ({ theme, size: size2, variant = "default", className, label }) => /* @__PURE__ */ React.createElement(
  "button",
  {
    className: cx(styles$1D.button, className, buttonLoaderSize(size2), buttonLoaderVariant(variant, theme)),
    type: "button",
    role: "status",
    tabIndex: "-1"
  },
  /* @__PURE__ */ React.createElement(Spinner, { theme, variant: spinnerVariant$1(variant), className: styles$1D.spinner }),
  label
);
ButtonLoader.propTypes = {
  label: PropTypes.string,
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "light", "dark", "tertiary", "info"]),
  size: PropTypes.oneOf(["", "default", "small", "medium"]),
  variant: PropTypes.oneOf(["", "default", "outlined", "dashed"]),
  className: PropTypes.string
};
ButtonLoader.defaultProps = {
  label: "Loading",
  theme: "primary",
  size: "default"
};
const styles$1C = {
  card: css({
    width: "100%",
    display: "flex",
    boxSizing: "border-box",
    borderBottom: `1px solid ${colors.mystic}`,
    borderTop: `1px solid ${colors.mystic}`,
    [mediaQueryHelper(breakpoint.tablet)]: {
      borderRadius: borderRadius.default,
      boxShadow: `1px 1px 5px ${hexToRgba(colors.black, 0.1)}`,
      border: 0
    }
  })
};
const cardTheme$1 = (theme) => {
  switch (theme) {
    case "light":
      return css({
        backgroundColor: colors.athensGray
      });
    default:
      return css({
        backgroundColor: colors.white
      });
  }
};
const Card = ({ id, theme = "default", className, onClick, children, innerRef, dataCy, ariaLabelledBy }) => /* @__PURE__ */ React.createElement(
  "div",
  {
    id,
    className: cx(styles$1C.card, cardTheme$1(theme), className),
    ref: innerRef,
    onClick,
    "data-cy": dataCy,
    "aria-labelledby": ariaLabelledBy
  },
  children
);
Card.propTypes = {
  id: PropTypes.string,
  theme: PropTypes.oneOf(["", "default", "light"]),
  className: PropTypes.string,
  onClick: PropTypes.func,
  innerRef: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  dataCy: PropTypes.string,
  ariaLabelledBy: PropTypes.string
};
const styles$1B = {
  list: css({
    margin: 0,
    "& > * + *": {
      margin: 0,
      marginTop: spacing.default
    },
    "& > dd + dt": {
      marginTop: spacing.large
    }
  })
};
const CardList = ({ className, children }) => /* @__PURE__ */ React.createElement("dl", { className: cx(styles$1B.list, className) }, children);
CardList.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
const styles$1A = {
  heading: css({
    borderRadius: borderRadius.default,
    backgroundColor: colors.athensGray,
    boxShadow: `1px 1px 5px ${hexToRgba(colors.black, 0.1)}`,
    fontSize: fontSize.small,
    fontWeight: fontWeight.semiBold,
    fontFamily: fontFamily.body,
    color: colors.jumbo,
    padding: shorthandHelper([spacing.small, spacing.default])
  })
};
const CardListHeading = ({ label }) => /* @__PURE__ */ React.createElement("dt", { className: styles$1A.heading }, label);
CardListHeading.propTypes = {
  label: PropTypes.string.isRequired
};
const CardListItem = ({ className, onClick, children }) => /* @__PURE__ */ React.createElement("dd", { onClick }, /* @__PURE__ */ React.createElement(Card, { className }, children));
CardListItem.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
const n$j = ({
  title: l,
  titleId: o,
  ...i2
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...i2,
    children: [
      l ? /* @__PURE__ */ fr.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M358.859 829.399a42.614 42.614 0 0 1-30.677-13.035L136.907 618.22c-16.384-16.939-15.893-43.968 1.067-60.331 16.917-16.341 43.968-15.915 60.309 1.067l160.469 166.229 432.277-450.581c16.299-17.003 43.328-17.557 60.331-1.237 17.003 16.299 17.557 43.328 1.259 60.331L389.643 816.279a42.707 42.707 0 0 1-30.72 13.12z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), t$6 = memo(n$j);
const styles$1z = {
  wrapper: css({
    display: "inline-flex",
    fontFamily: fontFamily.body,
    fontSize: fontSize.small,
    fontWeight: fontWeight.bold,
    lineHeight: 1.2,
    marginTop: spacing.extraSmall,
    color: colors.mandy
  })
};
const FormErrorMessage = ({ className, text }) => /* @__PURE__ */ React.createElement("small", { className: cx(styles$1z.wrapper, className) }, text);
FormErrorMessage.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string
};
const styles$1y = {
  wrapper: css({
    display: "flex",
    alignItems: "center",
    "& > * + *": {
      marginLeft: spacing.default
    }
  }),
  label: css({
    fontFamily: fontFamily.body,
    fontSize: fontSize.default,
    color: colors.blackPearl,
    userSelect: "none",
    cursor: "pointer",
    flex: 1
  }),
  labelDisabled: css({
    color: colors.grayChateau
  }),
  checkbox: css({
    position: "relative",
    boxSizing: "border-box",
    width: 20,
    height: 20,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }),
  input: css({
    cursor: "pointer",
    appearance: "none",
    margin: 0,
    width: "100%",
    height: "100%",
    border: `1px solid ${colors.geyser}`,
    borderRadius: borderRadius.default,
    "&:focus": {
      outline: "none"
    }
  }),
  icon: css({
    pointerEvents: "none",
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  })
};
const focusStyles = (color) => ({
  borderColor: color,
  boxShadow: `0 0 0 2px ${hexToRgba(color, 0.25)}`
});
const inputTheme$2 = (theme) => {
  const themed = getThemeColors(theme);
  return css({
    borderColor: theme === "error" ? themed.base : colors.geyser,
    "&:checked": {
      borderColor: themed.base,
      backgroundColor: themed.light
    },
    "&[disabled]": {
      backgroundColor: colors.porcelain,
      borderColor: colors.geyser,
      "& + * svg path": {
        fill: colors.grayChateau
      }
    },
    "&[disabled]:checked:hover": {
      backgroundColor: colors.porcelain,
      "& + * svg path": {
        fill: colors.grayChateau
      }
    },
    "&:checked:hover": {
      backgroundColor: themed.base,
      "& + * svg path": {
        fill: colors.white
      }
    },
    "&:active": {
      backgroundColor: themed.base,
      "& + * svg path": {
        fill: colors.white
      }
    },
    "&:hover:not([disabled])": {
      borderColor: themed.base
    },
    "&:focus": focusStyles(themed.base)
  });
};
const iconTheme$5 = (theme) => {
  const themed = getThemeColors(theme);
  return themed.base;
};
const Checkbox = ({ id, label, checked, meta, input, className, onChange, ...props }) => {
  const checkedBox = input.value || checked;
  const handler = input.onChange || onChange;
  const errored = meta.touched && meta.error;
  const theme = errored ? "error" : props.theme;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: cx(styles$1y.wrapper, className) }, /* @__PURE__ */ React.createElement("span", { className: cx(styles$1y.checkbox, props.disabled && styles$1y.disabledCheckbox) }, /* @__PURE__ */ React.createElement(
    "input",
    {
      id,
      type: "checkbox",
      className: cx(styles$1y.input, inputTheme$2(theme)),
      ...input,
      onChange: handler,
      value: void 0,
      checked: checkedBox,
      ...props
    }
  ), Boolean(checkedBox) && /* @__PURE__ */ React.createElement("div", { className: styles$1y.icon }, /* @__PURE__ */ React.createElement(AccessibleIcon, { icon: t$6, size: 18, color: iconTheme$5(theme) }))), Boolean(label) && /* @__PURE__ */ React.createElement("label", { htmlFor: id, className: cx(styles$1y.label, props.disabled && styles$1y.labelDisabled) }, label)), Boolean(errored) && /* @__PURE__ */ React.createElement(FormErrorMessage, { text: meta.error }));
};
Checkbox.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  label: PropTypes.string,
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "dark", "tertiary", "info"]),
  className: PropTypes.string,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string
  }),
  input: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    onChange: PropTypes.func
  }),
  disabled: PropTypes.bool
};
Checkbox.defaultProps = {
  meta: {},
  input: {},
  theme: "primary",
  checked: false
};
const styles$1x = {
  chip: css({
    display: "inline-flex",
    alignItems: "center",
    fontFamily: fontFamily.body,
    fontWeight: fontWeight.bold,
    lineHeight: 1.2,
    whiteSpace: "nowrap",
    borderRadius: borderRadius.extraLarge,
    padding: shorthandHelper([0, spacing.default])
  })
};
const chipTheme$1 = (theme, mode) => {
  const themed = getThemeColors(theme);
  switch (mode) {
    case "dark":
      return css({
        backgroundColor: themed.base,
        color: colors.white
      });
    default:
      return css({
        backgroundColor: themed.light,
        color: theme === "light" ? colors.jumbo : themed.base
      });
  }
};
const chipSize$1 = (size2) => {
  switch (size2) {
    case "small":
      return css({
        height: 20,
        maxHeight: 20,
        fontSize: fontSize.extraSmall
      });
    default:
      return css({
        height: 26,
        maxHeight: 26,
        fontSize: fontSize.small
      });
  }
};
const Chip = ({ theme, style, mode = style, size: size2, className, label, children, ...props }) => (
  // todo remove style once consumers have been updated
  /* @__PURE__ */ React.createElement("div", { className: cx(styles$1x.chip, chipTheme$1(theme, mode), chipSize$1(size2), className), onMouseEnter: props.onMouseEnter }, label ? /* @__PURE__ */ React.createElement("span", null, label) : children)
);
Chip.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.node,
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "light", "dark", "tertiary", "info"]),
  size: PropTypes.oneOf(["", "default", "small"]),
  style: PropTypes.oneOf(["", "light", "dark"]),
  mode: PropTypes.oneOf(["", "light", "dark"]),
  className: PropTypes.string,
  onMouseEnter: PropTypes.func
};
Chip.defaultProps = {
  theme: "primary",
  size: "small",
  style: "light",
  mode: "light"
};
const n$i = ({
  title: l,
  titleId: o,
  ...r2
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...r2,
    children: [
      l ? /* @__PURE__ */ fr.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M736.442 579.484 541.071 385.479c-16.64-16.533-43.499-16.533-60.139 0L285.54 579.484c-27.008 26.837-8.021 72.939 30.059 72.939h390.784c38.08 0 57.088-46.101 30.059-72.939",
          clipRule: "evenodd"
        }
      )
    ]
  }
), m$f = memo(n$i);
const n$h = ({
  title: o,
  titleId: l,
  ...r2
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": l,
    ...r2,
    children: [
      o ? /* @__PURE__ */ fr.jsx("title", { id: l, children: o }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M738.212 446.025 542.82 640.03c-16.64 16.512-43.477 16.512-60.139 0L287.289 446.025c-27.008-26.837-8.021-72.939 30.059-72.939h390.805c38.08 0 57.088 46.101 30.059 72.939",
          clipRule: "evenodd"
        }
      )
    ]
  }
), m$e = memo(n$h);
const subheadingStyles = {
  fontFamily: fontFamily.heading,
  fontSize: fontSize.default,
  fontWeight: "inherit",
  lineHeight: 1.2,
  color: colors.oxfordBlue,
  margin: 0
};
const styles$1w = {
  wrapper: css(subheadingStyles)
};
const Subheading = ({ className, children }) => /* @__PURE__ */ React.createElement("h2", { className: cx(styles$1w.wrapper, className) }, children);
Subheading.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};
const styles$1v = {
  wrapper: css({
    flexDirection: "column"
  }),
  toggle: css({
    boxSizing: "border-box",
    cursor: "pointer",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    fontWeight: fontWeight.semiBold,
    backgroundColor: colors.porcelain,
    padding: shorthandHelper([spacing.default, spacing.medium]),
    userSelect: "none",
    borderTopLeftRadius: borderRadius.default,
    borderTopRightRadius: borderRadius.default,
    border: "none",
    [`&:focus .${styles$1w.wrapper}`]: {
      outline: "none",
      textDecoration: "underline"
    }
  }),
  icon: css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }),
  body: css({
    padding: spacing.medium
  })
};
class Collapsible extends Component {
  constructor() {
    super(...arguments);
    // eslint-disable-next-line react/state-in-constructor
    __publicField(this, "state", {
      openState: this.props.open
    });
    __publicField(this, "toggleCollapsible", () => {
      const newOpenState = !this.state.openState;
      this.setState({ openState: newOpenState });
      if (this.props.onToggle) {
        this.props.onToggle(newOpenState);
      }
    });
  }
  componentDidUpdate(prevProps) {
    if (prevProps.open !== this.props.open) {
      this.setState({ openState: this.props.open });
    }
  }
  render() {
    const { openState } = this.state;
    const { children, ...props } = this.props;
    return /* @__PURE__ */ React.createElement(Card, { theme: "light", className: cx(styles$1v.wrapper, props.className) }, /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        className: styles$1v.toggle,
        tabIndex: "0",
        onClick: this.toggleCollapsible,
        onKeyDown: (ev) => {
          if (ev.key === 13 && !specialKeyPressed(ev)) {
            this.toggleCollapsible();
          }
        }
      },
      typeof props.toggle === "string" ? /* @__PURE__ */ React.createElement(Subheading, null, props.toggle) : props.toggle,
      /* @__PURE__ */ React.createElement("div", { className: styles$1v.icon }, /* @__PURE__ */ React.createElement(AccessibleIcon, { icon: openState ? m$f : m$e, size: 16, color: colors.grayChateau }))
    ), Boolean(openState) && /* @__PURE__ */ React.createElement("div", { className: styles$1v.body }, children));
  }
}
Collapsible.propTypes = {
  toggle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  open: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  onToggle: PropTypes.func
};
Collapsible.defaultProps = {
  open: true
};
const styles$1u = {
  wrapper: css({
    boxSizing: "border-box",
    margin: "auto",
    padding: shorthandHelper([0, spacing.default]),
    width: "100%",
    [mediaQueryHelper(breakpoint.tablet)]: {
      padding: shorthandHelper([0, spacing.medium])
    },
    [mediaQueryHelper(breakpoint.desktop)]: {
      width: breakpoint.desktop
    }
  })
};
const Container = ({ className, children }) => /* @__PURE__ */ React.createElement("div", { className: cx(styles$1u.wrapper, className) }, children);
Container.propTypes = {
  className: propTypesExports.string,
  children: propTypesExports.oneOfType([propTypesExports.node, propTypesExports.arrayOf(propTypesExports.node)])
};
const styles$1t = {
  wrapper: css({
    borderRadius: borderRadius.default,
    fontSize: fontSize.default,
    fontWeight: fontWeight.regular,
    fontFamily: fontFamily.body,
    lineHeight: 1.4,
    color: colors.jumbo,
    boxSizing: "border-box"
  })
};
const wrapperTheme$c = (theme) => {
  switch (theme) {
    case "dark":
      return css({
        backgroundColor: colors.porcelain
      });
    default:
      return css({
        backgroundColor: colors.athensGray
      });
  }
};
const wrapperSize$3 = (size2) => {
  switch (size2) {
    case "small":
      return css({
        padding: spacing.small
      });
    case "medium":
      return css({
        padding: spacing.medium
      });
    default:
      return css({
        padding: spacing.default
      });
  }
};
const ContentBox = ({ theme, size: size2, className, children }) => /* @__PURE__ */ React.createElement("div", { className: cx(styles$1t.wrapper, wrapperTheme$c(theme), wrapperSize$3(size2), className) }, children);
ContentBox.propTypes = {
  theme: PropTypes.oneOf(["", "light", "dark"]),
  size: PropTypes.oneOf(["", "default", "small", "medium"]),
  children: PropTypes.oneOfType([PropTypes.arrayOf([PropTypes.node]), PropTypes.node]),
  className: PropTypes.string
};
ContentBox.defaultProps = {
  theme: "light",
  size: "default"
};
const styles$1s = {
  counter: css({
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: fontFamily.body,
    fontWeight: fontWeight.semiBold,
    lineHeight: 1.2,
    borderRadius: "50%"
  }),
  clickable: css({
    cursor: "pointer"
  })
};
const counterSize = (size2) => {
  switch (size2) {
    case "medium":
      return css({
        width: 24,
        height: 24,
        fontSize: fontSize.small
      });
    default:
      return css({
        width: 20,
        height: 20,
        fontSize: fontSize.extraSmall
      });
  }
};
const counterTheme = (theme, clickable, mode = "light") => {
  const themed = getThemeColors(theme);
  const accentColor = mode === "light" ? themed.base : themed.medium;
  let backgroundColor;
  let color;
  switch (mode) {
    case "dark":
      backgroundColor = themed.base;
      color = colors.white;
      break;
    default:
      backgroundColor = themed.light;
      color = theme === "light" ? colors.jumbo : themed.base;
  }
  return css({
    backgroundColor,
    color,
    ...clickable && {
      "&:hover": {
        backgroundColor: accentColor,
        color: colors.white
      },
      "&:focus": {
        outline: "none",
        boxShadow: `0 0 2px 2px ${hexToRgba(accentColor, 0.3)}`,
        backgroundColor: accentColor,
        color: colors.white
      }
    }
  });
};
const Counter = ({ value, size: size2, theme, className, onClick, clickable = false, mode = "light" }) => {
  const isClickable = !!onClick || clickable;
  return /* @__PURE__ */ React.createElement(
    "span",
    {
      className: cx(styles$1s.counter, className, counterSize(size2), counterTheme(theme, isClickable, mode), isClickable && styles$1s.clickable),
      onClick,
      tabIndex: onClick ? "0" : "-1"
    },
    value
  );
};
Counter.propTypes = {
  value: PropTypes.number.isRequired,
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "light", "dark", "tertiary", "info"]),
  size: PropTypes.oneOf(["", "default", "medium"]),
  onClick: PropTypes.func,
  className: PropTypes.string,
  clickable: PropTypes.bool,
  mode: PropTypes.oneOf(["", "light", "dark"])
};
Counter.defaultProps = {
  theme: "primary",
  size: "default",
  mode: "light"
};
const n$g = ({
  title: l,
  titleId: o,
  ...r2
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...r2,
    children: [
      l ? /* @__PURE__ */ fr.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M145.207 858.693V165.306c0-54.015 42.709-96.722 96.722-96.722H547.17c111.797 0 198.47 31.404 256.253 89.187 48.99 48.99 75.368 118.078 75.368 200.981v2.513c0 138.175-69.087 223.592-175.86 267.558l134.407 163.298c18.843 23.867 31.404 43.964 31.404 74.112 0 54.015-45.221 89.187-91.698 89.187-43.964 0-72.855-21.354-95.466-50.245l-188.42-238.667H338.654v192.189c0 54.015-42.709 96.722-96.722 96.722s-96.722-42.709-96.722-96.722zm193.446-363.024H534.61c94.211 0 148.223-50.245 148.223-124.358v-2.513c0-82.906-57.782-125.613-151.993-125.613H338.651v252.483z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), m$d = memo(n$g);
const s$7 = ({
  title: o,
  titleId: l,
  ...c2
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": l,
    ...c2,
    children: [
      o ? /* @__PURE__ */ fr.jsx("title", { id: l, children: o }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M625.316 961.215c-193.709 0-340.96-114.236-384.704-294.358H206.87c-34.33 0-62.264-27.935-62.264-62.264s27.935-62.264 62.264-62.264h21.518c0-18.182.162-38.333.455-56.699H206.87c-34.33 0-62.264-27.935-62.264-62.264s27.935-62.264 62.264-62.264h37.643c49.331-180.13 197.775-298.329 380.803-298.329 80.498 0 158.076 27.013 224.34 78.103 13.146 10.127 21.587 24.801 23.729 41.312 2.127 16.489-2.281 32.82-12.426 45.996-11.89 15.416-29.859 24.254-49.32 24.254-13.705 0-27.215-4.612-38.058-12.985-44.251-34.117-95.536-52.159-148.264-52.159-115.088 0-208.123 66.478-249.901 173.833h354.308c34.33 0 62.264 27.935 62.264 62.264s-27.935 62.243-62.264 62.243H353.311c-.265 17.738-.404 38.425-.415 56.699h350.356c34.33 0 62.264 27.935 62.264 62.264s-27.935 62.264-62.264 62.264H370.208c37.481 107.426 129.41 169.84 255.11 169.84 54.591 0 107.426-19.276 152.782-55.766 10.998-8.867 24.864-13.752 39.013-13.752 18.965 0 36.651 8.474 48.53 23.24 10.421 12.974 15.174 29.209 13.378 45.731-1.792 16.551-9.921 31.398-22.895 41.819-67.697 54.437-147.511 83.235-230.808 83.235z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), m$c = memo(s$7);
const c$3 = ({
  title: o,
  titleId: l,
  ...s2
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": l,
    ...s2,
    children: [
      o ? /* @__PURE__ */ fr.jsx("title", { id: l, children: o }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M748.22 797.09H438.695V634.183h81.457c48.871 0 81.457-32.581 81.457-81.457s-32.58-81.457-81.457-81.457h-81.457V308.361c0-48.87 32.58-81.456 81.457-81.456s81.457 32.58 81.457 81.456c0 48.871 32.58 81.457 81.457 81.457s81.457-32.58 81.457-81.457c0-138.472-105.892-244.364-244.365-244.364S275.793 169.889 275.793 308.361v162.908c-48.871 0-81.457 32.581-81.457 81.457s32.58 81.457 81.457 81.457V797.09c-48.871 0-81.457 32.581-81.457 81.457s32.58 81.457 81.457 81.457h472.439c48.871 0 81.457-32.581 81.457-81.457s-40.725-81.457-81.457-81.457z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), m$b = memo(c$3);
const i$8 = ({
  title: l,
  titleId: o,
  ...c2
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...c2,
    children: [
      l ? /* @__PURE__ */ fr.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M476.55 108.49v21.727c-130.325 10.347-218.946 86.909-218.946 197.617 0 116.915 70.897 173.82 223.117 213.137v203.823c-57.342-10.345-105.303-34.142-154.304-69.321-9.385-7.243-21.897-11.381-34.406-11.381-32.322 0-57.344 24.832-57.344 56.907 0 21.726 10.426 38.281 28.149 49.662 63.601 44.491 135.539 72.425 213.734 80.702v64.149c0 24.83 20.853 44.489 45.875 44.489 25.024 0 44.832-19.659 44.832-44.489v-62.08c132.412-12.416 222.076-87.945 222.076-201.756 0-110.705-67.77-173.82-226.246-213.135V239.889c35.45 8.277 70.897 23.797 107.39 45.525 10.426 6.206 20.851 9.31 31.277 9.31 32.322 0 58.387-24.83 58.387-56.905 0-24.831-14.596-40.351-31.279-49.663-47.959-30.005-100.09-49.663-161.604-56.905v-22.762c0-24.831-19.808-44.49-44.832-44.49-25.022 0-45.875 19.658-45.875 44.49zm189.756 550.428c0 49.664-36.491 82.771-103.219 90.014V560.627c80.282 24.832 103.219 52.768 103.219 98.291M380.631 320.591c0-45.523 33.363-80.702 100.09-86.91v183.132c-80.279-25.867-100.09-52.766-100.09-96.222",
          clipRule: "evenodd"
        }
      )
    ]
  }
), s$6 = memo(i$8);
const styles$1r = {
  wrapper: css({
    display: "inline-flex",
    fontWeight: fontWeight.semiBold,
    fontSize: fontSize.small,
    fontFamily: fontFamily.body,
    lineHeight: 1.2,
    color: colors.jumbo,
    marginTop: spacing.extraSmall
  })
};
const FormHelpText = ({ text }) => /* @__PURE__ */ React.createElement("small", { className: styles$1r.wrapper }, text);
FormHelpText.propTypes = {
  text: PropTypes.string.isRequired
};
const styles$1q = {
  container: css({
    width: 240,
    maxWidth: "100%"
  }),
  wrapper: css({
    display: "flex",
    alignItems: "center",
    background: colors.white,
    borderRadius: borderRadius.default,
    border: `1px solid ${colors.mystic}`,
    height: 40,
    width: "100%",
    boxSizing: "border-box"
  }),
  wrapperError: css({
    borderColor: colors.mandy,
    "&:focus-within": {
      borderColor: colors.mandy,
      boxShadow: `0 0 0 2px ${hexToRgba(colors.mandy, 0.25)}`
    }
  }),
  wrapperWarning: css({
    borderColor: colors.sandyBrown,
    "&:focus-within": {
      borderColor: colors.sandyBrown,
      boxShadow: `0 0 0 2px ${hexToRgba(colors.sandyBrown, 0.25)}`
    }
  }),
  input: css({
    color: colors.jumbo,
    fontFamily: fontFamily.body,
    fontSize: fontSize.default,
    lineHeight: 1.2,
    padding: shorthandHelper([spacing.small, spacing.default]),
    appearance: "none",
    border: "none",
    width: "100%",
    height: "100%",
    boxSizing: "border-box",
    borderRadius: borderRadius.default,
    "&::placeholder": {
      color: colors.grayChateau,
      userSelect: "none"
    },
    "&[readonly]": {
      backgroundColor: colors.athensGray
    },
    "&:focus": {
      outline: "none"
    }
  }),
  currencySymbol: css({
    color: colors.geyser,
    fontSize: "24px",
    fontWeight: fontWeight.semiBold
  }),
  warning: css({ color: colors.sandyBrown }),
  error: css({ color: colors.mandy }),
  disabled: css({ backgroundColor: colors.athensGray }),
  icon: css({
    display: "flex",
    height: "min-content",
    padding: shorthandHelper([0, 0, 0, spacing.default]),
    pointerEvents: "none"
  })
};
const wrapperTheme$b = (theme) => {
  const themed = getThemeColors(theme);
  return css({
    "&:focus-within": {
      borderColor: themed.base,
      boxShadow: `0 0 0 2px ${hexToRgba(themed.base, 0.25)}`
    }
  });
};
const iconColor$5 = (errored, warning) => {
  if (errored)
    return colors.mandy;
  if (warning)
    return colors.sandyBrown;
  return colors.geyser;
};
const styles$1p = {
  wrapper: css({
    display: "inline-flex",
    fontFamily: fontFamily.body,
    fontSize: fontSize.small,
    fontWeight: fontWeight.bold,
    lineHeight: lineHeight.default,
    marginTop: spacing.extraSmall,
    color: colors.sandyBrown
  })
};
const FormWarningMessage = ({ className, text }) => /* @__PURE__ */ React.createElement("small", { className: cx(styles$1p.wrapper, className) }, text);
FormWarningMessage.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string
};
const MAX_VALUE = 999999999999999e-2;
const currencies = {
  rand: m$d,
  euro: m$c,
  pound: m$b,
  dollar: s$6
};
class CurrencyInput extends Component {
  constructor() {
    super(...arguments);
    // eslint-disable-next-line react/state-in-constructor
    __publicField(this, "state", {
      addingCents: false,
      cursorStart: 0,
      cursorEnd: 0,
      counter: 0
    });
    __publicField(this, "format", (value) => {
      if (Number.isNaN(value) || value == null)
        return "";
      if (value === "0")
        return value;
      const validValue = Number(value) > MAX_VALUE ? `${MAX_VALUE}` : value;
      const decimalDelimiter = validValue.indexOf(".");
      if (decimalDelimiter === -1) {
        const integer = validValue.replace(/(?!^)(?=(?:\d{3})+(?:$))/g, ",");
        return this.state.addingCents ? `${integer}.` : integer;
      }
      if (this.props.allowCents) {
        const decimalPlaces = validValue.length - 1 - decimalDelimiter;
        const floatingString = Number(validValue).toFixed(decimalPlaces > 2 ? 2 : decimalPlaces);
        const integer = floatingString.replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/g, ",");
        return integer;
      }
    });
    __publicField(this, "parse", (value) => {
      if (value == null || value.length === 0)
        return null;
      const checkMax = value.replace(/,/g, "");
      if (Number(checkMax) > MAX_VALUE)
        return;
      const decimalDelimiter = value.indexOf(".");
      if (decimalDelimiter === -1) {
        const stripped = value.replace(/,/g, "");
        if (Number.isNaN(stripped))
          return;
        return `${stripped}`;
      }
      if (this.props.allowCents) {
        if (decimalDelimiter === value.length - 1) {
          const stripped = value.substring(0, decimalDelimiter).replace(/,/g, "");
          if (Number.isNaN(stripped))
            return;
          return `${stripped}`;
        }
        const integer = value.substring(0, decimalDelimiter).replace(/,/g, "");
        const decimals = value.substring(decimalDelimiter + 1, decimalDelimiter + 3);
        if (Number.isNaN(integer) || Number.isNaN(decimals))
          return;
        return `${integer}.${decimals}`;
      }
    });
  }
  componentDidUpdate(_, prevState) {
    if (!this.input)
      return;
    if (this.state.counter === 0)
      return;
    if (this.state.counter !== prevState.counter) {
      this.input.setSelectionRange(this.state.cursorStart, this.state.cursorEnd);
    } else if (this.input.selectionStart !== this.state.cursorStart || this.input.selectionEnd !== this.state.cursorEnd) {
      this.input.setSelectionRange(this.state.cursorStart, this.state.cursorEnd);
    }
  }
  render() {
    const { currency, currencySymbol, meta, input, theme, helpText, className, onChange, onKeyUp, onClick, allowCents, ...props } = this.props;
    const name = input.name || props.name;
    const value = input.value || props.value;
    const errored = meta.touched && meta.error;
    const warning = meta.touched && meta.warning;
    const handler = input.onChange || onChange;
    const formatted = this.format(value);
    return /* @__PURE__ */ React.createElement("div", { className: cx(styles$1q.container, className) }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cx(
          styles$1q.wrapper,
          wrapperTheme$b(theme),
          errored && styles$1q.wrapperError,
          warning && styles$1q.wrapperWarning,
          props.readOnly && styles$1q.disabled
        )
      },
      /* @__PURE__ */ React.createElement("div", { className: styles$1q.icon }, currencySymbol ? /* @__PURE__ */ React.createElement("span", { className: cx(styles$1q.currencySymbol, errored && styles$1q.error, warning && styles$1q.warning) }, currencySymbol) : /* @__PURE__ */ React.createElement(AccessibleIcon, { icon: currencies[currency], size: 18, color: iconColor$5(errored, warning) })),
      /* @__PURE__ */ React.createElement(
        "input",
        {
          className: styles$1q.input,
          type: "text",
          ...input,
          ...props,
          name,
          value: formatted,
          ref: (el) => this.input = el,
          onChange: (ev) => {
            ev.preventDefault();
            this.setState({ counter: this.state.counter + 1 });
            const stripRegex = allowCents ? /[^0-9.]/g : /[^0-9]/g;
            const strippedValue = ev.target.value.replace(stripRegex, "");
            const newValue = Number(strippedValue.replace(/,/g, "")) > MAX_VALUE ? formatted : strippedValue;
            if (newValue === formatted)
              return;
            const parsed = this.parse(newValue);
            if (parsed !== void 0) {
              if (allowCents) {
                const addingCents = newValue.indexOf(".") !== -1;
                this.setState({ addingCents });
              }
              const decimalDelimiterLength = newValue.endsWith(".") ? 1 : 0;
              const charDiff = this.format(parsed).length - newValue.length + decimalDelimiterLength;
              const cursorStartIndex = Math.max(0, ev.target.selectionStart + charDiff);
              const cursorEndIndex = Math.max(0, ev.target.selectionEnd + charDiff);
              this.setState({ cursorStart: cursorStartIndex, cursorEnd: cursorEndIndex });
              if (handler)
                handler(parsed);
            }
          },
          onKeyUp: (ev) => {
            const key = ev.which;
            if ([37, 38, 39, 40].includes(key)) {
              this.setState({ cursorStart: ev.target.selectionStart, cursorEnd: ev.target.selectionEnd });
            }
            if (onKeyUp)
              onKeyUp(ev);
          },
          onClick: (ev) => {
            this.setState({ cursorStart: ev.target.selectionStart, cursorEnd: ev.target.selectionEnd });
            if (onClick)
              onClick(ev);
          },
          onFocus: (ev) => {
            this.setState({ cursorStart: ev.target.selectionStart, cursorEnd: ev.target.selectionEnd });
            const focusHandler = input.onFocus || props.onFocus;
            if (focusHandler)
              focusHandler(value);
          },
          onBlur: (ev) => {
            ev.preventDefault();
            const blurHandler = input.onBlur || props.onBlur;
            if (blurHandler)
              blurHandler(value);
          }
        }
      )
    ), Boolean(helpText && !errored && !warning) && /* @__PURE__ */ React.createElement(FormHelpText, { text: helpText }), Boolean(errored) && /* @__PURE__ */ React.createElement(FormErrorMessage, { text: meta.error }), Boolean(warning) && /* @__PURE__ */ React.createElement(FormWarningMessage, { text: meta.warning }));
  }
}
const { oneOf: oneOf$2, oneOfType: oneOfType$3, string: string$4, node: node$3, bool: bool$3, shape: shape$2, func: func$3 } = PropTypes;
CurrencyInput.propTypes = {
  currency: oneOf$2(["rand", "euro", "pound", "dollar"]),
  currencySymbol: oneOfType$3([string$4, node$3]),
  allowCents: bool$3,
  meta: shape$2({
    touched: bool$3,
    error: string$4,
    warning: string$4
  }),
  input: shape$2({
    name: string$4,
    value: string$4,
    onChange: func$3,
    onFocus: func$3,
    onBlur: func$3
  }),
  value: string$4,
  helpText: string$4,
  tabIndex: string$4,
  readOnly: bool$3,
  theme: oneOf$2(["", "primary", "secondary", "success", "warning", "error", "legacy", "dark", "tertiary", "info"]),
  className: string$4,
  onChange: func$3,
  onFocus: func$3,
  onBlur: func$3,
  onClick: func$3,
  onKeyUp: func$3
};
CurrencyInput.defaultProps = {
  currency: "rand",
  allowCents: false,
  meta: {},
  input: {},
  tabIndex: "0",
  theme: "primary"
};
const m$a = ({
  title: e,
  titleId: o,
  ...c2
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...c2,
    children: [
      e ? /* @__PURE__ */ fr.jsx("title", { id: o, children: e }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M858.513 170.665c19.627 0 28.544 24.491 13.525 37.12L519.931 503.444c-7.829 6.613-19.285 6.613-27.136 0L140.646 207.785c-15.019-12.608-6.123-37.12 13.504-37.12zm26.229 180.115v423.083c0 34.816-28.224 63.061-63.061 63.061H191.046c-34.795 0-63.061-28.245-63.061-63.061V350.78c0-17.877 20.928-27.605 34.581-16.064l316.693 267.413c7.765 6.507 17.451 9.877 27.115 9.877s19.349-3.371 27.115-9.877l316.672-267.413c13.675-11.541 34.581-1.813 34.581 16.064",
          clipRule: "evenodd"
        }
      )
    ]
  }
), n$f = memo(m$a);
const styles$1o = {
  container: css({
    width: 240,
    maxWidth: "100%"
  }),
  wrapper: css({
    position: "relative",
    borderRadius: borderRadius.default,
    border: `1px solid ${colors.mystic}`,
    height: 40,
    width: "100%",
    boxSizing: "border-box"
  }),
  wrapperError: css({
    borderColor: colors.mandy,
    "&:focus-within": {
      borderColor: colors.mandy,
      boxShadow: `0 0 0 2px ${hexToRgba(colors.mandy, 0.25)}`
    }
  }),
  input: css({
    color: colors.jumbo,
    fontFamily: fontFamily.body,
    fontSize: fontSize.default,
    lineHeight: 1.2,
    padding: shorthandHelper([spacing.small, 42, spacing.small, spacing.default]),
    appearance: "none",
    border: "none",
    width: "100%",
    height: "100%",
    boxSizing: "border-box",
    borderRadius: borderRadius.default,
    "&::placeholder": {
      color: colors.grayChateau,
      userSelect: "none"
    },
    "&[readonly]": {
      backgroundColor: colors.athensGray
    },
    "&:focus": {
      outline: "none"
    }
  }),
  icon: css({
    pointerEvents: "none",
    position: "absolute",
    top: 0,
    bottom: 0,
    right: 0,
    padding: shorthandHelper([0, spacing.default]),
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  })
};
const wrapperTheme$a = (theme) => {
  const themed = getThemeColors(theme);
  return css({
    "&:focus-within": {
      borderColor: themed.base,
      boxShadow: `0 0 0 2px ${hexToRgba(themed.base, 0.25)}`
    }
  });
};
const EmailInput = ({ meta, input, className, theme, helpText, onChange, ...props }) => {
  const value = input.value || props.value;
  const errored = meta.touched && meta.error;
  return /* @__PURE__ */ React.createElement("div", { className: cx(styles$1o.container, className) }, /* @__PURE__ */ React.createElement("div", { className: cx(styles$1o.wrapper, wrapperTheme$a(theme), errored && styles$1o.wrapperError) }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "email",
      ...input,
      ...props,
      value,
      className: styles$1o.input,
      onChange: (ev) => {
        const handler = input.onChange || onChange;
        if (handler)
          handler(ev.target.value);
      }
    }
  ), /* @__PURE__ */ React.createElement("div", { className: styles$1o.icon }, /* @__PURE__ */ React.createElement(AccessibleIcon, { icon: n$f, size: 18, color: errored ? colors.mandy : colors.geyser }))), Boolean(helpText && !errored) && /* @__PURE__ */ React.createElement(FormHelpText, { text: helpText }), Boolean(errored) && /* @__PURE__ */ React.createElement(FormErrorMessage, { text: meta.error }));
};
EmailInput.propTypes = {
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string
  }),
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func
  }),
  name: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  helpText: PropTypes.string,
  autoFocus: PropTypes.bool,
  tabIndex: PropTypes.string,
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "dark", "tertiary", "info"]),
  className: PropTypes.string,
  onChange: PropTypes.func
};
EmailInput.defaultProps = {
  meta: {},
  input: {},
  value: "",
  tabIndex: "0"
};
const s$5 = ({
  title: l,
  titleId: o,
  ...n2
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...n2,
    children: [
      l ? /* @__PURE__ */ fr.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M512.789 690.135c-10.923 0-21.824-4.16-30.165-12.501l-269.44-269.44c-16.661-16.661-16.661-43.669 0-60.331s43.669-16.661 60.331 0L512.79 587.138l239.189-239.189c16.661-16.661 43.669-16.661 60.331 0s16.661 43.691 0 60.352L542.955 677.634c-8.341 8.341-19.243 12.501-30.165 12.501z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), t$5 = memo(s$5);
const styles$1n = {
  wrapper: css({
    position: "relative"
  }),
  labelDefault: css({
    fontSize: fontSize.default
  }),
  labelMedium: css({
    fontSize: fontSize.medium
  }),
  label: css({
    position: "relative",
    zIndex: zIndex.level8,
    display: "flex",
    alignItems: "center",
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer",
    color: colors.oxfordBlue,
    fontFamily: fontFamily.body,
    height: 1.2,
    lineHeight: lineHeight.default,
    padding: 0,
    userSelect: "none",
    "&:hover": {
      textDecoration: "underline"
    },
    "&:focus": {
      textDecoration: "underline",
      outline: "none"
    },
    "& > * + *": {
      marginLeft: spacing.small
    }
  }),
  disabled: css({
    color: colors.grayChateau,
    pointerEvents: "none"
  }),
  body: css({
    marginTop: spacing.extraSmall,
    backgroundColor: colors.white,
    position: "absolute",
    top: "100%",
    left: "100%",
    transform: "translateX(-70px)",
    zIndex: zIndex.level8,
    borderRadius: borderRadius.default,
    border: `1px solid ${colors.mystic}`,
    boxShadow: `0 2px 4px ${hexToRgba(colors.black, 0.1)}`,
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 48,
      width: 10,
      height: 10,
      backgroundColor: colors.white,
      borderLeft: `1px solid ${colors.mystic}`,
      borderTop: `1px solid ${colors.mystic}`,
      transform: "rotate(45deg) translateY(-9px)",
      zIndex: 0
    }
  }),
  list: css({
    whiteSpace: "nowrap",
    listStyle: "none",
    padding: 0,
    margin: 0,
    overflowY: "auto",
    position: "relative",
    zIndex: 1,
    "& > * + *": {
      borderTop: `1px solid ${colors.mystic}`
    }
  }),
  listMaxHeight: (height) => css({
    ...scrollGradient,
    maxHeight: height
  }),
  overlay: css({
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: zIndex.level7
  })
};
const FilterMenu = ({
  selected,
  children,
  onSelect,
  defaultLabel,
  className,
  disabled,
  maxHeight,
  theme = "primary",
  labelSize: labelSize2 = "default"
}) => {
  const [open, setOpen] = useState(false);
  const selectedLabel = React.Children.map(children, (child) => child.props.id === selected ? child.props.label : "").join("");
  return /* @__PURE__ */ React.createElement("div", { className: cx(styles$1n.wrapper, className) }, /* @__PURE__ */ React.createElement(
    "button",
    {
      role: "heading",
      type: "button",
      onClick: () => setOpen(!open),
      "aria-haspopup": "true",
      "aria-expanded": open,
      className: cx(styles$1n.label, labelSize2 === "medium" ? styles$1n.labelMedium : styles$1n.labelDefault, disabled && styles$1n.disabled),
      tabIndex: "0"
    },
    /* @__PURE__ */ React.createElement("span", null, selectedLabel || defaultLabel),
    /* @__PURE__ */ React.createElement(AccessibleIcon, { icon: t$5, size: 18, color: colors.grayChateau })
  ), Boolean(open) && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: styles$1n.body }, /* @__PURE__ */ React.createElement("ul", { role: "menu", className: cx(styles$1n.list, maxHeight && styles$1n.listMaxHeight(maxHeight)) }, React.Children.map(
    children,
    (child) => React.cloneElement(child, {
      theme,
      active: child.props.id === selected,
      onClick: () => {
        if (onSelect)
          onSelect(child.props.id);
        setOpen(false);
      }
    })
  ))), /* @__PURE__ */ React.createElement("div", { className: styles$1n.overlay, onClick: () => setOpen(false) })));
};
FilterMenu.propTypes = {
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "dark", "tertiary", "info"]),
  selected: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  onSelect: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  defaultLabel: PropTypes.string,
  maxHeight: PropTypes.number,
  className: PropTypes.string,
  labelSize: PropTypes.oneOf(["", "medium"])
};
const styles$1m = {
  option: css({
    padding: spacing.default,
    cursor: "pointer",
    "&:first-child": {
      borderTopLeftRadius: borderRadius.default,
      borderTopRightRadius: borderRadius.default
    },
    "&:last-child": {
      borderBottomLeftRadius: borderRadius.default,
      borderBottomRightRadius: borderRadius.default
    }
  }),
  active: css({
    color: colors.oxfordBlue,
    fontWeight: fontWeight.semiBold
  })
};
const optionTheme = (theme) => {
  const themed = getThemeColors(theme);
  return css({
    "&:hover": {
      backgroundColor: themed.light,
      color: themed.base
    },
    "&:focus": {
      backgroundColor: themed.light,
      color: themed.base,
      outline: "none"
    }
  });
};
const MenuOption = ({ id, label, active, theme, onClick }) => /* @__PURE__ */ React.createElement("li", { id, className: cx(styles$1m.option, active && styles$1m.active, optionTheme(theme)), role: "menuitem", onClick }, label);
MenuOption.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  active: PropTypes.bool,
  theme: PropTypes.string,
  onClick: PropTypes.func
};
const styles$1l = {
  error: css({
    fontSize: fontSize.small,
    fontWeight: fontWeight.semiBold,
    fontFamily: fontFamily.body,
    fontStyle: "italic",
    lineHeight: 1.2,
    borderRadius: borderRadius.default,
    padding: spacing.default,
    color: colors.mandy,
    backgroundColor: colors.linen,
    wordBreak: "break-word",
    boxSizing: "border-box"
  })
};
const errorScope = (scope) => {
  switch (scope) {
    case "fieldTop":
      return css({
        marginBottom: spacing.default
      });
    case "fieldBottom":
      return css({
        marginTop: spacing.default
      });
    case "generalMiddle":
      return css({
        marginTop: spacing.medium,
        marginBottom: spacing.medium
      });
    default:
      return css({
        marginBottom: spacing.medium
      });
  }
};
const FormErrorNotification = ({ scope, text }) => /* @__PURE__ */ React.createElement("div", { className: cx(styles$1l.error, errorScope(scope)) }, text);
FormErrorNotification.propTypes = {
  text: PropTypes.string.isRequired,
  scope: PropTypes.oneOf(["", "generalTop", "generalMiddle", "fieldTop", "fieldBottom"])
};
FormErrorNotification.defaultProps = {
  scope: "generalTop"
};
const styles$1k = {
  fieldset: css({
    border: "none",
    padding: 0,
    margin: 0
  }),
  legend: css({
    padding: 0,
    margin: shorthandHelper([0, 0, spacing.default]),
    fontFamily: fontFamily.body,
    fontSize: fontSize.default,
    fontWeight: fontWeight.regular,
    lineHeight: lineHeight.default,
    color: colors.blackPearl
  }),
  hideLegend: css(accessiblyHidden)
};
const FormFieldset = (props) => /* @__PURE__ */ React.createElement("fieldset", { className: cx(styles$1k.fieldset, props.className) }, /* @__PURE__ */ React.createElement("legend", { className: cx(styles$1k.legend, props.hideLegend && styles$1k.hideLegend) }, props.legend), props.children);
FormFieldset.propTypes = {
  className: PropTypes.string,
  legend: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  hideLegend: PropTypes.bool,
  children: PropTypes.node.isRequired
};
const styles$1j = {
  link: css({
    display: "inline-flex",
    justifyContent: "center",
    textDecoration: "none",
    alignItems: "center",
    "&[disabled]": {
      opacity: 1,
      pointerEvents: "auto"
    }
  })
};
const HyperButton = ({ className, size: size2, variant = "default", theme, href, rel, target, download, label, onClick, external, as }) => {
  const Component2 = href && !external ? PinataLink : "a";
  const componentProps = {
    ...href ? {
      ...external ? {
        href,
        rel
      } : {
        to: href,
        as
      },
      target,
      download,
      onClick
    } : {
      onClick,
      onKeyDown: (ev) => {
        if (ev.which === 13 && !specialKeyPressed(ev) && onClick)
          onClick(ev);
      },
      tabIndex: "0"
    }
  };
  return /* @__PURE__ */ React.createElement(
    Component2,
    {
      className: cx(styles$1G.button, styles$1j.link, className, buttonSize(size2), buttonVariant(variant, theme)),
      ...componentProps
    },
    label
  );
};
HyperButton.propTypes = {
  label: PropTypes.string.isRequired,
  href: PropTypes.string,
  target: PropTypes.oneOf(["_self", "_blank", "_parent", "_top"]),
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "light", "tertiary", "info"]),
  size: PropTypes.oneOf(["", "default", "small", "medium"]),
  variant: PropTypes.oneOf(["", "default", "outlined", "dashed"]),
  onClick: PropTypes.func,
  download: PropTypes.string,
  external: PropTypes.bool,
  rel: PropTypes.string,
  className: PropTypes.string,
  as: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({})])
};
HyperButton.defaultProps = {
  theme: "primary",
  size: "default",
  external: false
};
const styles$1i = {
  link: css({
    display: "flex",
    alignItems: "center",
    fontFamily: fontFamily.body,
    fontWeight: "inherit",
    cursor: "pointer",
    userSelect: "none",
    textDecoration: "none",
    whiteSpace: "nowrap",
    "&:hover": {
      textDecoration: "underline"
    },
    "&:focus": {
      outline: "none",
      textDecoration: "underline"
    },
    "&:active": {
      textDecoration: "underline"
    },
    "& > * + *": {
      marginLeft: spacing.small
    }
  }),
  disabled: css({
    pointerEvents: "none",
    cursor: "default",
    opacity: 0.3
  }),
  badge: css({
    flexGrow: 0,
    flexShrink: 0,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%"
  })
};
const linkSize = (size2) => {
  switch (size2) {
    case "small":
      return css({
        fontSize: fontSize.small
      });
    default:
      return css({
        fontSize: fontSize.default
      });
  }
};
const linkTheme$1 = (theme, withBackground) => {
  const themed = getThemeColors(theme);
  let iconHoverBackground = {};
  if (withBackground) {
    iconHoverBackground = {
      "& > div": {
        backgroundColor: themed.base,
        "& svg": {
          color: colors.white
        }
      }
    };
  }
  if (theme === "light") {
    return css({
      color: colors.jumbo,
      "&:hover": iconHoverBackground,
      "&:active": {
        color: themed.dark
      }
    });
  }
  return css({
    color: themed.base,
    "&:hover": iconHoverBackground,
    "&:active": {
      color: themed.dark
    }
  });
};
const badgeSize = (size2) => {
  switch (size2) {
    case "small":
      return css({
        width: 20,
        height: 20
      });
    case "medium":
      return css({
        width: 30,
        height: 30
      });
    default:
      return css({
        width: 24,
        height: 24
      });
  }
};
const badgeTheme = (theme) => {
  const themed = getThemeColors(theme);
  return css({
    backgroundColor: themed.light
  });
};
const iconSize$3 = (size2) => {
  switch (size2) {
    case "small":
      return 12;
    case "medium":
      return 16;
    default:
      return 14;
  }
};
const iconTheme$4 = (theme) => {
  const themed = getThemeColors(theme);
  return themed.base;
};
const styles$1h = {
  button: css({
    // Override default button styling
    border: "none",
    background: "none",
    outline: "none",
    padding: 0,
    fontWeight: fontWeight.default
  })
};
const IconButtonLink = ({ theme, size: size2, className, icon, withBackground, label, disabled, ...props }) => /* @__PURE__ */ React.createElement(
  "button",
  {
    className: cx(
      styles$1h.button,
      styles$1i.link,
      linkSize(size2),
      linkTheme$1(theme, withBackground),
      disabled && styles$1i.disabled,
      className
    ),
    type: "button",
    ...props
  },
  /* @__PURE__ */ React.createElement("span", { className: cx(styles$1i.badge, withBackground && [badgeTheme(theme), badgeSize(size2)]) }, /* @__PURE__ */ React.createElement(AccessibleIcon, { icon, size: iconSize$3(size2), color: iconTheme$4(theme) })),
  /* @__PURE__ */ React.createElement("span", null, label)
);
IconButtonLink.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.shape({})]).isRequired,
  withBackground: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "light", "dark", "tertiary", "info"]),
  size: PropTypes.oneOf(["", "default", "small", "medium"]),
  disabled: PropTypes.bool,
  className: PropTypes.oneOfType([PropTypes.shape(), PropTypes.string])
};
IconButtonLink.defaultProps = {
  theme: "primary",
  size: "default",
  withBackground: true
};
const IconHyperlink = ({
  theme,
  size: size2,
  className,
  disabled,
  icon,
  withBackground,
  label,
  href,
  onClick,
  target,
  download,
  external,
  rel,
  as
}) => {
  const Component2 = href && !external ? PinataLink : "a";
  const componentProps = {
    ...href ? {
      ...external ? {
        href,
        rel
      } : {
        to: href,
        as
      },
      target,
      download,
      onClick
    } : {
      onClick,
      onKeyDown: (ev) => {
        if (ev.which === 13 && !specialKeyPressed(ev) && onClick)
          onClick(ev);
      },
      tabIndex: disabled ? "-1" : "0"
    }
  };
  return /* @__PURE__ */ React.createElement(
    Component2,
    {
      className: cx(styles$1i.link, className, linkSize(size2), linkTheme$1(theme, withBackground), disabled && styles$1i.disabled),
      ...componentProps
    },
    /* @__PURE__ */ React.createElement("div", { className: cx(styles$1i.badge, withBackground && [badgeTheme(theme), badgeSize(size2)]) }, /* @__PURE__ */ React.createElement(AccessibleIcon, { icon, size: iconSize$3(size2), color: iconTheme$4(theme) })),
    /* @__PURE__ */ React.createElement("span", null, label)
  );
};
IconHyperlink.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.shape({})]),
  withBackground: PropTypes.bool,
  label: PropTypes.string.isRequired,
  href: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onClick: PropTypes.func,
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "light", "dark", "tertiary", "info"]),
  size: PropTypes.oneOf(["", "default", "small", "medium"]),
  target: PropTypes.oneOf(["_self", "_blank", "_parent", "_top"]),
  download: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  external: PropTypes.bool,
  rel: PropTypes.string,
  as: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({})])
};
IconHyperlink.defaultProps = {
  theme: "primary",
  size: "default",
  external: false,
  withBackground: true
};
const styles$1g = {
  wrapper: css({
    listStyle: "none",
    padding: 0,
    margin: 0,
    display: "flex",
    flexDirection: "column",
    "& > * + *": {
      marginTop: spacing.default
    }
  })
};
const IconList = ({ className, theme, size: size2, withBackground, children }) => /* @__PURE__ */ React.createElement("ul", { className: cx(styles$1g.wrapper, className) }, React.Children.map(children, (child) => {
  if (!child)
    return null;
  return React.cloneElement(child, { theme, size: size2, withBackground });
}));
IconList.propTypes = {
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "light", "dark", "tertiary", "info"]),
  size: PropTypes.oneOf(["", "default", "small", "extraSmall", "medium", "large"]),
  withBackground: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
IconList.defaultProps = {
  theme: "primary",
  size: "default"
};
const styles$1f = {
  wrapper: css({
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%"
  })
};
const wrapperTheme$9 = (theme) => {
  const themed = getThemeColors(theme);
  return css({
    backgroundColor: themed.light
  });
};
const wrapperSize$2 = (size2) => {
  switch (size2) {
    case "extraSmall":
      return css({
        width: 14,
        height: 14
      });
    case "small":
      return css({
        width: 16,
        height: 16
      });
    case "medium":
      return css({
        width: 20,
        height: 20
      });
    case "large":
      return css({
        width: 24,
        height: 24
      });
    default:
      return css({
        width: 18,
        height: 18
      });
  }
};
const iconColor$4 = (theme) => {
  const themed = getThemeColors(theme);
  return themed.base;
};
const iconSize$2 = (size2, withBackground) => {
  switch (size2) {
    case "extraSmall":
      return withBackground ? 10 : 14;
    case "small":
      return withBackground ? 12 : 16;
    case "medium":
      return withBackground ? 14 : 20;
    case "large":
      return withBackground ? 16 : 24;
    default:
      return withBackground ? 12 : 18;
  }
};
const ItemIcon = ({ theme, size: size2, withBackground, icon }) => /* @__PURE__ */ React.createElement("div", { className: cx(styles$1f.wrapper, withBackground && wrapperTheme$9(theme), wrapperSize$2(size2)) }, /* @__PURE__ */ React.createElement(AccessibleIcon, { icon, color: iconColor$4(theme), size: iconSize$2(size2, withBackground) }));
ItemIcon.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.shape({})]),
  theme: PropTypes.string,
  size: PropTypes.string,
  withBackground: PropTypes.bool
};
const styles$1e = {
  item: css({
    display: "flex",
    alignItems: "center",
    lineHeight: 1.2,
    fontWeight: fontWeight.regular,
    color: colors.jumbo,
    marginLeft: 0,
    "& > * + *": {
      marginLeft: spacing.default
    }
  })
};
const itemSize$1 = (size2) => {
  switch (size2) {
    case "extraSmall":
    case "small":
      return css({
        fontSize: fontSize.small
      });
    case "medium":
    case "large":
      return css({
        fontSize: fontSize.default
      });
    default:
      return css({
        fontSize: fontSize.small
      });
  }
};
const SimpleItem = ({ className, icon, theme, size: size2, withBackground, label, children }) => /* @__PURE__ */ React.createElement("li", { className: cx(styles$1e.item, className, itemSize$1(size2)) }, /* @__PURE__ */ React.createElement(ItemIcon, { icon, theme, size: size2, withBackground }), /* @__PURE__ */ React.createElement("span", null, children || label));
SimpleItem.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.shape({})]),
  label: PropTypes.string,
  theme: PropTypes.string,
  size: PropTypes.string,
  withBackground: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
const n$e = ({
  title: e,
  titleId: o,
  ...i2
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...i2,
    children: [
      e ? /* @__PURE__ */ fr.jsx("title", { id: o, children: e }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m321.463 854.308 409.493-409.472-164.843-164.864-409.536 409.515a24.69 24.69 0 0 0-7.232 17.856l1.963 127.445c.213 13.312 10.923 24.064 24.235 24.32l127.979 2.453a24.698 24.698 0 0 0 17.941-7.253m437.251-437.239 96.619-96.619c8.341-8.341 8.341-21.845 0-30.187L720.656 155.586c-8.341-8.32-21.845-8.32-30.165 0l-96.64 96.619 164.864 164.864z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), t$4 = memo(n$e);
const m$9 = ({
  title: s2,
  titleId: c2,
  ...l
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": c2,
    ...l,
    children: [
      s2 ? /* @__PURE__ */ fr.jsx("title", { id: c2, children: s2 }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M847.755 159.671v64.677h-671.48v-64.677c0-26.328 21.095-47.454 47.128-47.454h156.005V82.998c0-22.133 17.877-40.333 39.943-40.333h185.292c22.103 0 39.975 18.199 39.975 40.333v29.219h156.005c26.001 0 47.128 21.127 47.128 47.454zM715.151 844.046c0 13.455-10.921 24.376-24.376 24.376s-24.376-10.921-24.376-24.376V388.182c0-13.455 10.921-24.376 24.376-24.376s24.376 10.921 24.376 24.376zm-178.757 0c0 13.455-10.921 24.376-24.376 24.376s-24.376-10.921-24.376-24.376V388.182c0-13.455 10.921-24.376 24.376-24.376s24.376 10.921 24.376 24.376zm-178.762 0c0 13.455-10.921 24.376-24.376 24.376s-24.376-10.921-24.376-24.376V388.182c0-13.455 10.921-24.376 24.376-24.376s24.376 10.921 24.376 24.376zm485.8-567.443H176.145v657.57c0 26.032 21.095 47.159 47.128 47.159h577.454c26.032 0 47.128-21.127 47.128-47.159V281.022a4.426 4.426 0 0 0-4.422-4.422z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), h = memo(m$9);
const styles$1d = {
  wrapper: css({
    display: "inline",
    color: colors.jumbo,
    fontFamily: fontFamily.body,
    fontSize: fontSize.small,
    fontWeight: "inherit",
    lineHeight: 1.2
  })
};
const SmallText = ({ className, children }) => /* @__PURE__ */ React.createElement("small", { className: cx(styles$1d.wrapper, className) }, children);
SmallText.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string
};
const styles$1c = {
  item: css({
    display: "flex",
    alignItems: "flex-start",
    lineHeight: 1.2,
    fontWeight: fontWeight.regular,
    color: colors.jumbo,
    marginLeft: 0,
    "& > * + *": {
      marginLeft: spacing.default
    }
  }),
  iconWrapper: css({
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%"
  }),
  title: css({
    marginBottom: spacing.extraSmall,
    fontWeight: fontWeight.semiBold,
    marginRight: "auto"
  }),
  subtitle: css({
    "& + *": {
      marginTop: spacing.default
    }
  }),
  content: css({
    width: "100%"
  }),
  deleteButton: css({
    margin: shorthandHelper(["auto", 0, "auto", spacing.small])
  }),
  editButton: css({
    margin: shorthandHelper(["auto", 0])
  }),
  titleWrapper: css({
    display: "flex",
    alignItems: "center"
  })
};
const itemSize = (size2) => {
  switch (size2) {
    case "extraSmall":
    case "small":
      return css({
        fontSize: fontSize.small
      });
    case "medium":
    case "large":
      return css({
        fontSize: fontSize.default
      });
    default:
      return css({
        fontSize: fontSize.small
      });
  }
};
const StructuredItem = ({ theme, size: size2, withBackground, icon, title, subtitle, className, children, onEdit, onDelete }) => /* @__PURE__ */ React.createElement("li", { className: cx(styles$1c.item, className, itemSize(size2)) }, /* @__PURE__ */ React.createElement(ItemIcon, { icon, theme, size: size2, withBackground }), /* @__PURE__ */ React.createElement("div", { className: styles$1c.content }, /* @__PURE__ */ React.createElement("div", { className: styles$1c.titleWrapper }, /* @__PURE__ */ React.createElement(Subheading, { className: styles$1c.title }, title), Boolean(onEdit) && /* @__PURE__ */ React.createElement(BadgeButton, { className: styles$1c.deleteButton, onClick: onEdit, icon: t$4, ariaLabel: `Edit ${title}` }), Boolean(onDelete) && /* @__PURE__ */ React.createElement(BadgeButton, { className: styles$1c.deleteButton, onClick: onDelete, icon: h, ariaLabel: `Delete ${title}` })), /* @__PURE__ */ React.createElement(SmallText, { className: styles$1c.subtitle }, subtitle), Boolean(children) && children));
StructuredItem.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.shape({})]).isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  theme: PropTypes.string,
  size: PropTypes.string,
  withBackground: PropTypes.bool,
  className: PropTypes.string,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func
};
const styles$1b = {
  icon: css({
    borderRadius: "50%",
    width: 20,
    height: 20,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flex: "0 0 auto",
    marginRight: spacing.small
  })
};
const iconTheme$3 = (theme) => {
  const themed = getThemeColors(theme);
  return css({
    backgroundColor: themed.light
  });
};
const iconColor$3 = (theme) => {
  const themed = getThemeColors(theme);
  return themed.base;
};
const MenuIcon = ({ theme, icon }) => /* @__PURE__ */ React.createElement("div", { className: cx(styles$1b.icon, iconTheme$3(theme)) }, /* @__PURE__ */ React.createElement(AccessibleIcon, { icon, color: iconColor$3(theme), size: 14 }));
MenuIcon.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.shape({})]).isRequired,
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "light", "dark", "tertiary", "info"])
};
MenuIcon.defaultProps = {
  theme: "primary"
};
const styles$1a = {
  wrapper: css({
    position: "relative",
    fontFamily: fontFamily.body
  }),
  label: css({
    display: "flex",
    alignItems: "center",
    color: colors.jumbo,
    cursor: "pointer",
    userSelect: "none",
    whiteSpace: "nowrap",
    "&[disabled]": {
      pointerEvents: "none",
      cursor: "default"
    },
    "&:hover": {
      textDecoration: "underline"
    },
    "&:focus": {
      outline: "none",
      textDecoration: "underline"
    }
  }),
  labelPlaceholder: css({
    color: colors.grayChateau
  }),
  labelOpen: css({
    position: "relative",
    zIndex: zIndex.level6
  }),
  arrow: css({
    display: "flex",
    aligItems: "center",
    justifyContent: "center",
    marginLeft: spacing.small
  }),
  body: css({
    position: "absolute",
    top: "100%",
    right: -24,
    zIndex: zIndex.level6,
    listStyle: "none",
    padding: 0,
    margin: 0,
    marginTop: spacing.extraSmall,
    backgroundColor: colors.white,
    border: `1px solid ${colors.mystic}`,
    borderRadius: borderRadius.default,
    boxShadow: `0 2px 4px ${hexToRgba(colors.scorpion, 0.1)}`,
    "& > * + *": {
      borderTop: `1px solid ${colors.mystic}`
    }
  }),
  overlay: css({
    position: "fixed",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: zIndex.level5
  })
};
class IconMenu extends Component {
  constructor() {
    super(...arguments);
    // eslint-disable-next-line react/state-in-constructor
    __publicField(this, "state", {
      open: false
    });
  }
  render() {
    const { open } = this.state;
    const { value, onChange, disabled, ...props } = this.props;
    const children = React.Children.toArray(props.children);
    const selectedChild = children.find((child) => child.props.value === value) || { props: { label: "", icon: "", theme: "" } };
    const isPlaceholder = value === "" && !!children.find((child) => child.props.value === "" && child.props.disabled);
    return /* @__PURE__ */ React.createElement("div", { className: styles$1a.wrapper }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cx(styles$1a.label, isPlaceholder && styles$1a.labelPlaceholder, open && styles$1a.labelOpen),
        disabled,
        tabIndex: disabled ? "-1" : props.tabIndex,
        onClick: () => {
          if (!disabled)
            this.setState({ open: !open });
        }
      },
      Boolean(selectedChild.props.icon) && /* @__PURE__ */ React.createElement(MenuIcon, { icon: selectedChild.props.icon, theme: selectedChild.props.theme }),
      /* @__PURE__ */ React.createElement("span", null, selectedChild.props.label),
      /* @__PURE__ */ React.createElement("span", { className: styles$1a.arrow }, /* @__PURE__ */ React.createElement(AccessibleIcon, { icon: t$5, color: colors.grayChateau, size: 12 }))
    ), Boolean(open) && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("ul", { className: styles$1a.body }, React.Children.map(
      children,
      (child) => React.cloneElement(child, {
        selected: child.props.value === value,
        onClick: () => {
          if (onChange)
            onChange(child.props.value);
          this.setState({ open: false });
        }
      })
    )), /* @__PURE__ */ React.createElement("div", { className: styles$1a.overlay, onClick: () => this.setState({ open: false }) })));
  }
}
IconMenu.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  tabIndex: PropTypes.string,
  disabled: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
IconMenu.defaultProps = {
  tabIndex: "0"
};
const styles$19 = {
  wrapper: css({
    listStyle: "none",
    margin: 0,
    padding: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%"
  })
};
const IconTabBar = ({ theme, children }) => /* @__PURE__ */ React.createElement("ul", { className: styles$19.wrapper }, React.Children.map(children, (child) => {
  if (child == null)
    return null;
  return React.cloneElement(child, { theme });
}));
IconTabBar.propTypes = {
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "dark", "tertiary", "info"]),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
const styles$18 = {
  wrapper: css({
    flex: 1,
    color: colors.jumbo
  }),
  link: css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    color: "inherit",
    fontSize: fontSize.small,
    fontWeight: fontWeight.regular,
    fontFamily: fontFamily.body,
    lineHeight: 1.2,
    textDecoration: "none"
  })
};
const linkTheme = (theme) => {
  const themed = getThemeColors(theme);
  return css({
    color: themed.base,
    "& svg": {
      color: colors.geyser
    }
  });
};
const IconTabItem = ({ theme, href, icon, label, asLink }) => /* @__PURE__ */ React.createElement("li", { className: styles$18.wrapper }, /* @__PURE__ */ React.createElement(PinataLink, { to: href, className: styles$18.link, activeClassName: linkTheme(theme), as: asLink }, /* @__PURE__ */ React.createElement(AccessibleIcon, { icon, color: colors.geyser, size: 24 }), /* @__PURE__ */ React.createElement("span", null, label)));
IconTabItem.propTypes = {
  href: PropTypes.string.isRequired,
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.shape({})]).isRequired,
  label: PropTypes.string.isRequired,
  theme: PropTypes.string,
  asLink: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({})])
};
function isObject$5(value) {
  var type2 = typeof value;
  return value != null && (type2 == "object" || type2 == "function");
}
var isObject_1 = isObject$5;
var root$7 = _root;
var now$1 = function() {
  return root$7.Date.now();
};
var now_1 = now$1;
var reWhitespace = /\s/;
function trimmedEndIndex$1(string2) {
  var index = string2.length;
  while (index-- && reWhitespace.test(string2.charAt(index))) {
  }
  return index;
}
var _trimmedEndIndex = trimmedEndIndex$1;
var trimmedEndIndex = _trimmedEndIndex;
var reTrimStart = /^\s+/;
function baseTrim$1(string2) {
  return string2 ? string2.slice(0, trimmedEndIndex(string2) + 1).replace(reTrimStart, "") : string2;
}
var _baseTrim = baseTrim$1;
var baseTrim = _baseTrim, isObject$4 = isObject_1, isSymbol$4 = isSymbol_1;
var NAN = 0 / 0;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
function toNumber$1(value) {
  if (typeof value == "number") {
    return value;
  }
  if (isSymbol$4(value)) {
    return NAN;
  }
  if (isObject$4(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject$4(other) ? other + "" : other;
  }
  if (typeof value != "string") {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var toNumber_1 = toNumber$1;
var isObject$3 = isObject_1, now = now_1, toNumber = toNumber_1;
var FUNC_ERROR_TEXT$1 = "Expected a function";
var nativeMax$1 = Math.max, nativeMin = Math.min;
function debounce(func2, wait, options) {
  var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
  if (typeof func2 != "function") {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  wait = toNumber(wait) || 0;
  if (isObject$3(options)) {
    leading = !!options.leading;
    maxing = "maxWait" in options;
    maxWait = maxing ? nativeMax$1(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = "trailing" in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time) {
    var args = lastArgs, thisArg = lastThis;
    lastArgs = lastThis = void 0;
    lastInvokeTime = time;
    result = func2.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time) {
    lastInvokeTime = time;
    timerId = setTimeout(timerExpired, wait);
    return leading ? invokeFunc(time) : result;
  }
  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    timerId = setTimeout(timerExpired, remainingWait(time));
  }
  function trailingEdge(time) {
    timerId = void 0;
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = void 0;
    return result;
  }
  function cancel() {
    if (timerId !== void 0) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = void 0;
  }
  function flush() {
    return timerId === void 0 ? result : trailingEdge(now());
  }
  function debounced() {
    var time = now(), isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;
    if (isInvoking) {
      if (timerId === void 0) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === void 0) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}
var debounce_1 = debounce;
const debounce$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(debounce_1);
class InfiniteScroll extends Component {
  constructor() {
    super(...arguments);
    // eslint-disable-next-line react/state-in-constructor
    __publicField(this, "state", {
      renderBack: false
    });
    __publicField(this, "triggerListener", debounce$1(() => {
      if (!this.container)
        return;
      this.checkPosition();
      if (this.props.preventListener)
        return;
      if (window.scrollY + window.innerHeight > this.container.clientHeight + this.container.offsetTop - this.props.scrollTriggerHeight) {
        this.props.scrollListener();
      }
    }, 100));
    __publicField(this, "checkPosition", () => {
      if (!this.props.backTopComponent)
        return;
      this.setState({ renderBack: window.scrollY > window.innerHeight * 0.2 });
    });
  }
  componentDidMount() {
    window.addEventListener("scroll", this.triggerListener);
    this.checkPosition();
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.triggerListener);
  }
  render() {
    const { children, backTopComponent: Back, ...rest } = this.props;
    return /* @__PURE__ */ React.createElement(React.Fragment, null, children({ ...rest, containerRef: (el) => this.container = el }), Boolean(this.state.renderBack) && /* @__PURE__ */ React.createElement(Back, null));
  }
}
InfiniteScroll.propTypes = {
  children: PropTypes.func,
  scrollListener: PropTypes.func.isRequired,
  backTopComponent: PropTypes.func,
  preventListener: PropTypes.bool,
  scrollTriggerHeight: PropTypes.number
};
InfiniteScroll.defaultProps = {
  preventListener: false,
  scrollTriggerHeight: 100
};
class LazyComponent extends Component {
  constructor() {
    super(...arguments);
    // eslint-disable-next-line react/state-in-constructor
    __publicField(this, "state", {
      component: null,
      waitForReducers: !!this.props.reducers,
      loadedReducers: false,
      waitForSagas: !!this.props.sagas,
      loadedSagas: false
    });
  }
  componentDidMount() {
    this.mounted = true;
    if (this.props.reducers)
      this.loadReducers();
    if (this.props.sagas)
      this.loadSagas();
    this.loadComponent();
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  async loadComponent() {
    const { default: component } = await this.props.loader();
    if (this.mounted)
      this.setState({ component });
  }
  async loadReducers() {
    const { default: dynamicReducer } = await this.props.reducers();
    if (this.mounted) {
      if (!this.props.componentName) {
        console.error("Supply a componentName to LazyComponent to register reducers");
        return;
      }
      this.context.store.registerReducer(this.props.componentName, dynamicReducer);
      this.setState({ loadedReducers: true });
    }
  }
  async loadSagas() {
    const { default: dynamicSaga } = await this.props.sagas();
    if (this.mounted) {
      if (!this.props.componentName) {
        console.error("Supply a componentName to LazyComponent to register sagas");
        return;
      }
      this.context.store.registerSaga(this.props.componentName, dynamicSaga);
      this.setState({ loadedSagas: true });
    }
  }
  render() {
    const { component, waitForReducers, loadedReducers, waitForSagas, loadedSagas } = this.state;
    const { children } = this.props;
    if (waitForReducers && !loadedReducers)
      return children(null);
    if (waitForSagas && !loadedSagas)
      return children(null);
    return children(component);
  }
}
LazyComponent.propTypes = {
  componentName: PropTypes.string,
  loader: PropTypes.func.isRequired,
  reducers: PropTypes.func,
  sagas: PropTypes.func,
  children: PropTypes.func
};
LazyComponent.contextTypes = {
  store: PropTypes.shape({})
};
const LockScroll = ({ locked, children = null }) => {
  useEffect(() => {
    const lockScroll = (isLocked) => {
      const bodyStyle = document.body.style;
      const position = bodyStyle.top;
      bodyStyle.width = isLocked ? "100%" : "";
      bodyStyle.height = isLocked ? "100%" : "";
      bodyStyle.overflow = isLocked ? "hidden" : "";
      if (!isLocked && position) {
        document.documentElement.scrollTop = parseInt(position.replace("px"), 10) * -1;
      }
    };
    lockScroll(locked);
    return () => lockScroll(false);
  }, [locked]);
  return children;
};
LockScroll.propTypes = {
  locked: PropTypes.bool.isRequired,
  children: PropTypes.node
};
const handleMediaQuery = (config2 = {}) => (WrappedComponent) => {
  const breakpointToTrack = config2.breakpoints || [];
  class MediaQueryHandler extends Component {
    constructor() {
      super(...arguments);
      // eslint-disable-next-line react/state-in-constructor
      __publicField(this, "state", {
        matchesPhone: false,
        matchesTablet: false,
        matchesDesktop: false,
        matchesBreakpoints: {}
      });
      __publicField(this, "onPhoneChange", () => this.setState({ matchesPhone: this.phoneQueryList.matches }));
      __publicField(this, "onTabletChange", () => this.setState({ matchesTablet: this.tabletQueryList.matches }));
      __publicField(this, "onDesktopChange", () => this.setState({ matchesDesktop: this.desktopQueryList.matches }));
      __publicField(this, "onMediaChange", (match2) => {
        const trackedBreakpoint = this.breakpoints[match2.media];
        this.setState({
          matchesBreakpoints: {
            // eslint-disable-next-line react/no-access-state-in-setstate
            ...this.state.matchesBreakpoints,
            [trackedBreakpoint.value]: match2.matches
          }
        });
      });
    }
    componentDidMount() {
      this.phoneQueryList = window.matchMedia(`(min-width: ${breakpoint.phone}px)`);
      this.phoneQueryList.addListener(this.onPhoneChange);
      this.tabletQueryList = window.matchMedia(`(min-width: ${breakpoint.tablet}px)`);
      this.tabletQueryList.addListener(this.onTabletChange);
      this.desktopQueryList = window.matchMedia(`(min-width: ${breakpoint.desktop}px)`);
      this.desktopQueryList.addListener(this.onDesktopChange);
      this.onDesktopChange();
      const stateBreakpoints = {};
      this.breakpoints = {};
      breakpointToTrack.forEach((bp) => {
        const media = `(min-width: ${bp}px)`;
        const queryList = window.matchMedia(media);
        queryList.addListener(this.onMediaChange);
        this.breakpoints[media] = {
          value: bp,
          queryList
        };
        stateBreakpoints[bp] = queryList.matches;
      });
      this.setState({
        matchesPhone: this.phoneQueryList.matches,
        matchesTablet: this.tabletQueryList.matches,
        matchesDesktop: this.desktopQueryList.matches,
        matchesBreakpoints: stateBreakpoints
      });
    }
    componentWillUnmount() {
      if (this.phoneQueryList)
        this.phoneQueryList.removeListener(this.onPhoneChange);
      if (this.tabletQueryList)
        this.tabletQueryList.removeListener(this.onTabletChange);
      if (this.desktopQueryList)
        this.desktopQueryList.removeListener(this.onDesktopChange);
      if (this.breakpoints) {
        Object.values(this.breakpoints).map(({ queryList }) => queryList.removeListener(this.onMediaChange));
      }
    }
    render() {
      return /* @__PURE__ */ React.createElement(
        WrappedComponent,
        {
          ...this.props,
          isPhoneOrLarger: this.state.matchesPhone,
          isTabletOrLarger: this.state.matchesTablet,
          isDesktopOrLarger: this.state.matchesDesktop,
          isBreakpointOrLarger: this.state.matchesBreakpoints
        }
      );
    }
  }
  MediaQueryHandler.displayName = `HandleMediaQuery(${WrappedComponent.displayName || WrappedComponent.name || "Component"})`;
  return MediaQueryHandler;
};
const MatchingQueriesContext = createContext();
const defaultMatches = {
  isPhoneOrLarger: false,
  isTabletOrLarger: false,
  isDesktopOrLarger: false
};
const mediaQueryReducer = (state, action) => {
  switch (action.type) {
    case "phone":
      return { ...state, isPhoneOrLarger: action.value };
    case "tablet":
      return { ...state, isTabletOrLarger: action.value };
    case "desktop":
      return { ...state, isDesktopOrLarger: action.value };
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
};
const breakpointNames = ["phone", "tablet", "desktop"];
const MediaQueryProvider = ({ children }) => {
  const [state, dispatch] = useReducer(mediaQueryReducer, defaultMatches);
  useEffect(() => {
    const queriesAndListeners = breakpointNames.map((breakpointName) => {
      const mediaQueryList = window.matchMedia(`(min-width: ${breakpoint[breakpointName]}px)`);
      const listener = () => dispatch({ type: breakpointName, value: mediaQueryList.matches });
      listener();
      if (typeof mediaQueryList.addEventListener === "function") {
        mediaQueryList.addEventListener("change", listener);
      } else {
        mediaQueryList.addListener(listener);
      }
      return {
        mediaQueryList,
        listener
      };
    });
    return () => queriesAndListeners.forEach((query) => {
      if (typeof query.mediaQueryList.removeEventListener === "function") {
        query.mediaQueryList.removeEventListener("change", query.listener);
      } else {
        query.mediaQueryList.removeListener(query.listener);
      }
    });
  }, []);
  return /* @__PURE__ */ React.createElement(MatchingQueriesContext.Provider, { value: state }, children);
};
const useMediaQuery = () => {
  const context = React.useContext(MatchingQueriesContext);
  if (context === void 0) {
    throw new Error("useMediaQuery must be used within a MediaQueryProvider");
  }
  return context;
};
MediaQueryProvider.propTypes = {
  children: PropTypes.node
};
const n$d = ({
  title: o,
  titleId: l,
  ...r2
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": l,
    ...r2,
    children: [
      o ? /* @__PURE__ */ fr.jsx("title", { id: l, children: o }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m289.833 657.517 196.885 196.885c16 16 44.352 16 60.352 0l195.627-195.627c16.661-16.683 16.661-43.669 0-60.352-16.661-16.661-43.691-16.661-60.331 0L558.931 721.879V192.002c0-23.573-19.093-42.667-42.667-42.667-23.552 0-42.667 19.093-42.667 42.667v528.619L350.162 597.186c-8.32-8.341-19.243-12.501-30.165-12.501s-21.845 4.16-30.165 12.501c-16.661 16.661-16.661 43.669 0 60.331z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), c$2 = memo(n$d);
const n$c = ({
  title: l,
  titleId: o,
  ...r2
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...r2,
    children: [
      l ? /* @__PURE__ */ fr.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M742.693 358.219 545.808 161.334c-16-16-44.352-16-60.352 0L289.829 356.961c-16.661 16.683-16.661 43.669 0 60.352 16.661 16.661 43.691 16.661 60.331 0l123.435-123.456v529.877c0 23.573 19.093 42.667 42.667 42.667 23.552 0 42.667-19.093 42.667-42.667V295.115L682.364 418.55c8.32 8.341 19.243 12.501 30.165 12.501s21.845-4.16 30.165-12.501c16.661-16.661 16.661-43.669 0-60.331z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), m$8 = memo(n$c);
const styles$17 = {
  heading: css({
    flex: "0 0 auto",
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: colors.athensGray,
    padding: shorthandHelper([spacing.small, spacing.default])
  }),
  navigation: css({
    display: "inline-flex",
    alignItems: "center"
  })
};
const MentionHeading = ({ label }) => /* @__PURE__ */ React.createElement("dt", { className: styles$17.heading }, /* @__PURE__ */ React.createElement("strong", null, label), /* @__PURE__ */ React.createElement("span", { className: styles$17.navigation }, /* @__PURE__ */ React.createElement(AccessibleIcon, { icon: c$2, size: 12, color: colors.oxfordBlue }), /* @__PURE__ */ React.createElement(AccessibleIcon, { icon: m$8, size: 12, color: colors.oxfordBlue }), " to navigate"));
MentionHeading.propTypes = {
  label: PropTypes.string.isRequired
};
const styles$16 = {
  list: css({
    position: "absolute",
    left: 0,
    right: 0,
    zIndex: zIndex.level8,
    fontSize: fontSize.small,
    color: colors.oxfordBlue,
    margin: 0,
    backgroundColor: colors.white,
    border: `1px solid ${colors.mystic}`,
    overflow: "hidden",
    "& > * + *": {
      borderTop: `1px solid ${colors.catskillWhite}`
    }
  }),
  body: css({
    maxHeight: 260,
    overflowY: "auto",
    margin: 0,
    // Scroll gradient
    ...scrollGradient,
    "& > * + *": {
      borderTop: `1px solid ${colors.catskillWhite}`
    }
  })
};
const listPosition = (position) => {
  switch (position) {
    case "top":
      return css({
        bottom: "100%",
        borderTopLeftRadius: borderRadius.default,
        borderTopRightRadius: borderRadius.default
      });
    default:
      return css({
        top: "100%",
        borderBottomLeftRadius: borderRadius.default,
        borderBottomRightRadius: borderRadius.default
      });
  }
};
const MentionMenu = ({ position, label, theme, selectedHandle, children, ...props }) => /* @__PURE__ */ React.createElement("dl", { className: cx(styles$16.list, listPosition(position)) }, Boolean(position === "bottom") && /* @__PURE__ */ React.createElement(MentionHeading, { label }), /* @__PURE__ */ React.createElement("dl", { className: styles$16.body, ref: props.menuRef, onMouseOver: props.onHover }, React.Children.map(children, (child) => {
  const childHandle = child.props.handle;
  const selected = selectedHandle === childHandle;
  return React.cloneElement(child, {
    theme,
    selected,
    onHover: () => props.onOptionHover(childHandle),
    onSelect: () => props.onOptionSelect(childHandle)
  });
})), Boolean(position === "top") && /* @__PURE__ */ React.createElement(MentionHeading, { label }));
MentionMenu.propTypes = {
  label: PropTypes.string,
  position: PropTypes.oneOf(["", "bottom", "top"]),
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "light", "dark", "tertiary", "info"]),
  selectedHandle: PropTypes.string,
  onHover: PropTypes.func,
  onOptionHover: PropTypes.func,
  onOptionSelect: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  menuRef: PropTypes.func
};
MentionMenu.defaultProps = {
  label: "Teammates matching @",
  position: "bottom",
  theme: "primary"
};
const styles$15 = {
  mention: css({
    flex: "0 0 auto",
    display: "flex",
    alignItems: "center",
    padding: shorthandHelper([spacing.small, spacing.default]),
    margin: 0,
    cursor: "pointer",
    "& > * + *": {
      marginLeft: spacing.small
    }
  }),
  name: css({
    marginLeft: spacing.small,
    color: colors.grayChateau
  })
};
const mentionTheme = (theme) => {
  const themed = getThemeColors(theme);
  return css({
    backgroundColor: hexToRgba(themed.light, 0.3)
  });
};
const MentionOption = ({ theme, selected, avatar, avatarTheme: avatarTheme2, avatarThemeModifier, avatarFallback, handle, name, onHover, onSelect }) => /* @__PURE__ */ React.createElement("dd", { className: cx(styles$15.mention, selected && mentionTheme(theme)), onMouseOver: onHover, onClick: onSelect }, /* @__PURE__ */ React.createElement(
  Avatar,
  {
    url: avatar,
    themeModifier: avatarThemeModifier,
    name,
    theme: avatarTheme2,
    size: "extraSmall",
    fallback: avatarFallback,
    round: true
  }
), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("strong", null, /* @__PURE__ */ React.createElement(SmallText, null, handle)), /* @__PURE__ */ React.createElement(SmallText, { className: styles$15.name }, name)));
MentionOption.propTypes = {
  selected: PropTypes.bool,
  avatar: PropTypes.string,
  avatarFallback: PropTypes.oneOf(["", "icon", "initials"]),
  handle: PropTypes.string.isRequired,
  name: PropTypes.string,
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "tertiary", "info"]),
  avatarTheme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "tertiary", "info"]),
  avatarThemeModifier: PropTypes.oneOf(["", "light", "dark"]),
  onHover: PropTypes.func,
  onSelect: PropTypes.func
};
MentionOption.defaultProps = {
  avatarFallback: "initials",
  avatarTheme: "primary",
  avatarThemeModifier: "dark"
};
const styles$14 = {
  wrapper: css({
    position: "relative"
  })
};
const handleMention = (WrappedComponent) => {
  class HandleMention extends Component {
    constructor() {
      super(...arguments);
      // eslint-disable-next-line react/state-in-constructor
      __publicField(this, "state", {
        hovering: false,
        mentioning: false,
        activeMention: null,
        filteredMentions: this.props.mentionList,
        selectedMention: 0,
        cursorPosition: 0
      });
      __publicField(this, "filterMentions", (activeMention) => {
        if (!activeMention)
          return this.props.mentionList;
        const active = activeMention.toLowerCase();
        const filtered = this.props.mentionList.filter(
          ({ handle, name }) => handle.toLowerCase().startsWith(active) || name.toLowerCase().startsWith(active)
        );
        return filtered;
      });
      __publicField(this, "toggleMentions", (ev) => {
        this.setState({ hovering: false });
        const textarea = ev.target;
        const { value } = textarea;
        const cursorPosition = textarea.selectionEnd;
        this.setState({ cursorPosition });
        const mentionSelection = value.substring(0, textarea.selectionEnd);
        const mentioning = /(^|\s)@[\w|.]*$/.test(mentionSelection);
        const mentionExecution = /@([a-z|A-Z][\w|.]*)$/.exec(mentionSelection);
        const activeMention = mentionExecution ? mentionExecution[1] : null;
        const filteredMentions = this.filterMentions(activeMention);
        if (mentioning && filteredMentions.length === 0) {
          this.setState({
            mentioning: false,
            activeMention: null,
            selectedMention: 0,
            filteredMentions: this.props.mentionList
          });
        } else {
          this.setState({
            mentioning,
            activeMention,
            selectedMention: 0,
            filteredMentions
          });
        }
        const handler = this.props.input.onChange || this.props.onChange;
        if (handler)
          handler(ev);
      });
      __publicField(this, "navigateMentions", (ev) => {
        this.setState({ hovering: false });
        if (this.props.onKeyDown)
          this.props.onKeyDown(ev, ev.target.value);
        if (!this.state.mentioning)
          return;
        const textarea = ev.target;
        if (textarea.selectionStart !== textarea.selectionEnd) {
          this.setState({
            mentioning: false,
            activeMention: null,
            selectedMention: 0,
            filteredMentions: this.props.mentionList,
            cursorPosition: 0
          });
          return;
        }
        const key = ev.which;
        if (!specialKeyPressed(ev) && [9, 38, 40, 13].includes(key)) {
          ev.preventDefault();
          const { selectedMention, filteredMentions } = this.state;
          if (key === 9 || key === 13) {
            this.insertMention(filteredMentions[selectedMention].handle);
            return;
          }
          let newSelected = 0;
          if (key === 38) {
            newSelected = selectedMention > 0 ? selectedMention - 1 : 0;
          } else {
            newSelected = selectedMention < filteredMentions.length - 1 ? selectedMention + 1 : filteredMentions.length - 1;
          }
          this.setState({ selectedMention: newSelected });
          if (selectedMention !== newSelected && this.menu && this.menu.scrollHeight > this.menu.offsetHeight) {
            const selectedOption = this.menu.children[newSelected];
            const visibleArea = this.menu.scrollTop + this.menu.offsetHeight;
            if (selectedOption.offsetTop < this.menu.scrollTop) {
              selectedOption.scrollIntoView();
            } else if (selectedOption.offsetTop + selectedOption.offsetHeight > visibleArea) {
              this.menu.scrollTo({ top: this.menu.scrollTop + selectedOption.offsetHeight });
            }
          }
        }
      });
      __publicField(this, "insertMention", (mention) => {
        const { activeMention, cursorPosition } = this.state;
        const message2 = this.props.input.value || this.props.value;
        if (!message2)
          return;
        const typedMention = activeMention || "";
        const mentionPortion = message2.substring(0, cursorPosition);
        const newPortion = mentionPortion.replace(new RegExp(`@${typedMention}$`), `@${mention}`);
        const newMessage = `${newPortion} ${message2.substring(cursorPosition)}`;
        const changeHandler = this.props.input.onChange || this.props.onChange;
        if (changeHandler)
          changeHandler(newMessage);
        const newCursorPosition = cursorPosition + (mention.length - typedMention.length + 1);
        this.setState({
          mentioning: false,
          activeMention: null,
          selectedMention: 0,
          filteredMentions: this.props.mentionList,
          cursorPosition: newCursorPosition
        });
        this.textarea.focus();
      });
      __publicField(this, "onMentionHovered", (handle) => {
        if (!this.state.hovering)
          return;
        const selectedIndex = this.state.filteredMentions.findIndex((mention) => mention.handle === handle);
        this.setState({ selectedMention: selectedIndex > -1 ? selectedIndex : 0 });
      });
    }
    componentDidUpdate(prevProps) {
      const message2 = this.props.input.value || this.props.value;
      const prevMessage = prevProps.input.value || prevProps.value;
      const { cursorPosition } = this.state;
      if (prevMessage !== message2) {
        this.textarea.setSelectionRange(cursorPosition, cursorPosition);
      }
    }
    render() {
      const { mentioning, filteredMentions, selectedMention } = this.state;
      const { className, input, mentionList, menuPosition, menuTheme, ...props } = this.props;
      const componentProps = Object.keys(input).length > 0 ? {
        input: { ...input, onChange: this.toggleMentions }
      } : {
        onChange: this.toggleMentions
      };
      const selectedHandle = filteredMentions && filteredMentions.length > 0 ? filteredMentions[selectedMention].handle : null;
      return /* @__PURE__ */ React.createElement("div", { className: cx(styles$14.wrapper, className) }, /* @__PURE__ */ React.createElement(
        WrappedComponent,
        {
          ...props,
          ...componentProps,
          handlerRef: (el) => this.textarea = el,
          onKeyDown: this.navigateMentions
        }
      ), Boolean(mentioning) && /* @__PURE__ */ React.createElement(
        MentionMenu,
        {
          position: menuPosition,
          theme: menuTheme,
          menuRef: (el) => this.menu = el,
          selectedHandle,
          onHover: () => this.setState({ hovering: true }),
          onOptionHover: this.onMentionHovered,
          onOptionSelect: this.insertMention
        },
        filteredMentions.map(
          (mention) => mention.accountManager ? /* @__PURE__ */ React.createElement(
            MentionOption,
            {
              key: mention.handle,
              avatar: mention.avatar,
              avatarFallback: "icon",
              avatarTheme: "success",
              avatarThemeModifier: "dark",
              handle: mention.handle,
              name: `${mention.name} (OfferZen)`
            }
          ) : /* @__PURE__ */ React.createElement(MentionOption, { key: mention.handle, avatar: mention.avatar, handle: mention.handle, name: mention.name })
        )
      ));
    }
  }
  HandleMention.propTypes = {
    mentionList: PropTypes.PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    menuPosition: PropTypes.oneOf(["", "bottom", "top"]),
    menuTheme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "light", "dark", "tertiary", "info"]),
    input: PropTypes.shape({
      value: PropTypes.string,
      onChange: PropTypes.func
    }),
    value: PropTypes.string,
    className: PropTypes.string,
    onChange: PropTypes.func,
    onKeyDown: PropTypes.func
  };
  HandleMention.defaultProps = {
    menuPosition: "top",
    menuTheme: "primary"
  };
  HandleMention.displayName = `HandleMention(${WrappedComponent.displayName || WrappedComponent.name || "Component"})`;
  return HandleMention;
};
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++) {
    key = sourceKeys[i2];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf(o, p);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
const config = {
  disabled: false
};
var timeoutsShape = process$1.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null;
process$1.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;
const TransitionGroupContext = React.createContext(null);
var forceReflow = function forceReflow2(node2) {
  return node2.scrollTop;
};
var UNMOUNTED = "unmounted";
var EXITED = "exited";
var ENTERING = "entering";
var ENTERED = "entered";
var EXITING = "exiting";
var Transition = /* @__PURE__ */ function(_React$Component) {
  _inheritsLoose(Transition2, _React$Component);
  function Transition2(props, context) {
    var _this;
    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context;
    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;
    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }
    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }
  Transition2.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;
    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }
    return null;
  };
  var _proto = Transition2.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;
    if (prevProps !== this.props) {
      var status = this.state.status;
      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }
    this.updateStatus(false, nextStatus);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };
  _proto.getTimeouts = function getTimeouts() {
    var timeout2 = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout2;
    if (timeout2 != null && typeof timeout2 !== "number") {
      exit = timeout2.exit;
      enter = timeout2.enter;
      appear = timeout2.appear !== void 0 ? timeout2.appear : enter;
    }
    return {
      exit,
      enter,
      appear
    };
  };
  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }
    if (nextStatus !== null) {
      this.cancelNextCallback();
      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node2 = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this);
          if (node2)
            forceReflow(node2);
        }
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };
  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;
    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;
    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM.findDOMNode(this), appearing], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter;
    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function() {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }
    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function() {
      _this2.props.onEntering(maybeNode, maybeAppearing);
      _this2.onTransitionEnd(enterTimeout, function() {
        _this2.safeSetState({
          status: ENTERED
        }, function() {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };
  _proto.performExit = function performExit() {
    var _this3 = this;
    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? void 0 : ReactDOM.findDOMNode(this);
    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function() {
        _this3.props.onExited(maybeNode);
      });
      return;
    }
    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function() {
      _this3.props.onExiting(maybeNode);
      _this3.onTransitionEnd(timeouts.exit, function() {
        _this3.safeSetState({
          status: EXITED
        }, function() {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };
  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };
  _proto.safeSetState = function safeSetState(nextState, callback) {
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };
  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;
    var active = true;
    this.nextCallback = function(event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };
    this.nextCallback.cancel = function() {
      active = false;
    };
    return this.nextCallback;
  };
  _proto.onTransitionEnd = function onTransitionEnd(timeout2, handler) {
    this.setNextCallback(handler);
    var node2 = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout2 == null && !this.props.addEndListener;
    if (!node2 || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node2, this.nextCallback], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
      this.props.addEndListener(maybeNode, maybeNextCallback);
    }
    if (timeout2 != null) {
      setTimeout(this.nextCallback, timeout2);
    }
  };
  _proto.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }
    var _this$props = this.props, children = _this$props.children;
    _this$props.in;
    _this$props.mountOnEnter;
    _this$props.unmountOnExit;
    _this$props.appear;
    _this$props.enter;
    _this$props.exit;
    _this$props.timeout;
    _this$props.addEndListener;
    _this$props.onEnter;
    _this$props.onEntering;
    _this$props.onEntered;
    _this$props.onExit;
    _this$props.onExiting;
    _this$props.onExited;
    _this$props.nodeRef;
    var childProps = _objectWithoutPropertiesLoose(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ React.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === "function" ? children(status, childProps) : React.cloneElement(React.Children.only(children), childProps))
    );
  };
  return Transition2;
}(React.Component);
Transition.contextType = TransitionGroupContext;
Transition.propTypes = process$1.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element === "undefined" ? PropTypes.any : function(propValue, key, componentName, location, propFullName, secret) {
      var value = propValue[key];
      return PropTypes.instanceOf(value && "ownerDocument" in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener)
      pt = pt.isRequired;
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return pt.apply(void 0, [props].concat(args));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {};
function noop() {
}
Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
const styles$13 = {
  wrapper: css({
    position: "fixed",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: zIndex.level9,
    backgroundColor: hexToRgba(colors.oxfordBlue, 0.5),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "opacity 0.2s",
    overflowY: "auto",
    padding: spacing.large,
    [mediaQueryHelper(breakpoint.tablet)]: {
      padding: shorthandHelper([spacing.large, spacing.extraLarge])
    },
    // IE 11 adjustments
    "@media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none)": {
      display: "block"
    }
  }),
  overlay: css({
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: zIndex.level8
  }),
  container: css({
    position: "relative",
    backgroundColor: colors.white,
    margin: "auto",
    borderRadius: borderRadius.default,
    boxShadow: `1px 1px 5px ${hexToRgba(colors.black, 0.1)}`,
    zIndex: zIndex.level9,
    transition: "top 0.3s"
  }),
  icon: css({
    // override default button styles
    border: "none",
    margin: 0,
    textDecoration: "none",
    background: "none",
    cursor: "pointer",
    position: "absolute",
    top: 0,
    right: 0,
    padding: spacing.default,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }),
  accessiblyHidden: css(accessiblyHidden)
};
const wrapperTransition$2 = (status) => {
  switch (status) {
    case "entering":
      return css({
        opacity: 0
      });
    case "entered":
      return css({
        opacity: 1
      });
    case "exiting":
    case "exited":
      return css({
        opacity: 0
      });
    default:
      return css();
  }
};
const containerSize = (size2) => {
  switch (size2) {
    case "small":
      return css({
        width: 310
      });
    case "medium":
      return css({
        width: 760
      });
    case "large":
      return css({
        width: 1092
      });
    default:
      return css({
        width: 520
      });
  }
};
const containerTransition$1 = (status) => {
  switch (status) {
    case "entering":
      return css({
        top: -20
      });
    case "entered":
      return css({
        top: 0
      });
    case "exiting":
    case "exited":
      return css({
        top: -20
      });
    default:
      return css();
  }
};
const Modal = ({ children, className, onModalClose, visible, preventClose, hideModal, size: size2 = "default" }) => {
  const handleHideModal = () => {
    if (!preventClose)
      hideModal();
  };
  return /* @__PURE__ */ React.createElement(Transition, { in: visible, timeout: { enter: 0, exit: 300 }, mountOnEnter: true, unmountOnExit: true, onExited: onModalClose }, (status) => /* @__PURE__ */ React.createElement("div", { className: cx(styles$13.wrapper, className, wrapperTransition$2(status)) }, /* @__PURE__ */ React.createElement("div", { className: styles$13.overlay, onClick: handleHideModal }), /* @__PURE__ */ React.createElement("div", { className: cx(styles$13.container, containerSize(size2), containerTransition$1(status)) }, /* @__PURE__ */ React.createElement("button", { type: "button", className: styles$13.icon, onClick: handleHideModal }, /* @__PURE__ */ React.createElement(AccessibleIcon, { icon: t$7, color: colors.grayChateau, size: 20 }), /* @__PURE__ */ React.createElement("span", { className: styles$13.accessiblyHidden }, "Close")), Boolean(children) && /* @__PURE__ */ React.createElement(LockScroll, { locked: visible }, children({ hideModal: handleHideModal })))));
};
Modal.propTypes = {
  size: PropTypes.oneOf(["", "default", "small", "medium", "large"]),
  onModalClose: PropTypes.func,
  preventClose: PropTypes.bool,
  children: PropTypes.func.isRequired,
  className: PropTypes.string,
  visible: PropTypes.bool.isRequired,
  hideModal: PropTypes.func.isRequired
};
const styles$12 = {
  body: css({
    padding: spacing.medium
  })
};
const ModalBody = ({ className, children }) => /* @__PURE__ */ React.createElement("div", { className: cx(styles$12.body, className) }, children);
ModalBody.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};
const styles$11 = {
  footer: css({
    marginTop: spacing.medium,
    display: "flex"
  }),
  actions: css({
    alignSelf: "stretch",
    "& > *": {
      width: "100%"
    }
  })
};
const footerSize = (size2) => {
  switch (size2) {
    case "medium":
    case "large":
      return css({
        flexDirection: "row-reverse",
        justifyContent: "space-between",
        alignItems: "flex-end",
        "& > * + *": {
          marginRight: spacing.default
        }
      });
    default:
      return css({
        flexDirection: "column",
        alignItems: "center",
        "& > * + *": {
          marginTop: spacing.default
        }
      });
  }
};
const ModalFooter = ({ size: size2, children, onCancel, className }) => /* @__PURE__ */ React.createElement("div", { className: cx(styles$11.footer, className, footerSize(size2)) }, /* @__PURE__ */ React.createElement("div", { className: styles$11.actions }, children), Boolean(onCancel) && /* @__PURE__ */ React.createElement(ButtonLink, { theme: "light", label: "Cancel", onClick: onCancel }));
ModalFooter.propTypes = {
  size: PropTypes.oneOf(["", "default", "small", "medium", "large"]),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  onCancel: PropTypes.func,
  className: PropTypes.string
};
ModalFooter.defaultProps = {
  size: "default"
};
const styles$10 = {
  wrapper: css({
    fontFamily: fontFamily.heading,
    fontSize: fontSize.medium,
    fontWeight: "inherit",
    lineHeight: 1.2,
    color: colors.oxfordBlue,
    margin: 0
  })
};
const Heading = ({ className, children }) => /* @__PURE__ */ React.createElement("h1", { className: cx(styles$10.wrapper, className) }, children);
Heading.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string
};
const styles$$ = {
  header: css({
    padding: shorthandHelper([spacing.default, 44, spacing.default, spacing.medium]),
    borderBottom: `1px solid ${colors.catskillWhite}`
  })
};
const ModalHeader = ({ text, className }) => /* @__PURE__ */ React.createElement(Heading, { className: cx(styles$$.header, className) }, text);
ModalHeader.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  className: PropTypes.string
};
const styles$_ = {
  wrapper: css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    padding: shorthandHelper([spacing.medium, 44]),
    borderBottom: `1px solid ${colors.catskillWhite}`
  }),
  image: css({
    maxHeight: 90,
    marginBottom: spacing.small
  })
};
const ModalImageHeader = ({ imageLoader, imageWidth, text }) => /* @__PURE__ */ React.createElement("div", { className: styles$_.wrapper }, /* @__PURE__ */ React.createElement(LazyImage, { loader: imageLoader, alt: text, width: imageWidth, className: styles$_.image }), /* @__PURE__ */ React.createElement(Heading, null, /* @__PURE__ */ React.createElement("strong", null, text)));
ModalImageHeader.propTypes = {
  imageLoader: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  imageWidth: PropTypes.number
};
var baseGetTag$3 = _baseGetTag, isObject$2 = isObject_1;
var asyncTag = "[object AsyncFunction]", funcTag$1 = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction$2(value) {
  if (!isObject$2(value)) {
    return false;
  }
  var tag = baseGetTag$3(value);
  return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
}
var isFunction_1 = isFunction$2;
var root$6 = _root;
var coreJsData$1 = root$6["__core-js_shared__"];
var _coreJsData = coreJsData$1;
var coreJsData = _coreJsData;
var maskSrcKey = function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
}();
function isMasked$1(func2) {
  return !!maskSrcKey && maskSrcKey in func2;
}
var _isMasked = isMasked$1;
var funcProto$1 = Function.prototype;
var funcToString$1 = funcProto$1.toString;
function toSource$2(func2) {
  if (func2 != null) {
    try {
      return funcToString$1.call(func2);
    } catch (e) {
    }
    try {
      return func2 + "";
    } catch (e) {
    }
  }
  return "";
}
var _toSource = toSource$2;
var isFunction$1 = isFunction_1, isMasked = _isMasked, isObject$1 = isObject_1, toSource$1 = _toSource;
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var funcProto = Function.prototype, objectProto$9 = Object.prototype;
var funcToString = funcProto.toString;
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;
var reIsNative = RegExp(
  "^" + funcToString.call(hasOwnProperty$7).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative$1(value) {
  if (!isObject$1(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource$1(value));
}
var _baseIsNative = baseIsNative$1;
function getValue$1(object, key) {
  return object == null ? void 0 : object[key];
}
var _getValue = getValue$1;
var baseIsNative = _baseIsNative, getValue = _getValue;
function getNative$7(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : void 0;
}
var _getNative = getNative$7;
var getNative$6 = _getNative;
var nativeCreate$4 = getNative$6(Object, "create");
var _nativeCreate = nativeCreate$4;
var nativeCreate$3 = _nativeCreate;
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {};
  this.size = 0;
}
var _hashClear = hashClear$1;
function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}
var _hashDelete = hashDelete$1;
var nativeCreate$2 = _nativeCreate;
var HASH_UNDEFINED$2 = "__lodash_hash_undefined__";
var objectProto$8 = Object.prototype;
var hasOwnProperty$6 = objectProto$8.hasOwnProperty;
function hashGet$1(key) {
  var data = this.__data__;
  if (nativeCreate$2) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? void 0 : result;
  }
  return hasOwnProperty$6.call(data, key) ? data[key] : void 0;
}
var _hashGet = hashGet$1;
var nativeCreate$1 = _nativeCreate;
var objectProto$7 = Object.prototype;
var hasOwnProperty$5 = objectProto$7.hasOwnProperty;
function hashHas$1(key) {
  var data = this.__data__;
  return nativeCreate$1 ? data[key] !== void 0 : hasOwnProperty$5.call(data, key);
}
var _hashHas = hashHas$1;
var nativeCreate = _nativeCreate;
var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet$1(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED$1 : value;
  return this;
}
var _hashSet = hashSet$1;
var hashClear = _hashClear, hashDelete = _hashDelete, hashGet = _hashGet, hashHas = _hashHas, hashSet = _hashSet;
function Hash$1(entries) {
  var index = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
Hash$1.prototype.clear = hashClear;
Hash$1.prototype["delete"] = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;
var _Hash = Hash$1;
function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}
var _listCacheClear = listCacheClear$1;
function eq$2(value, other) {
  return value === other || value !== value && other !== other;
}
var eq_1 = eq$2;
var eq$1 = eq_1;
function assocIndexOf$4(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}
var _assocIndexOf = assocIndexOf$4;
var assocIndexOf$3 = _assocIndexOf;
var arrayProto = Array.prototype;
var splice = arrayProto.splice;
function listCacheDelete$1(key) {
  var data = this.__data__, index = assocIndexOf$3(data, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}
var _listCacheDelete = listCacheDelete$1;
var assocIndexOf$2 = _assocIndexOf;
function listCacheGet$1(key) {
  var data = this.__data__, index = assocIndexOf$2(data, key);
  return index < 0 ? void 0 : data[index][1];
}
var _listCacheGet = listCacheGet$1;
var assocIndexOf$1 = _assocIndexOf;
function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}
var _listCacheHas = listCacheHas$1;
var assocIndexOf = _assocIndexOf;
function listCacheSet$1(key, value) {
  var data = this.__data__, index = assocIndexOf(data, key);
  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}
var _listCacheSet = listCacheSet$1;
var listCacheClear = _listCacheClear, listCacheDelete = _listCacheDelete, listCacheGet = _listCacheGet, listCacheHas = _listCacheHas, listCacheSet = _listCacheSet;
function ListCache$4(entries) {
  var index = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype["delete"] = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;
var _ListCache = ListCache$4;
var getNative$5 = _getNative, root$5 = _root;
var Map$4 = getNative$5(root$5, "Map");
var _Map = Map$4;
var Hash = _Hash, ListCache$3 = _ListCache, Map$3 = _Map;
function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    "hash": new Hash(),
    "map": new (Map$3 || ListCache$3)(),
    "string": new Hash()
  };
}
var _mapCacheClear = mapCacheClear$1;
function isKeyable$1(value) {
  var type2 = typeof value;
  return type2 == "string" || type2 == "number" || type2 == "symbol" || type2 == "boolean" ? value !== "__proto__" : value === null;
}
var _isKeyable = isKeyable$1;
var isKeyable = _isKeyable;
function getMapData$4(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
var _getMapData = getMapData$4;
var getMapData$3 = _getMapData;
function mapCacheDelete$1(key) {
  var result = getMapData$3(this, key)["delete"](key);
  this.size -= result ? 1 : 0;
  return result;
}
var _mapCacheDelete = mapCacheDelete$1;
var getMapData$2 = _getMapData;
function mapCacheGet$1(key) {
  return getMapData$2(this, key).get(key);
}
var _mapCacheGet = mapCacheGet$1;
var getMapData$1 = _getMapData;
function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}
var _mapCacheHas = mapCacheHas$1;
var getMapData = _getMapData;
function mapCacheSet$1(key, value) {
  var data = getMapData(this, key), size2 = data.size;
  data.set(key, value);
  this.size += data.size == size2 ? 0 : 1;
  return this;
}
var _mapCacheSet = mapCacheSet$1;
var mapCacheClear = _mapCacheClear, mapCacheDelete = _mapCacheDelete, mapCacheGet = _mapCacheGet, mapCacheHas = _mapCacheHas, mapCacheSet = _mapCacheSet;
function MapCache$3(entries) {
  var index = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
MapCache$3.prototype.clear = mapCacheClear;
MapCache$3.prototype["delete"] = mapCacheDelete;
MapCache$3.prototype.get = mapCacheGet;
MapCache$3.prototype.has = mapCacheHas;
MapCache$3.prototype.set = mapCacheSet;
var _MapCache = MapCache$3;
var HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd$1(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}
var _setCacheAdd = setCacheAdd$1;
function setCacheHas$1(value) {
  return this.__data__.has(value);
}
var _setCacheHas = setCacheHas$1;
var MapCache$2 = _MapCache, setCacheAdd = _setCacheAdd, setCacheHas = _setCacheHas;
function SetCache$2(values) {
  var index = -1, length = values == null ? 0 : values.length;
  this.__data__ = new MapCache$2();
  while (++index < length) {
    this.add(values[index]);
  }
}
SetCache$2.prototype.add = SetCache$2.prototype.push = setCacheAdd;
SetCache$2.prototype.has = setCacheHas;
var _SetCache = SetCache$2;
function baseFindIndex$1(array, predicate, fromIndex, fromRight) {
  var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
  while (fromRight ? index-- : ++index < length) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}
var _baseFindIndex = baseFindIndex$1;
function baseIsNaN$1(value) {
  return value !== value;
}
var _baseIsNaN = baseIsNaN$1;
function strictIndexOf$1(array, value, fromIndex) {
  var index = fromIndex - 1, length = array.length;
  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}
var _strictIndexOf = strictIndexOf$1;
var baseFindIndex = _baseFindIndex, baseIsNaN = _baseIsNaN, strictIndexOf = _strictIndexOf;
function baseIndexOf$1(array, value, fromIndex) {
  return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
}
var _baseIndexOf = baseIndexOf$1;
var baseIndexOf = _baseIndexOf;
function arrayIncludes$1(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}
var _arrayIncludes = arrayIncludes$1;
function arrayIncludesWith$1(array, value, comparator) {
  var index = -1, length = array == null ? 0 : array.length;
  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}
var _arrayIncludesWith = arrayIncludesWith$1;
function baseUnary$3(func2) {
  return function(value) {
    return func2(value);
  };
}
var _baseUnary = baseUnary$3;
function cacheHas$2(cache, key) {
  return cache.has(key);
}
var _cacheHas = cacheHas$2;
var SetCache$1 = _SetCache, arrayIncludes = _arrayIncludes, arrayIncludesWith = _arrayIncludesWith, arrayMap$1 = _arrayMap, baseUnary$2 = _baseUnary, cacheHas$1 = _cacheHas;
var LARGE_ARRAY_SIZE$1 = 200;
function baseDifference$1(array, values, iteratee, comparator) {
  var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap$1(values, baseUnary$2(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  } else if (values.length >= LARGE_ARRAY_SIZE$1) {
    includes = cacheHas$1;
    isCommon = false;
    values = new SetCache$1(values);
  }
  outer:
    while (++index < length) {
      var value = array[index], computed = iteratee == null ? value : iteratee(value);
      value = comparator || value !== 0 ? value : 0;
      if (isCommon && computed === computed) {
        var valuesIndex = valuesLength;
        while (valuesIndex--) {
          if (values[valuesIndex] === computed) {
            continue outer;
          }
        }
        result.push(value);
      } else if (!includes(values, computed, comparator)) {
        result.push(value);
      }
    }
  return result;
}
var _baseDifference = baseDifference$1;
function arrayPush$2(array, values) {
  var index = -1, length = values.length, offset = array.length;
  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}
var _arrayPush = arrayPush$2;
var baseGetTag$2 = _baseGetTag, isObjectLike$4 = isObjectLike_1;
var argsTag$2 = "[object Arguments]";
function baseIsArguments$1(value) {
  return isObjectLike$4(value) && baseGetTag$2(value) == argsTag$2;
}
var _baseIsArguments = baseIsArguments$1;
var baseIsArguments = _baseIsArguments, isObjectLike$3 = isObjectLike_1;
var objectProto$6 = Object.prototype;
var hasOwnProperty$4 = objectProto$6.hasOwnProperty;
var propertyIsEnumerable$1 = objectProto$6.propertyIsEnumerable;
var isArguments$3 = baseIsArguments(/* @__PURE__ */ function() {
  return arguments;
}()) ? baseIsArguments : function(value) {
  return isObjectLike$3(value) && hasOwnProperty$4.call(value, "callee") && !propertyIsEnumerable$1.call(value, "callee");
};
var isArguments_1 = isArguments$3;
var Symbol$2 = _Symbol, isArguments$2 = isArguments_1, isArray$d = isArray_1;
var spreadableSymbol = Symbol$2 ? Symbol$2.isConcatSpreadable : void 0;
function isFlattenable$1(value) {
  return isArray$d(value) || isArguments$2(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}
var _isFlattenable = isFlattenable$1;
var arrayPush$1 = _arrayPush, isFlattenable = _isFlattenable;
function baseFlatten$1(array, depth, predicate, isStrict, result) {
  var index = -1, length = array.length;
  predicate || (predicate = isFlattenable);
  result || (result = []);
  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        baseFlatten$1(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush$1(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}
var _baseFlatten = baseFlatten$1;
var ListCache$2 = _ListCache;
function stackClear$1() {
  this.__data__ = new ListCache$2();
  this.size = 0;
}
var _stackClear = stackClear$1;
function stackDelete$1(key) {
  var data = this.__data__, result = data["delete"](key);
  this.size = data.size;
  return result;
}
var _stackDelete = stackDelete$1;
function stackGet$1(key) {
  return this.__data__.get(key);
}
var _stackGet = stackGet$1;
function stackHas$1(key) {
  return this.__data__.has(key);
}
var _stackHas = stackHas$1;
var ListCache$1 = _ListCache, Map$2 = _Map, MapCache$1 = _MapCache;
var LARGE_ARRAY_SIZE = 200;
function stackSet$1(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache$1) {
    var pairs = data.__data__;
    if (!Map$2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache$1(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}
var _stackSet = stackSet$1;
var ListCache = _ListCache, stackClear = _stackClear, stackDelete = _stackDelete, stackGet = _stackGet, stackHas = _stackHas, stackSet = _stackSet;
function Stack$2(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}
Stack$2.prototype.clear = stackClear;
Stack$2.prototype["delete"] = stackDelete;
Stack$2.prototype.get = stackGet;
Stack$2.prototype.has = stackHas;
Stack$2.prototype.set = stackSet;
var _Stack = Stack$2;
function arraySome$1(array, predicate) {
  var index = -1, length = array == null ? 0 : array.length;
  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}
var _arraySome = arraySome$1;
var SetCache = _SetCache, arraySome = _arraySome, cacheHas = _cacheHas;
var COMPARE_PARTIAL_FLAG$5 = 1, COMPARE_UNORDERED_FLAG$3 = 2;
function equalArrays$2(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5, arrLength = array.length, othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG$3 ? new SetCache() : void 0;
  stack.set(array, other);
  stack.set(other, array);
  while (++index < arrLength) {
    var arrValue = array[index], othValue = other[index];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== void 0) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    if (seen) {
      if (!arraySome(other, function(othValue2, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack["delete"](array);
  stack["delete"](other);
  return result;
}
var _equalArrays = equalArrays$2;
var root$4 = _root;
var Uint8Array$2 = root$4.Uint8Array;
var _Uint8Array = Uint8Array$2;
function mapToArray$1(map) {
  var index = -1, result = Array(map.size);
  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}
var _mapToArray = mapToArray$1;
function setToArray$1(set) {
  var index = -1, result = Array(set.size);
  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}
var _setToArray = setToArray$1;
var Symbol$1 = _Symbol, Uint8Array$1 = _Uint8Array, eq = eq_1, equalArrays$1 = _equalArrays, mapToArray = _mapToArray, setToArray = _setToArray;
var COMPARE_PARTIAL_FLAG$4 = 1, COMPARE_UNORDERED_FLAG$2 = 2;
var boolTag$1 = "[object Boolean]", dateTag$1 = "[object Date]", errorTag$1 = "[object Error]", mapTag$2 = "[object Map]", numberTag$1 = "[object Number]", regexpTag$1 = "[object RegExp]", setTag$2 = "[object Set]", stringTag$1 = "[object String]", symbolTag = "[object Symbol]";
var arrayBufferTag$1 = "[object ArrayBuffer]", dataViewTag$2 = "[object DataView]";
var symbolProto = Symbol$1 ? Symbol$1.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
function equalByTag$1(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$2:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;
    case arrayBufferTag$1:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array$1(object), new Uint8Array$1(other))) {
        return false;
      }
      return true;
    case boolTag$1:
    case dateTag$1:
    case numberTag$1:
      return eq(+object, +other);
    case errorTag$1:
      return object.name == other.name && object.message == other.message;
    case regexpTag$1:
    case stringTag$1:
      return object == other + "";
    case mapTag$2:
      var convert = mapToArray;
    case setTag$2:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert || (convert = setToArray);
      if (object.size != other.size && !isPartial) {
        return false;
      }
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;
      stack.set(object, other);
      var result = equalArrays$1(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack["delete"](object);
      return result;
    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}
var _equalByTag = equalByTag$1;
var arrayPush = _arrayPush, isArray$c = isArray_1;
function baseGetAllKeys$1(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$c(object) ? result : arrayPush(result, symbolsFunc(object));
}
var _baseGetAllKeys = baseGetAllKeys$1;
function arrayFilter$1(array, predicate) {
  var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}
var _arrayFilter = arrayFilter$1;
function stubArray$1() {
  return [];
}
var stubArray_1 = stubArray$1;
var arrayFilter = _arrayFilter, stubArray = stubArray_1;
var objectProto$5 = Object.prototype;
var propertyIsEnumerable = objectProto$5.propertyIsEnumerable;
var nativeGetSymbols = Object.getOwnPropertySymbols;
var getSymbols$1 = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};
var _getSymbols = getSymbols$1;
function baseTimes$1(n2, iteratee) {
  var index = -1, result = Array(n2);
  while (++index < n2) {
    result[index] = iteratee(index);
  }
  return result;
}
var _baseTimes = baseTimes$1;
var isBuffer$3 = { exports: {} };
function stubFalse() {
  return false;
}
var stubFalse_1 = stubFalse;
isBuffer$3.exports;
(function(module, exports) {
  var root2 = _root, stubFalse2 = stubFalse_1;
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var Buffer2 = moduleExports ? root2.Buffer : void 0;
  var nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : void 0;
  var isBuffer3 = nativeIsBuffer || stubFalse2;
  module.exports = isBuffer3;
})(isBuffer$3, isBuffer$3.exports);
var isBufferExports = isBuffer$3.exports;
var MAX_SAFE_INTEGER$1 = 9007199254740991;
var reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex$2(value, length) {
  var type2 = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;
  return !!length && (type2 == "number" || type2 != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
}
var _isIndex = isIndex$2;
var MAX_SAFE_INTEGER = 9007199254740991;
function isLength$3(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
var isLength_1 = isLength$3;
var baseGetTag$1 = _baseGetTag, isLength$2 = isLength_1, isObjectLike$2 = isObjectLike_1;
var argsTag$1 = "[object Arguments]", arrayTag$1 = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", mapTag$1 = "[object Map]", numberTag = "[object Number]", objectTag$2 = "[object Object]", regexpTag = "[object RegExp]", setTag$1 = "[object Set]", stringTag = "[object String]", weakMapTag$1 = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag$1 = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag$1] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag$1] = typedArrayTags[numberTag] = typedArrayTags[objectTag$2] = typedArrayTags[regexpTag] = typedArrayTags[setTag$1] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag$1] = false;
function baseIsTypedArray$1(value) {
  return isObjectLike$2(value) && isLength$2(value.length) && !!typedArrayTags[baseGetTag$1(value)];
}
var _baseIsTypedArray = baseIsTypedArray$1;
var _nodeUtil = { exports: {} };
_nodeUtil.exports;
(function(module, exports) {
  var freeGlobal2 = _freeGlobal;
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var freeProcess = moduleExports && freeGlobal2.process;
  var nodeUtil2 = function() {
    try {
      var types = freeModule && freeModule.require && freeModule.require("util").types;
      if (types) {
        return types;
      }
      return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {
    }
  }();
  module.exports = nodeUtil2;
})(_nodeUtil, _nodeUtil.exports);
var _nodeUtilExports = _nodeUtil.exports;
var baseIsTypedArray = _baseIsTypedArray, baseUnary$1 = _baseUnary, nodeUtil = _nodeUtilExports;
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
var isTypedArray$2 = nodeIsTypedArray ? baseUnary$1(nodeIsTypedArray) : baseIsTypedArray;
var isTypedArray_1 = isTypedArray$2;
var baseTimes = _baseTimes, isArguments$1 = isArguments_1, isArray$b = isArray_1, isBuffer$2 = isBufferExports, isIndex$1 = _isIndex, isTypedArray$1 = isTypedArray_1;
var objectProto$4 = Object.prototype;
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;
function arrayLikeKeys$1(value, inherited) {
  var isArr = isArray$b(value), isArg = !isArr && isArguments$1(value), isBuff = !isArr && !isArg && isBuffer$2(value), isType = !isArr && !isArg && !isBuff && isTypedArray$1(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty$3.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex$1(key, length)))) {
      result.push(key);
    }
  }
  return result;
}
var _arrayLikeKeys = arrayLikeKeys$1;
var objectProto$3 = Object.prototype;
function isPrototype$1(value) {
  var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto$3;
  return value === proto;
}
var _isPrototype = isPrototype$1;
function overArg$1(func2, transform) {
  return function(arg) {
    return func2(transform(arg));
  };
}
var _overArg = overArg$1;
var overArg = _overArg;
var nativeKeys$1 = overArg(Object.keys, Object);
var _nativeKeys = nativeKeys$1;
var isPrototype = _isPrototype, nativeKeys = _nativeKeys;
var objectProto$2 = Object.prototype;
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;
function baseKeys$1(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$2.call(object, key) && key != "constructor") {
      result.push(key);
    }
  }
  return result;
}
var _baseKeys = baseKeys$1;
var isFunction = isFunction_1, isLength$1 = isLength_1;
function isArrayLike$4(value) {
  return value != null && isLength$1(value.length) && !isFunction(value);
}
var isArrayLike_1 = isArrayLike$4;
var arrayLikeKeys = _arrayLikeKeys, baseKeys = _baseKeys, isArrayLike$3 = isArrayLike_1;
function keys$3(object) {
  return isArrayLike$3(object) ? arrayLikeKeys(object) : baseKeys(object);
}
var keys_1 = keys$3;
var baseGetAllKeys = _baseGetAllKeys, getSymbols = _getSymbols, keys$2 = keys_1;
function getAllKeys$1(object) {
  return baseGetAllKeys(object, keys$2, getSymbols);
}
var _getAllKeys = getAllKeys$1;
var getAllKeys = _getAllKeys;
var COMPARE_PARTIAL_FLAG$3 = 1;
var objectProto$1 = Object.prototype;
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;
function equalObjects$1(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$1.call(other, key))) {
      return false;
    }
  }
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);
  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key], othValue = other[key];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    }
    if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == "constructor");
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor, othCtor = other.constructor;
    if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack["delete"](object);
  stack["delete"](other);
  return result;
}
var _equalObjects = equalObjects$1;
var getNative$4 = _getNative, root$3 = _root;
var DataView$2 = getNative$4(root$3, "DataView");
var _DataView = DataView$2;
var getNative$3 = _getNative, root$2 = _root;
var Promise$2 = getNative$3(root$2, "Promise");
var _Promise = Promise$2;
var getNative$2 = _getNative, root$1 = _root;
var Set$2 = getNative$2(root$1, "Set");
var _Set = Set$2;
var getNative$1 = _getNative, root = _root;
var WeakMap$2 = getNative$1(root, "WeakMap");
var _WeakMap = WeakMap$2;
var DataView$1 = _DataView, Map$1 = _Map, Promise$1 = _Promise, Set$1 = _Set, WeakMap$1 = _WeakMap, baseGetTag = _baseGetTag, toSource = _toSource;
var mapTag = "[object Map]", objectTag$1 = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]";
var dataViewTag = "[object DataView]";
var dataViewCtorString = toSource(DataView$1), mapCtorString = toSource(Map$1), promiseCtorString = toSource(Promise$1), setCtorString = toSource(Set$1), weakMapCtorString = toSource(WeakMap$1);
var getTag$1 = baseGetTag;
if (DataView$1 && getTag$1(new DataView$1(new ArrayBuffer(1))) != dataViewTag || Map$1 && getTag$1(new Map$1()) != mapTag || Promise$1 && getTag$1(Promise$1.resolve()) != promiseTag || Set$1 && getTag$1(new Set$1()) != setTag || WeakMap$1 && getTag$1(new WeakMap$1()) != weakMapTag) {
  getTag$1 = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag$1 ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag;
        case mapCtorString:
          return mapTag;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag;
        case weakMapCtorString:
          return weakMapTag;
      }
    }
    return result;
  };
}
var _getTag = getTag$1;
var Stack$1 = _Stack, equalArrays = _equalArrays, equalByTag = _equalByTag, equalObjects = _equalObjects, getTag = _getTag, isArray$a = isArray_1, isBuffer$1 = isBufferExports, isTypedArray = isTypedArray_1;
var COMPARE_PARTIAL_FLAG$2 = 1;
var argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]";
var objectProto = Object.prototype;
var hasOwnProperty = objectProto.hasOwnProperty;
function baseIsEqualDeep$1(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$a(object), othIsArr = isArray$a(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;
  var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
  if (isSameTag && isBuffer$1(object)) {
    if (!isBuffer$1(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack$1());
    return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack$1());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack$1());
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
var _baseIsEqualDeep = baseIsEqualDeep$1;
var baseIsEqualDeep = _baseIsEqualDeep, isObjectLike$1 = isObjectLike_1;
function baseIsEqual$2(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike$1(value) && !isObjectLike$1(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual$2, stack);
}
var _baseIsEqual = baseIsEqual$2;
var Stack = _Stack, baseIsEqual$1 = _baseIsEqual;
var COMPARE_PARTIAL_FLAG$1 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
function baseIsMatch$1(object, source, matchData, customizer) {
  var index = matchData.length, length = index, noCustomizer = !customizer;
  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0], objValue = object[key], srcValue = data[1];
    if (noCustomizer && data[2]) {
      if (objValue === void 0 && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack();
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === void 0 ? baseIsEqual$1(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack) : result)) {
        return false;
      }
    }
  }
  return true;
}
var _baseIsMatch = baseIsMatch$1;
var isObject = isObject_1;
function isStrictComparable$2(value) {
  return value === value && !isObject(value);
}
var _isStrictComparable = isStrictComparable$2;
var isStrictComparable$1 = _isStrictComparable, keys$1 = keys_1;
function getMatchData$1(object) {
  var result = keys$1(object), length = result.length;
  while (length--) {
    var key = result[length], value = object[key];
    result[length] = [key, value, isStrictComparable$1(value)];
  }
  return result;
}
var _getMatchData = getMatchData$1;
function matchesStrictComparable$2(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue && (srcValue !== void 0 || key in Object(object));
  };
}
var _matchesStrictComparable = matchesStrictComparable$2;
var baseIsMatch = _baseIsMatch, getMatchData = _getMatchData, matchesStrictComparable$1 = _matchesStrictComparable;
function baseMatches$1(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable$1(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}
var _baseMatches = baseMatches$1;
var isArray$9 = isArray_1, isSymbol$3 = isSymbol_1;
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
function isKey$3(value, object) {
  if (isArray$9(value)) {
    return false;
  }
  var type2 = typeof value;
  if (type2 == "number" || type2 == "symbol" || type2 == "boolean" || value == null || isSymbol$3(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
var _isKey = isKey$3;
var MapCache = _MapCache;
var FUNC_ERROR_TEXT = "Expected a function";
function memoize$1(func2, resolver) {
  if (typeof func2 != "function" || resolver != null && typeof resolver != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func2.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$1.Cache || MapCache)();
  return memoized;
}
memoize$1.Cache = MapCache;
var memoize_1 = memoize$1;
var memoize = memoize_1;
var MAX_MEMOIZE_SIZE = 500;
function memoizeCapped$1(func2) {
  var result = memoize(func2, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });
  var cache = result.cache;
  return result;
}
var _memoizeCapped = memoizeCapped$1;
var memoizeCapped = _memoizeCapped;
var rePropName$1 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var reEscapeChar$1 = /\\(\\)?/g;
var stringToPath$2 = memoizeCapped(function(string2) {
  var result = [];
  if (string2.charCodeAt(0) === 46) {
    result.push("");
  }
  string2.replace(rePropName$1, function(match2, number2, quote2, subString) {
    result.push(quote2 ? subString.replace(reEscapeChar$1, "$1") : number2 || match2);
  });
  return result;
});
var _stringToPath = stringToPath$2;
var isArray$8 = isArray_1, isKey$2 = _isKey, stringToPath$1 = _stringToPath, toString$1 = toString_1;
function castPath$2(value, object) {
  if (isArray$8(value)) {
    return value;
  }
  return isKey$2(value, object) ? [value] : stringToPath$1(toString$1(value));
}
var _castPath = castPath$2;
var isSymbol$2 = isSymbol_1;
var INFINITY = 1 / 0;
function toKey$4(value) {
  if (typeof value == "string" || isSymbol$2(value)) {
    return value;
  }
  var result = value + "";
  return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
var _toKey = toKey$4;
var castPath$1 = _castPath, toKey$3 = _toKey;
function baseGet$3(object, path) {
  path = castPath$1(path, object);
  var index = 0, length = path.length;
  while (object != null && index < length) {
    object = object[toKey$3(path[index++])];
  }
  return index && index == length ? object : void 0;
}
var _baseGet = baseGet$3;
var baseGet$2 = _baseGet;
function get$1(object, path, defaultValue) {
  var result = object == null ? void 0 : baseGet$2(object, path);
  return result === void 0 ? defaultValue : result;
}
var get_1 = get$1;
function baseHasIn$1(object, key) {
  return object != null && key in Object(object);
}
var _baseHasIn = baseHasIn$1;
var castPath = _castPath, isArguments = isArguments_1, isArray$7 = isArray_1, isIndex = _isIndex, isLength = isLength_1, toKey$2 = _toKey;
function hasPath$1(object, path, hasFunc) {
  path = castPath(path, object);
  var index = -1, length = path.length, result = false;
  while (++index < length) {
    var key = toKey$2(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) && (isArray$7(object) || isArguments(object));
}
var _hasPath = hasPath$1;
var baseHasIn = _baseHasIn, hasPath = _hasPath;
function hasIn$1(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}
var hasIn_1 = hasIn$1;
var baseIsEqual = _baseIsEqual, get = get_1, hasIn = hasIn_1, isKey$1 = _isKey, isStrictComparable = _isStrictComparable, matchesStrictComparable = _matchesStrictComparable, toKey$1 = _toKey;
var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
function baseMatchesProperty$1(path, srcValue) {
  if (isKey$1(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey$1(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return objValue === void 0 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}
var _baseMatchesProperty = baseMatchesProperty$1;
function identity$4(value) {
  return value;
}
var identity_1 = identity$4;
function baseProperty$1(key) {
  return function(object) {
    return object == null ? void 0 : object[key];
  };
}
var _baseProperty = baseProperty$1;
var baseGet$1 = _baseGet;
function basePropertyDeep$1(path) {
  return function(object) {
    return baseGet$1(object, path);
  };
}
var _basePropertyDeep = basePropertyDeep$1;
var baseProperty = _baseProperty, basePropertyDeep = _basePropertyDeep, isKey = _isKey, toKey = _toKey;
function property$1(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
var property_1 = property$1;
var baseMatches = _baseMatches, baseMatchesProperty = _baseMatchesProperty, identity$3 = identity_1, isArray$6 = isArray_1, property = property_1;
function baseIteratee$2(value) {
  if (typeof value == "function") {
    return value;
  }
  if (value == null) {
    return identity$3;
  }
  if (typeof value == "object") {
    return isArray$6(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
  }
  return property(value);
}
var _baseIteratee = baseIteratee$2;
function apply$1(func2, thisArg, args) {
  switch (args.length) {
    case 0:
      return func2.call(thisArg);
    case 1:
      return func2.call(thisArg, args[0]);
    case 2:
      return func2.call(thisArg, args[0], args[1]);
    case 3:
      return func2.call(thisArg, args[0], args[1], args[2]);
  }
  return func2.apply(thisArg, args);
}
var _apply = apply$1;
var apply = _apply;
var nativeMax = Math.max;
function overRest$1(func2, start, transform) {
  start = nativeMax(start === void 0 ? func2.length - 1 : start, 0);
  return function() {
    var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func2, this, otherArgs);
  };
}
var _overRest = overRest$1;
function constant$1(value) {
  return function() {
    return value;
  };
}
var constant_1 = constant$1;
var getNative = _getNative;
var defineProperty$1 = function() {
  try {
    var func2 = getNative(Object, "defineProperty");
    func2({}, "", {});
    return func2;
  } catch (e) {
  }
}();
var _defineProperty = defineProperty$1;
var constant = constant_1, defineProperty = _defineProperty, identity$2 = identity_1;
var baseSetToString$1 = !defineProperty ? identity$2 : function(func2, string2) {
  return defineProperty(func2, "toString", {
    "configurable": true,
    "enumerable": false,
    "value": constant(string2),
    "writable": true
  });
};
var _baseSetToString = baseSetToString$1;
var HOT_COUNT = 800, HOT_SPAN = 16;
var nativeNow = Date.now;
function shortOut$1(func2) {
  var count = 0, lastCalled = 0;
  return function() {
    var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func2.apply(void 0, arguments);
  };
}
var _shortOut = shortOut$1;
var baseSetToString = _baseSetToString, shortOut = _shortOut;
var setToString$1 = shortOut(baseSetToString);
var _setToString = setToString$1;
var identity$1 = identity_1, overRest = _overRest, setToString = _setToString;
function baseRest$1(func2, start) {
  return setToString(overRest(func2, start, identity$1), func2 + "");
}
var _baseRest = baseRest$1;
var isArrayLike$2 = isArrayLike_1, isObjectLike = isObjectLike_1;
function isArrayLikeObject$1(value) {
  return isObjectLike(value) && isArrayLike$2(value);
}
var isArrayLikeObject_1 = isArrayLikeObject$1;
function last$1(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : void 0;
}
var last_1 = last$1;
var baseDifference = _baseDifference, baseFlatten = _baseFlatten, baseIteratee$1 = _baseIteratee, baseRest = _baseRest, isArrayLikeObject = isArrayLikeObject_1, last = last_1;
var differenceBy = baseRest(function(array, values) {
  var iteratee = last(values);
  if (isArrayLikeObject(iteratee)) {
    iteratee = void 0;
  }
  return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), baseIteratee$1(iteratee)) : [];
});
var differenceBy_1 = differenceBy;
const differenceBy$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(differenceBy_1);
const s$4 = ({
  title: o,
  titleId: l,
  ...r2
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": l,
    ...r2,
    children: [
      o ? /* @__PURE__ */ fr.jsx("title", { id: l, children: o }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M510.955 872.555c-12.267 0-24.683-.619-36.885-1.856-23.445-2.368-40.533-23.317-38.187-46.741 2.389-23.445 23.275-40.533 46.763-38.165 9.365.96 18.901 1.429 28.309 1.429 152.363 0 276.288-123.947 276.288-276.267 0-152.363-123.925-276.288-276.288-276.288S234.667 358.592 234.667 510.955c0 27.648 4.053 54.912 12.053 81.045 6.891 22.528-5.76 46.379-28.288 53.291-22.507 6.891-46.4-5.76-53.291-28.288-10.496-34.261-15.808-69.931-15.808-106.048 0-199.403 162.219-361.621 361.621-361.621s361.621 162.219 361.621 361.621c0 199.381-162.219 361.6-361.621 361.6z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), t$3 = memo(s$4);
const c$1 = ({
  title: l,
  titleId: o,
  ...s2
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...s2,
    children: [
      l ? /* @__PURE__ */ fr.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M265.094 540.081c-78.507-78.507-78.507-206.229 0-284.736 38.016-38.037 88.576-58.965 142.357-58.965s104.32 20.949 142.379 58.965c78.485 78.507 78.485 206.229 0 284.736-38.059 38.016-88.597 58.987-142.379 58.987s-104.341-20.971-142.357-58.987m567.915 225.685L636.657 569.393c37.099-49.301 57.472-108.864 57.472-171.691 0-76.565-29.824-148.544-83.968-202.688s-126.123-83.968-202.709-83.968c-76.565 0-148.565 29.824-202.688 83.968-54.144 54.144-83.968 126.123-83.968 202.688 0 76.587 29.824 148.565 83.968 202.709 54.123 54.144 126.123 83.989 202.688 83.989 61.461 0 119.765-19.499 168.448-55.083l196.779 196.779c8.341 8.341 19.243 12.501 30.165 12.501s21.824-4.16 30.165-12.501c16.661-16.661 16.661-43.669 0-60.331z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), n$b = memo(c$1);
const styles$Z = {
  wrapper: css({
    display: "inline-flex",
    alignItems: "center",
    fontFamily: fontFamily.body,
    fontSize: fontSize.small,
    lineHeight: 1.2,
    fontWeight: fontWeight.semiBold,
    borderRadius: borderRadius.default,
    padding: shorthandHelper([0, spacing.default])
  }),
  icon: css({
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "transparent",
    borderWidth: 0,
    padding: 0
  }),
  accessiblyHidden: css(accessiblyHidden)
};
const wrapperTheme$8 = (theme) => {
  const themed = getThemeColors(theme);
  if (theme === "light") {
    return css({
      backgroundColor: themed.light,
      color: colors.jumbo
    });
  }
  return css({
    backgroundColor: themed.light,
    color: themed.base
  });
};
const hoverTheme = (theme) => {
  const themed = getThemeColors(theme);
  if (theme === "light") {
    return css({
      "&:hover": {
        backgroundColor: themed.medium,
        color: colors.jumbo
      }
    });
  }
  return css({
    "&:hover": {
      backgroundColor: themed.base,
      color: colors.white,
      "& svg path": {
        fill: colors.white
      }
    }
  });
};
const iconTheme$2 = (theme) => {
  if (theme === "light")
    return colors.jumbo;
  const themed = getThemeColors(theme);
  return themed.base;
};
const wrapperSize$1 = (size2) => {
  switch (size2) {
    case "small":
      return css({
        height: 30
      });
    default:
      return css({
        height: 35
      });
  }
};
const iconSize$1 = (size2) => {
  switch (size2) {
    case "small":
      return 16;
    default:
      return 18;
  }
};
const iconWrapperSize = (size2) => {
  switch (size2) {
    case "small":
      return css({
        marginLeft: spacing.small
      });
    default:
      return css({
        marginLeft: spacing.default
      });
  }
};
const Tag = ({ theme, size: size2, className, text, onClear }) => /* @__PURE__ */ React.createElement("div", { className: cx(styles$Z.wrapper, wrapperTheme$8(theme), wrapperSize$1(size2), onClear && hoverTheme(theme), className) }, /* @__PURE__ */ React.createElement("span", null, text), Boolean(onClear) && /* @__PURE__ */ React.createElement("button", { type: "button", className: cx(styles$Z.icon, iconWrapperSize(size2)), onClick: onClear }, /* @__PURE__ */ React.createElement("span", { className: styles$Z.accessiblyHidden }, `clear ${text}`), /* @__PURE__ */ React.createElement(AccessibleIcon, { icon: t$7, color: iconTheme$2(theme), size: iconSize$1(size2) })));
Tag.propTypes = {
  text: PropTypes.string.isRequired,
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "light", "dark", "tertiary", "info"]),
  size: PropTypes.oneOf(["", "default", "small"]),
  onClear: PropTypes.func,
  className: PropTypes.string
};
Tag.defaultProps = {
  theme: "primary",
  size: "default"
};
const flash = keyframes({
  "0%": { opacity: 0.6 },
  "50%": { opacity: 1 },
  "100%": { opacity: 0.6 }
});
const spin = keyframes({
  from: {
    transform: "rotate(0deg)"
  },
  to: {
    transform: "rotate(360deg)"
  }
});
const styles$Y = {
  wrapper: css({
    position: "relative",
    width: 240
  }),
  field: css({
    position: "relative",
    display: "flex",
    alignItems: "center",
    boxSizing: "border-box",
    height: 40,
    border: `1px solid ${colors.mystic}`,
    borderRadius: borderRadius.default
  }),
  openField: css({
    zIndex: zIndex.level6
  }),
  fieldError: css({
    borderColor: colors.mandy,
    "&:focus-within": {
      borderColor: colors.mandy,
      boxShadow: `0 0 0 2px ${hexToRgba(colors.mandy, 0.25)}`
    }
  }),
  fieldWarning: css({
    borderColor: colors.sandyBrown,
    "&:focus-within": {
      borderColor: colors.sandyBrown,
      boxShadow: `0 0 0 2px ${hexToRgba(colors.sandyBrown, 0.25)}`
    }
  }),
  input: css({
    boxSizing: "border-box",
    fontFamily: fontFamily.body,
    fontSize: fontSize.default,
    lineHeight: 1.2,
    padding: shorthandHelper([spacing.small, 44, spacing.small, spacing.default]),
    color: colors.jumbo,
    backgroundColor: "transparent",
    border: 0,
    borderRadius: borderRadius.default,
    flex: 1,
    height: "100%",
    "&::placeholder": {
      color: colors.grayChateau,
      userSelect: "none"
    },
    "&:focus": {
      outline: "none"
    },
    "&[disabled]": {
      backgroundColor: colors.athensGray
    }
  }),
  icon: css({
    position: "absolute",
    right: 0,
    top: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    padding: shorthandHelper([0, spacing.default]),
    pointerEvents: "none"
  }),
  iconSpinning: css({
    animationName: spin,
    animationDuration: "2000ms",
    animationIterationCount: "infinite",
    animationTimingFunction: "linear"
  }),
  iconClear: css({
    cursor: "pointer",
    pointerEvents: "auto"
  }),
  body: css({
    listStyle: "none",
    margin: 0,
    padding: 0,
    position: "absolute",
    top: 40,
    left: 0,
    right: 0,
    maxHeight: 280,
    overflowY: "auto",
    border: `1px solid ${colors.mystic}`,
    borderRadius: borderRadius.default,
    zIndex: zIndex.level6,
    marginTop: -2,
    borderTopRightRadius: 0,
    borderTopLeftRadius: 0,
    // Scroll gradient
    ...scrollGradient,
    "&:focus": {
      outline: "none"
    }
  }),
  emptyText: css({
    color: colors.grayChateau,
    cursor: "default",
    pointerEvents: "none"
  }),
  item: css({
    fontFamily: fontFamily.body,
    position: "relative",
    userSelect: "none",
    color: colors.jumbo,
    padding: spacing.default,
    fontSize: fontSize.default,
    cursor: "pointer",
    "&[disabled]": {
      cursor: "default",
      pointerEvents: "none",
      color: colors.geyser
    }
  }),
  overlay: css({
    position: "fixed",
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    zIndex: zIndex.level5
  }),
  selectedItems: css({
    listStyleType: "none",
    paddingLeft: 0,
    marginTop: spacing.small,
    marginBottom: spacing.default
  }),
  listItem: css({
    display: "inline-block",
    marginTop: spacing.small,
    marginRight: spacing.small
  })
};
const fieldTheme$3 = (theme) => {
  const themed = getThemeColors(theme);
  return css({
    "&:focus-within": {
      borderColor: themed.base,
      boxShadow: `0 0 0 2px ${hexToRgba(themed.base, 0.25)}`
    }
  });
};
const itemTheme$3 = (theme, selected) => {
  const themed = getThemeColors(theme);
  return css({
    ...selected && {
      backgroundColor: themed.light,
      color: themed.base
    },
    "&:focus": {
      outline: "none",
      backgroundColor: colors.athensGray
    },
    "&:hover": {
      backgroundColor: themed.light,
      color: themed.base
    }
  });
};
const iconColor$2 = (errored, warning) => {
  if (errored)
    return colors.mandy;
  if (warning)
    return colors.sandyBrown;
  return colors.geyser;
};
const MultiSearchNoResults = ({ canSelectSearchTerm, handleClick, label, addStyles, emptyStyles, noResultsText }) => {
  let newProps = { className: emptyStyles, children: noResultsText };
  if (canSelectSearchTerm) {
    newProps = { onClick: handleClick, className: addStyles, children: `Add "${label}"` };
  }
  return /* @__PURE__ */ React.createElement("li", { ...newProps });
};
MultiSearchNoResults.propTypes = {
  canSelectSearchTerm: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  noResultsText: PropTypes.string.isRequired,
  addStyles: PropTypes.string.isRequired,
  emptyStyles: PropTypes.string.isRequired
};
const MultiSearchOption = ({ handleClick, handleMouseOver, styles: styles2, children }) => /* @__PURE__ */ React.createElement("li", { onClick: handleClick, onMouseOver: handleMouseOver, className: styles2 }, children);
MultiSearchOption.propTypes = {
  handleClick: PropTypes.func.isRequired,
  handleMouseOver: PropTypes.func.isRequired,
  styles: PropTypes.string.isRequired,
  children: PropTypes.string.isRequired
};
class MultiSearch extends Component {
  constructor() {
    super(...arguments);
    // eslint-disable-next-line react/state-in-constructor
    __publicField(this, "state", {
      open: false,
      selectedIndex: -1,
      options: []
    });
    __publicField(this, "triggerFetch", debounce$1((query) => {
      if (query === "") {
        this.clearInput();
        return;
      }
      if (this.props.onClear)
        this.props.onClear();
      this.props.onSearch(query);
    }, 150));
    __publicField(this, "handleNavigation", (ev) => {
      if (ev.keyCode === 38 || ev.keyCode === 40) {
        ev.preventDefault();
        const selectedIndex = this.state.selectedIndex + (ev.keyCode - 39);
        if (selectedIndex >= 0 && selectedIndex < this.state.options.length) {
          this.setState({ selectedIndex });
          if (this.body && this.body.scrollHeight > this.body.offsetHeight) {
            const selectedOption = this.body.children[selectedIndex];
            const visibleArea = this.body.scrollTop + this.body.offsetHeight;
            if (selectedOption.offsetTop < this.body.scrollTop) {
              selectedOption.scrollIntoView();
            } else if (selectedOption.offsetTop + selectedOption.offsetHeight > visibleArea) {
              this.body.scrollTop = this.body.scrollTop + selectedOption.offsetHeight;
            }
          }
        }
      } else if (ev.keyCode === 27) {
        ev.preventDefault();
        this.setState({ open: false, selectedIndex: -1, options: [] });
      } else if (ev.keyCode === 13) {
        ev.preventDefault();
        const { selectedIndex } = this.state;
        if (selectedIndex >= 0) {
          const item = this.state.options[selectedIndex];
          this.selectItem(item);
          this.setState({ open: false, selectedIndex: -1, options: [] });
        } else if (this.props.canSelectSearchTerm) {
          const value = this.props.input.value || this.props.value;
          const labelObject = value.find((elem) => !elem.value);
          if (labelObject) {
            this.selectItem({ ...labelObject, value: labelObject.label });
            this.setState({ open: false, selectedIndex: -1, options: [] });
          }
        }
      }
      if (this.props.onKeyDown)
        this.props.onKeyDown(ev);
    });
    __publicField(this, "handleChange", (ev) => {
      const value = this.props.input.value || this.props.value;
      const handler = this.props.input.onChange || this.props.onChange;
      if (handler)
        handler([...value.filter((elem) => !!elem.value), { label: ev.target.value }]);
      this.triggerFetch(ev.target.value);
    });
    __publicField(this, "handleBlur", () => {
      const handler = this.props.input.onBlur || this.props.onBlur;
      if (handler)
        handler();
    });
    __publicField(this, "handleFocus", (ev) => {
      const handler = this.props.input.onFocus || this.props.onFocus;
      if (handler)
        handler(ev);
      const value = this.props.input.value || this.props.value;
      const labelObject = value.find((elem) => !elem.value) || {};
      if (!labelObject.label)
        return;
      this.setState({ selectedIndex: -1, options: [] });
    });
    __publicField(this, "clearInput", () => {
      const handler = this.props.input.onChange || this.props.onChange;
      const value = this.props.input.value || this.props.value;
      if (handler)
        handler(value.filter((elem) => !!elem.value));
      if (this.props.onClear)
        this.props.onClear();
      this.setState({ open: false, selectedIndex: -1, options: [] });
    });
    __publicField(this, "selectItem", (item) => {
      const handler = this.props.input.onChange || this.props.onChange;
      const value = this.props.input.value || this.props.value;
      if (handler)
        handler([...value.filter((elem) => !!elem.value), item]);
      this.input.focus();
    });
  }
  componentDidUpdate(prevProps) {
    if (prevProps.fetching && !this.props.fetching) {
      const selectedOptions = this.props.input.value || this.props.value;
      const options = differenceBy$1(this.props.results, selectedOptions, "value");
      this.setState({ open: true, options, selectedIndex: -1 });
    }
  }
  render() {
    const { open, selectedIndex, options } = this.state;
    const {
      meta,
      input,
      className,
      theme,
      helpText,
      results,
      value,
      onSearch,
      onClear,
      fetching,
      canSelectSearchTerm,
      noResultsText,
      onRemove,
      ...props
    } = this.props;
    const handler = input.onChange || props.onChange;
    const valueArray = input.value || value;
    const valueTags = valueArray.filter((elem) => !!elem.value);
    const labelObject = valueArray.find((elem) => !elem.value) || {};
    const label = labelObject.label || "";
    const errored = meta.touched && meta.error;
    const { warning } = meta;
    return /* @__PURE__ */ React.createElement("div", { className: cx(styles$Y.wrapper, className) }, Boolean(open) && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      "ul",
      {
        className: styles$Y.body,
        ref: (el) => this.body = el
      },
      !fetching && !warning && options.length < 1 && label.length > 0 ? /* @__PURE__ */ React.createElement(
        MultiSearchNoResults,
        {
          canSelectSearchTerm,
          handleClick: () => {
            this.selectItem({ ...labelObject, value: labelObject.label });
            this.setState({ open: false, selectedIndex: -1, options: [] });
          },
          label,
          addStyles: cx(styles$Y.item, itemTheme$3(theme)),
          emptyStyles: cx(styles$Y.item, styles$Y.emptyText),
          noResultsText
        }
      ) : null,
      options.length > 0 ? options.map((item, idx) => /* @__PURE__ */ React.createElement(
        MultiSearchOption,
        {
          key: item.value,
          styles: cx(styles$Y.item, itemTheme$3(theme, idx === selectedIndex)),
          handleMouseOver: () => this.setState({ selectedIndex: idx }),
          handleClick: () => {
            this.selectItem(item);
            this.setState({ open: false, selectedIndex: -1, options: [] });
          }
        },
        item.label
      )) : null
    ), /* @__PURE__ */ React.createElement("div", { "data-testid": "hack-overlay", className: styles$Y.overlay, onClick: () => this.setState({ open: false, selectedIndex: -1 }) })), /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cx(
          styles$Y.field,
          fieldTheme$3(theme),
          open && styles$Y.openField,
          errored && styles$Y.fieldError,
          warning && styles$Y.fieldWarning
        )
      },
      /* @__PURE__ */ React.createElement(
        "input",
        {
          className: styles$Y.input,
          type: "text",
          ...input,
          ...props,
          value: label,
          autoComplete: "off",
          ref: (el) => this.input = el,
          onChange: this.handleChange,
          onFocus: this.handleFocus,
          onBlur: this.handleBlur,
          onKeyDown: this.handleNavigation
        }
      ),
      /* @__PURE__ */ React.createElement(
        "div",
        {
          "aria-label": "clear value",
          className: cx(styles$Y.icon, fetching && styles$Y.iconSpinning, label && styles$Y.iconClear),
          onClick: this.clearInput
        },
        /* @__PURE__ */ React.createElement(
          AccessibleIcon,
          {
            icon: fetching ? t$3 : label ? t$7 : n$b,
            size: 20,
            color: iconColor$2(errored, warning)
          }
        )
      )
    ), Boolean(helpText && !errored && !warning) && /* @__PURE__ */ React.createElement(FormHelpText, { text: helpText }), Boolean(errored) && /* @__PURE__ */ React.createElement(FormErrorMessage, { text: meta.error }), Boolean(warning) && /* @__PURE__ */ React.createElement(FormWarningMessage, { text: meta.warning }), Boolean(valueTags.length) && /* @__PURE__ */ React.createElement("ul", { className: styles$Y.selectedItems }, valueTags.map((item, index) => /* @__PURE__ */ React.createElement("li", { className: styles$Y.listItem, key: item.value }, /* @__PURE__ */ React.createElement(
      Tag,
      {
        text: item.label,
        theme: item.theme || theme,
        onClear: () => {
          const removedTag = valueTags.splice(index, 1)[0];
          if (onRemove)
            onRemove(removedTag);
          if (handler)
            handler(valueTags);
        }
      }
    )))));
  }
}
const themeOpts = ["", "primary", "secondary", "success", "warning", "error", "legacy", "dark", "tertiary", "info"];
MultiSearch.propTypes = {
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
    warning: PropTypes.string
  }),
  input: PropTypes.shape({
    value: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string,
        label: PropTypes.string
      })
    ),
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func
  }),
  value: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
      theme: PropTypes.oneOf(themeOpts)
    })
  ),
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyDown: PropTypes.func,
  onSearch: PropTypes.func.isRequired,
  onClear: PropTypes.func,
  onRemove: PropTypes.func,
  helpText: PropTypes.string,
  theme: PropTypes.oneOf(themeOpts),
  className: PropTypes.string,
  fetching: PropTypes.bool,
  results: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ),
  canSelectSearchTerm: PropTypes.bool,
  noResultsText: PropTypes.string
};
MultiSearch.defaultProps = {
  meta: {},
  input: {},
  value: [],
  results: [],
  fetching: false,
  theme: "primary",
  canSelectSearchTerm: false,
  noResultsText: "No results found"
};
const counterArrow = 74;
const styles$X = {
  wrapper: css({
    position: "relative",
    width: 240,
    fontFamily: fontFamily.body
  }),
  wrapperError: css({
    "&:focus-within > div:last-child": {
      borderColor: colors.mandy,
      boxShadow: `0 0 0 2px ${hexToRgba(colors.mandy, 0.25)}`
    }
  }),
  label: css({
    height: 40,
    width: "100%",
    userSelect: "none",
    cursor: "pointer",
    border: `1px solid ${colors.mystic}`,
    borderRadius: borderRadius.default,
    position: "relative",
    color: colors.jumbo,
    backgroundColor: colors.white,
    boxSizing: "border-box",
    "&[readonly]": {
      cursor: "default",
      pointerEvents: "none",
      backgroundColor: colors.athensGray
    },
    "&:focus": {
      outline: "none"
    }
  }),
  openLabel: css({
    zIndex: zIndex.level6
  }),
  errorLabel: css({
    borderColor: colors.mandy,
    "&:focus": {
      borderColor: colors.mandy,
      boxShadow: `0 0 0 2px ${hexToRgba(colors.mandy, 0.25)}`
    }
  }),
  placeholderInput: css({
    color: colors.grayChateau
  }),
  input: css({
    boxSizing: "border-box",
    color: colors.jumbo,
    fontSize: fontSize.default,
    lineHeight: "40px",
    padding: shorthandHelper([0, counterArrow, 0, spacing.default]),
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    borderRadius: borderRadius.default
  }),
  arrow: css({
    pointerEvents: "none",
    position: "absolute",
    right: 0,
    top: 0,
    bottom: 0,
    padding: shorthandHelper([0, spacing.default]),
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }),
  counter: css({
    marginRight: spacing.default
  }),
  body: css({
    listStyle: "none",
    margin: 0,
    padding: spacing.default,
    position: "absolute",
    top: 40,
    left: 0,
    right: 0,
    maxHeight: 280,
    overflowY: "auto",
    border: `1px solid ${colors.mystic}`,
    borderRadius: borderRadius.default,
    zIndex: zIndex.level6,
    marginTop: -1,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    // Scroll gradient
    ...scrollGradient,
    "&:focus": {
      outline: "none"
    },
    "& > * + *": {
      marginTop: spacing.default
    }
  })
};
const wrapperTheme$7 = (theme) => {
  const themed = getThemeColors(theme);
  return css({
    "&:focus-within > div:last-child": {
      borderColor: themed.base,
      boxShadow: `0 0 0 2px ${hexToRgba(themed.base, 0.25)}`
    }
  });
};
const labelTheme$1 = (theme) => {
  const themed = getThemeColors(theme);
  return css({
    "&:focus": {
      borderColor: themed.base,
      boxShadow: `0 0 0 2px ${hexToRgba(themed.base, 0.25)}`
    }
  });
};
const MultiSelect = ({ children, theme, meta, input, readOnly, helpText, ...props }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [focusIndex, setFocusIndex] = useState(-1);
  const nodeRef = useRef();
  const buttonRef = useRef();
  const listBoxRef = useRef();
  const value = input.value || props.value || [];
  const onBlur = input.onBlur || props.onBlur;
  useEffect(() => {
    if (isOpen) {
      listBoxRef.current.focus();
    } else {
      setFocusIndex(-1);
    }
  }, [isOpen]);
  useEffect(() => {
    if (props.autoFocus)
      buttonRef.current.focus();
  }, [props.autoFocus]);
  useEffect(() => {
    const handleClosingClick = (ev) => {
      if (nodeRef.current.contains(ev.target))
        return;
      setIsOpen(false);
      if (onBlur)
        onBlur(ev);
    };
    if (isOpen) {
      document.addEventListener("mousedown", handleClosingClick);
    } else {
      document.removeEventListener("mousedown", handleClosingClick);
    }
    return () => {
      document.removeEventListener("mousedown", handleClosingClick);
    };
  }, [isOpen, onBlur]);
  const onLabelClick = (ev) => {
    setIsOpen((currentOpenValue) => !currentOpenValue);
    const focusHandler = input.onFocus || props.onFocus;
    if (!isOpen && focusHandler)
      focusHandler(ev);
    if (isOpen && onBlur)
      onBlur(ev);
  };
  const keyboardFocusIndexOnOpen = () => {
    if (value.length === 0)
      return 0;
    const childrenArr = React.Children.toArray(children);
    if (childrenArr.length === 0)
      return 0;
    const firstSelectedChildIndex = childrenArr.findIndex((child) => Array.isArray(value) ? value.includes(child.props.id) : -1);
    return firstSelectedChildIndex;
  };
  const handleButtonNavigation = (ev) => {
    switch (ev.key) {
      case "ArrowUp":
      case "ArrowDown":
      case " ":
      case "Enter":
        ev.preventDefault();
        if (!isOpen) {
          setIsOpen(true);
          const keyboardFocusIndex = keyboardFocusIndexOnOpen();
          setFocusIndex(keyboardFocusIndex);
        }
        break;
      case "Escape":
        ev.preventDefault();
        setIsOpen(false);
        break;
    }
  };
  const onChildChange = (id) => {
    const idIsInArray = Array.isArray(value) ? value.includes(id) : false;
    const newValue = idIsInArray ? value.filter((option) => option !== id) : [...value, id];
    const name = input.name || props.name;
    if (input.onChange)
      input.onChange(newValue);
    if (props.onSelect)
      props.onSelect(name, newValue, value);
  };
  const handleOptionsNavigation = (ev) => {
    const keyboardFocusIndex = focusIndex < 0 ? 0 : focusIndex;
    switch (ev.key) {
      case "ArrowUp":
      case "ArrowDown": {
        ev.preventDefault();
        const offsetDirection = ev.key === "ArrowDown" ? 1 : -1;
        const focusOffset = keyboardFocusIndex + offsetDirection;
        if (focusOffset >= 0 && focusOffset < React.Children.count(children)) {
          setFocusIndex(focusOffset);
          const listBox = listBoxRef.current;
          if (listBox && listBox.scrollHeight > listBox.offsetHeight) {
            const focussedOption = listBox.children[focusOffset];
            const visibleArea = listBox.scrollTop + listBox.offsetHeight;
            if (focussedOption.offsetTop < listBox.scrollTop) {
              focussedOption.scrollIntoView();
            } else if (focussedOption.offsetTop + focussedOption.offsetHeight > visibleArea) {
              listBox.scrollTop = listBox.scrollTop + focussedOption.offsetHeight;
            }
          }
        }
        break;
      }
      case "Escape": {
        ev.preventDefault();
        setIsOpen(false);
        buttonRef.current.focus();
        break;
      }
      case "Enter":
      case " ": {
        ev.preventDefault();
        const selectedChild = React.Children.toArray(children)[keyboardFocusIndex];
        const childId = selectedChild.props.id;
        if (childId)
          onChildChange(childId);
        break;
      }
    }
  };
  const getActiveDescendent = () => {
    const childrenArr = React.Children.toArray(children);
    if (!childrenArr.length)
      return;
    if (focusIndex < 0)
      return;
    const activeElementId = childrenArr[focusIndex].props.id;
    return activeElementId || childrenArr[0].props.id;
  };
  const activeDescendant = getActiveDescendent();
  const parentName = input.name || props.name;
  const errored = meta.touched && meta.error;
  const isPlaceholder = value.length === 0;
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      ref: nodeRef,
      className: cx(styles$X.wrapper, props.className, wrapperTheme$7(theme), errored && styles$X.wrapperError),
      onBlur: (event) => {
        const focusedElement = event.relatedTarget;
        if (nodeRef.current.contains(focusedElement))
          return;
        if (onBlur)
          onBlur(event);
        setIsOpen(false);
      }
    },
    /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cx(styles$X.label, labelTheme$1(theme), isOpen && styles$X.openLabel, errored && styles$X.errorLabel),
        readOnly,
        tabIndex: readOnly ? "-1" : props.tabIndex,
        ref: buttonRef,
        onClick: onLabelClick,
        onKeyDown: handleButtonNavigation,
        role: "button",
        "aria-haspopup": "listbox",
        "aria-expanded": isOpen,
        "aria-labelledby": `${props.ariaLabelledby || props.id || ""}`
      },
      /* @__PURE__ */ React.createElement("div", { className: cx(styles$X.input, isPlaceholder && styles$X.placeholderInput) }, value.length > 0 ? props.label : props.placeholder || props.label),
      /* @__PURE__ */ React.createElement("div", { className: styles$X.arrow }, Boolean(!!props.counterValue || value.length > 0) && /* @__PURE__ */ React.createElement(Counter, { value: props.counterValue || value.length, theme: errored ? "error" : theme, className: styles$X.counter }), /* @__PURE__ */ React.createElement(AccessibleIcon, { icon: t$5, size: 18, color: errored ? colors.mandy : colors.geyser }))
    ),
    Boolean(isOpen) && /* @__PURE__ */ React.createElement(
      "ul",
      {
        className: styles$X.body,
        role: "listbox",
        "aria-multiselectable": "true",
        tabIndex: "-1",
        "aria-activedescendant": activeDescendant,
        ref: listBoxRef,
        onKeyDown: handleOptionsNavigation
      },
      React.Children.map(
        children,
        (child, index) => React.cloneElement(child, {
          name: `${parentName}[${index}]`,
          onChange: () => onChildChange(child.props.id),
          theme,
          selected: Array.isArray(value) ? value.includes(child.props.id) : false,
          focused: focusIndex === index ? "true" : null
        })
      )
    ),
    Boolean(helpText && !errored) && /* @__PURE__ */ React.createElement(FormHelpText, { text: helpText }),
    Boolean(errored) && /* @__PURE__ */ React.createElement(FormErrorMessage, { text: meta.error })
  );
};
const { shape: shape$1, string: string$3, number: number$1, bool: bool$2, func: func$2, node: node$2, arrayOf: arrayOf$2, oneOf: oneOf$1, oneOfType: oneOfType$2 } = PropTypes;
MultiSelect.propTypes = {
  meta: shape$1({
    touched: bool$2,
    error: string$3
  }),
  input: shape$1({
    value: oneOfType$2([arrayOf$2(string$3), string$3]),
    onBlur: func$2,
    onFocus: func$2,
    onChange: func$2
  }),
  value: oneOfType$2([arrayOf$2(string$3), string$3]),
  onBlur: func$2,
  onFocus: func$2,
  id: string$3,
  name: string$3,
  label: string$3.isRequired,
  placeholder: string$3,
  counterValue: number$1,
  helpText: string$3,
  readOnly: bool$2,
  onSelect: func$2,
  tabIndex: string$3,
  theme: oneOf$1(["", "primary", "secondary", "success", "warning", "error", "legacy", "dark", "tertiary", "info"]),
  className: string$3,
  children: oneOfType$2([arrayOf$2(node$2), node$2]),
  ariaLabelledby: string$3,
  autoFocus: bool$2
};
MultiSelect.defaultProps = {
  input: {},
  meta: {},
  value: [],
  theme: "primary",
  tabIndex: "0"
};
const styles$W = {
  focused: (focused, theme) => {
    if (!focused)
      return null;
    const themed = getThemeColors(theme);
    return css({
      'input[type="checkbox"]': focusStyles(themed.base)
    });
  }
};
const MultiOption = ({ selected, focused, ...props }) => /* @__PURE__ */ React.createElement("li", { role: "option", "aria-selected": selected }, /* @__PURE__ */ React.createElement(
  Checkbox,
  {
    checked: selected,
    className: styles$W.focused(focused, props.theme),
    ...props
  }
));
MultiOption.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  focused: PropTypes.string,
  theme: PropTypes.string
};
const navbarHeight = 60;
const styles$V = {
  wrapper: css({
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    height: navbarHeight,
    backgroundColor: colors.oxfordBlue,
    zIndex: zIndex.level8,
    display: "flex",
    alignItems: "center",
    [mediaQueryHelper(breakpoint.tablet)]: {
      position: "relative"
    }
  }),
  container: css({
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  }),
  logo: css({
    display: "inline-flex",
    alignItems: "center",
    "&:focus": {
      outline: "none"
    }
  }),
  logoImage: css({
    height: 28
  }),
  navItems: css({
    display: "flex",
    height: "100%",
    alignItems: "center"
  })
};
const Navbar = ({ className, containerClassName, children }) => /* @__PURE__ */ React.createElement("nav", { className: cx(styles$V.wrapper, className) }, /* @__PURE__ */ React.createElement(Container, { className: cx(styles$V.container, containerClassName) }, /* @__PURE__ */ React.createElement("a", { href: "/", className: styles$V.logo, "aria-label": "Home" }, /* @__PURE__ */ React.createElement(LazyImage, { className: styles$V.logoImage, loader: () => import("./offerzen-logo-BuXzaC6j.js") })), /* @__PURE__ */ React.createElement("div", { className: styles$V.navItems }, children)));
Navbar.propTypes = {
  className: propTypesExports.string,
  containerClassName: propTypesExports.string,
  children: propTypesExports.oneOfType([propTypesExports.node, propTypesExports.arrayOf(propTypesExports.node)])
};
const styles$U = {
  wrapper: css({
    display: "flex",
    alignItems: "flex-start",
    position: "relative",
    padding: spacing.default,
    fontFamily: fontFamily.body,
    fontSize: fontSize.default,
    fontWeight: fontWeight.regular,
    lineHeight: lineHeight.default,
    border: "1px solid transparent",
    borderRadius: borderRadius.default,
    whiteSpace: "pre-wrap"
  }),
  wrapperDismissible: css({
    paddingRight: 40
  }),
  icon: css({
    marginRight: spacing.small
  }),
  dismiss: css({
    // override default button styles
    border: "none",
    margin: 0,
    textDecoration: "none",
    background: "none",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: 0,
    bottom: 0,
    right: 0,
    padding: shorthandHelper([0, spacing.default])
  }),
  accessiblyHidden: css(accessiblyHidden)
};
const wrapperTheme$6 = (theme) => {
  const themed = getThemeColors(theme);
  if (theme === "light") {
    return css({
      backgroundColor: colors.athensGray,
      color: colors.oxfordBlue,
      borderColor: hexToRgba(colors.oxfordBlue, 0.3)
    });
  }
  return css({
    backgroundColor: themed.light,
    color: themed.base,
    borderColor: hexToRgba(themed.base, 0.3)
  });
};
const iconColor$1 = (theme) => {
  if (theme === "light")
    return colors.oxfordBlue;
  const themed = getThemeColors(theme);
  return themed.base;
};
const Notification = ({ theme = "primary", className, onDismiss, icon, children }) => /* @__PURE__ */ React.createElement("div", { className: cx(styles$U.wrapper, className, wrapperTheme$6(theme), onDismiss && styles$U.wrapperDismissible) }, Boolean(icon) && /* @__PURE__ */ React.createElement(AccessibleIcon, { icon, className: styles$U.icon, size: 16, color: iconColor$1(theme) }), /* @__PURE__ */ React.createElement("div", null, children), Boolean(onDismiss) && /* @__PURE__ */ React.createElement("button", { type: "button", onClick: onDismiss, className: styles$U.dismiss }, /* @__PURE__ */ React.createElement(AccessibleIcon, { icon: t$7, color: iconColor$1(theme), size: 20 }), /* @__PURE__ */ React.createElement("span", { className: styles$U.accessiblyHidden }, "Close")));
Notification.propTypes = {
  onDismiss: PropTypes.func,
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "light", "dark", "tertiary", "info"]),
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};
const n$a = ({
  title: l,
  titleId: o,
  ...i2
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...i2,
    children: [
      l ? /* @__PURE__ */ fr.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M690.462 510.895c0 10.923-4.16 21.824-12.501 30.165L408.521 810.5c-16.661 16.661-43.691 16.661-60.331 0-16.683-16.661-16.683-43.669 0-60.331l239.275-239.275-239.189-239.189c-16.661-16.661-16.661-43.669 0-60.331s43.669-16.661 60.331 0l269.355 269.355c8.341 8.341 12.501 19.243 12.501 30.165z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), m$7 = memo(n$a);
const n$9 = ({
  title: l,
  titleId: o,
  ...r2
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...r2,
    children: [
      l ? /* @__PURE__ */ fr.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M333.538 513.105c0-10.923 4.16-21.824 12.501-30.165l269.44-269.44c16.661-16.661 43.691-16.661 60.331 0 16.683 16.661 16.683 43.669 0 60.331L436.535 513.106l239.189 239.189c16.661 16.661 16.661 43.669 0 60.331s-43.669 16.661-60.331 0L346.038 543.271c-8.341-8.341-12.501-19.243-12.501-30.165z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), m$6 = memo(n$9);
const styles$T = {
  wrapper: css({
    fontSize: fontSize.small,
    fontWeight: fontWeight.semiBold,
    lineHeight: 1.2,
    color: colors.jumbo,
    listStyle: "none",
    padding: 0,
    margin: 0,
    display: "flex",
    justifyContent: "center",
    "& > * + *": {
      marginLeft: spacing.default
    }
  }),
  page: css({
    userSelect: "none",
    width: 24,
    height: 24,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: colors.mystic
    },
    "&:focus": {
      outline: "none",
      backgroundColor: colors.geyser
    }
  }),
  pageHidden: css({
    visibility: "hidden"
  }),
  pageDisabled: css({
    pointerEvents: "none"
  })
};
const pageTheme = (theme) => {
  const themed = getThemeColors(theme);
  return css({
    backgroundColor: themed.base,
    color: colors.white,
    pointerEvents: "none"
  });
};
const maxVisibleItems = 7;
const renderArrow = (arrow, currentPage, totalPages, onPageSelect) => {
  if (arrow === "left") {
    return /* @__PURE__ */ React.createElement(
      "li",
      {
        onClick: () => {
          if (currentPage > 1)
            onPageSelect(currentPage - 1);
        },
        onKeyDown: (ev) => {
          if (ev.which === 13 && !specialKeyPressed(ev) && currentPage > 1)
            onPageSelect(currentPage - 1);
        }
      },
      /* @__PURE__ */ React.createElement("span", { className: cx(styles$T.page, currentPage <= 1 && styles$T.pageHidden), tabIndex: "0" }, /* @__PURE__ */ React.createElement(AccessibleIcon, { icon: m$6, size: 16, color: colors.jumbo }))
    );
  }
  if (arrow === "right") {
    return /* @__PURE__ */ React.createElement(
      "li",
      {
        onClick: () => {
          if (currentPage < totalPages)
            onPageSelect(currentPage + 1);
        },
        onKeyDown: (ev) => {
          if (ev.which === 13 && !specialKeyPressed(ev) && currentPage < totalPages)
            onPageSelect(currentPage + 1);
        }
      },
      /* @__PURE__ */ React.createElement("span", { className: cx(styles$T.page, currentPage >= totalPages && styles$T.pageHidden), tabIndex: "0" }, /* @__PURE__ */ React.createElement(AccessibleIcon, { icon: m$7, size: 16, color: colors.jumbo }))
    );
  }
  return null;
};
const renderEllipsis = () => /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("span", { className: styles$T.page }, "..."));
const renderPage = (theme, currentPage, page, onPageSelect) => /* @__PURE__ */ React.createElement(
  "li",
  {
    key: page,
    onClick: () => onPageSelect(page),
    onKeyDown: (ev) => {
      if (ev.which === 13 && !specialKeyPressed(ev))
        onPageSelect(page);
    }
  },
  /* @__PURE__ */ React.createElement("span", { className: cx(styles$T.page, currentPage === page && pageTheme(theme)), tabIndex: currentPage === page ? "-1" : "0" }, page)
);
const calculatePages = (currentPage, totalPages) => {
  if (totalPages <= maxVisibleItems) {
    const pages = new Array(totalPages - 2).fill(0);
    return pages.map((_, index) => index + 2);
  }
  if (currentPage <= 4)
    return [2, 3, 4, 5];
  if (currentPage >= totalPages - 3)
    return [totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1];
  return [currentPage - 1, currentPage, currentPage + 1];
};
const Pagination = ({ theme, className, currentPage, totalPages, onPageSelect }) => /* @__PURE__ */ React.createElement("ul", { className: cx(styles$T.wrapper, className) }, renderArrow("left", currentPage, totalPages, onPageSelect), renderPage(theme, currentPage, 1, onPageSelect), Boolean(currentPage > 4 && totalPages > maxVisibleItems) && /* @__PURE__ */ React.createElement(React.Fragment, null, renderEllipsis()), calculatePages(currentPage, totalPages).map((page) => renderPage(theme, currentPage, page, onPageSelect)), Boolean(currentPage < totalPages - 3 && totalPages > maxVisibleItems) && /* @__PURE__ */ React.createElement(React.Fragment, null, renderEllipsis()), renderPage(theme, currentPage, totalPages, onPageSelect), renderArrow("right", currentPage, totalPages, onPageSelect));
Pagination.propTypes = {
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "dark", "tertiary", "info"]),
  className: PropTypes.string,
  onPageSelect: PropTypes.func.isRequired
};
Pagination.defaultProps = {
  theme: "primary"
};
const n$8 = ({
  title: e,
  titleId: o,
  ...c2
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...c2,
    children: [
      e ? /* @__PURE__ */ fr.jsx("title", { id: o, children: e }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M887.893 763.339c-36.245 55.915-68.651 130.56-145.941 130.56-3.392 0-6.805-.213-10.219-.619-.853 0-1.707 0-2.56-.235-38.4-4.267-75.52-11.733-112-25.813-38.613-14.933-73.621-37.12-107.947-59.733-90.453-59.52-173.013-132.267-237.013-219.925-1.515-2.155-3.221-4.267-4.693-6.421-30.528-42.027-59.733-85.12-81.067-132.48-17.088-37.333-29.461-79.552-34.795-121.792-.213-1.301-.619-2.581-.619-3.861-.213-.427-.213-.853-.213-1.28-.427-5.099-1.088-10.24-1.28-15.147-.213-.853-.213-1.707-.213-2.56 0-37.973 18.56-71.467 47.147-91.733l12.139-8.085c.448 0 .64-.235.875-.427l72.107-46.741c23.659-15.147 55.253-7.253 68.693 17.28l83.819 150.827c11.328 20.48 6.421 46.08-11.712 61.013l-39.467 32.427c-19.413 15.787-23.68 43.947-9.6 64.64 24.96 37.12 50.56 74.453 82.56 106.261 31.765 31.552 68.885 57.152 105.813 82.112 20.693 14.08 48.853 9.813 64.619-9.6l32.448-39.467c14.933-18.112 40.512-23.232 61.013-11.712l150.805 83.819c24.555 13.44 32.448 45.035 17.301 68.693z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), m$5 = memo(n$8);
const styles$S = {
  container: css({
    width: 240,
    maxWidth: "100%"
  }),
  wrapper: css({
    position: "relative",
    borderRadius: borderRadius.default,
    border: `1px solid ${colors.mystic}`,
    height: 40,
    width: "100%",
    boxSizing: "border-box"
  }),
  wrapperError: css({
    borderColor: colors.mandy,
    "&:focus-within": {
      borderColor: colors.mandy,
      boxShadow: `0 0 0 2px ${hexToRgba(colors.mandy, 0.25)}`
    }
  }),
  input: css({
    color: colors.jumbo,
    fontFamily: fontFamily.body,
    fontSize: fontSize.default,
    lineHeight: 1.2,
    padding: shorthandHelper([spacing.small, 42, spacing.small, spacing.default]),
    appearance: "none",
    border: "none",
    width: "100%",
    height: "100%",
    boxSizing: "border-box",
    borderRadius: borderRadius.default,
    "&::placeholder": {
      color: colors.grayChateau,
      userSelect: "none"
    },
    "&[readonly]": {
      backgroundColor: colors.athensGray
    },
    "&:focus": {
      outline: "none"
    }
  }),
  icon: css({
    pointerEvents: "none",
    position: "absolute",
    top: 0,
    bottom: 0,
    right: 0,
    padding: shorthandHelper([0, spacing.default]),
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  })
};
const wrapperTheme$5 = (theme) => {
  const themed = getThemeColors(theme);
  return css({
    "&:focus-within": {
      borderColor: themed.base,
      boxShadow: `0 0 0 2px ${hexToRgba(themed.base, 0.25)}`
    }
  });
};
const PhoneInput = ({ meta, input, className, theme, helpText, onChange, ...props }) => {
  const value = input.value || props.value;
  const errored = meta.touched && meta.error;
  return /* @__PURE__ */ React.createElement("div", { className: cx(styles$S.container, className) }, /* @__PURE__ */ React.createElement("div", { className: cx(styles$S.wrapper, wrapperTheme$5(theme), errored && styles$S.wrapperError) }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "tel",
      ...input,
      ...props,
      className: styles$S.input,
      value,
      onChange: (ev) => {
        ev.preventDefault();
        const newValue = ev.target.value.replace(/[^\d\s-()+]|[a-zA-Z]/g, "");
        const handler = input.onChange || onChange;
        if (handler)
          handler(newValue);
      }
    }
  ), /* @__PURE__ */ React.createElement("div", { className: styles$S.icon }, /* @__PURE__ */ React.createElement(AccessibleIcon, { icon: m$5, size: 18, color: errored ? colors.mandy : colors.geyser }))), Boolean(helpText && !errored) && /* @__PURE__ */ React.createElement(FormHelpText, { text: helpText }), Boolean(errored) && /* @__PURE__ */ React.createElement(FormErrorMessage, { text: meta.error }));
};
PhoneInput.propTypes = {
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string
  }),
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func
  }),
  name: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  helpText: PropTypes.string,
  autoFocus: PropTypes.bool,
  tabIndex: PropTypes.string,
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "dark", "tertiary", "info"]),
  className: PropTypes.string,
  onChange: PropTypes.func
};
PhoneInput.defaultProps = {
  meta: {},
  input: {},
  value: "",
  tabIndex: "0"
};
const styles$R = {
  wrapper: css({
    position: "fixed",
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    backgroundColor: hexToRgba(colors.oxfordBlue, 0.5),
    zIndex: zIndex.level10,
    paddingTop: 60,
    transition: "opacity 0.2s"
  }),
  overlay: css({
    position: "absolute",
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    zIndex: zIndex.level9
  }),
  container: css({
    position: "relative",
    zIndex: zIndex.level10,
    height: "100%",
    backgroundColor: colors.white,
    overflowY: "auto",
    transition: "transform 0.3s"
  }),
  header: css({
    padding: shorthandHelper([spacing.default, spacing.default]),
    color: colors.white,
    fontWeight: fontWeight.semiBold,
    fontSize: fontSize.default,
    fontFamily: fontFamily.body,
    display: "grid",
    gridColumnGap: "1rem",
    gridTemplateColumns: "1fr auto",
    "& > div": {
      alignSelf: "start",
      textAlign: "center",
      width: "100%"
    },
    "& > button": {
      verticalAlign: "top",
      padding: 0,
      margin: 0,
      border: "none",
      lineHeight: 1,
      height: 20,
      backgroundColor: "transparent"
    }
  }),
  accessiblyHidden: css(accessiblyHidden)
};
const wrapperTransition$1 = (status) => {
  switch (status) {
    case "entering":
      return css({
        opacity: 0
      });
    case "entered":
      return css({
        opacity: 1
      });
    case "exiting":
    case "exited":
    default:
      return css({
        opacity: 0
      });
  }
};
const containerTransition = (status) => {
  switch (status) {
    case "entering":
      return css({
        transform: "translateY(100%)"
      });
    case "entered":
      return css({
        transform: "translateY(0)"
      });
    case "exiting":
    case "exited":
    default:
      return css({
        transform: "translateY(100%)"
      });
  }
};
const headerTheme = (theme) => {
  const themed = getThemeColors(theme);
  if (theme === "light") {
    return css({
      backgroundColor: themed.light,
      color: colors.jumbo
    });
  }
  return css({
    backgroundColor: themed.base
  });
};
const iconColor = (theme) => {
  if (theme === "light")
    return colors.jumbo;
  return colors.white;
};
class Popup extends Component {
  constructor(props) {
    super(props);
    __publicField(this, "handleHidePopup", () => {
      if (!this.props.preventClose)
        this.props.hidePopup();
    });
    this.scrollElement = document.scrollingElement || document.documentElement;
  }
  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.scrollElement.style.overflow = "hidden";
    } else if (!this.props.visible && prevProps.visible) {
      this.scrollElement.style.overflow = "";
    }
  }
  componentWillUnmount() {
    this.scrollElement.style.overflow = "";
  }
  render() {
    const { visible, onPopupClose, theme, title, children, className } = this.props;
    return /* @__PURE__ */ React.createElement(Transition, { in: visible, timeout: { enter: 0, exit: 300 }, mountOnEnter: true, unmountOnExit: true, onExited: onPopupClose }, (status) => /* @__PURE__ */ React.createElement("div", { className: cx(styles$R.wrapper, className, wrapperTransition$1(status)) }, /* @__PURE__ */ React.createElement("div", { onClick: this.handleHidePopup, className: styles$R.overlay }), /* @__PURE__ */ React.createElement("div", { className: cx(styles$R.container, containerTransition(status)) }, /* @__PURE__ */ React.createElement("div", { className: cx(styles$R.header, headerTheme(theme)) }, /* @__PURE__ */ React.createElement("div", null, title), /* @__PURE__ */ React.createElement("button", { type: "button", onClick: this.handleHidePopup }, /* @__PURE__ */ React.createElement(AccessibleIcon, { icon: t$7, color: iconColor(theme), size: 20 }), /* @__PURE__ */ React.createElement("span", { className: styles$R.accessiblyHidden }, "Close"))), Boolean(children) && children({ hidePopup: this.handleHidePopup }))));
  }
}
Popup.propTypes = {
  title: PropTypes.string.isRequired,
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "light", "dark", "tertiary", "info"]),
  onPopupClose: PropTypes.func,
  preventClose: PropTypes.bool,
  children: PropTypes.func,
  hidePopup: PropTypes.func,
  visible: PropTypes.bool,
  className: PropTypes.string
};
Popup.defaultProps = {
  theme: "primary"
};
const i$7 = ({
  title: e,
  titleId: o,
  ...s2
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...s2,
    children: [
      e ? /* @__PURE__ */ fr.jsx("title", { id: o, children: e }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m699.563 684.587-14.976 14.955c-5.803 5.805-13.821 9.396-22.677 9.396s-16.874-3.591-22.677-9.396L512.044 572.353 384.791 699.606c-5.787 5.788-13.782 9.367-22.613 9.367s-16.826-3.58-22.613-9.367l-15.189-15.211c-5.776-5.772-9.349-13.749-9.349-22.56 0-8.79 3.556-16.749 9.308-22.518L451.14 512.022 324.399 384.79c-5.763-5.786-9.327-13.768-9.327-22.581 0-8.835 3.58-16.834 9.369-22.624l15.147-15.147c5.807-5.813 13.833-9.409 22.699-9.409 8.812 0 16.795 3.553 22.594 9.304l-.002-.002L512.58 451.158l126.699-126.699c5.792-5.795 13.794-9.38 22.635-9.38s16.843 3.585 22.634 9.38l15.083 15.083c5.789 5.791 9.369 13.789 9.369 22.624s-3.58 16.833-9.369 22.624L572.399 512.022l127.147 127.189c5.81 5.801 9.405 13.819 9.405 22.677s-3.594 16.877-9.404 22.677zM512 64C264.533 64 64 264.533 64 512s200.533 448 448 448 448-200.533 448-448S759.467 64 512 64m0 42.667c223.509 0 405.333 181.824 405.333 405.333S735.509 917.333 512 917.333 106.667 735.509 106.667 512 288.491 106.667 512 106.667",
          clipRule: "evenodd"
        }
      )
    ]
  }
), n$7 = memo(i$7);
const styles$Q = {
  wrapper: css({
    position: "relative",
    "&:focus": {
      outline: "none"
    }
  }),
  body: css({
    padding: shorthandHelper([spacing.medium, spacing.default]),
    position: "absolute",
    top: -spacing.medium,
    zIndex: zIndex.level7,
    backgroundColor: colors.oxfordBlue,
    display: "flex",
    flexDirection: "row-reverse",
    justifyContent: "space-between",
    color: colors.white,
    fontFamily: fontFamily.body,
    fontSize: fontSize.default,
    fontWeight: fontWeight.regular,
    boxSizing: "border-box",
    "&:focus": {
      outline: "none"
    }
  }),
  closeButton: css({
    display: "flex",
    alignItems: "flex-start",
    zIndex: zIndex.level8,
    border: 0,
    padding: 0,
    background: "transparent",
    "&:focus": {
      outline: "none"
    }
  }),
  children: css({
    display: "flex",
    alignItems: "center"
  }),
  overlay: css({
    position: "fixed",
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    zIndex: zIndex.level6
  })
};
const bodySize = (offsetLeft, width) => css({
  left: -offsetLeft,
  width
});
class PopupTip extends Component {
  constructor(props) {
    super(props);
    // eslint-disable-next-line react/state-in-constructor
    __publicField(this, "state", {
      open: false,
      offsetLeft: 0,
      width: 0
    });
    __publicField(this, "resize", () => {
      this.setState({ offsetLeft: this.getTriggerLeftWindowOffset() });
    });
    __publicField(this, "getTriggerLeftWindowOffset", () => {
      if (!this.triggerRef.current)
        return null;
      return this.triggerRef.current.getBoundingClientRect().left;
    });
    // eslint-disable-next-line class-methods-use-this
    __publicField(this, "getDocumentWidth", () => document.documentElement.clientWidth);
    __publicField(this, "togglePopupTip", () => {
      const nextOpenState = !this.state.open;
      let { offsetLeft } = this.state;
      let { width } = this.state;
      if (nextOpenState) {
        offsetLeft = this.getTriggerLeftWindowOffset();
        width = this.getDocumentWidth();
      }
      this.setState({
        open: nextOpenState,
        offsetLeft,
        width
      });
      if (this.state.open && this.props.onOpen)
        this.props.onOpen();
    });
    this.triggerRef = React.createRef();
  }
  componentDidMount() {
    window.addEventListener("resize", debounce$1(this.resize, 10));
    this.setState({
      offsetLeft: this.getTriggerLeftWindowOffset(),
      width: this.getDocumentWidth()
    });
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.resize);
  }
  render() {
    const { children, trigger: Trigger, className, triggerClassName, ...triggerProps } = this.props;
    triggerProps.className = triggerClassName;
    return /* @__PURE__ */ React.createElement("div", { className: cx(styles$Q.wrapper, className), ref: this.triggerRef, onClick: this.togglePopupTip }, /* @__PURE__ */ React.createElement(
      Trigger,
      {
        ...triggerProps
      }
    ), Boolean(this.state.open) && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { onClick: this.togglePopupTip, className: styles$Q.overlay }), /* @__PURE__ */ React.createElement("div", { className: cx(styles$Q.body, bodySize(this.state.offsetLeft, this.state.width)) }, /* @__PURE__ */ React.createElement("button", { type: "button", onClick: this.togglePopupTip, className: styles$Q.closeButton, "aria-label": "Close" }, /* @__PURE__ */ React.createElement(AccessibleIcon, { icon: n$7, color: colors.white, size: 24 })), /* @__PURE__ */ React.createElement("div", { className: styles$Q.children }, children))));
  }
}
PopupTip.propTypes = {
  trigger: PropTypes.func,
  className: PropTypes.string,
  triggerClassName: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  onOpen: PropTypes.func
};
const styles$P = {
  wrapper: css({
    display: "flex",
    alignItems: "center",
    position: "relative",
    zIndex: 0,
    "& > * + *": {
      marginLeft: spacing.default
    }
  })
};
const RadioBoxGroup = ({ input, children, ...props }) => {
  const name = input.name || props.name;
  const value = input.value != null ? input.value : props.value;
  const handler = input.onChange || props.onChange;
  return /* @__PURE__ */ React.createElement("div", { className: cx(styles$P.wrapper, props.className) }, React.Children.map(
    children,
    (child, index) => React.cloneElement(child, {
      id: `${name}-${index}`,
      name,
      checked: child.props.value === value,
      theme: props.theme,
      ...props.autoFocus && {
        autoFocus: value ? child.props.value === value : index === 0
      },
      onChange: handler
    })
  ));
};
RadioBoxGroup.propTypes = {
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string
  }),
  input: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    onChange: PropTypes.func
  }),
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  onChange: PropTypes.func,
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "dark", "tertiary", "info"]),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
RadioBoxGroup.defaultProps = {
  meta: {},
  input: {},
  theme: "primary"
};
const styles$O = {
  box: css({
    cursor: "pointer",
    position: "relative",
    padding: spacing.default,
    fontFamily: fontFamily.body,
    fontSize: fontSize.small,
    fontWeight: fontWeight.semiBold,
    color: colors.jumbo,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flex: 1
  }),
  input: css({
    position: "absolute",
    width: "100%",
    height: "100%",
    appearance: "none",
    margin: 0,
    border: `1px solid ${colors.mystic}`,
    borderRadius: borderRadius.default,
    zIndex: -1,
    "&:focus": {
      outline: "none"
    }
  })
};
const inputTheme$1 = (theme) => {
  const themed = getThemeColors(theme);
  return css({
    "&:checked": {
      borderColor: themed.base,
      backgroundColor: themed.light,
      "& + *": {
        color: themed.base
      }
    },
    "&:hover": {
      borderColor: themed.base,
      "& + *": {
        color: themed.base
      }
    },
    "&:focus": {
      borderColor: themed.base,
      boxShadow: `0 0 0 2px ${hexToRgba(themed.medium, 0.25)}`,
      "& + *": {
        color: themed.base
      }
    }
  });
};
const RadioBoxOption = ({ className = null, theme = "", label, ...props }) => /* @__PURE__ */ React.createElement("label", { className: cx(styles$O.box, className), htmlFor: props.id }, /* @__PURE__ */ React.createElement(
  "input",
  {
    className: cx(styles$O.input, inputTheme$1(theme)),
    type: "radio",
    ...props
  }
), /* @__PURE__ */ React.createElement("span", null, label));
RadioBoxOption.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  checked: PropTypes.bool,
  autoFocus: PropTypes.bool,
  theme: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string
};
const styles$N = {
  fieldset: css({
    fontFamily: fontFamily.body,
    fontSize: fontSize.default,
    color: colors.jumbo
  }),
  radioInputs: css({
    display: "flex",
    flexWrap: "wrap",
    // Negative margin to compensate for
    // spacing between each nested RadioInput
    marginBottom: -spacing.default
  }),
  errorMessage: css({
    marginTop: spacing.small
  })
};
const RadioInputGroup = ({ input, children, meta, ...props }) => {
  const name = input.name || props.name;
  const value = input.value || props.value;
  const handler = input.onChange || props.onChange;
  const errored = meta.touched && meta.error;
  const theme = errored && "error" || props.theme;
  return /* @__PURE__ */ React.createElement(FormFieldset, { legend: props.label, hideLegend: props.hideLegend, className: cx(styles$N.fieldset, props.className) }, /* @__PURE__ */ React.createElement("div", { className: styles$N.radioInputs }, React.Children.map(
    children,
    (child, index) => React.cloneElement(child, {
      id: `${name}-${index}`,
      name,
      checked: child.props.value === value,
      theme,
      ...props.autoFocus && {
        autoFocus: value ? child.props.value === value : index === 0
      },
      onChange: handler,
      disabled: props.disabled
    })
  )), Boolean(errored) && /* @__PURE__ */ React.createElement(FormErrorMessage, { text: meta.error, className: styles$N.errorMessage }));
};
RadioInputGroup.propTypes = {
  name: PropTypes.string,
  label: PropTypes.node.isRequired,
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "dark", "tertiary", "info"]),
  className: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string
  }),
  input: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    onChange: PropTypes.func
  }),
  disabled: PropTypes.bool,
  hideLegend: PropTypes.bool,
  autoFocus: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
RadioInputGroup.defaultProps = {
  meta: {},
  input: {},
  theme: "primary"
};
const outerCircleSize = 20;
const innerCircleSize = 12;
const innerCircleOffset = (outerCircleSize - innerCircleSize) / 2;
const pseudoRadio = {
  display: "block",
  content: '""',
  borderRadius: "50%",
  boxSizing: "border-box",
  cursor: "pointer",
  width: outerCircleSize,
  height: outerCircleSize,
  flex: "none"
};
const styles$M = {
  input: css(accessiblyHidden),
  label: css({
    position: "relative",
    display: "flex",
    alignItems: "center",
    paddingRight: spacing.large,
    marginBottom: spacing.default,
    cursor: "pointer",
    color: colors.blackPearl,
    fontSize: fontSize.default,
    "&::before": {
      ...pseudoRadio,
      border: `1px solid ${colors.geyser}`,
      marginRight: spacing.default
    }
  })
};
const inputTheme = (theme) => {
  const themed = getThemeColors(theme);
  return css({
    "&:checked + label::before": {
      borderColor: themed.base,
      backgroundColor: themed.light
    },
    "&:checked + label::after": {
      ...pseudoRadio,
      position: "absolute",
      width: innerCircleSize,
      height: innerCircleSize,
      left: innerCircleOffset,
      top: "50%",
      transform: "translateY(-50%)",
      backgroundColor: themed.base
    },
    "&:not(:disabled) + label:hover::before": {
      borderColor: themed.base
    },
    "&:focus + label::before": {
      boxShadow: `0 0 2px 1px ${hexToRgba(themed.medium, 0.5)}`
    },
    "&:disabled + label::before": {
      backgroundColor: colors.athensGray
    }
  });
};
const RadioInput = ({ id = null, ...props }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
  "input",
  {
    id,
    type: "radio",
    ...props,
    className: cx(styles$M.input, inputTheme(props.theme))
  }
), /* @__PURE__ */ React.createElement("label", { className: cx(styles$M.label, props.className), htmlFor: id }, props.label));
RadioInput.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  checked: PropTypes.bool,
  autoFocus: PropTypes.bool,
  theme: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string
};
const styles$L = {
  wrapper: css({
    position: "relative",
    display: "flex",
    alignItems: "center",
    boxSizing: "border-box",
    height: 40,
    width: 240,
    border: `1px solid ${colors.mystic}`,
    borderRadius: borderRadius.default
  }),
  input: css({
    boxSizing: "border-box",
    fontFamily: fontFamily.body,
    fontSize: fontSize.default,
    lineHeight: 1.2,
    padding: shorthandHelper([spacing.small, 44, spacing.small, spacing.default]),
    color: colors.jumbo,
    backgroundColor: "transparent",
    border: 0,
    borderRadius: borderRadius.default,
    flex: 1,
    height: "100%",
    "&::placeholder": {
      color: colors.grayChateau,
      userSelect: "none"
    },
    "&:focus": {
      outline: "none"
    },
    "&[disabled]": {
      backgroundColor: colors.athensGray
    }
  }),
  icon: css({
    position: "absolute",
    right: 0,
    top: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    padding: shorthandHelper([0, spacing.default]),
    pointerEvents: "none"
  })
};
const wrapperTheme$4 = (theme) => {
  const themed = getThemeColors(theme);
  return css({
    "&:focus-within": {
      borderColor: themed.base,
      boxShadow: `0 0 0 2px ${hexToRgba(themed.base, 0.25)}`
    }
  });
};
const SearchInput = ({ meta, input, theme, className, onChange, ...props }) => {
  const value = input.value || props.value;
  const handler = input.onChange || onChange;
  return /* @__PURE__ */ React.createElement("div", { className: cx(styles$L.wrapper, className, wrapperTheme$4(theme)) }, /* @__PURE__ */ React.createElement(
    "input",
    {
      className: styles$L.input,
      ...input,
      ...props,
      type: "text",
      value,
      onChange: handler
    }
  ), /* @__PURE__ */ React.createElement("div", { className: styles$L.icon }, /* @__PURE__ */ React.createElement(AccessibleIcon, { icon: n$b, size: 20, color: colors.geyser })));
};
SearchInput.propTypes = {
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string
  }),
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func
  }),
  name: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  autoFocus: PropTypes.bool,
  tabIndex: PropTypes.string,
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "dark", "tertiary", "info"]),
  className: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func
};
SearchInput.defaultProps = {
  meta: {},
  input: {},
  theme: "primary",
  value: "",
  tabIndex: "0"
};
var toString = toString_1;
var idCounter = 0;
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}
var uniqueId_1 = uniqueId;
const uniqueId$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(uniqueId_1);
const styles$K = {
  wrapper: css({
    position: "relative",
    width: 240,
    fontFamily: fontFamily.body
  }),
  field: css({
    position: "relative",
    display: "flex",
    alignItems: "center",
    boxSizing: "border-box",
    height: 40,
    border: `1px solid ${colors.mystic}`,
    borderRadius: borderRadius.default
  }),
  openField: css({
    zIndex: zIndex.level6
  }),
  fieldError: css({
    borderColor: colors.mandy,
    "&:focus-within": {
      borderColor: colors.mandy,
      boxShadow: `0 0 0 2px ${hexToRgba(colors.mandy, 0.25)}`
    }
  }),
  input: css({
    boxSizing: "border-box",
    fontFamily: fontFamily.body,
    fontSize: fontSize.default,
    color: colors.jumbo,
    lineHeight: 1.2,
    padding: shorthandHelper([spacing.small, 44, spacing.small, spacing.default]),
    backgroundColor: "transparent",
    border: 0,
    borderRadius: borderRadius.default,
    flex: 1,
    height: "100%",
    "&::placeholder": {
      fontFamily: fontFamily.body,
      color: colors.grayChateau,
      userSelect: "none"
    },
    "&:focus": {
      outline: "none"
    },
    "&[disabled]": {
      backgroundColor: colors.athensGray
    }
  }),
  icon: css({
    position: "absolute",
    right: 0,
    top: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    padding: shorthandHelper([0, spacing.default]),
    pointerEvents: "none",
    background: "none",
    border: "none"
  }),
  iconSpinning: css({
    animationName: spin,
    animationDuration: "2000ms",
    animationIterationCount: "infinite",
    animationTimingFunction: "linear"
  }),
  iconClear: css({
    cursor: "pointer",
    pointerEvents: "auto"
  }),
  body: css({
    listStyle: "none",
    margin: 0,
    padding: 0,
    position: "absolute",
    top: 40,
    left: 0,
    right: 0,
    maxHeight: 280,
    overflowY: "auto",
    border: `1px solid ${colors.mystic}`,
    borderRadius: borderRadius.default,
    zIndex: zIndex.level6,
    marginTop: -2,
    borderTopRightRadius: 0,
    borderTopLeftRadius: 0,
    // Scroll gradient
    ...scrollGradient,
    "&:focus": {
      outline: "none"
    }
  }),
  item: css({
    position: "relative",
    userSelect: "none",
    padding: spacing.default,
    fontSize: fontSize.default,
    color: colors.jumbo,
    cursor: "pointer",
    "&[disabled]": {
      cursor: "default",
      pointerEvents: "none",
      color: colors.geyser
    }
  })
};
const fieldTheme$2 = (theme) => {
  const themed = getThemeColors(theme);
  return css({
    "&:focus-within": {
      borderColor: themed.base,
      boxShadow: `0 0 0 2px ${hexToRgba(themed.base, 0.25)}`
    }
  });
};
const itemTheme$2 = (theme, selected) => {
  const themed = getThemeColors(theme);
  return css({
    ...selected && {
      backgroundColor: themed.light,
      color: themed.base
    },
    "&:focus": {
      outline: "none",
      backgroundColor: colors.athensGray
    },
    "&:hover": {
      backgroundColor: themed.light,
      color: themed.base
    }
  });
};
const SingleSearch = ({
  className,
  helpText,
  onChange,
  onFocus,
  onSearch,
  onClear,
  onBlur,
  onKeyDown,
  meta = {},
  input = {},
  value = "",
  results = [],
  fetching = false,
  theme = "primary",
  ...props
}) => {
  const [open, setOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [options, setOptions] = useState([]);
  const wrapperRef = useRef(null);
  const bodyRef = useRef(null);
  const inputRef = useRef(null);
  const prevFetching = useRef(false);
  const componentId = useRef(uniqueId$1("single-search-items-"));
  useEffect(() => {
    if (!prevFetching.current && fetching) {
      setOptions([]);
      setSelectedIndex(-1);
    }
    if (prevFetching.current && !fetching) {
      setOpen(true);
      setOptions(results);
    }
    if (prevFetching.current !== fetching) {
      prevFetching.current = fetching;
    }
  }, [fetching, results]);
  useEffect(() => {
    const handleClosingClick = (e) => {
      if (wrapperRef.current.contains(e.target))
        return;
      setOpen(false);
    };
    if (open) {
      document.addEventListener("mousedown", handleClosingClick);
    } else {
      document.removeEventListener("mousedown", handleClosingClick);
    }
    return () => {
      document.removeEventListener("mousedown", handleClosingClick);
    };
  }, [open]);
  const inputValueObject = typeof input.value === "string" ? { label: input.value } : input.value;
  const valueObject = inputValueObject || { label: value };
  const handler = input.onChange || onChange;
  const errored = meta.touched && meta.error && selectedIndex === -1;
  const displayIcon = ({ isLoading, inputHasText }) => {
    if (isLoading)
      return t$3;
    if (inputHasText) {
      return t$7;
    }
    return n$b;
  };
  const clearInput = () => {
    const clearHandler = input.onChange || onChange;
    if (clearHandler) {
      clearHandler({ label: "" });
    }
    if (onClear) {
      onClear();
    }
    setOpen(false);
    setSelectedIndex(-1);
    setOptions([]);
  };
  const triggerFetch = debounce$1((query) => {
    if (query === "") {
      clearInput();
      return;
    }
    onSearch(query);
  }, 150);
  const handleNavigation = (ev) => {
    if (ev.keyCode === 38 || ev.keyCode === 40) {
      ev.preventDefault();
      const localSelectedIndex = selectedIndex + (ev.keyCode - 39);
      if (localSelectedIndex >= 0 && localSelectedIndex < options.length) {
        setSelectedIndex(localSelectedIndex);
        if (bodyRef && bodyRef.current && bodyRef.current.scrollHeight > bodyRef.current.offsetHeight) {
          const selectedOption = bodyRef.current.children[localSelectedIndex];
          const visibleArea = bodyRef.current.scrollTop + bodyRef.current.offsetHeight;
          if (selectedOption.offsetTop < bodyRef.current.scrollTop) {
            selectedOption.scrollIntoView();
          } else if (selectedOption.offsetTop + selectedOption.offsetHeight > visibleArea) {
            bodyRef.current.scrollTo({ top: bodyRef.current.scrollTop + selectedOption.offsetHeight });
          }
        }
      }
    } else if (ev.keyCode === 27) {
      ev.preventDefault();
      setOpen(false);
      setSelectedIndex(-1);
      setOptions([]);
    } else if (ev.keyCode === 13) {
      ev.preventDefault();
      const changeHandler = input.onChange || onChange;
      const item = options[selectedIndex];
      const freeTextItem = ev.target.value;
      if (changeHandler) {
        if (item)
          changeHandler({ value: item.value, label: item.label });
        else
          changeHandler({ value: null, label: freeTextItem });
      }
      setOpen(false);
      setSelectedIndex(-1);
      setOptions([]);
      if (inputRef) {
        inputRef.current.blur();
      }
    }
    if (onKeyDown) {
      onKeyDown(ev);
    }
  };
  const handleInputChange = (ev) => {
    triggerFetch(ev.target.value);
    const changeHandler = input.onChange || onChange;
    if (changeHandler)
      changeHandler({ label: ev.target.value });
  };
  const handleInputBlur = () => {
    const blurHandler = input.onBlur || onBlur;
    if (blurHandler) {
      blurHandler();
    }
    if (selectedIndex === -1 && open) {
      setOpen(false);
      setSelectedIndex(-1);
      setOptions([]);
    }
  };
  const handleInputFocus = (ev) => {
    const focusHandler = input.onFocus || onFocus;
    if (focusHandler) {
      focusHandler(ev);
    }
    if (!valueObject || !valueObject.label) {
      return;
    }
    setSelectedIndex(-1);
    setOptions([]);
    triggerFetch(valueObject.label);
  };
  const handleItemClick = (item) => {
    if (handler)
      handler({ value: item.value, label: item.label });
    setOpen(false);
    setSelectedIndex(-1);
    setOptions([]);
  };
  const handleItemFocus = (idx) => {
    setSelectedIndex(idx);
  };
  const handleItemBlur = () => {
    setSelectedIndex(-1);
  };
  return /* @__PURE__ */ React.createElement("div", { className: cx(styles$K.wrapper, className), ref: wrapperRef }, Boolean(open && options.length > 0) && /* @__PURE__ */ React.createElement("ul", { className: styles$K.body, ref: bodyRef, id: componentId.current, role: "listbox" }, options.map((item, idx) => /* @__PURE__ */ React.createElement(
    "li",
    {
      key: item.value,
      role: "option",
      "aria-selected": idx === selectedIndex,
      className: cx(styles$K.item, itemTheme$2(theme, idx === selectedIndex)),
      onMouseOver: () => handleItemFocus(idx),
      onFocus: () => handleItemFocus(idx),
      onMouseLeave: () => handleItemFocus(-1),
      onMouseOut: handleItemBlur,
      onBlur: handleItemBlur,
      onClick: () => handleItemClick(item),
      onKeyUp: () => handleItemClick(item),
      id: `${componentId.current}-${idx}`
    },
    item.label
  ))), /* @__PURE__ */ React.createElement("div", { className: cx(styles$K.field, fieldTheme$2(theme), open && styles$K.openField, errored && styles$K.fieldError) }, /* @__PURE__ */ React.createElement(
    "input",
    {
      className: styles$K.input,
      type: "text",
      ...{ ...input, ...props },
      value: valueObject.label,
      autoComplete: "off",
      ref: inputRef,
      onChange: handleInputChange,
      onFocus: handleInputFocus,
      onBlur: handleInputBlur,
      onKeyDown: handleNavigation,
      role: "combobox",
      "aria-expanded": open,
      "aria-controls": componentId.current,
      "aria-activedescendant": selectedIndex === -1 ? "" : `${componentId.current}-${selectedIndex}`
    }
  ), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: cx(styles$K.icon, fetching && styles$K.iconSpinning, valueObject.label && styles$K.iconClear),
      onClick: clearInput,
      "aria-label": "Clear input"
    },
    /* @__PURE__ */ React.createElement(
      AccessibleIcon,
      {
        icon: displayIcon({ isLoading: fetching, inputHasText: valueObject.label }),
        size: 20,
        color: errored ? colors.mandy : colors.geyser
      }
    )
  )), Boolean(helpText && !errored) && /* @__PURE__ */ React.createElement(FormHelpText, { text: helpText }), Boolean(errored) && /* @__PURE__ */ React.createElement(FormErrorMessage, { text: meta.error }));
};
const valuePropTypes$1 = PropTypes.oneOfType([
  PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
  }),
  PropTypes.string
]);
const inputEventPropTypes$1 = {
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyDown: PropTypes.func
};
SingleSearch.propTypes = {
  className: PropTypes.string,
  fetching: PropTypes.bool,
  results: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ),
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "dark", "tertiary", "info"]),
  input: PropTypes.shape({
    value: valuePropTypes$1,
    ...inputEventPropTypes$1
  }),
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string
  }),
  value: valuePropTypes$1,
  ...inputEventPropTypes$1,
  helpText: PropTypes.string,
  onSearch: PropTypes.func.isRequired,
  onClear: PropTypes.func
};
const styles$J = {
  wrapper: css({
    position: "relative",
    width: 240,
    fontFamily: fontFamily.body
  }),
  wrapperError: css({
    "&:focus-within > div:last-child": {
      borderColor: colors.mandy,
      boxShadow: `0 0 0 2px ${hexToRgba(colors.mandy, 0.25)}`
    }
  }),
  label: css({
    height: 40,
    width: "100%",
    userSelect: "none",
    cursor: "pointer",
    border: `1px solid ${colors.mystic}`,
    borderRadius: borderRadius.default,
    position: "relative",
    color: colors.jumbo,
    backgroundColor: colors.white,
    boxSizing: "border-box",
    "&[readonly]": {
      pointerEvents: "none",
      cursor: "default",
      backgroundColor: colors.athensGray
    },
    "&:focus": {
      outline: "none"
    }
  }),
  openLabel: css({
    zIndex: zIndex.level6
  }),
  errorLabel: css({
    borderColor: colors.mandy,
    "&:focus": {
      borderColor: colors.mandy,
      boxShadow: `0 0 0 2px ${hexToRgba(colors.mandy, 0.25)}`
    }
  }),
  input: css({
    boxSizing: "border-box",
    color: colors.jumbo,
    fontSize: fontSize.default,
    lineHeight: "40px",
    padding: shorthandHelper([0, 42, 0, spacing.default]),
    borderRadius: borderRadius.default,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }),
  placeholderInput: css({
    color: colors.grayChateau
  }),
  arrow: css({
    pointerEvents: "none",
    position: "absolute",
    top: 0,
    bottom: 0,
    right: 0,
    padding: shorthandHelper([0, spacing.default]),
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }),
  body: css({
    listStyle: "none",
    margin: 0,
    padding: 0,
    position: "absolute",
    top: 40,
    left: 0,
    right: 0,
    maxHeight: 280,
    overflowY: "auto",
    border: `1px solid ${colors.mystic}`,
    borderRadius: borderRadius.default,
    zIndex: zIndex.level6,
    marginTop: -2,
    borderTopRightRadius: 0,
    borderTopLeftRadius: 0,
    // Scroll gradient
    ...scrollGradient,
    "&:focus": {
      outline: "none"
    }
  }),
  overlay: css({
    position: "fixed",
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    zIndex: zIndex.level5
  })
};
const wrapperTheme$3 = (theme) => {
  const themed = getThemeColors(theme);
  return css({
    "&:focus-within > div:last-child": {
      borderColor: themed.base,
      boxShadow: `0 0 0 2px ${hexToRgba(themed.base, 0.25)}`
    }
  });
};
const labelTheme = (theme) => {
  const themed = getThemeColors(theme);
  return css({
    "&:focus": {
      borderColor: themed.base,
      boxShadow: `0 0 0 2px ${hexToRgba(themed.base, 0.25)}`
    }
  });
};
class SingleSelectField extends Component {
  constructor(props) {
    super(props);
    __publicField(this, "onLabelClick", (ev) => {
      const { open } = this.state;
      this.setState({ open: !open });
      const { input, ...props } = this.props;
      const focusHandler = input.onFocus || props.onFocus;
      if (!open && focusHandler)
        focusHandler(ev);
      const blurHandler = input.onBlur || props.onBlur;
      if (open && blurHandler)
        blurHandler(ev);
    });
    __publicField(this, "onChildClick", (childValue, childIndex, childId) => {
      const { input, ...props } = this.props;
      const name = input.name || props.name;
      const value = input.value || props.value;
      this.setState({
        open: false,
        focusIndex: childIndex,
        selectedOptionIndex: childIndex,
        selectedOptionId: childId
      });
      const handler = input.onChange || props.onChange;
      if (handler)
        handler(childValue);
      if (props.onSelect)
        props.onSelect(name, childValue, value);
    });
    __publicField(this, "onOverlayClick", (ev) => {
      this.setState({ open: false });
      const { input, ...props } = this.props;
      const handler = input.onBlur || props.onBlur;
      if (handler)
        handler(ev);
    });
    __publicField(this, "focusOnSelectedChild", () => {
      const { selectedOptionIndex } = this.state;
      if (selectedOptionIndex < 0)
        return;
      let selectedOption;
      if (this.body && this.body.scrollHeight > this.body.offsetHeight) {
        selectedOption = this.body.children[selectedOptionIndex];
        this.body.scrollTop = selectedOption.offsetTop - this.body.offsetHeight * 0.5;
      }
      this.setState({
        selectedOptionId: selectedOption && selectedOption.id,
        focusIndex: selectedOptionIndex
      });
    });
    __publicField(this, "handleButtonNavigation", (ev) => {
      const focusIndex = this.keyboardFocusIndex();
      switch (ev.key) {
        case "ArrowUp":
        case "ArrowDown":
        case " ":
        case "Spacebar":
        case "Enter":
          ev.preventDefault();
          if (!this.state.open)
            this.setState({ open: true, focusIndex });
          break;
        case "Escape":
        case "Esc":
          ev.preventDefault();
          this.setState({ open: false, focusIndex: -1 });
          break;
      }
    });
    __publicField(this, "handleOptionsNavigation", (ev) => {
      const focusIndex = this.keyboardFocusIndex();
      switch (ev.key) {
        case "ArrowUp":
        case "ArrowDown": {
          ev.preventDefault();
          const offsetDirection = ev.key === "ArrowDown" ? 1 : -1;
          const focusOffset = focusIndex + offsetDirection;
          if (focusOffset >= 0 && focusOffset < React.Children.count(this.props.children)) {
            this.setState({ focusIndex: focusOffset });
            if (this.body && this.body.scrollHeight > this.body.offsetHeight) {
              const selectedOption = this.body.children[focusOffset];
              const visibleArea = this.body.scrollTop + this.body.offsetHeight;
              this.setState({ selectedOptionId: selectedOption.id });
              if (selectedOption.offsetTop < this.body.scrollTop) {
                selectedOption.scrollIntoView();
              } else if (selectedOption.offsetTop + selectedOption.offsetHeight > visibleArea) {
                this.body.scrollTop = this.body.scrollTop + selectedOption.offsetHeight;
              }
            }
          }
          break;
        }
        case "Escape":
        case "Esc": {
          ev.preventDefault();
          this.setState({ open: false, focusIndex: -1 });
          break;
        }
        case "Enter": {
          ev.preventDefault();
          const selectedChild = React.Children.toArray(this.props.children)[focusIndex];
          const childValue = selectedChild.props.value;
          const childId = this.constructChildId(childValue);
          this.onChildClick(childValue, focusIndex, childId);
          if (this.input)
            this.input.blur();
          break;
        }
      }
    });
    __publicField(this, "handleBlur", (ev) => {
      ev.persist();
      this.onBlurTimeout = setTimeout(() => {
        const handler = this.props.input.onBlur || this.props.onBlur;
        if (handler)
          handler();
        this.setState({ open: false, focusIndex: -1 });
      });
    });
    __publicField(this, "onOptionsFocus", () => {
      clearTimeout(this.onBlurTimeout);
    });
    __publicField(this, "constructChildId", (childValue) => `${this.props.id}-option-${childValue}`);
    // When opening with keyboard, the first item should be
    // highlighted if nothing has been selected yet
    __publicField(this, "keyboardFocusIndex", () => this.state.focusIndex < 0 ? 0 : this.state.focusIndex);
    __publicField(this, "getActiveDescendent", () => {
      const children = React.Children.toArray(this.props.children);
      if (!children.length)
        return;
      return this.state.selectedOptionId || this.constructChildId(children[0].props.value);
    });
    const value = this.props.input.value || this.props.value;
    const selectedOptionIndex = React.Children.toArray(this.props.children).findIndex((child) => child.props.value === value);
    this.state = {
      open: false,
      focusIndex: -1,
      selectedOptionId: null,
      selectedOptionIndex
    };
    this.onBlurTimeout = null;
  }
  componentDidUpdate(_, prevState) {
    if (prevState.open !== this.state.open) {
      if (this.state.open) {
        this.focusOnSelectedChild();
        this.body.focus();
      } else {
        this.input.focus();
      }
    }
  }
  componentWillUnmount() {
    clearTimeout(this.onBlurTimeout);
  }
  render() {
    const { open, focusIndex } = this.state;
    const { meta, input, label, theme, helpText, readOnly, id, ...props } = this.props;
    const children = React.Children.toArray(props.children);
    const value = input.value || props.value;
    const errored = meta.touched && meta.error;
    const selectedChild = children.find((child) => child.props.value === value) || {
      props: { value: "", label: props.placeholder, disabled: true }
    };
    const isPlaceholder = selectedChild.props.value === "" && selectedChild.props.disabled;
    const activeDescendant = this.getActiveDescendent();
    const listboxId = `${id}-listbox`;
    return /* @__PURE__ */ React.createElement("div", { className: cx(styles$J.wrapper, props.className, wrapperTheme$3(theme), errored && styles$J.wrapperError) }, Boolean(open) && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      "ul",
      {
        id: listboxId,
        className: styles$J.body,
        role: "listbox",
        "aria-activedescendant": activeDescendant,
        tabIndex: "-1",
        ref: (el) => this.body = el,
        onKeyDown: this.handleOptionsNavigation,
        onFocus: this.onOptionsFocus,
        "aria-label": "Select an option"
      },
      React.Children.map(children, (child, index) => {
        const childValue = child.props.value;
        const childId = this.constructChildId(childValue);
        return React.cloneElement(child, {
          theme,
          onClick: () => this.onChildClick(childValue, index, childId),
          selected: value === childValue,
          focused: focusIndex === index ? "true" : null,
          id: childId,
          onMouseEnter: () => this.setState({ focusIndex: index })
        });
      })
    ), /* @__PURE__ */ React.createElement("div", { "data-testid": "hack-overlay", className: styles$J.overlay, onClick: this.onOverlayClick })), /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cx(styles$J.label, labelTheme(theme), open && styles$J.openLabel, errored && styles$J.errorLabel),
        readOnly,
        onClick: this.onLabelClick,
        tabIndex: readOnly ? "-1" : props.tabIndex,
        role: "button",
        "aria-haspopup": "listbox",
        "aria-expanded": open,
        "aria-labelledby": `${props.ariaLabelledby || id || ""}`,
        "aria-owns": listboxId,
        onKeyDown: this.handleButtonNavigation,
        onBlur: this.handleBlur,
        ref: (el) => {
          this.input = el;
          this.props.setInnerRef && this.props.setInnerRef(el);
        }
      },
      /* @__PURE__ */ React.createElement("div", { id, className: cx(styles$J.input, isPlaceholder && styles$J.placeholderInput), "data-test": props.dataTest }, Boolean(label) && /* @__PURE__ */ React.createElement(React.Fragment, null, label, ": "), selectedChild.props.label),
      /* @__PURE__ */ React.createElement("div", { className: styles$J.arrow }, /* @__PURE__ */ React.createElement(AccessibleIcon, { icon: t$5, size: 18, color: errored ? colors.mandy : colors.geyser }))
    ), Boolean(helpText && !errored) && /* @__PURE__ */ React.createElement(FormHelpText, { text: helpText }), Boolean(errored) && /* @__PURE__ */ React.createElement(FormErrorMessage, { text: meta.error }));
  }
}
SingleSelectField.propTypes = {
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string
  }),
  input: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    onChange: PropTypes.func
  }),
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  dataTest: PropTypes.string,
  onSelect: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  helpText: PropTypes.string,
  tabIndex: PropTypes.string,
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "dark", "tertiary", "info", "light"]),
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  id: PropTypes.string.isRequired,
  setInnerRef: PropTypes.func
};
SingleSelectField.defaultProps = {
  meta: {},
  input: {},
  value: "",
  placeholder: "",
  theme: "primary",
  tabIndex: "0"
};
const SingleSelect = (props) => {
  const singleSelectField = /* @__PURE__ */ React.createElement(
    SingleSelectField,
    {
      meta: props.meta,
      input: props.input,
      name: props.name,
      label: props.innerLabel,
      value: props.value,
      placeholder: props.placeholder,
      readOnly: props.readOnly,
      dataTest: props.dataTest,
      onSelect: props.onSelect,
      onFocus: props.onFocus,
      onBlur: props.onBlur,
      helpText: props.helpText,
      tabIndex: props.tabIndex,
      theme: props.theme,
      id: props.id,
      className: props.selectClassName
    },
    props.children
  );
  if (!props.label)
    return singleSelectField;
  return /* @__PURE__ */ React.createElement(
    AccessibleFormLabel,
    {
      formFieldId: props.id,
      label: props.label,
      labelClassName: props.labelClassName,
      readOnly: props.readOnly,
      optional: props.optional
    },
    singleSelectField
  );
};
SingleSelect.propTypes = {
  meta: PropTypes.shape(),
  input: PropTypes.shape(),
  name: PropTypes.string,
  innerLabel: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  dataTest: PropTypes.string,
  onSelect: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  helpText: PropTypes.string,
  tabIndex: PropTypes.string,
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "dark", "tertiary", "info", "light"]),
  selectClassName: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  id: PropTypes.string.isRequired,
  labelClassName: PropTypes.string,
  label: PropTypes.string,
  optional: PropTypes.bool
};
const styles$I = {
  item: css({
    position: "relative",
    userSelect: "none",
    color: colors.blackPearl,
    padding: spacing.default,
    fontSize: fontSize.default,
    cursor: "pointer",
    "&[disabled]": {
      cursor: "default",
      pointerEvents: "none",
      color: colors.geyser
    }
  }),
  subItem: css({
    display: "block"
  }),
  icon: css({
    position: "absolute",
    right: 0,
    top: 0,
    bottom: 0,
    padding: shorthandHelper([0, spacing.default]),
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  })
};
const itemTheme$1 = (theme, selected, focused) => {
  const themed = getThemeColors(theme);
  return css({
    ...selected && {
      "&:not([disabled])": {
        color: themed.base
      }
    },
    "&:focus": {
      outline: "none",
      backgroundColor: colors.athensGray
    },
    ...focused && {
      backgroundColor: themed.light,
      color: themed.base
    }
  });
};
const iconTheme$1 = (theme) => {
  const themed = getThemeColors(theme);
  return themed.base;
};
const SingleOption = ({ theme = null, label, subLabel = null, selected = null, focused = null, className = null, ...props }) => /* @__PURE__ */ React.createElement(
  "li",
  {
    role: "option",
    "aria-selected": selected,
    className: cx(styles$I.item, itemTheme$1(theme, selected, focused), className),
    tabIndex: props.disabled ? "-1" : "0",
    ...props
  },
  label,
  Boolean(subLabel) && /* @__PURE__ */ React.createElement(SmallText, { className: styles$I.subItem }, subLabel),
  Boolean(selected) && /* @__PURE__ */ React.createElement("div", { className: styles$I.icon }, /* @__PURE__ */ React.createElement(AccessibleIcon, { icon: t$6, color: props.disabled ? colors.geyser : iconTheme$1(theme), size: 16 }))
);
SingleOption.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string.isRequired,
  subLabel: PropTypes.string,
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  focused: PropTypes.string,
  theme: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string
};
const styles$H = {
  wrapper: css({
    position: "relative",
    width: 240,
    fontFamily: fontFamily.body
  }),
  field: css({
    position: "relative",
    display: "flex",
    alignItems: "center",
    boxSizing: "border-box",
    height: 40
  }),
  fieldError: css({
    "&:focus-within input": {
      borderColor: colors.mandy,
      boxShadow: `0 0 0 2px ${hexToRgba(colors.mandy, 0.25)}`
    }
  }),
  input: css({
    boxSizing: "border-box",
    fontFamily: fontFamily.body,
    fontSize: fontSize.default,
    color: colors.jumbo,
    lineHeight: 1.2,
    padding: shorthandHelper([spacing.small, 44, spacing.small, spacing.default]),
    backgroundColor: "transparent",
    border: `1px solid ${colors.mystic}`,
    borderRadius: borderRadius.default,
    flex: 1,
    height: "100%",
    "&::placeholder": {
      fontFamily: fontFamily.body,
      color: colors.grayChateau,
      userSelect: "none"
    },
    "&:focus": {
      outline: "none"
    },
    "&[disabled]": {
      backgroundColor: colors.athensGray
    }
  }),
  inputError: css({
    borderColor: colors.mandy
  }),
  inputOpen: css({
    position: "relative",
    zIndex: zIndex.level6
  }),
  icon: css({
    position: "absolute",
    right: 0,
    top: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    padding: shorthandHelper([0, spacing.default]),
    pointerEvents: "none",
    background: "none",
    border: "none",
    "&:focus": {
      outline: "none"
    }
  }),
  iconSpinning: css({
    animationName: spin,
    animationDuration: "2000ms",
    animationIterationCount: "infinite",
    animationTimingFunction: "linear"
  }),
  iconClear: css({
    cursor: "pointer",
    pointerEvents: "auto"
  }),
  body: css({
    listStyle: "none",
    margin: 0,
    padding: 0,
    position: "absolute",
    top: 40,
    left: 0,
    right: 0,
    maxHeight: 280,
    overflowY: "auto",
    border: `1px solid ${colors.mystic}`,
    borderRadius: borderRadius.default,
    zIndex: zIndex.level5,
    marginTop: -2,
    borderTopRightRadius: 0,
    borderTopLeftRadius: 0,
    // Scroll gradient
    ...scrollGradient,
    "&:focus": {
      outline: "none"
    }
  }),
  item: css({
    position: "relative",
    userSelect: "none",
    padding: spacing.default,
    fontSize: fontSize.default,
    color: colors.jumbo,
    cursor: "pointer",
    "&[disabled]": {
      cursor: "default",
      pointerEvents: "none",
      color: colors.geyser
    }
  }),
  accessiblyHidden: css(accessiblyHidden)
};
const fieldTheme$1 = (theme) => {
  const themed = getThemeColors(theme);
  return css({
    "&:focus-within input": {
      borderColor: themed.base,
      boxShadow: `0 0 0 2px ${hexToRgba(themed.base, 0.25)}`
    }
  });
};
const itemTheme = (theme, selected) => {
  const themed = getThemeColors(theme);
  return css({
    ...selected && {
      backgroundColor: themed.light,
      color: themed.base
    },
    "&:focus": {
      outline: "none",
      backgroundColor: colors.athensGray
    },
    "&:hover": {
      backgroundColor: themed.light,
      color: themed.base
    }
  });
};
const SingleSelectFilter = ({
  className,
  helpText,
  onChange,
  onFocus,
  onClear,
  onBlur,
  onKeyDown,
  meta = {},
  input = {},
  value = "",
  results = [],
  fetching = false,
  theme = "primary",
  ...props
}) => {
  const [open, setOpen] = useState(false);
  const [focusedIndex, setFocusedIndex] = useState(-1);
  const [options, setOptions] = useState(results);
  const wrapperRef = useRef(null);
  const bodyRef = useRef(null);
  const inputRef = useRef(null);
  const componentId = useRef(uniqueId$1("single-search-items-"));
  const inputValueObject = typeof input.value === "string" ? { label: input.value } : input.value;
  const valueObject = inputValueObject || { label: value };
  const errored = meta.touched && meta.error && focusedIndex === -1;
  useEffect(() => {
    const handleClosingClick = (e) => {
      if (wrapperRef.current.contains(e.target))
        return;
      setOpen(false);
    };
    if (open) {
      document.addEventListener("mousedown", handleClosingClick);
    } else {
      document.removeEventListener("mousedown", handleClosingClick);
    }
    return () => {
      document.removeEventListener("mousedown", handleClosingClick);
    };
  }, [open]);
  useEffect(() => {
    let updatedResults = results;
    if (valueObject.label !== "") {
      updatedResults = results.filter((result) => result.label.toLowerCase().includes(valueObject.label.toLowerCase()));
    }
    setFocusedIndex(-1);
    setOptions(updatedResults);
  }, [valueObject.label, results]);
  const displayButtonLabel = () => {
    if (fetching)
      return "Loading";
    if (valueObject.label) {
      return "Clear";
    }
    return "Open dropdown";
  };
  const displayIcon = () => {
    if (fetching)
      return t$3;
    if (valueObject.label) {
      return t$7;
    }
    return t$5;
  };
  const handleButtonClick = () => {
    const clearHandler = input.onChange || onChange;
    if (clearHandler) {
      clearHandler({ label: "", value: "" });
      setFocusedIndex(-1);
      setOpen(true);
      if (inputRef) {
        inputRef.current.focus();
      }
    }
    if (onClear) {
      onClear();
    }
  };
  const handleNavigation = (ev) => {
    if (ev.keyCode === 38 || ev.keyCode === 40) {
      ev.preventDefault();
      const localFocusedIndex = focusedIndex + (ev.keyCode - 39);
      if (localFocusedIndex >= 0 && localFocusedIndex < options.length) {
        setFocusedIndex(localFocusedIndex);
        if (bodyRef && bodyRef.current && bodyRef.current.scrollHeight > bodyRef.current.offsetHeight) {
          const focusedOption = bodyRef.current.children[localFocusedIndex];
          const visibleArea = bodyRef.current.scrollTop + bodyRef.current.offsetHeight;
          if (focusedOption.offsetTop < bodyRef.current.scrollTop) {
            focusedOption.scrollIntoView();
          } else if (focusedOption.offsetTop + focusedOption.offsetHeight > visibleArea) {
            bodyRef.current.scrollTo({ top: bodyRef.current.scrollTop + focusedOption.offsetHeight });
          }
        }
      }
    } else if (ev.keyCode === 27) {
      ev.preventDefault();
      setOpen(false);
      setFocusedIndex(-1);
    } else if (ev.keyCode === 13) {
      ev.preventDefault();
      const changeHandler = input.onChange || onChange;
      const item = options[focusedIndex];
      const freeTextItem = ev.target.value;
      if (changeHandler) {
        if (item)
          changeHandler({ value: item.value, label: item.label });
        else
          changeHandler({ value: null, label: freeTextItem });
      }
      setOpen(false);
      setFocusedIndex(-1);
      if (inputRef) {
        inputRef.current.blur();
      }
    }
    if (onKeyDown) {
      onKeyDown(ev);
    }
  };
  const handleInputChange = (ev) => {
    const changeHandler = input.onChange || onChange;
    if (changeHandler)
      changeHandler({ label: ev.target.value });
    if (!open)
      setOpen(true);
  };
  const handleInputBlur = () => {
    const blurHandler = input.onBlur || onBlur;
    if (blurHandler) {
      blurHandler();
    }
    if (focusedIndex === -1 && open) {
      setOpen(false);
      setFocusedIndex(-1);
      setOptions(results);
    }
  };
  const handleInputFocus = (ev) => {
    const focusHandler = input.onFocus || onFocus;
    if (focusHandler) {
      focusHandler(ev);
    }
    setOpen(true);
  };
  const handleItemClick = (item) => {
    const changeHandler = input.onChange || onChange;
    if (changeHandler)
      changeHandler({ value: item.value, label: item.label });
    setOpen(false);
    setFocusedIndex(-1);
    setOptions(results);
  };
  const handleItemFocus = (idx) => {
    setFocusedIndex(idx);
  };
  const handleItemBlur = () => {
    setFocusedIndex(-1);
  };
  return /* @__PURE__ */ React.createElement("div", { className: cx(styles$H.wrapper, className), ref: wrapperRef }, /* @__PURE__ */ React.createElement("div", { className: cx(styles$H.field, fieldTheme$1(theme), errored && styles$H.fieldError) }, /* @__PURE__ */ React.createElement(
    "input",
    {
      className: cx(styles$H.input, open && styles$H.inputOpen, errored && styles$H.inputError),
      type: "text",
      ...{ ...input, ...props },
      value: valueObject.label,
      autoComplete: "off",
      ref: inputRef,
      onChange: handleInputChange,
      onFocus: handleInputFocus,
      onBlur: handleInputBlur,
      onKeyDown: handleNavigation,
      role: "combobox",
      "aria-expanded": open,
      "aria-controls": componentId.current,
      "aria-activedescendant": focusedIndex === -1 ? "" : `${componentId.current}-${focusedIndex}`,
      "aria-autocomplete": "list",
      "aria-haspopup": "listbox"
    }
  ), Boolean(open && options.length > 0) && /* @__PURE__ */ React.createElement("ul", { className: styles$H.body, ref: bodyRef, id: componentId.current, role: "listbox" }, options.map((item, idx) => /* @__PURE__ */ React.createElement(
    "li",
    {
      key: item.value,
      role: "option",
      "aria-selected": item.label === valueObject.label,
      className: cx(styles$H.item, itemTheme(theme, idx === focusedIndex)),
      onMouseOver: () => handleItemFocus(idx),
      onFocus: () => handleItemFocus(idx),
      onMouseLeave: () => handleItemFocus(-1),
      onMouseOut: handleItemBlur,
      onBlur: handleItemBlur,
      onClick: () => handleItemClick(item),
      onKeyUp: () => handleItemClick(item),
      id: `${componentId.current}-${idx}`
    },
    item.label
  ))), /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: cx(styles$H.icon, fetching && styles$H.iconSpinning, valueObject.label && styles$H.iconClear),
      onClick: handleButtonClick
    },
    /* @__PURE__ */ React.createElement("span", { className: styles$H.accessiblyHidden }, displayButtonLabel()),
    /* @__PURE__ */ React.createElement(AccessibleIcon, { icon: displayIcon(), size: 20, color: errored ? colors.mandy : colors.geyser })
  )), Boolean(helpText && !errored) && /* @__PURE__ */ React.createElement(FormHelpText, { text: helpText }), Boolean(errored) && /* @__PURE__ */ React.createElement(FormErrorMessage, { text: meta.error }));
};
const valuePropTypes = PropTypes.oneOfType([
  PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
  }),
  PropTypes.string
]);
const inputEventPropTypes = {
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyDown: PropTypes.func
};
SingleSelectFilter.propTypes = {
  className: PropTypes.string,
  fetching: PropTypes.bool,
  results: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ),
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "dark", "tertiary", "info"]),
  input: PropTypes.shape({
    value: valuePropTypes,
    ...inputEventPropTypes
  }),
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string
  }),
  value: valuePropTypes,
  ...inputEventPropTypes,
  helpText: PropTypes.string,
  // onSearch: PropTypes.func.isRequired,
  onClear: PropTypes.func
};
const styles$G = {
  spinner: css({
    marginRight: spacing.small
  })
};
const spinnerVariant = (variant) => {
  switch (variant) {
    case "outlined":
    case "dashed":
      return "colored";
    default:
      return "white";
  }
};
const SubmitButtonLoading = ({ theme, variant, submittingLabel }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Spinner, { theme, variant: spinnerVariant(variant), className: styles$G.spinner }), submittingLabel);
SubmitButtonLoading.propTypes = {
  submittingLabel: PropTypes.string,
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "light", "dark", "tertiary", "info"]),
  variant: PropTypes.oneOf(["", "default", "outlined", "dashed"])
};
const styles$F = {
  status: css({
    // based upon https://adrianroselli.com/2021/01/multi-function-button.html#HideLive
    // it is possible that some browser/screenreaders might
    // ignore elements set to full opacity, undesirable behaviour in an element
    // built for screenreading.
    opacity: "0.00001",
    position: "absolute",
    pointerEvents: "none"
  })
};
const SubmitButton = ({
  className,
  size: size2 = "default",
  theme = "primary",
  variant = "default",
  label = "Submit",
  submitLabel,
  submittingLabel = "Submitting",
  isSubmitting,
  onClick,
  ...props
}) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", { role: "status", className: styles$F.status }, isSubmitting ? submittingLabel : null), /* @__PURE__ */ React.createElement(
  Button,
  {
    onClick: isSubmitting ? null : onClick,
    variant,
    theme,
    className,
    size: size2,
    tabIndex: isSubmitting ? "-1" : null,
    ...props,
    label: isSubmitting ? /* @__PURE__ */ React.createElement(SubmitButtonLoading, { theme, variant, submittingLabel }) : submitLabel || label,
    type: isSubmitting ? "button" : "submit"
  }
));
SubmitButton.propTypes = {
  label: PropTypes.string,
  submitLabel: PropTypes.string,
  submittingLabel: PropTypes.string,
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "light", "dark", "tertiary", "info"]),
  size: PropTypes.oneOf(["", "default", "small", "medium"]),
  variant: PropTypes.oneOf(["", "default", "outlined", "dashed"]),
  onClick: PropTypes.func,
  className: PropTypes.string,
  isSubmitting: PropTypes.bool
};
const styles$E = {
  wrapper: css({
    position: "fixed",
    left: 0,
    right: 0,
    color: colors.mandy,
    backgroundColor: colors.linen,
    zIndex: zIndex.level7,
    overflow: "hidden",
    transition: "max-height 0.3s"
  }),
  container: css({
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: spacing.default,
    fontSize: fontSize.small,
    lineHeight: 1.2,
    fontStyle: "italic"
  }),
  icon: css({
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  })
};
const wrapperTop = (offsetTop) => css({
  top: offsetTop
});
const wrapperTransition = (status) => {
  switch (status) {
    case "entering":
      return css({
        maxHeight: 0
      });
    case "entered":
      return css({
        maxHeight: "30vh"
        // Set it to something big to generate the transition correctly
      });
    case "exiting":
    case "exited":
      return css({
        maxHeight: 0
      });
    default:
      return css();
  }
};
class SystemError extends Component {
  constructor() {
    super(...arguments);
    // eslint-disable-next-line react/state-in-constructor
    __publicField(this, "state", {
      dismissTimeout: null
    });
    __publicField(this, "autoHide", () => {
      if (this.props.visible) {
        this.props.hide();
        setTimeout(this.props.clear, 300);
      }
    });
  }
  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible) {
      clearInterval(this.state.dismissTimeout);
      const dismissTimeout = setTimeout(this.autoHide, this.props.hideTimeout);
      this.setState({ dismissTimeout });
    }
  }
  render() {
    const { visible, offsetTop, className, message: message2, hide } = this.props;
    return /* @__PURE__ */ React.createElement(Transition, { in: visible, timeout: 300, mountOnEnter: true, unmountOnExit: true }, (status) => /* @__PURE__ */ React.createElement("div", { className: cx(styles$E.wrapper, className, wrapperTop(offsetTop), wrapperTransition(status)) }, /* @__PURE__ */ React.createElement("div", { className: styles$E.container }, message2, /* @__PURE__ */ React.createElement("span", { className: styles$E.icon, onClick: hide }, /* @__PURE__ */ React.createElement(AccessibleIcon, { icon: t$7, color: colors.mandy, size: 18 })))));
  }
}
SystemError.propTypes = {
  offsetTop: PropTypes.number,
  visible: PropTypes.bool,
  message: PropTypes.string,
  className: PropTypes.string,
  hide: PropTypes.func,
  clear: PropTypes.func,
  hideTimeout: PropTypes.number
};
SystemError.defaultProps = {
  hideTimeout: 1e4
};
const styles$D = {
  wrapper: css({
    boxSizing: "border-box",
    listStyle: "none",
    margin: 0,
    padding: 0,
    display: "flex",
    alignItems: "stretch",
    height: 50,
    borderBottom: `1px solid ${colors.geyser}`,
    backgroundColor: colors.white
  })
};
const TabBar = ({ theme, children }) => /* @__PURE__ */ React.createElement("ul", { className: styles$D.wrapper }, React.Children.map(children, (child) => React.cloneElement(child, { theme })));
TabBar.propTypes = {
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "dark", "tertiary", "info"]),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
TabBar.defaultProps = {
  theme: "primary"
};
const styles$C = {
  item: css({
    display: "flex",
    alignItems: "stretch",
    fontSize: fontSize.default,
    fontWeight: fontWeight.regular,
    fontFamily: fontFamily.body,
    lineHeight: 1.2,
    color: colors.jumbo,
    margin: shorthandHelper([0, spacing.medium])
  }),
  link: css({
    display: "flex",
    alignItems: "center",
    borderTop: "2px solid transparent",
    borderBottom: "2px solid transparent",
    color: "inherit",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "none",
      color: colors.oxfordBlue
    },
    "&:focus": {
      outline: "none"
    }
  }),
  activeLink: css({
    color: colors.oxfordBlue,
    fontWeight: fontWeight.semiBold
  })
};
const activeLinkTheme = (theme) => {
  const themed = getThemeColors(theme);
  return css({
    borderBottomColor: themed.base
  });
};
const TabItem = ({ theme, href, label, isActive, asLink }) => /* @__PURE__ */ React.createElement("li", { className: styles$C.item }, /* @__PURE__ */ React.createElement(
  PinataLink,
  {
    to: href,
    className: styles$C.link,
    activeClassName: cx(styles$C.activeLink, activeLinkTheme(theme)),
    isActive,
    as: asLink
  },
  label
));
TabItem.propTypes = {
  href: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  theme: PropTypes.string,
  isActive: PropTypes.func,
  asLink: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({})])
};
const styles$B = {
  table: css({
    width: "100%",
    tableLayout: "fixed",
    backgroundColor: colors.white,
    borderRadius: borderRadius.default,
    boxShadow: `1px 1px 5px ${hexToRgba(colors.black, 0.1)}`,
    fontSize: fontSize.small,
    borderCollapse: "collapse",
    borderSpacing: 0
  })
};
const rowTheme = (theme) => {
  const themed = getThemeColors(theme);
  return css({
    "& tbody tr:hover": {
      backgroundColor: hexToRgba(themed.light, 0.5)
    }
  });
};
const Table = ({ theme, className, children }) => /* @__PURE__ */ React.createElement("table", { className: cx(styles$B.table, className, rowTheme(theme)) }, children);
Table.propTypes = {
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "light", "dark", "tertiary", "info"]),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string
};
Table.defaultProps = {
  theme: "primary"
};
const TableBody = ({ children }) => /* @__PURE__ */ React.createElement("tbody", null, children);
TableBody.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
const n$6 = ({
  title: l,
  titleId: o,
  ...r2
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...r2,
    children: [
      l ? /* @__PURE__ */ fr.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M312.962 427.94h390.763c38.101 0 57.088-46.123 30.08-72.939L538.392 160.974c-16.619-16.512-43.477-16.512-60.117 0L282.883 355.001c-27.029 26.816-8 72.939 30.08 72.939zm394.293 145.835H316.471c-38.101 0-57.088 46.101-30.08 72.939l195.413 194.005c16.619 16.512 43.477 16.512 60.117 0l195.392-194.005c27.029-26.837 8.021-72.939-30.059-72.939z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), s$3 = memo(n$6);
const directionMap = {
  asc: {
    id: "asc",
    icon: m$f
  },
  desc: {
    id: "desc",
    icon: m$e
  },
  "asc-desc": {
    id: "asc-desc",
    icon: s$3
  }
};
const getCurrentDirection = (column, currentColumn, currentDir) => {
  if (currentColumn === column)
    return currentDir;
  return "asc-desc";
};
const getNextDirection = (column, currentColumn, currentDir) => {
  if (currentColumn !== column)
    return "asc";
  if (currentDir === "asc")
    return "desc";
  return "asc";
};
const styles$A = {
  header: css({
    color: colors.oxfordBlue,
    backgroundColor: colors.athensGray
  }),
  row: css({
    "& > th:first-child": {
      borderTopLeftRadius: borderRadius.default
    },
    "& > th:last-child": {
      borderTopRightRadius: borderRadius.default
    }
  }),
  cell: css({
    textAlign: "left",
    padding: spacing.default,
    userSelect: "none"
  }),
  sortable: css({
    cursor: "pointer",
    "&:focus": {
      outline: "none",
      textDecoration: "underline"
    },
    "& > *": {
      verticalAlign: "middle"
    },
    "& > * + *": {
      marginLeft: spacing.small
    }
  })
};
const cellAlignment = (alignment) => css({
  textAlign: alignment || "left"
});
const TableHeader = ({ sortBy, sortDirection, onSort, children }) => /* @__PURE__ */ React.createElement("thead", { className: styles$A.header }, /* @__PURE__ */ React.createElement("tr", { className: styles$A.row }, React.Children.map(children, (child) => {
  if (!child)
    return null;
  const sortable = !!child.props.sortable && !!onSort;
  const sortIcon = sortable ? directionMap[getCurrentDirection(child.props.sortable, sortBy, sortDirection)].icon : "";
  const headerProps = sortable ? {
    tabIndex: "0",
    onClick: () => onSort(child.props.sortable, getNextDirection(child.props.sortable, sortBy, sortDirection)),
    onKeyDown: (ev) => {
      if (ev.which === 13 && !specialKeyPressed(ev)) {
        onSort(child.props.sortable, getNextDirection(child.props.sortable, sortBy, sortDirection));
      }
    }
  } : {};
  return /* @__PURE__ */ React.createElement(
    "th",
    {
      className: cx(styles$A.cell, cellAlignment(child.props.alignment), sortable && styles$A.sortable),
      width: child.props.width,
      ...headerProps
    },
    React.cloneElement(child, { alignment: void 0, sortable: void 0, width: void 0 }),
    Boolean(sortable) && /* @__PURE__ */ React.createElement(AccessibleIcon, { icon: sortIcon, size: 14, color: colors.oxfordBlue })
  );
})));
TableHeader.propTypes = {
  sortBy: PropTypes.string,
  sortDirection: PropTypes.string,
  onSort: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
TableHeader.defaultProps = {
  sortBy: "",
  sortDirection: ""
};
const styles$z = {
  row: css({
    borderTop: `1px solid ${colors.catskillWhite}`
  }),
  cell: css({
    padding: spacing.default
  }),
  cellLink: css({
    padding: 0
  }),
  link: css({
    display: "flex",
    textDecoration: "none",
    color: "inherit",
    "&:focus": {
      outline: "none"
    },
    "&:hover": {
      textDecoration: "none"
    }
  })
};
const TableRow = ({ className, children, href, target, rel, onLinkClick, asLink }) => /* @__PURE__ */ React.createElement("tr", { className: cx(styles$z.row, className) }, React.Children.map(children, (child) => {
  if (!child)
    return null;
  const clickable = child.props.clickable != void 0 ? child.props.clickable : true;
  const newChild = React.cloneElement(child, { clickable: void 0 });
  if (href && clickable) {
    return /* @__PURE__ */ React.createElement("td", { className: styles$z.cellLink }, /* @__PURE__ */ React.createElement(
      PinataLink,
      {
        className: cx(styles$z.cell, styles$z.link),
        to: href,
        target,
        rel,
        tabIndex: "-1",
        onClick: onLinkClick,
        as: asLink
      },
      newChild
    ));
  }
  return /* @__PURE__ */ React.createElement("td", { className: styles$z.cell }, newChild);
}));
TableRow.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  href: PropTypes.string,
  target: PropTypes.oneOf(["_blank"]),
  rel: PropTypes.string,
  onLinkClick: PropTypes.func,
  asLink: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({})])
};
const resizeTextarea = (textarea) => {
  const { style, clientHeight, scrollHeight } = textarea;
  if (scrollHeight > clientHeight) {
    style.height = `${scrollHeight}px`;
    return;
  }
  style.height = "auto";
  const newHeight = textarea.scrollHeight;
  style.height = `${scrollHeight > newHeight ? newHeight : scrollHeight}px`;
};
const styles$y = {
  container: css({
    maxWidth: "100%"
  }),
  wrapper: css({
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    border: `1px solid ${colors.mystic}`,
    borderRadius: borderRadius.default
  }),
  textarea: css({
    boxSizing: "border-box",
    width: "100%",
    border: 0,
    borderRadius: borderRadius.default,
    padding: spacing.default,
    fontSize: fontSize.default,
    fontFamily: fontFamily.body,
    fontWeight: fontWeight.regular,
    lineHeight: 1.2,
    color: colors.jumbo,
    resize: "vertical",
    overflowX: "hidden",
    overflowY: "auto",
    WebkitOverflowScrolling: "touch",
    "&::placeholder": {
      color: colors.grayChateau
    },
    "&[readonly]": {
      userSelect: "none",
      backgroundColor: colors.athensGray
    },
    "&:focus": {
      outline: "none"
    }
  }),
  wrapperError: css({
    borderColor: colors.mandy,
    "&:focus-within": {
      borderColor: colors.mandy,
      boxShadow: `0 0 0 2px ${hexToRgba(colors.mandy, 0.25)}`
    }
  })
};
const wrapperTheme$2 = (theme) => {
  const themed = getThemeColors(theme);
  return css({
    "&:focus-within": {
      borderColor: themed.base,
      boxShadow: `0 0 0 2px ${hexToRgba(themed.base, 0.25)}`
    }
  });
};
const textareaSize = (size2) => {
  switch (size2) {
    case "small":
      return css({
        minHeight: 60,
        maxHeight: 150
      });
    case "medium":
      return css({
        minHeight: 150,
        maxHeight: 350
      });
    case "large":
      return css({
        minHeight: 200,
        maxHeight: 400
      });
    default:
      return css({
        minHeight: 100,
        maxHeight: 300
      });
  }
};
const textareaResize = (autosize) => css({
  ...autosize && {
    resize: "none"
  }
});
class Textarea extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "onKeyDown", (ev) => {
      const handler = this.props.onKeyDown;
      if (handler)
        handler(ev);
    });
    __publicField(this, "onChange", (ev) => {
      const handler = this.props.input.onChange || this.props.onChange;
      if (handler)
        handler(ev);
    });
    __publicField(this, "onFocus", (ev) => {
      const focusHandler = this.props.input.onFocus || this.props.onFocus;
      if (focusHandler)
        focusHandler(ev);
    });
    __publicField(this, "onBlur", (ev) => {
      const blurHandler = this.props.input.onBlur || this.props.onBlur;
      if (blurHandler)
        blurHandler(ev);
    });
  }
  componentDidMount() {
    const value = this.props.input.value || this.props.value;
    if (value && this.textarea) {
      resizeTextarea(this.textarea);
    }
  }
  componentDidUpdate(prevProps) {
    const value = this.props.input.value || this.props.value;
    const prevValue = prevProps.input.value || prevProps.value;
    if (this.textarea && value !== prevValue) {
      resizeTextarea(this.textarea);
    }
  }
  render() {
    const { input, meta, size: size2, theme, className, autosize, helpText, innerRef, ariaDescribedby, ...props } = this.props;
    const value = input.value || props.value || "";
    const errored = meta.touched && meta.error;
    return /* @__PURE__ */ React.createElement("div", { className: cx(styles$y.container, className), onScroll: (ev) => ev.stopPropagation() }, /* @__PURE__ */ React.createElement("div", { className: cx(styles$y.wrapper, wrapperTheme$2(theme), errored && styles$y.wrapperError) }, /* @__PURE__ */ React.createElement(
      "textarea",
      {
        ...input,
        ...props,
        ref: (el) => {
          this.textarea = el;
          if (innerRef)
            innerRef(el);
        },
        value,
        tabIndex: props.readOnly ? "-1" : props.tabIndex,
        className: cx(styles$y.textarea, textareaSize(size2), textareaResize(autosize)),
        onClick: (ev) => resizeTextarea(ev.target),
        onKeyDown: this.onKeyDown,
        onChange: this.onChange,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        "aria-describedby": ariaDescribedby
      }
    )), Boolean(helpText && !errored) && /* @__PURE__ */ React.createElement(FormHelpText, { text: helpText }), Boolean(errored) && /* @__PURE__ */ React.createElement(FormErrorMessage, { text: meta.error }));
  }
}
Textarea.propTypes = {
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string
  }),
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func
  }),
  value: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  helpText: PropTypes.string,
  tabIndex: PropTypes.string,
  readOnly: PropTypes.bool,
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "dark", "tertiary", "info"]),
  size: PropTypes.oneOf(["", "default", "small", "medium", "large"]),
  autosize: PropTypes.bool,
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  innerRef: PropTypes.func,
  ariaDescribedby: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyDown: PropTypes.func
};
Textarea.defaultProps = {
  meta: {},
  input: {},
  tabIndex: "0",
  theme: "primary",
  size: "default"
};
const styles$x = {
  container: css({
    width: 240,
    maxWidth: "100%"
  }),
  wrapper: css({
    position: "relative",
    borderRadius: borderRadius.default,
    border: `1px solid ${colors.mystic}`,
    height: 40,
    width: "100%",
    boxSizing: "border-box",
    "&:focus": {
      outline: "none"
    }
  }),
  wrapperError: css({
    borderColor: colors.mandy,
    "&:focus": {
      borderColor: colors.mandy,
      boxShadow: `0 0 0 2px ${hexToRgba(colors.mandy, 0.25)}`
    },
    "&:focus-within": {
      borderColor: colors.mandy,
      boxShadow: `0 0 0 2px ${hexToRgba(colors.mandy, 0.25)}`
    }
  }),
  input: css({
    color: colors.jumbo,
    fontFamily: fontFamily.body,
    fontSize: fontSize.default,
    lineHeight: 1.2,
    padding: shorthandHelper([spacing.small, spacing.default]),
    appearance: "none",
    border: "none",
    width: "100%",
    height: "100%",
    boxSizing: "border-box",
    borderRadius: borderRadius.default,
    "&::placeholder": {
      color: colors.grayChateau,
      userSelect: "none"
    },
    "&[readonly]": {
      backgroundColor: colors.athensGray
    },
    "&:focus": {
      outline: "none"
    }
  })
};
const wrapperTheme$1 = (theme) => {
  const themed = getThemeColors(theme);
  return css({
    "&:focus": {
      borderColor: themed.base,
      boxShadow: `0 0 0 2px ${hexToRgba(themed.base, 0.25)}`
    },
    "&:focus-within": {
      borderColor: themed.base,
      boxShadow: `0 0 0 2px ${hexToRgba(themed.base, 0.25)}`
    }
  });
};
const TextInput = ({ meta, input, theme, helpText, className, onChange, ...props }) => {
  const value = input.value || props.value;
  const errored = meta.touched && meta.error;
  return /* @__PURE__ */ React.createElement("div", { className: cx(styles$x.container, className) }, /* @__PURE__ */ React.createElement("div", { className: cx(styles$x.wrapper, wrapperTheme$1(theme), errored && styles$x.wrapperError) }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "text",
      ...input,
      ...props,
      value,
      className: styles$x.input,
      onChange: (ev) => {
        const handler = input.onChange || onChange;
        if (handler)
          handler(ev.target.value);
      }
    }
  )), Boolean(helpText && !errored) && /* @__PURE__ */ React.createElement(FormHelpText, { text: helpText }), Boolean(errored) && /* @__PURE__ */ React.createElement(FormErrorMessage, { text: meta.error }));
};
TextInput.propTypes = {
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string
  }),
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func
  }),
  name: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  helpText: PropTypes.string,
  autoFocus: PropTypes.bool,
  tabIndex: PropTypes.string,
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "dark", "tertiary", "info"]),
  className: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func
};
TextInput.defaultProps = {
  meta: {},
  input: {},
  value: "",
  tabIndex: "0"
};
const styles$w = {
  wrapper: css({
    position: "relative"
  }),
  body: css({
    color: colors.white,
    backgroundColor: colors.oxfordBlue,
    fontSize: fontSize.small,
    fontWeight: fontWeight.semiBold,
    fontFamily: fontFamily.body,
    lineHeight: 1.2,
    borderRadius: borderRadius.default,
    position: "absolute",
    zIndex: zIndex.level7,
    width: "max-content"
  })
};
const positionModifier = (position) => {
  const distanceFromTrigger = `calc(100% + ${spacing.small}px)`;
  switch (position) {
    case "bottom":
      return css({
        top: distanceFromTrigger,
        right: "50%",
        transform: "translateX(50%)"
      });
    case "top":
      return css({
        bottom: distanceFromTrigger,
        right: "50%",
        transform: "translateX(50%)"
      });
    case "left":
      return css({
        right: distanceFromTrigger,
        bottom: "50%",
        transform: "translateY(50%)"
      });
    case "right":
      return css({
        left: distanceFromTrigger,
        bottom: "50%",
        transform: "translateY(50%)"
      });
    case "bottom-left":
      return css({
        top: distanceFromTrigger,
        left: 0
      });
    case "bottom-right":
      return css({
        top: distanceFromTrigger,
        right: 0
      });
    case "top-left":
      return css({
        bottom: distanceFromTrigger,
        left: 0
      });
    case "top-right":
      return css({
        bottom: distanceFromTrigger,
        right: 0
      });
    case "left-top":
      return css({
        right: distanceFromTrigger,
        top: 0
      });
    case "left-bottom":
      return css({
        right: distanceFromTrigger,
        bottom: 0
      });
    case "right-top":
      return css({
        left: distanceFromTrigger,
        top: 0
      });
    case "right-bottom":
      return css({
        left: distanceFromTrigger,
        bottom: 0
      });
    default:
      return css();
  }
};
const sizeModifier = (size2) => {
  switch (size2) {
    case "small":
      return css({
        padding: shorthandHelper([spacing.extraSmall, spacing.small]),
        maxWidth: 250
      });
    default:
      return css({
        padding: shorthandHelper([spacing.small, spacing.default]),
        maxWidth: 350
      });
  }
};
const Tooltip = (props) => {
  const { children, trigger: Trigger, className, position, tooltipSize, tabIndex = 0, isEnabled = true, ...rest } = props;
  const [isOpen, setIsOpen] = useState(false);
  const handleVisibility = (isVisible) => {
    if (isEnabled) {
      setIsOpen(isVisible);
      if (isVisible && props.onOpen)
        props.onOpen();
    }
  };
  useEffect(() => {
    if (!isEnabled)
      setIsOpen(false);
  }, [isEnabled]);
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cx(styles$w.wrapper, className),
      onMouseEnter: () => {
        handleVisibility(true);
      },
      onMouseLeave: () => {
        handleVisibility(false);
      },
      onFocus: () => {
        handleVisibility(true);
      },
      onBlur: () => {
        handleVisibility(false);
      },
      tabIndex
    },
    /* @__PURE__ */ React.createElement(
      Trigger,
      {
        ...rest
      }
    ),
    Boolean(isOpen && isEnabled) && /* @__PURE__ */ React.createElement("div", { className: cx(styles$w.body, positionModifier(position), sizeModifier(tooltipSize)) }, children)
  );
};
const { func: func$1, string: string$2, number, bool: bool$1, node: node$1, shape, oneOfType: oneOfType$1, oneOf, arrayOf: arrayOf$1 } = PropTypes;
Tooltip.propTypes = {
  trigger: func$1,
  className: string$2,
  triggerProps: shape({}),
  children: oneOfType$1([arrayOf$1(node$1), node$1]),
  onOpen: func$1,
  position: oneOf([
    "bottom",
    "top",
    "left",
    "right",
    "bottom-left",
    "bottom-right",
    "top-left",
    "top-right",
    "left-top",
    "left-bottom",
    "right-top",
    "right-bottom"
  ]),
  tooltipSize: oneOf(["", "default", "small"]),
  tabIndex: oneOfType$1([string$2, number]),
  isEnabled: bool$1
};
Tooltip.defaultProps = {
  triggerProps: {},
  position: "bottom",
  tooltipSize: "default"
};
const trackEvent = (name, properties) => {
  analytics.track(name, properties, {
    integrations: { Intercom: false }
  });
};
const identifyUser = (userId, properties = {}) => {
  analytics.identify(userId, properties, {
    integrations: { Intercom: false }
  });
};
const pageLoad = () => analytics.page();
const initializeAnalytics = (segmentApiKey) => {
  var analytics2 = window.analytics = window.analytics || [];
  if (analytics2.initialize)
    return;
  if (analytics2.invoked) {
    if (window.console && console.error) {
      console.error("Segment snippet included twice.");
    }
    return;
  }
  analytics2.invoked = true;
  analytics2.methods = [
    "trackSubmit",
    "trackClick",
    "trackLink",
    "trackForm",
    "pageview",
    "identify",
    "reset",
    "group",
    "track",
    "ready",
    "alias",
    "debug",
    "page",
    "once",
    "off",
    "on",
    "addSourceMiddleware",
    "addIntegrationMiddleware",
    "setAnonymousId",
    "addDestinationMiddleware"
  ];
  analytics2.factory = function(method) {
    return function() {
      var args = Array.prototype.slice.call(arguments);
      args.unshift(method);
      analytics2.push(args);
      return analytics2;
    };
  };
  for (var i2 = 0; i2 < analytics2.methods.length; i2++) {
    var key = analytics2.methods[i2];
    analytics2[key] = analytics2.factory(key);
  }
  analytics2.load = function(key2, options) {
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src = "https://cdn.segment.com/analytics.js/v1/" + key2 + "/analytics.min.js";
    var first = document.getElementsByTagName("script")[0];
    first.parentNode.insertBefore(script, first);
    analytics2._loadOptions = options;
  };
  analytics2._writeKey = segmentApiKey;
  analytics2.SNIPPET_VERSION = "4.15.2";
  analytics2.load(segmentApiKey);
  analytics2.page();
};
const formatCurrency = (amount, currency) => `${currency}${Math.round(amount || 0).toLocaleString("en-US")}`;
const formatCurrencyRand = (amount) => formatCurrency(amount, "R");
const formatCurrencyEuro = (amount) => formatCurrency(amount, "€");
const formatSalary = (currencyCode, salary, remunerationPeriod) => {
  let formattedCurrency;
  switch (currencyCode && currencyCode.toLowerCase()) {
    case "eur":
      formattedCurrency = formatCurrencyEuro(salary);
      break;
    case "gbp":
      formattedCurrency = formatCurrency(salary, "£");
      break;
    case "usd":
      formattedCurrency = formatCurrency(salary, "$");
      break;
    default:
      formattedCurrency = formatCurrencyRand(salary);
  }
  return remunerationPeriod ? `${formattedCurrency}/${remunerationPeriod.toLowerCase()}` : formattedCurrency;
};
const formatRemuneration = ({ currencySymbol = "", amount, remunerationPeriod }) => {
  const formattedRemuneration = formatCurrency(amount, currencySymbol);
  if (!remunerationPeriod)
    return formattedRemuneration;
  return `${formattedRemuneration}/${remunerationPeriod.toLowerCase()}`;
};
const millisecondsInWeek = 6048e5;
const millisecondsInDay = 864e5;
const millisecondsInMinute = 6e4;
const minutesInYear = 525600;
const minutesInMonth = 43200;
const minutesInDay = 1440;
function toDate(argument) {
  const argStr = Object.prototype.toString.call(argument);
  if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") {
    return new argument.constructor(+argument);
  } else if (typeof argument === "number" || argStr === "[object Number]" || typeof argument === "string" || argStr === "[object String]") {
    return new Date(argument);
  } else {
    return /* @__PURE__ */ new Date(NaN);
  }
}
function startOfDay(date) {
  const _date = toDate(date);
  _date.setHours(0, 0, 0, 0);
  return _date;
}
function getTimezoneOffsetInMilliseconds(date) {
  const _date = toDate(date);
  const utcDate = new Date(
    Date.UTC(
      _date.getFullYear(),
      _date.getMonth(),
      _date.getDate(),
      _date.getHours(),
      _date.getMinutes(),
      _date.getSeconds(),
      _date.getMilliseconds()
    )
  );
  utcDate.setUTCFullYear(_date.getFullYear());
  return +date - +utcDate;
}
function differenceInCalendarDays(dateLeft, dateRight) {
  const startOfDayLeft = startOfDay(dateLeft);
  const startOfDayRight = startOfDay(dateRight);
  const timestampLeft = +startOfDayLeft - getTimezoneOffsetInMilliseconds(startOfDayLeft);
  const timestampRight = +startOfDayRight - getTimezoneOffsetInMilliseconds(startOfDayRight);
  return Math.round((timestampLeft - timestampRight) / millisecondsInDay);
}
function differenceInDays(dateLeft, dateRight) {
  const _dateLeft = toDate(dateLeft);
  const _dateRight = toDate(dateRight);
  const sign = compareLocalAsc(_dateLeft, _dateRight);
  const difference = Math.abs(differenceInCalendarDays(_dateLeft, _dateRight));
  _dateLeft.setDate(_dateLeft.getDate() - sign * difference);
  const isLastDayNotFull = Number(
    compareLocalAsc(_dateLeft, _dateRight) === -sign
  );
  const result = sign * (difference - isLastDayNotFull);
  return result === 0 ? 0 : result;
}
function compareLocalAsc(dateLeft, dateRight) {
  const diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1;
  } else {
    return diff;
  }
}
function getRoundingMethod(method) {
  return (number2) => {
    const round = method ? Math[method] : Math.trunc;
    const result = round(number2);
    return result === 0 ? 0 : result;
  };
}
function differenceInMilliseconds(dateLeft, dateRight) {
  return +toDate(dateLeft) - +toDate(dateRight);
}
function differenceInSeconds(dateLeft, dateRight, options) {
  const diff = differenceInMilliseconds(dateLeft, dateRight) / 1e3;
  return getRoundingMethod(options == null ? void 0 : options.roundingMethod)(diff);
}
const formatDistanceLocale = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
};
const formatDistance = (token, count, options) => {
  let result;
  const tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }
  if (options == null ? void 0 : options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result;
    } else {
      return result + " ago";
    }
  }
  return result;
};
function buildFormatLongFn(args) {
  return (options = {}) => {
    const width = options.width ? String(options.width) : args.defaultWidth;
    const format2 = args.formats[width] || args.formats[args.defaultWidth];
    return format2;
  };
}
const dateFormats = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
};
const timeFormats = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
};
const dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
const formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full"
  })
};
const formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
};
const formatRelative = (token, _date, _baseDate, _options) => formatRelativeLocale[token];
function buildLocalizeFn(args) {
  return (value, options) => {
    const context = (options == null ? void 0 : options.context) ? String(options.context) : "standalone";
    let valuesArray;
    if (context === "formatting" && args.formattingValues) {
      const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      const width = (options == null ? void 0 : options.width) ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      const defaultWidth = args.defaultWidth;
      const width = (options == null ? void 0 : options.width) ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[width] || args.values[defaultWidth];
    }
    const index = args.argumentCallback ? args.argumentCallback(value) : value;
    return valuesArray[index];
  };
}
const eraValues = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
};
const quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
};
const monthValues = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
};
const dayValues = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
};
const dayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
};
const formattingDayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
};
const ordinalNumber = (dirtyNumber, _options) => {
  const number2 = Number(dirtyNumber);
  const rem100 = number2 % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number2 + "st";
      case 2:
        return number2 + "nd";
      case 3:
        return number2 + "rd";
    }
  }
  return number2 + "th";
};
const localize = {
  ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide"
  })
};
function buildMatchFn(args) {
  return (string2, options = {}) => {
    const width = options.width;
    const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    const matchResult = string2.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    const matchedString = matchResult[0];
    const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    const key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, (pattern) => pattern.test(matchedString)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      findKey(parsePatterns, (pattern) => pattern.test(matchedString))
    );
    let value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      options.valueCallback(value)
    ) : value;
    const rest = string2.slice(matchedString.length);
    return { value, rest };
  };
}
function findKey(object, predicate) {
  for (const key in object) {
    if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) {
      return key;
    }
  }
  return void 0;
}
function findIndex(array, predicate) {
  for (let key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return void 0;
}
function buildMatchPatternFn(args) {
  return (string2, options = {}) => {
    const matchResult = string2.match(args.matchPattern);
    if (!matchResult)
      return null;
    const matchedString = matchResult[0];
    const parseResult = string2.match(args.parsePattern);
    if (!parseResult)
      return null;
    let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    const rest = string2.slice(matchedString.length);
    return { value, rest };
  };
}
const matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const parseOrdinalNumberPattern = /\d+/i;
const matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
const parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
const matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
const parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
const matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const parseMonthPatterns = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
};
const matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
const matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
const match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: (value) => parseInt(value, 10)
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any"
  })
};
const enUS = {
  code: "en-US",
  formatDistance,
  formatLong,
  formatRelative,
  localize,
  match,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
let defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}
function compareAsc(dateLeft, dateRight) {
  const _dateLeft = toDate(dateLeft);
  const _dateRight = toDate(dateRight);
  const diff = _dateLeft.getTime() - _dateRight.getTime();
  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1;
  } else {
    return diff;
  }
}
function formatDistanceStrict(date, baseDate, options) {
  const defaultOptions2 = getDefaultOptions();
  const locale = (options == null ? void 0 : options.locale) ?? defaultOptions2.locale ?? enUS;
  const comparison = compareAsc(date, baseDate);
  if (isNaN(comparison)) {
    throw new RangeError("Invalid time value");
  }
  const localizeOptions = Object.assign({}, options, {
    addSuffix: options == null ? void 0 : options.addSuffix,
    comparison
  });
  let dateLeft;
  let dateRight;
  if (comparison > 0) {
    dateLeft = toDate(baseDate);
    dateRight = toDate(date);
  } else {
    dateLeft = toDate(date);
    dateRight = toDate(baseDate);
  }
  const roundingMethod = getRoundingMethod((options == null ? void 0 : options.roundingMethod) ?? "round");
  const milliseconds = dateRight.getTime() - dateLeft.getTime();
  const minutes = milliseconds / millisecondsInMinute;
  const timezoneOffset = getTimezoneOffsetInMilliseconds(dateRight) - getTimezoneOffsetInMilliseconds(dateLeft);
  const dstNormalizedMinutes = (milliseconds - timezoneOffset) / millisecondsInMinute;
  const defaultUnit = options == null ? void 0 : options.unit;
  let unit;
  if (!defaultUnit) {
    if (minutes < 1) {
      unit = "second";
    } else if (minutes < 60) {
      unit = "minute";
    } else if (minutes < minutesInDay) {
      unit = "hour";
    } else if (dstNormalizedMinutes < minutesInMonth) {
      unit = "day";
    } else if (dstNormalizedMinutes < minutesInYear) {
      unit = "month";
    } else {
      unit = "year";
    }
  } else {
    unit = defaultUnit;
  }
  if (unit === "second") {
    const seconds = roundingMethod(milliseconds / 1e3);
    return locale.formatDistance("xSeconds", seconds, localizeOptions);
  } else if (unit === "minute") {
    const roundedMinutes = roundingMethod(minutes);
    return locale.formatDistance("xMinutes", roundedMinutes, localizeOptions);
  } else if (unit === "hour") {
    const hours = roundingMethod(minutes / 60);
    return locale.formatDistance("xHours", hours, localizeOptions);
  } else if (unit === "day") {
    const days = roundingMethod(dstNormalizedMinutes / minutesInDay);
    return locale.formatDistance("xDays", days, localizeOptions);
  } else if (unit === "month") {
    const months2 = roundingMethod(dstNormalizedMinutes / minutesInMonth);
    return months2 === 12 && defaultUnit !== "month" ? locale.formatDistance("xYears", 1, localizeOptions) : locale.formatDistance("xMonths", months2, localizeOptions);
  } else {
    const years = roundingMethod(dstNormalizedMinutes / minutesInYear);
    return locale.formatDistance("xYears", years, localizeOptions);
  }
}
function constructFrom(date, value) {
  if (date instanceof Date) {
    return new date.constructor(value);
  } else {
    return new Date(value);
  }
}
function startOfYear(date) {
  const cleanDate = toDate(date);
  const _date = constructFrom(date, 0);
  _date.setFullYear(cleanDate.getFullYear(), 0, 1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}
function getDayOfYear(date) {
  const _date = toDate(date);
  const diff = differenceInCalendarDays(_date, startOfYear(_date));
  const dayOfYear = diff + 1;
  return dayOfYear;
}
function startOfWeek(date, options) {
  var _a, _b, _c, _d;
  const defaultOptions2 = getDefaultOptions();
  const weekStartsOn = (options == null ? void 0 : options.weekStartsOn) ?? ((_b = (_a = options == null ? void 0 : options.locale) == null ? void 0 : _a.options) == null ? void 0 : _b.weekStartsOn) ?? defaultOptions2.weekStartsOn ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.weekStartsOn) ?? 0;
  const _date = toDate(date);
  const day = _date.getDay();
  const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  _date.setDate(_date.getDate() - diff);
  _date.setHours(0, 0, 0, 0);
  return _date;
}
function startOfISOWeek(date) {
  return startOfWeek(date, { weekStartsOn: 1 });
}
function getISOWeekYear(date) {
  const _date = toDate(date);
  const year = _date.getFullYear();
  const fourthOfJanuaryOfNextYear = constructFrom(date, 0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear);
  const fourthOfJanuaryOfThisYear = constructFrom(date, 0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear);
  if (_date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (_date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfISOWeekYear(date) {
  const year = getISOWeekYear(date);
  const fourthOfJanuary = constructFrom(date, 0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  return startOfISOWeek(fourthOfJanuary);
}
function getISOWeek(date) {
  const _date = toDate(date);
  const diff = +startOfISOWeek(_date) - +startOfISOWeekYear(_date);
  return Math.round(diff / millisecondsInWeek) + 1;
}
function getWeekYear(date, options) {
  var _a, _b, _c, _d;
  const _date = toDate(date);
  const year = _date.getFullYear();
  const defaultOptions2 = getDefaultOptions();
  const firstWeekContainsDate = (options == null ? void 0 : options.firstWeekContainsDate) ?? ((_b = (_a = options == null ? void 0 : options.locale) == null ? void 0 : _a.options) == null ? void 0 : _b.firstWeekContainsDate) ?? defaultOptions2.firstWeekContainsDate ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.firstWeekContainsDate) ?? 1;
  const firstWeekOfNextYear = constructFrom(date, 0);
  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = startOfWeek(firstWeekOfNextYear, options);
  const firstWeekOfThisYear = constructFrom(date, 0);
  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = startOfWeek(firstWeekOfThisYear, options);
  if (_date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (_date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfWeekYear(date, options) {
  var _a, _b, _c, _d;
  const defaultOptions2 = getDefaultOptions();
  const firstWeekContainsDate = (options == null ? void 0 : options.firstWeekContainsDate) ?? ((_b = (_a = options == null ? void 0 : options.locale) == null ? void 0 : _a.options) == null ? void 0 : _b.firstWeekContainsDate) ?? defaultOptions2.firstWeekContainsDate ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.firstWeekContainsDate) ?? 1;
  const year = getWeekYear(date, options);
  const firstWeek = constructFrom(date, 0);
  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  const _date = startOfWeek(firstWeek, options);
  return _date;
}
function getWeek(date, options) {
  const _date = toDate(date);
  const diff = +startOfWeek(_date, options) - +startOfWeekYear(_date, options);
  return Math.round(diff / millisecondsInWeek) + 1;
}
function addLeadingZeros(number2, targetLength) {
  const sign = number2 < 0 ? "-" : "";
  const output = Math.abs(number2).toString().padStart(targetLength, "0");
  return sign + output;
}
const lightFormatters = {
  // Year
  y(date, token) {
    const signedYear = date.getFullYear();
    const year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === "yy" ? year % 100 : year, token.length);
  },
  // Month
  M(date, token) {
    const month = date.getMonth();
    return token === "M" ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d(date, token) {
    return addLeadingZeros(date.getDate(), token.length);
  },
  // AM or PM
  a(date, token) {
    const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "a":
      case "aa":
        return dayPeriodEnumValue.toUpperCase();
      case "aaa":
        return dayPeriodEnumValue;
      case "aaaaa":
        return dayPeriodEnumValue[0];
      case "aaaa":
      default:
        return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(date, token) {
    return addLeadingZeros(date.getHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H(date, token) {
    return addLeadingZeros(date.getHours(), token.length);
  },
  // Minute
  m(date, token) {
    return addLeadingZeros(date.getMinutes(), token.length);
  },
  // Second
  s(date, token) {
    return addLeadingZeros(date.getSeconds(), token.length);
  },
  // Fraction of second
  S(date, token) {
    const numberOfDigits = token.length;
    const milliseconds = date.getMilliseconds();
    const fractionalSeconds = Math.trunc(
      milliseconds * Math.pow(10, numberOfDigits - 3)
    );
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
const dayPeriodEnum = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
};
const formatters = {
  // Era
  G: function(date, token, localize2) {
    const era = date.getFullYear() > 0 ? 1 : 0;
    switch (token) {
      case "G":
      case "GG":
      case "GGG":
        return localize2.era(era, { width: "abbreviated" });
      case "GGGGG":
        return localize2.era(era, { width: "narrow" });
      case "GGGG":
      default:
        return localize2.era(era, { width: "wide" });
    }
  },
  // Year
  y: function(date, token, localize2) {
    if (token === "yo") {
      const signedYear = date.getFullYear();
      const year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize2.ordinalNumber(year, { unit: "year" });
    }
    return lightFormatters.y(date, token);
  },
  // Local week-numbering year
  Y: function(date, token, localize2, options) {
    const signedWeekYear = getWeekYear(date, options);
    const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
    if (token === "YY") {
      const twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }
    if (token === "Yo") {
      return localize2.ordinalNumber(weekYear, { unit: "year" });
    }
    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function(date, token) {
    const isoWeekYear = getISOWeekYear(date);
    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(date, token) {
    const year = date.getFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function(date, token, localize2) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token) {
      case "Q":
        return String(quarter);
      case "QQ":
        return addLeadingZeros(quarter, 2);
      case "Qo":
        return localize2.ordinalNumber(quarter, { unit: "quarter" });
      case "QQQ":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(date, token, localize2) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token) {
      case "q":
        return String(quarter);
      case "qq":
        return addLeadingZeros(quarter, 2);
      case "qo":
        return localize2.ordinalNumber(quarter, { unit: "quarter" });
      case "qqq":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(date, token, localize2) {
    const month = date.getMonth();
    switch (token) {
      case "M":
      case "MM":
        return lightFormatters.M(date, token);
      case "Mo":
        return localize2.ordinalNumber(month + 1, { unit: "month" });
      case "MMM":
        return localize2.month(month, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return localize2.month(month, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return localize2.month(month, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(date, token, localize2) {
    const month = date.getMonth();
    switch (token) {
      case "L":
        return String(month + 1);
      case "LL":
        return addLeadingZeros(month + 1, 2);
      case "Lo":
        return localize2.ordinalNumber(month + 1, { unit: "month" });
      case "LLL":
        return localize2.month(month, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return localize2.month(month, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return localize2.month(month, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(date, token, localize2, options) {
    const week = getWeek(date, options);
    if (token === "wo") {
      return localize2.ordinalNumber(week, { unit: "week" });
    }
    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function(date, token, localize2) {
    const isoWeek = getISOWeek(date);
    if (token === "Io") {
      return localize2.ordinalNumber(isoWeek, { unit: "week" });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function(date, token, localize2) {
    if (token === "do") {
      return localize2.ordinalNumber(date.getDate(), { unit: "date" });
    }
    return lightFormatters.d(date, token);
  },
  // Day of year
  D: function(date, token, localize2) {
    const dayOfYear = getDayOfYear(date);
    if (token === "Do") {
      return localize2.ordinalNumber(dayOfYear, { unit: "dayOfYear" });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function(date, token, localize2) {
    const dayOfWeek = date.getDay();
    switch (token) {
      case "E":
      case "EE":
      case "EEE":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(date, token, localize2, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      case "e":
        return String(localDayOfWeek);
      case "ee":
        return addLeadingZeros(localDayOfWeek, 2);
      case "eo":
        return localize2.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "eee":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(date, token, localize2, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      case "c":
        return String(localDayOfWeek);
      case "cc":
        return addLeadingZeros(localDayOfWeek, token.length);
      case "co":
        return localize2.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "ccc":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(date, token, localize2) {
    const dayOfWeek = date.getDay();
    const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      case "i":
        return String(isoDayOfWeek);
      case "ii":
        return addLeadingZeros(isoDayOfWeek, token.length);
      case "io":
        return localize2.ordinalNumber(isoDayOfWeek, { unit: "day" });
      case "iii":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(date, token, localize2) {
    const hours = date.getHours();
    const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "a":
      case "aa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(date, token, localize2) {
    const hours = date.getHours();
    let dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    }
    switch (token) {
      case "b":
      case "bb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(date, token, localize2) {
    const hours = date.getHours();
    let dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case "B":
      case "BB":
      case "BBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(date, token, localize2) {
    if (token === "ho") {
      let hours = date.getHours() % 12;
      if (hours === 0)
        hours = 12;
      return localize2.ordinalNumber(hours, { unit: "hour" });
    }
    return lightFormatters.h(date, token);
  },
  // Hour [0-23]
  H: function(date, token, localize2) {
    if (token === "Ho") {
      return localize2.ordinalNumber(date.getHours(), { unit: "hour" });
    }
    return lightFormatters.H(date, token);
  },
  // Hour [0-11]
  K: function(date, token, localize2) {
    const hours = date.getHours() % 12;
    if (token === "Ko") {
      return localize2.ordinalNumber(hours, { unit: "hour" });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function(date, token, localize2) {
    let hours = date.getHours();
    if (hours === 0)
      hours = 24;
    if (token === "ko") {
      return localize2.ordinalNumber(hours, { unit: "hour" });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function(date, token, localize2) {
    if (token === "mo") {
      return localize2.ordinalNumber(date.getMinutes(), { unit: "minute" });
    }
    return lightFormatters.m(date, token);
  },
  // Second
  s: function(date, token, localize2) {
    if (token === "so") {
      return localize2.ordinalNumber(date.getSeconds(), { unit: "second" });
    }
    return lightFormatters.s(date, token);
  },
  // Fraction of second
  S: function(date, token) {
    return lightFormatters.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return "Z";
    }
    switch (token) {
      case "X":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "XXXX":
      case "XX":
        return formatTimezone(timezoneOffset);
      case "XXXXX":
      case "XXX":
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    switch (token) {
      case "x":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "xxxx":
      case "xx":
        return formatTimezone(timezoneOffset);
      case "xxxxx":
      case "xxx":
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (GMT)
  O: function(date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    switch (token) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      case "OOOO":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    switch (token) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      case "zzzz":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  // Seconds timestamp
  t: function(date, token, _localize) {
    const timestamp = Math.trunc(date.getTime() / 1e3);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function(date, token, _localize) {
    const timestamp = date.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, delimiter = "") {
  const sign = offset > 0 ? "-" : "+";
  const absOffset = Math.abs(offset);
  const hours = Math.trunc(absOffset / 60);
  const minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, delimiter) {
  if (offset % 60 === 0) {
    const sign = offset > 0 ? "-" : "+";
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, delimiter);
}
function formatTimezone(offset, delimiter = "") {
  const sign = offset > 0 ? "-" : "+";
  const absOffset = Math.abs(offset);
  const hours = addLeadingZeros(Math.trunc(absOffset / 60), 2);
  const minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
const dateLongFormatter = (pattern, formatLong2) => {
  switch (pattern) {
    case "P":
      return formatLong2.date({ width: "short" });
    case "PP":
      return formatLong2.date({ width: "medium" });
    case "PPP":
      return formatLong2.date({ width: "long" });
    case "PPPP":
    default:
      return formatLong2.date({ width: "full" });
  }
};
const timeLongFormatter = (pattern, formatLong2) => {
  switch (pattern) {
    case "p":
      return formatLong2.time({ width: "short" });
    case "pp":
      return formatLong2.time({ width: "medium" });
    case "ppp":
      return formatLong2.time({ width: "long" });
    case "pppp":
    default:
      return formatLong2.time({ width: "full" });
  }
};
const dateTimeLongFormatter = (pattern, formatLong2) => {
  const matchResult = pattern.match(/(P+)(p+)?/) || [];
  const datePattern = matchResult[1];
  const timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong2);
  }
  let dateTimeFormat;
  switch (datePattern) {
    case "P":
      dateTimeFormat = formatLong2.dateTime({ width: "short" });
      break;
    case "PP":
      dateTimeFormat = formatLong2.dateTime({ width: "medium" });
      break;
    case "PPP":
      dateTimeFormat = formatLong2.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      dateTimeFormat = formatLong2.dateTime({ width: "full" });
      break;
  }
  return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong2)).replace("{{time}}", timeLongFormatter(timePattern, formatLong2));
};
const longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
const dayOfYearTokenRE = /^D+$/;
const weekYearTokenRE = /^Y+$/;
const throwTokens = ["D", "DD", "YY", "YYYY"];
function isProtectedDayOfYearToken(token) {
  return dayOfYearTokenRE.test(token);
}
function isProtectedWeekYearToken(token) {
  return weekYearTokenRE.test(token);
}
function warnOrThrowProtectedError(token, format2, input) {
  const _message = message(token, format2, input);
  console.warn(_message);
  if (throwTokens.includes(token))
    throw new RangeError(_message);
}
function message(token, format2, input) {
  const subject = token[0] === "Y" ? "years" : "days of the month";
  return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format2}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
function isDate$1(value) {
  return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
function isValid(date) {
  if (!isDate$1(date) && typeof date !== "number") {
    return false;
  }
  const _date = toDate(date);
  return !isNaN(Number(_date));
}
const formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
const longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const escapedStringRegExp = /^'([^]*?)'?$/;
const doubleQuoteRegExp = /''/g;
const unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function format(date, formatStr, options) {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const defaultOptions2 = getDefaultOptions();
  const locale = (options == null ? void 0 : options.locale) ?? defaultOptions2.locale ?? enUS;
  const firstWeekContainsDate = (options == null ? void 0 : options.firstWeekContainsDate) ?? ((_b = (_a = options == null ? void 0 : options.locale) == null ? void 0 : _a.options) == null ? void 0 : _b.firstWeekContainsDate) ?? defaultOptions2.firstWeekContainsDate ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.firstWeekContainsDate) ?? 1;
  const weekStartsOn = (options == null ? void 0 : options.weekStartsOn) ?? ((_f = (_e = options == null ? void 0 : options.locale) == null ? void 0 : _e.options) == null ? void 0 : _f.weekStartsOn) ?? defaultOptions2.weekStartsOn ?? ((_h = (_g = defaultOptions2.locale) == null ? void 0 : _g.options) == null ? void 0 : _h.weekStartsOn) ?? 0;
  const originalDate = toDate(date);
  if (!isValid(originalDate)) {
    throw new RangeError("Invalid time value");
  }
  let parts = formatStr.match(longFormattingTokensRegExp).map((substring) => {
    const firstCharacter = substring[0];
    if (firstCharacter === "p" || firstCharacter === "P") {
      const longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp).map((substring) => {
    if (substring === "''") {
      return { isToken: false, value: "'" };
    }
    const firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return { isToken: false, value: cleanEscapedString(substring) };
    }
    if (formatters[firstCharacter]) {
      return { isToken: true, value: substring };
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + firstCharacter + "`"
      );
    }
    return { isToken: false, value: substring };
  });
  if (locale.localize.preprocessor) {
    parts = locale.localize.preprocessor(originalDate, parts);
  }
  const formatterOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale
  };
  return parts.map((part) => {
    if (!part.isToken)
      return part.value;
    const token = part.value;
    if (!(options == null ? void 0 : options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(token) || !(options == null ? void 0 : options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(token)) {
      warnOrThrowProtectedError(token, formatStr, String(date));
    }
    const formatter = formatters[token[0]];
    return formatter(originalDate, token, locale.localize, formatterOptions);
  }).join("");
}
function cleanEscapedString(input) {
  const matched = input.match(escapedStringRegExp);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
}
function getMonth(date) {
  const _date = toDate(date);
  const month = _date.getMonth();
  return month;
}
function constructNow(date) {
  return constructFrom(date, Date.now());
}
function isSameDay(dateLeft, dateRight) {
  const dateLeftStartOfDay = startOfDay(dateLeft);
  const dateRightStartOfDay = startOfDay(dateRight);
  return +dateLeftStartOfDay === +dateRightStartOfDay;
}
function isToday(date) {
  return isSameDay(date, constructNow(date));
}
const formatSmartTimestamp = (timestamp) => {
  const today = /* @__PURE__ */ new Date();
  if (isToday(timestamp)) {
    if (differenceInSeconds(today, timestamp) < 60) {
      return "just now";
    }
    return formatDistanceStrict(timestamp, today, { addSuffix: true });
  }
  const elapsedDays = differenceInDays(today, timestamp);
  if (elapsedDays < 365) {
    return format(timestamp, "d MMMM, HH:mm");
  }
  return format(timestamp, "d MMMM yyyy, HH:mm");
};
const formatSmartDate = (timestamp) => {
  const today = /* @__PURE__ */ new Date();
  if (isToday(timestamp)) {
    if (differenceInSeconds(today, timestamp) < 60) {
      return "just now";
    }
    return formatDistanceStrict(timestamp, today, { addSuffix: true });
  }
  const elapsedDays = differenceInDays(today, timestamp);
  if (elapsedDays < 365) {
    return format(timestamp, "d MMMM");
  }
  return format(timestamp, "d MMMM yyyy");
};
const formatDistanceInWords = (timestamp) => {
  const today = /* @__PURE__ */ new Date();
  if (differenceInSeconds(today, timestamp) < 60) {
    return "just now";
  }
  return formatDistanceStrict(timestamp, today, { addSuffix: true });
};
const IANATimeZoneName = () => {
  const dateInParts = new Intl.DateTimeFormat("en-US", { timeZoneName: "long" }).formatToParts(/* @__PURE__ */ new Date());
  return dateInParts.find((part) => part.type === "timeZoneName").value;
};
const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
const formatDateWithShortMonth = (timestamp, options = {}) => {
  if (!timestamp)
    return "";
  const { includeDay = true, includeTimestamp = false } = options;
  const dayFormatString = includeDay ? "d " : "";
  const monthFormatString = months[getMonth(timestamp)].length <= 3 ? "MMM" : "MMM.";
  const timeFormatString = includeTimestamp ? " 'at' HH:mm" : "";
  return format(timestamp, `${dayFormatString}${monthFormatString} yyyy${timeFormatString}`);
};
var esErrors = Error;
var _eval = EvalError;
var range = RangeError;
var ref = ReferenceError;
var syntax = SyntaxError;
var type = TypeError;
var uri = URIError;
var shams = function hasSymbols() {
  if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") {
    return false;
  }
  if (typeof Symbol.iterator === "symbol") {
    return true;
  }
  var obj = {};
  var sym = Symbol("test");
  var symObj = Object(sym);
  if (typeof sym === "string") {
    return false;
  }
  if (Object.prototype.toString.call(sym) !== "[object Symbol]") {
    return false;
  }
  if (Object.prototype.toString.call(symObj) !== "[object Symbol]") {
    return false;
  }
  var symVal = 42;
  obj[sym] = symVal;
  for (sym in obj) {
    return false;
  }
  if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) {
    return false;
  }
  if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) {
    return false;
  }
  var syms = Object.getOwnPropertySymbols(obj);
  if (syms.length !== 1 || syms[0] !== sym) {
    return false;
  }
  if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
    return false;
  }
  if (typeof Object.getOwnPropertyDescriptor === "function") {
    var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
    if (descriptor.value !== symVal || descriptor.enumerable !== true) {
      return false;
    }
  }
  return true;
};
var origSymbol = typeof Symbol !== "undefined" && Symbol;
var hasSymbolSham = shams;
var hasSymbols$1 = function hasNativeSymbols() {
  if (typeof origSymbol !== "function") {
    return false;
  }
  if (typeof Symbol !== "function") {
    return false;
  }
  if (typeof origSymbol("foo") !== "symbol") {
    return false;
  }
  if (typeof Symbol("bar") !== "symbol") {
    return false;
  }
  return hasSymbolSham();
};
var test = {
  foo: {}
};
var $Object = Object;
var hasProto$1 = function hasProto() {
  return { __proto__: test }.foo === test.foo && !({ __proto__: null } instanceof $Object);
};
var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var toStr$1 = Object.prototype.toString;
var max = Math.max;
var funcType = "[object Function]";
var concatty = function concatty2(a, b) {
  var arr = [];
  for (var i2 = 0; i2 < a.length; i2 += 1) {
    arr[i2] = a[i2];
  }
  for (var j2 = 0; j2 < b.length; j2 += 1) {
    arr[j2 + a.length] = b[j2];
  }
  return arr;
};
var slicy = function slicy2(arrLike, offset) {
  var arr = [];
  for (var i2 = offset || 0, j2 = 0; i2 < arrLike.length; i2 += 1, j2 += 1) {
    arr[j2] = arrLike[i2];
  }
  return arr;
};
var joiny = function(arr, joiner) {
  var str = "";
  for (var i2 = 0; i2 < arr.length; i2 += 1) {
    str += arr[i2];
    if (i2 + 1 < arr.length) {
      str += joiner;
    }
  }
  return str;
};
var implementation$1 = function bind(that) {
  var target = this;
  if (typeof target !== "function" || toStr$1.apply(target) !== funcType) {
    throw new TypeError(ERROR_MESSAGE + target);
  }
  var args = slicy(arguments, 1);
  var bound;
  var binder = function() {
    if (this instanceof bound) {
      var result = target.apply(
        this,
        concatty(args, arguments)
      );
      if (Object(result) === result) {
        return result;
      }
      return this;
    }
    return target.apply(
      that,
      concatty(args, arguments)
    );
  };
  var boundLength = max(0, target.length - args.length);
  var boundArgs = [];
  for (var i2 = 0; i2 < boundLength; i2++) {
    boundArgs[i2] = "$" + i2;
  }
  bound = Function("binder", "return function (" + joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
  if (target.prototype) {
    var Empty = function Empty2() {
    };
    Empty.prototype = target.prototype;
    bound.prototype = new Empty();
    Empty.prototype = null;
  }
  return bound;
};
var implementation = implementation$1;
var functionBind = Function.prototype.bind || implementation;
var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind$1 = functionBind;
var hasown = bind$1.call(call, $hasOwn);
var undefined$1;
var $Error = esErrors;
var $EvalError = _eval;
var $RangeError = range;
var $ReferenceError = ref;
var $SyntaxError$1 = syntax;
var $TypeError$3 = type;
var $URIError = uri;
var $Function = Function;
var getEvalledConstructor = function(expressionSyntax) {
  try {
    return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
  } catch (e) {
  }
};
var $gOPD$1 = Object.getOwnPropertyDescriptor;
if ($gOPD$1) {
  try {
    $gOPD$1({}, "");
  } catch (e) {
    $gOPD$1 = null;
  }
}
var throwTypeError = function() {
  throw new $TypeError$3();
};
var ThrowTypeError = $gOPD$1 ? function() {
  try {
    arguments.callee;
    return throwTypeError;
  } catch (calleeThrows) {
    try {
      return $gOPD$1(arguments, "callee").get;
    } catch (gOPDthrows) {
      return throwTypeError;
    }
  }
}() : throwTypeError;
var hasSymbols2 = hasSymbols$1();
var hasProto2 = hasProto$1();
var getProto = Object.getPrototypeOf || (hasProto2 ? function(x) {
  return x.__proto__;
} : null);
var needsEval = {};
var TypedArray = typeof Uint8Array === "undefined" || !getProto ? undefined$1 : getProto(Uint8Array);
var INTRINSICS = {
  __proto__: null,
  "%AggregateError%": typeof AggregateError === "undefined" ? undefined$1 : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined$1 : ArrayBuffer,
  "%ArrayIteratorPrototype%": hasSymbols2 && getProto ? getProto([][Symbol.iterator]()) : undefined$1,
  "%AsyncFromSyncIteratorPrototype%": undefined$1,
  "%AsyncFunction%": needsEval,
  "%AsyncGenerator%": needsEval,
  "%AsyncGeneratorFunction%": needsEval,
  "%AsyncIteratorPrototype%": needsEval,
  "%Atomics%": typeof Atomics === "undefined" ? undefined$1 : Atomics,
  "%BigInt%": typeof BigInt === "undefined" ? undefined$1 : BigInt,
  "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined$1 : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined$1 : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView === "undefined" ? undefined$1 : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": $Error,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": $EvalError,
  "%Float32Array%": typeof Float32Array === "undefined" ? undefined$1 : Float32Array,
  "%Float64Array%": typeof Float64Array === "undefined" ? undefined$1 : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined$1 : FinalizationRegistry,
  "%Function%": $Function,
  "%GeneratorFunction%": needsEval,
  "%Int8Array%": typeof Int8Array === "undefined" ? undefined$1 : Int8Array,
  "%Int16Array%": typeof Int16Array === "undefined" ? undefined$1 : Int16Array,
  "%Int32Array%": typeof Int32Array === "undefined" ? undefined$1 : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": hasSymbols2 && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined$1,
  "%JSON%": typeof JSON === "object" ? JSON : undefined$1,
  "%Map%": typeof Map === "undefined" ? undefined$1 : Map,
  "%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols2 || !getProto ? undefined$1 : getProto((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise === "undefined" ? undefined$1 : Promise,
  "%Proxy%": typeof Proxy === "undefined" ? undefined$1 : Proxy,
  "%RangeError%": $RangeError,
  "%ReferenceError%": $ReferenceError,
  "%Reflect%": typeof Reflect === "undefined" ? undefined$1 : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set === "undefined" ? undefined$1 : Set,
  "%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols2 || !getProto ? undefined$1 : getProto((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined$1 : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": hasSymbols2 && getProto ? getProto(""[Symbol.iterator]()) : undefined$1,
  "%Symbol%": hasSymbols2 ? Symbol : undefined$1,
  "%SyntaxError%": $SyntaxError$1,
  "%ThrowTypeError%": ThrowTypeError,
  "%TypedArray%": TypedArray,
  "%TypeError%": $TypeError$3,
  "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined$1 : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined$1 : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined$1 : Uint16Array,
  "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined$1 : Uint32Array,
  "%URIError%": $URIError,
  "%WeakMap%": typeof WeakMap === "undefined" ? undefined$1 : WeakMap,
  "%WeakRef%": typeof WeakRef === "undefined" ? undefined$1 : WeakRef,
  "%WeakSet%": typeof WeakSet === "undefined" ? undefined$1 : WeakSet
};
if (getProto) {
  try {
    null.error;
  } catch (e) {
    var errorProto = getProto(getProto(e));
    INTRINSICS["%Error.prototype%"] = errorProto;
  }
}
var doEval = function doEval2(name) {
  var value;
  if (name === "%AsyncFunction%") {
    value = getEvalledConstructor("async function () {}");
  } else if (name === "%GeneratorFunction%") {
    value = getEvalledConstructor("function* () {}");
  } else if (name === "%AsyncGeneratorFunction%") {
    value = getEvalledConstructor("async function* () {}");
  } else if (name === "%AsyncGenerator%") {
    var fn = doEval2("%AsyncGeneratorFunction%");
    if (fn) {
      value = fn.prototype;
    }
  } else if (name === "%AsyncIteratorPrototype%") {
    var gen = doEval2("%AsyncGenerator%");
    if (gen && getProto) {
      value = getProto(gen.prototype);
    }
  }
  INTRINSICS[name] = value;
  return value;
};
var LEGACY_ALIASES = {
  __proto__: null,
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
};
var bind2 = functionBind;
var hasOwn$1 = hasown;
var $concat$1 = bind2.call(Function.call, Array.prototype.concat);
var $spliceApply = bind2.call(Function.apply, Array.prototype.splice);
var $replace$1 = bind2.call(Function.call, String.prototype.replace);
var $strSlice = bind2.call(Function.call, String.prototype.slice);
var $exec = bind2.call(Function.call, RegExp.prototype.exec);
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g;
var stringToPath = function stringToPath2(string2) {
  var first = $strSlice(string2, 0, 1);
  var last2 = $strSlice(string2, -1);
  if (first === "%" && last2 !== "%") {
    throw new $SyntaxError$1("invalid intrinsic syntax, expected closing `%`");
  } else if (last2 === "%" && first !== "%") {
    throw new $SyntaxError$1("invalid intrinsic syntax, expected opening `%`");
  }
  var result = [];
  $replace$1(string2, rePropName, function(match2, number2, quote2, subString) {
    result[result.length] = quote2 ? $replace$1(subString, reEscapeChar, "$1") : number2 || match2;
  });
  return result;
};
var getBaseIntrinsic = function getBaseIntrinsic2(name, allowMissing) {
  var intrinsicName = name;
  var alias;
  if (hasOwn$1(LEGACY_ALIASES, intrinsicName)) {
    alias = LEGACY_ALIASES[intrinsicName];
    intrinsicName = "%" + alias[0] + "%";
  }
  if (hasOwn$1(INTRINSICS, intrinsicName)) {
    var value = INTRINSICS[intrinsicName];
    if (value === needsEval) {
      value = doEval(intrinsicName);
    }
    if (typeof value === "undefined" && !allowMissing) {
      throw new $TypeError$3("intrinsic " + name + " exists, but is not available. Please file an issue!");
    }
    return {
      alias,
      name: intrinsicName,
      value
    };
  }
  throw new $SyntaxError$1("intrinsic " + name + " does not exist!");
};
var getIntrinsic = function GetIntrinsic(name, allowMissing) {
  if (typeof name !== "string" || name.length === 0) {
    throw new $TypeError$3("intrinsic name must be a non-empty string");
  }
  if (arguments.length > 1 && typeof allowMissing !== "boolean") {
    throw new $TypeError$3('"allowMissing" argument must be a boolean');
  }
  if ($exec(/^%?[^%]*%?$/, name) === null) {
    throw new $SyntaxError$1("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  }
  var parts = stringToPath(name);
  var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
  var intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
  var intrinsicRealName = intrinsic.name;
  var value = intrinsic.value;
  var skipFurtherCaching = false;
  var alias = intrinsic.alias;
  if (alias) {
    intrinsicBaseName = alias[0];
    $spliceApply(parts, $concat$1([0, 1], alias));
  }
  for (var i2 = 1, isOwn = true; i2 < parts.length; i2 += 1) {
    var part = parts[i2];
    var first = $strSlice(part, 0, 1);
    var last2 = $strSlice(part, -1);
    if ((first === '"' || first === "'" || first === "`" || (last2 === '"' || last2 === "'" || last2 === "`")) && first !== last2) {
      throw new $SyntaxError$1("property names with quotes must have matching quotes");
    }
    if (part === "constructor" || !isOwn) {
      skipFurtherCaching = true;
    }
    intrinsicBaseName += "." + part;
    intrinsicRealName = "%" + intrinsicBaseName + "%";
    if (hasOwn$1(INTRINSICS, intrinsicRealName)) {
      value = INTRINSICS[intrinsicRealName];
    } else if (value != null) {
      if (!(part in value)) {
        if (!allowMissing) {
          throw new $TypeError$3("base intrinsic for " + name + " exists, but the property is not available.");
        }
        return void 0;
      }
      if ($gOPD$1 && i2 + 1 >= parts.length) {
        var desc = $gOPD$1(value, part);
        isOwn = !!desc;
        if (isOwn && "get" in desc && !("originalValue" in desc.get)) {
          value = desc.get;
        } else {
          value = value[part];
        }
      } else {
        isOwn = hasOwn$1(value, part);
        value = value[part];
      }
      if (isOwn && !skipFurtherCaching) {
        INTRINSICS[intrinsicRealName] = value;
      }
    }
  }
  return value;
};
var callBind$1 = { exports: {} };
var esDefineProperty;
var hasRequiredEsDefineProperty;
function requireEsDefineProperty() {
  if (hasRequiredEsDefineProperty)
    return esDefineProperty;
  hasRequiredEsDefineProperty = 1;
  var GetIntrinsic3 = getIntrinsic;
  var $defineProperty2 = GetIntrinsic3("%Object.defineProperty%", true) || false;
  if ($defineProperty2) {
    try {
      $defineProperty2({}, "a", { value: 1 });
    } catch (e) {
      $defineProperty2 = false;
    }
  }
  esDefineProperty = $defineProperty2;
  return esDefineProperty;
}
var GetIntrinsic$3 = getIntrinsic;
var $gOPD = GetIntrinsic$3("%Object.getOwnPropertyDescriptor%", true);
if ($gOPD) {
  try {
    $gOPD([], "length");
  } catch (e) {
    $gOPD = null;
  }
}
var gopd$1 = $gOPD;
var $defineProperty$1 = requireEsDefineProperty();
var $SyntaxError = syntax;
var $TypeError$2 = type;
var gopd = gopd$1;
var defineDataProperty = function defineDataProperty2(obj, property2, value) {
  if (!obj || typeof obj !== "object" && typeof obj !== "function") {
    throw new $TypeError$2("`obj` must be an object or a function`");
  }
  if (typeof property2 !== "string" && typeof property2 !== "symbol") {
    throw new $TypeError$2("`property` must be a string or a symbol`");
  }
  if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) {
    throw new $TypeError$2("`nonEnumerable`, if provided, must be a boolean or null");
  }
  if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) {
    throw new $TypeError$2("`nonWritable`, if provided, must be a boolean or null");
  }
  if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) {
    throw new $TypeError$2("`nonConfigurable`, if provided, must be a boolean or null");
  }
  if (arguments.length > 6 && typeof arguments[6] !== "boolean") {
    throw new $TypeError$2("`loose`, if provided, must be a boolean");
  }
  var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
  var nonWritable = arguments.length > 4 ? arguments[4] : null;
  var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
  var loose = arguments.length > 6 ? arguments[6] : false;
  var desc = !!gopd && gopd(obj, property2);
  if ($defineProperty$1) {
    $defineProperty$1(obj, property2, {
      configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
      enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
      value,
      writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
  } else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) {
    obj[property2] = value;
  } else {
    throw new $SyntaxError("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
  }
};
var $defineProperty = requireEsDefineProperty();
var hasPropertyDescriptors = function hasPropertyDescriptors2() {
  return !!$defineProperty;
};
hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
  if (!$defineProperty) {
    return null;
  }
  try {
    return $defineProperty([], "length", { value: 1 }).length !== 1;
  } catch (e) {
    return true;
  }
};
var hasPropertyDescriptors_1 = hasPropertyDescriptors;
var GetIntrinsic$2 = getIntrinsic;
var define = defineDataProperty;
var hasDescriptors = hasPropertyDescriptors_1();
var gOPD = gopd$1;
var $TypeError$1 = type;
var $floor$1 = GetIntrinsic$2("%Math.floor%");
var setFunctionLength = function setFunctionLength2(fn, length) {
  if (typeof fn !== "function") {
    throw new $TypeError$1("`fn` is not a function");
  }
  if (typeof length !== "number" || length < 0 || length > 4294967295 || $floor$1(length) !== length) {
    throw new $TypeError$1("`length` must be a positive 32-bit integer");
  }
  var loose = arguments.length > 2 && !!arguments[2];
  var functionLengthIsConfigurable = true;
  var functionLengthIsWritable = true;
  if ("length" in fn && gOPD) {
    var desc = gOPD(fn, "length");
    if (desc && !desc.configurable) {
      functionLengthIsConfigurable = false;
    }
    if (desc && !desc.writable) {
      functionLengthIsWritable = false;
    }
  }
  if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
    if (hasDescriptors) {
      define(
        /** @type {Parameters<define>[0]} */
        fn,
        "length",
        length,
        true,
        true
      );
    } else {
      define(
        /** @type {Parameters<define>[0]} */
        fn,
        "length",
        length
      );
    }
  }
  return fn;
};
(function(module) {
  var bind3 = functionBind;
  var GetIntrinsic3 = getIntrinsic;
  var setFunctionLength$1 = setFunctionLength;
  var $TypeError2 = type;
  var $apply = GetIntrinsic3("%Function.prototype.apply%");
  var $call = GetIntrinsic3("%Function.prototype.call%");
  var $reflectApply = GetIntrinsic3("%Reflect.apply%", true) || bind3.call($call, $apply);
  var $defineProperty2 = requireEsDefineProperty();
  var $max = GetIntrinsic3("%Math.max%");
  module.exports = function callBind2(originalFunction) {
    if (typeof originalFunction !== "function") {
      throw new $TypeError2("a function is required");
    }
    var func2 = $reflectApply(bind3, $call, arguments);
    return setFunctionLength$1(
      func2,
      1 + $max(0, originalFunction.length - (arguments.length - 1)),
      true
    );
  };
  var applyBind = function applyBind2() {
    return $reflectApply(bind3, $apply, arguments);
  };
  if ($defineProperty2) {
    $defineProperty2(module.exports, "apply", { value: applyBind });
  } else {
    module.exports.apply = applyBind;
  }
})(callBind$1);
var callBindExports = callBind$1.exports;
var GetIntrinsic$1 = getIntrinsic;
var callBind = callBindExports;
var $indexOf = callBind(GetIntrinsic$1("String.prototype.indexOf"));
var callBound$1 = function callBoundIntrinsic(name, allowMissing) {
  var intrinsic = GetIntrinsic$1(name, !!allowMissing);
  if (typeof intrinsic === "function" && $indexOf(name, ".prototype.") > -1) {
    return callBind(intrinsic);
  }
  return intrinsic;
};
const __viteBrowserExternal = {};
const __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: __viteBrowserExternal
}, Symbol.toStringTag, { value: "Module" }));
const require$$0 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
var hasMap = typeof Map === "function" && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === "function" ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === "function" && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === "function" ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
var toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;
var gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(O) {
  return O.__proto__;
} : null);
function addNumericSeparator(num, str) {
  if (num === Infinity || num === -Infinity || num !== num || num && num > -1e3 && num < 1e3 || $test.call(/e/, str)) {
    return str;
  }
  var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
  if (typeof num === "number") {
    var int = num < 0 ? -$floor(-num) : $floor(num);
    if (int !== num) {
      var intStr = String(int);
      var dec = $slice.call(str, intStr.length + 1);
      return $replace.call(intStr, sepRegex, "$&_") + "." + $replace.call($replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
    }
  }
  return $replace.call(str, sepRegex, "$&_");
}
var utilInspect = require$$0;
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol$1(inspectCustom) ? inspectCustom : null;
var objectInspect = function inspect_(obj, options, depth, seen) {
  var opts = options || {};
  if (has$3(opts, "quoteStyle") && (opts.quoteStyle !== "single" && opts.quoteStyle !== "double")) {
    throw new TypeError('option "quoteStyle" must be "single" or "double"');
  }
  if (has$3(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) {
    throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
  }
  var customInspect = has$3(opts, "customInspect") ? opts.customInspect : true;
  if (typeof customInspect !== "boolean" && customInspect !== "symbol") {
    throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
  }
  if (has$3(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) {
    throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
  }
  if (has$3(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") {
    throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
  }
  var numericSeparator = opts.numericSeparator;
  if (typeof obj === "undefined") {
    return "undefined";
  }
  if (obj === null) {
    return "null";
  }
  if (typeof obj === "boolean") {
    return obj ? "true" : "false";
  }
  if (typeof obj === "string") {
    return inspectString(obj, opts);
  }
  if (typeof obj === "number") {
    if (obj === 0) {
      return Infinity / obj > 0 ? "0" : "-0";
    }
    var str = String(obj);
    return numericSeparator ? addNumericSeparator(obj, str) : str;
  }
  if (typeof obj === "bigint") {
    var bigIntStr = String(obj) + "n";
    return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
  }
  var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
  if (typeof depth === "undefined") {
    depth = 0;
  }
  if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") {
    return isArray$5(obj) ? "[Array]" : "[Object]";
  }
  var indent = getIndent(opts, depth);
  if (typeof seen === "undefined") {
    seen = [];
  } else if (indexOf(seen, obj) >= 0) {
    return "[Circular]";
  }
  function inspect2(value, from, noIndent) {
    if (from) {
      seen = $arrSlice.call(seen);
      seen.push(from);
    }
    if (noIndent) {
      var newOpts = {
        depth: opts.depth
      };
      if (has$3(opts, "quoteStyle")) {
        newOpts.quoteStyle = opts.quoteStyle;
      }
      return inspect_(value, newOpts, depth + 1, seen);
    }
    return inspect_(value, opts, depth + 1, seen);
  }
  if (typeof obj === "function" && !isRegExp$1(obj)) {
    var name = nameOf(obj);
    var keys2 = arrObjKeys(obj, inspect2);
    return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys2.length > 0 ? " { " + $join.call(keys2, ", ") + " }" : "");
  }
  if (isSymbol$1(obj)) {
    var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : symToString.call(obj);
    return typeof obj === "object" && !hasShammedSymbols ? markBoxed(symString) : symString;
  }
  if (isElement(obj)) {
    var s2 = "<" + $toLowerCase.call(String(obj.nodeName));
    var attrs = obj.attributes || [];
    for (var i2 = 0; i2 < attrs.length; i2++) {
      s2 += " " + attrs[i2].name + "=" + wrapQuotes(quote(attrs[i2].value), "double", opts);
    }
    s2 += ">";
    if (obj.childNodes && obj.childNodes.length) {
      s2 += "...";
    }
    s2 += "</" + $toLowerCase.call(String(obj.nodeName)) + ">";
    return s2;
  }
  if (isArray$5(obj)) {
    if (obj.length === 0) {
      return "[]";
    }
    var xs = arrObjKeys(obj, inspect2);
    if (indent && !singleLineValues(xs)) {
      return "[" + indentedJoin(xs, indent) + "]";
    }
    return "[ " + $join.call(xs, ", ") + " ]";
  }
  if (isError(obj)) {
    var parts = arrObjKeys(obj, inspect2);
    if (!("cause" in Error.prototype) && "cause" in obj && !isEnumerable.call(obj, "cause")) {
      return "{ [" + String(obj) + "] " + $join.call($concat.call("[cause]: " + inspect2(obj.cause), parts), ", ") + " }";
    }
    if (parts.length === 0) {
      return "[" + String(obj) + "]";
    }
    return "{ [" + String(obj) + "] " + $join.call(parts, ", ") + " }";
  }
  if (typeof obj === "object" && customInspect) {
    if (inspectSymbol && typeof obj[inspectSymbol] === "function" && utilInspect) {
      return utilInspect(obj, { depth: maxDepth - depth });
    } else if (customInspect !== "symbol" && typeof obj.inspect === "function") {
      return obj.inspect();
    }
  }
  if (isMap(obj)) {
    var mapParts = [];
    if (mapForEach) {
      mapForEach.call(obj, function(value, key) {
        mapParts.push(inspect2(key, obj, true) + " => " + inspect2(value, obj));
      });
    }
    return collectionOf("Map", mapSize.call(obj), mapParts, indent);
  }
  if (isSet(obj)) {
    var setParts = [];
    if (setForEach) {
      setForEach.call(obj, function(value) {
        setParts.push(inspect2(value, obj));
      });
    }
    return collectionOf("Set", setSize.call(obj), setParts, indent);
  }
  if (isWeakMap(obj)) {
    return weakCollectionOf("WeakMap");
  }
  if (isWeakSet(obj)) {
    return weakCollectionOf("WeakSet");
  }
  if (isWeakRef(obj)) {
    return weakCollectionOf("WeakRef");
  }
  if (isNumber(obj)) {
    return markBoxed(inspect2(Number(obj)));
  }
  if (isBigInt(obj)) {
    return markBoxed(inspect2(bigIntValueOf.call(obj)));
  }
  if (isBoolean(obj)) {
    return markBoxed(booleanValueOf.call(obj));
  }
  if (isString(obj)) {
    return markBoxed(inspect2(String(obj)));
  }
  if (typeof window !== "undefined" && obj === window) {
    return "{ [object Window] }";
  }
  if (obj === commonjsGlobal) {
    return "{ [object globalThis] }";
  }
  if (!isDate(obj) && !isRegExp$1(obj)) {
    var ys = arrObjKeys(obj, inspect2);
    var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
    var protoTag = obj instanceof Object ? "" : "null prototype";
    var stringTag2 = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? "Object" : "";
    var constructorTag = isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
    var tag = constructorTag + (stringTag2 || protoTag ? "[" + $join.call($concat.call([], stringTag2 || [], protoTag || []), ": ") + "] " : "");
    if (ys.length === 0) {
      return tag + "{}";
    }
    if (indent) {
      return tag + "{" + indentedJoin(ys, indent) + "}";
    }
    return tag + "{ " + $join.call(ys, ", ") + " }";
  }
  return String(obj);
};
function wrapQuotes(s2, defaultStyle, opts) {
  var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
  return quoteChar + s2 + quoteChar;
}
function quote(s2) {
  return $replace.call(String(s2), /"/g, "&quot;");
}
function isArray$5(obj) {
  return toStr(obj) === "[object Array]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isDate(obj) {
  return toStr(obj) === "[object Date]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isRegExp$1(obj) {
  return toStr(obj) === "[object RegExp]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isError(obj) {
  return toStr(obj) === "[object Error]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isString(obj) {
  return toStr(obj) === "[object String]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isNumber(obj) {
  return toStr(obj) === "[object Number]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isBoolean(obj) {
  return toStr(obj) === "[object Boolean]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isSymbol$1(obj) {
  if (hasShammedSymbols) {
    return obj && typeof obj === "object" && obj instanceof Symbol;
  }
  if (typeof obj === "symbol") {
    return true;
  }
  if (!obj || typeof obj !== "object" || !symToString) {
    return false;
  }
  try {
    symToString.call(obj);
    return true;
  } catch (e) {
  }
  return false;
}
function isBigInt(obj) {
  if (!obj || typeof obj !== "object" || !bigIntValueOf) {
    return false;
  }
  try {
    bigIntValueOf.call(obj);
    return true;
  } catch (e) {
  }
  return false;
}
var hasOwn = Object.prototype.hasOwnProperty || function(key) {
  return key in this;
};
function has$3(obj, key) {
  return hasOwn.call(obj, key);
}
function toStr(obj) {
  return objectToString.call(obj);
}
function nameOf(f) {
  if (f.name) {
    return f.name;
  }
  var m2 = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
  if (m2) {
    return m2[1];
  }
  return null;
}
function indexOf(xs, x) {
  if (xs.indexOf) {
    return xs.indexOf(x);
  }
  for (var i2 = 0, l = xs.length; i2 < l; i2++) {
    if (xs[i2] === x) {
      return i2;
    }
  }
  return -1;
}
function isMap(x) {
  if (!mapSize || !x || typeof x !== "object") {
    return false;
  }
  try {
    mapSize.call(x);
    try {
      setSize.call(x);
    } catch (s2) {
      return true;
    }
    return x instanceof Map;
  } catch (e) {
  }
  return false;
}
function isWeakMap(x) {
  if (!weakMapHas || !x || typeof x !== "object") {
    return false;
  }
  try {
    weakMapHas.call(x, weakMapHas);
    try {
      weakSetHas.call(x, weakSetHas);
    } catch (s2) {
      return true;
    }
    return x instanceof WeakMap;
  } catch (e) {
  }
  return false;
}
function isWeakRef(x) {
  if (!weakRefDeref || !x || typeof x !== "object") {
    return false;
  }
  try {
    weakRefDeref.call(x);
    return true;
  } catch (e) {
  }
  return false;
}
function isSet(x) {
  if (!setSize || !x || typeof x !== "object") {
    return false;
  }
  try {
    setSize.call(x);
    try {
      mapSize.call(x);
    } catch (m2) {
      return true;
    }
    return x instanceof Set;
  } catch (e) {
  }
  return false;
}
function isWeakSet(x) {
  if (!weakSetHas || !x || typeof x !== "object") {
    return false;
  }
  try {
    weakSetHas.call(x, weakSetHas);
    try {
      weakMapHas.call(x, weakMapHas);
    } catch (s2) {
      return true;
    }
    return x instanceof WeakSet;
  } catch (e) {
  }
  return false;
}
function isElement(x) {
  if (!x || typeof x !== "object") {
    return false;
  }
  if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) {
    return true;
  }
  return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function inspectString(str, opts) {
  if (str.length > opts.maxStringLength) {
    var remaining = str.length - opts.maxStringLength;
    var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
    return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
  }
  var s2 = $replace.call($replace.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, lowbyte);
  return wrapQuotes(s2, "single", opts);
}
function lowbyte(c2) {
  var n2 = c2.charCodeAt(0);
  var x = {
    8: "b",
    9: "t",
    10: "n",
    12: "f",
    13: "r"
  }[n2];
  if (x) {
    return "\\" + x;
  }
  return "\\x" + (n2 < 16 ? "0" : "") + $toUpperCase.call(n2.toString(16));
}
function markBoxed(str) {
  return "Object(" + str + ")";
}
function weakCollectionOf(type2) {
  return type2 + " { ? }";
}
function collectionOf(type2, size2, entries, indent) {
  var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ", ");
  return type2 + " (" + size2 + ") {" + joinedEntries + "}";
}
function singleLineValues(xs) {
  for (var i2 = 0; i2 < xs.length; i2++) {
    if (indexOf(xs[i2], "\n") >= 0) {
      return false;
    }
  }
  return true;
}
function getIndent(opts, depth) {
  var baseIndent;
  if (opts.indent === "	") {
    baseIndent = "	";
  } else if (typeof opts.indent === "number" && opts.indent > 0) {
    baseIndent = $join.call(Array(opts.indent + 1), " ");
  } else {
    return null;
  }
  return {
    base: baseIndent,
    prev: $join.call(Array(depth + 1), baseIndent)
  };
}
function indentedJoin(xs, indent) {
  if (xs.length === 0) {
    return "";
  }
  var lineJoiner = "\n" + indent.prev + indent.base;
  return lineJoiner + $join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function arrObjKeys(obj, inspect2) {
  var isArr = isArray$5(obj);
  var xs = [];
  if (isArr) {
    xs.length = obj.length;
    for (var i2 = 0; i2 < obj.length; i2++) {
      xs[i2] = has$3(obj, i2) ? inspect2(obj[i2], obj) : "";
    }
  }
  var syms = typeof gOPS === "function" ? gOPS(obj) : [];
  var symMap;
  if (hasShammedSymbols) {
    symMap = {};
    for (var k2 = 0; k2 < syms.length; k2++) {
      symMap["$" + syms[k2]] = syms[k2];
    }
  }
  for (var key in obj) {
    if (!has$3(obj, key)) {
      continue;
    }
    if (isArr && String(Number(key)) === key && key < obj.length) {
      continue;
    }
    if (hasShammedSymbols && symMap["$" + key] instanceof Symbol) {
      continue;
    } else if ($test.call(/[^\w$]/, key)) {
      xs.push(inspect2(key, obj) + ": " + inspect2(obj[key], obj));
    } else {
      xs.push(key + ": " + inspect2(obj[key], obj));
    }
  }
  if (typeof gOPS === "function") {
    for (var j2 = 0; j2 < syms.length; j2++) {
      if (isEnumerable.call(obj, syms[j2])) {
        xs.push("[" + inspect2(syms[j2]) + "]: " + inspect2(obj[syms[j2]], obj));
      }
    }
  }
  return xs;
}
var GetIntrinsic2 = getIntrinsic;
var callBound = callBound$1;
var inspect = objectInspect;
var $TypeError = type;
var $WeakMap = GetIntrinsic2("%WeakMap%", true);
var $Map = GetIntrinsic2("%Map%", true);
var $weakMapGet = callBound("WeakMap.prototype.get", true);
var $weakMapSet = callBound("WeakMap.prototype.set", true);
var $weakMapHas = callBound("WeakMap.prototype.has", true);
var $mapGet = callBound("Map.prototype.get", true);
var $mapSet = callBound("Map.prototype.set", true);
var $mapHas = callBound("Map.prototype.has", true);
var listGetNode = function(list, key) {
  var prev = list;
  var curr;
  for (; (curr = prev.next) !== null; prev = curr) {
    if (curr.key === key) {
      prev.next = curr.next;
      curr.next = /** @type {NonNullable<typeof list.next>} */
      list.next;
      list.next = curr;
      return curr;
    }
  }
};
var listGet = function(objects, key) {
  var node2 = listGetNode(objects, key);
  return node2 && node2.value;
};
var listSet = function(objects, key, value) {
  var node2 = listGetNode(objects, key);
  if (node2) {
    node2.value = value;
  } else {
    objects.next = /** @type {import('.').ListNode<typeof value>} */
    {
      // eslint-disable-line no-param-reassign, no-extra-parens
      key,
      next: objects.next,
      value
    };
  }
};
var listHas = function(objects, key) {
  return !!listGetNode(objects, key);
};
var sideChannel = function getSideChannel() {
  var $wm;
  var $m;
  var $o;
  var channel = {
    assert: function(key) {
      if (!channel.has(key)) {
        throw new $TypeError("Side channel does not contain " + inspect(key));
      }
    },
    get: function(key) {
      if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
        if ($wm) {
          return $weakMapGet($wm, key);
        }
      } else if ($Map) {
        if ($m) {
          return $mapGet($m, key);
        }
      } else {
        if ($o) {
          return listGet($o, key);
        }
      }
    },
    has: function(key) {
      if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
        if ($wm) {
          return $weakMapHas($wm, key);
        }
      } else if ($Map) {
        if ($m) {
          return $mapHas($m, key);
        }
      } else {
        if ($o) {
          return listHas($o, key);
        }
      }
      return false;
    },
    set: function(key, value) {
      if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
        if (!$wm) {
          $wm = new $WeakMap();
        }
        $weakMapSet($wm, key, value);
      } else if ($Map) {
        if (!$m) {
          $m = new $Map();
        }
        $mapSet($m, key, value);
      } else {
        if (!$o) {
          $o = { key: {}, next: null };
        }
        listSet($o, key, value);
      }
    }
  };
  return channel;
};
var replace = String.prototype.replace;
var percentTwenties = /%20/g;
var Format = {
  RFC1738: "RFC1738",
  RFC3986: "RFC3986"
};
var formats$3 = {
  "default": Format.RFC3986,
  formatters: {
    RFC1738: function(value) {
      return replace.call(value, percentTwenties, "+");
    },
    RFC3986: function(value) {
      return String(value);
    }
  },
  RFC1738: Format.RFC1738,
  RFC3986: Format.RFC3986
};
var formats$2 = formats$3;
var has$2 = Object.prototype.hasOwnProperty;
var isArray$4 = Array.isArray;
var hexTable = function() {
  var array = [];
  for (var i2 = 0; i2 < 256; ++i2) {
    array.push("%" + ((i2 < 16 ? "0" : "") + i2.toString(16)).toUpperCase());
  }
  return array;
}();
var compactQueue = function compactQueue2(queue2) {
  while (queue2.length > 1) {
    var item = queue2.pop();
    var obj = item.obj[item.prop];
    if (isArray$4(obj)) {
      var compacted = [];
      for (var j2 = 0; j2 < obj.length; ++j2) {
        if (typeof obj[j2] !== "undefined") {
          compacted.push(obj[j2]);
        }
      }
      item.obj[item.prop] = compacted;
    }
  }
};
var arrayToObject = function arrayToObject2(source, options) {
  var obj = options && options.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  for (var i2 = 0; i2 < source.length; ++i2) {
    if (typeof source[i2] !== "undefined") {
      obj[i2] = source[i2];
    }
  }
  return obj;
};
var merge = function merge2(target, source, options) {
  if (!source) {
    return target;
  }
  if (typeof source !== "object") {
    if (isArray$4(target)) {
      target.push(source);
    } else if (target && typeof target === "object") {
      if (options && (options.plainObjects || options.allowPrototypes) || !has$2.call(Object.prototype, source)) {
        target[source] = true;
      }
    } else {
      return [target, source];
    }
    return target;
  }
  if (!target || typeof target !== "object") {
    return [target].concat(source);
  }
  var mergeTarget = target;
  if (isArray$4(target) && !isArray$4(source)) {
    mergeTarget = arrayToObject(target, options);
  }
  if (isArray$4(target) && isArray$4(source)) {
    source.forEach(function(item, i2) {
      if (has$2.call(target, i2)) {
        var targetItem = target[i2];
        if (targetItem && typeof targetItem === "object" && item && typeof item === "object") {
          target[i2] = merge2(targetItem, item, options);
        } else {
          target.push(item);
        }
      } else {
        target[i2] = item;
      }
    });
    return target;
  }
  return Object.keys(source).reduce(function(acc, key) {
    var value = source[key];
    if (has$2.call(acc, key)) {
      acc[key] = merge2(acc[key], value, options);
    } else {
      acc[key] = value;
    }
    return acc;
  }, mergeTarget);
};
var assign = function assignSingleSource(target, source) {
  return Object.keys(source).reduce(function(acc, key) {
    acc[key] = source[key];
    return acc;
  }, target);
};
var decode = function(str, decoder, charset) {
  var strWithoutPlus = str.replace(/\+/g, " ");
  if (charset === "iso-8859-1") {
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
  }
  try {
    return decodeURIComponent(strWithoutPlus);
  } catch (e) {
    return strWithoutPlus;
  }
};
var limit = 1024;
var encode = function encode2(str, defaultEncoder, charset, kind, format2) {
  if (str.length === 0) {
    return str;
  }
  var string2 = str;
  if (typeof str === "symbol") {
    string2 = Symbol.prototype.toString.call(str);
  } else if (typeof str !== "string") {
    string2 = String(str);
  }
  if (charset === "iso-8859-1") {
    return escape(string2).replace(/%u[0-9a-f]{4}/gi, function($0) {
      return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
  }
  var out = "";
  for (var j2 = 0; j2 < string2.length; j2 += limit) {
    var segment = string2.length >= limit ? string2.slice(j2, j2 + limit) : string2;
    var arr = [];
    for (var i2 = 0; i2 < segment.length; ++i2) {
      var c2 = segment.charCodeAt(i2);
      if (c2 === 45 || c2 === 46 || c2 === 95 || c2 === 126 || c2 >= 48 && c2 <= 57 || c2 >= 65 && c2 <= 90 || c2 >= 97 && c2 <= 122 || format2 === formats$2.RFC1738 && (c2 === 40 || c2 === 41)) {
        arr[arr.length] = segment.charAt(i2);
        continue;
      }
      if (c2 < 128) {
        arr[arr.length] = hexTable[c2];
        continue;
      }
      if (c2 < 2048) {
        arr[arr.length] = hexTable[192 | c2 >> 6] + hexTable[128 | c2 & 63];
        continue;
      }
      if (c2 < 55296 || c2 >= 57344) {
        arr[arr.length] = hexTable[224 | c2 >> 12] + hexTable[128 | c2 >> 6 & 63] + hexTable[128 | c2 & 63];
        continue;
      }
      i2 += 1;
      c2 = 65536 + ((c2 & 1023) << 10 | segment.charCodeAt(i2) & 1023);
      arr[arr.length] = hexTable[240 | c2 >> 18] + hexTable[128 | c2 >> 12 & 63] + hexTable[128 | c2 >> 6 & 63] + hexTable[128 | c2 & 63];
    }
    out += arr.join("");
  }
  return out;
};
var compact = function compact2(value) {
  var queue2 = [{ obj: { o: value }, prop: "o" }];
  var refs = [];
  for (var i2 = 0; i2 < queue2.length; ++i2) {
    var item = queue2[i2];
    var obj = item.obj[item.prop];
    var keys2 = Object.keys(obj);
    for (var j2 = 0; j2 < keys2.length; ++j2) {
      var key = keys2[j2];
      var val = obj[key];
      if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
        queue2.push({ obj, prop: key });
        refs.push(val);
      }
    }
  }
  compactQueue(queue2);
  return value;
};
var isRegExp = function isRegExp2(obj) {
  return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var isBuffer = function isBuffer2(obj) {
  if (!obj || typeof obj !== "object") {
    return false;
  }
  return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var combine = function combine2(a, b) {
  return [].concat(a, b);
};
var maybeMap = function maybeMap2(val, fn) {
  if (isArray$4(val)) {
    var mapped = [];
    for (var i2 = 0; i2 < val.length; i2 += 1) {
      mapped.push(fn(val[i2]));
    }
    return mapped;
  }
  return fn(val);
};
var utils$2 = {
  arrayToObject,
  assign,
  combine,
  compact,
  decode,
  encode,
  isBuffer,
  isRegExp,
  maybeMap,
  merge
};
var getSideChannel2 = sideChannel;
var utils$1 = utils$2;
var formats$1 = formats$3;
var has$1 = Object.prototype.hasOwnProperty;
var arrayPrefixGenerators = {
  brackets: function brackets(prefix) {
    return prefix + "[]";
  },
  comma: "comma",
  indices: function indices(prefix, key) {
    return prefix + "[" + key + "]";
  },
  repeat: function repeat(prefix) {
    return prefix;
  }
};
var isArray$3 = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function(arr, valueOrArray) {
  push.apply(arr, isArray$3(valueOrArray) ? valueOrArray : [valueOrArray]);
};
var toISO = Date.prototype.toISOString;
var defaultFormat = formats$1["default"];
var defaults$1 = {
  addQueryPrefix: false,
  allowDots: false,
  allowEmptyArrays: false,
  arrayFormat: "indices",
  charset: "utf-8",
  charsetSentinel: false,
  delimiter: "&",
  encode: true,
  encodeDotInKeys: false,
  encoder: utils$1.encode,
  encodeValuesOnly: false,
  format: defaultFormat,
  formatter: formats$1.formatters[defaultFormat],
  // deprecated
  indices: false,
  serializeDate: function serializeDate(date) {
    return toISO.call(date);
  },
  skipNulls: false,
  strictNullHandling: false
};
var isNonNullishPrimitive = function isNonNullishPrimitive2(v) {
  return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var sentinel = {};
var stringify$1 = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate2, format2, formatter, encodeValuesOnly, charset, sideChannel2) {
  var obj = object;
  var tmpSc = sideChannel2;
  var step = 0;
  var findFlag = false;
  while ((tmpSc = tmpSc.get(sentinel)) !== void 0 && !findFlag) {
    var pos = tmpSc.get(object);
    step += 1;
    if (typeof pos !== "undefined") {
      if (pos === step) {
        throw new RangeError("Cyclic object value");
      } else {
        findFlag = true;
      }
    }
    if (typeof tmpSc.get(sentinel) === "undefined") {
      step = 0;
    }
  }
  if (typeof filter === "function") {
    obj = filter(prefix, obj);
  } else if (obj instanceof Date) {
    obj = serializeDate2(obj);
  } else if (generateArrayPrefix === "comma" && isArray$3(obj)) {
    obj = utils$1.maybeMap(obj, function(value2) {
      if (value2 instanceof Date) {
        return serializeDate2(value2);
      }
      return value2;
    });
  }
  if (obj === null) {
    if (strictNullHandling) {
      return encoder && !encodeValuesOnly ? encoder(prefix, defaults$1.encoder, charset, "key", format2) : prefix;
    }
    obj = "";
  }
  if (isNonNullishPrimitive(obj) || utils$1.isBuffer(obj)) {
    if (encoder) {
      var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults$1.encoder, charset, "key", format2);
      return [formatter(keyValue) + "=" + formatter(encoder(obj, defaults$1.encoder, charset, "value", format2))];
    }
    return [formatter(prefix) + "=" + formatter(String(obj))];
  }
  var values = [];
  if (typeof obj === "undefined") {
    return values;
  }
  var objKeys;
  if (generateArrayPrefix === "comma" && isArray$3(obj)) {
    if (encodeValuesOnly && encoder) {
      obj = utils$1.maybeMap(obj, encoder);
    }
    objKeys = [{ value: obj.length > 0 ? obj.join(",") || null : void 0 }];
  } else if (isArray$3(filter)) {
    objKeys = filter;
  } else {
    var keys2 = Object.keys(obj);
    objKeys = sort ? keys2.sort(sort) : keys2;
  }
  var encodedPrefix = encodeDotInKeys ? prefix.replace(/\./g, "%2E") : prefix;
  var adjustedPrefix = commaRoundTrip && isArray$3(obj) && obj.length === 1 ? encodedPrefix + "[]" : encodedPrefix;
  if (allowEmptyArrays && isArray$3(obj) && obj.length === 0) {
    return adjustedPrefix + "[]";
  }
  for (var j2 = 0; j2 < objKeys.length; ++j2) {
    var key = objKeys[j2];
    var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
    if (skipNulls && value === null) {
      continue;
    }
    var encodedKey = allowDots && encodeDotInKeys ? key.replace(/\./g, "%2E") : key;
    var keyPrefix = isArray$3(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? "." + encodedKey : "[" + encodedKey + "]");
    sideChannel2.set(object, step);
    var valueSideChannel = getSideChannel2();
    valueSideChannel.set(sentinel, sideChannel2);
    pushToArray(values, stringify(
      value,
      keyPrefix,
      generateArrayPrefix,
      commaRoundTrip,
      allowEmptyArrays,
      strictNullHandling,
      skipNulls,
      encodeDotInKeys,
      generateArrayPrefix === "comma" && encodeValuesOnly && isArray$3(obj) ? null : encoder,
      filter,
      sort,
      allowDots,
      serializeDate2,
      format2,
      formatter,
      encodeValuesOnly,
      charset,
      valueSideChannel
    ));
  }
  return values;
};
var normalizeStringifyOptions = function normalizeStringifyOptions2(opts) {
  if (!opts) {
    return defaults$1;
  }
  if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") {
    throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
  }
  if (typeof opts.encodeDotInKeys !== "undefined" && typeof opts.encodeDotInKeys !== "boolean") {
    throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
  }
  if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") {
    throw new TypeError("Encoder has to be a function.");
  }
  var charset = opts.charset || defaults$1.charset;
  if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") {
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  }
  var format2 = formats$1["default"];
  if (typeof opts.format !== "undefined") {
    if (!has$1.call(formats$1.formatters, opts.format)) {
      throw new TypeError("Unknown format option provided.");
    }
    format2 = opts.format;
  }
  var formatter = formats$1.formatters[format2];
  var filter = defaults$1.filter;
  if (typeof opts.filter === "function" || isArray$3(opts.filter)) {
    filter = opts.filter;
  }
  var arrayFormat;
  if (opts.arrayFormat in arrayPrefixGenerators) {
    arrayFormat = opts.arrayFormat;
  } else if ("indices" in opts) {
    arrayFormat = opts.indices ? "indices" : "repeat";
  } else {
    arrayFormat = defaults$1.arrayFormat;
  }
  if ("commaRoundTrip" in opts && typeof opts.commaRoundTrip !== "boolean") {
    throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
  }
  var allowDots = typeof opts.allowDots === "undefined" ? opts.encodeDotInKeys === true ? true : defaults$1.allowDots : !!opts.allowDots;
  return {
    addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : defaults$1.addQueryPrefix,
    allowDots,
    allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : defaults$1.allowEmptyArrays,
    arrayFormat,
    charset,
    charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : defaults$1.charsetSentinel,
    commaRoundTrip: opts.commaRoundTrip,
    delimiter: typeof opts.delimiter === "undefined" ? defaults$1.delimiter : opts.delimiter,
    encode: typeof opts.encode === "boolean" ? opts.encode : defaults$1.encode,
    encodeDotInKeys: typeof opts.encodeDotInKeys === "boolean" ? opts.encodeDotInKeys : defaults$1.encodeDotInKeys,
    encoder: typeof opts.encoder === "function" ? opts.encoder : defaults$1.encoder,
    encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : defaults$1.encodeValuesOnly,
    filter,
    format: format2,
    formatter,
    serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : defaults$1.serializeDate,
    skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : defaults$1.skipNulls,
    sort: typeof opts.sort === "function" ? opts.sort : null,
    strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : defaults$1.strictNullHandling
  };
};
var stringify_1 = function(object, opts) {
  var obj = object;
  var options = normalizeStringifyOptions(opts);
  var objKeys;
  var filter;
  if (typeof options.filter === "function") {
    filter = options.filter;
    obj = filter("", obj);
  } else if (isArray$3(options.filter)) {
    filter = options.filter;
    objKeys = filter;
  }
  var keys2 = [];
  if (typeof obj !== "object" || obj === null) {
    return "";
  }
  var generateArrayPrefix = arrayPrefixGenerators[options.arrayFormat];
  var commaRoundTrip = generateArrayPrefix === "comma" && options.commaRoundTrip;
  if (!objKeys) {
    objKeys = Object.keys(obj);
  }
  if (options.sort) {
    objKeys.sort(options.sort);
  }
  var sideChannel2 = getSideChannel2();
  for (var i2 = 0; i2 < objKeys.length; ++i2) {
    var key = objKeys[i2];
    if (options.skipNulls && obj[key] === null) {
      continue;
    }
    pushToArray(keys2, stringify$1(
      obj[key],
      key,
      generateArrayPrefix,
      commaRoundTrip,
      options.allowEmptyArrays,
      options.strictNullHandling,
      options.skipNulls,
      options.encodeDotInKeys,
      options.encode ? options.encoder : null,
      options.filter,
      options.sort,
      options.allowDots,
      options.serializeDate,
      options.format,
      options.formatter,
      options.encodeValuesOnly,
      options.charset,
      sideChannel2
    ));
  }
  var joined = keys2.join(options.delimiter);
  var prefix = options.addQueryPrefix === true ? "?" : "";
  if (options.charsetSentinel) {
    if (options.charset === "iso-8859-1") {
      prefix += "utf8=%26%2310003%3B&";
    } else {
      prefix += "utf8=%E2%9C%93&";
    }
  }
  return joined.length > 0 ? prefix + joined : "";
};
var utils = utils$2;
var has = Object.prototype.hasOwnProperty;
var isArray$2 = Array.isArray;
var defaults = {
  allowDots: false,
  allowEmptyArrays: false,
  allowPrototypes: false,
  allowSparse: false,
  arrayLimit: 20,
  charset: "utf-8",
  charsetSentinel: false,
  comma: false,
  decodeDotInKeys: false,
  decoder: utils.decode,
  delimiter: "&",
  depth: 5,
  duplicates: "combine",
  ignoreQueryPrefix: false,
  interpretNumericEntities: false,
  parameterLimit: 1e3,
  parseArrays: true,
  plainObjects: false,
  strictNullHandling: false
};
var interpretNumericEntities = function(str) {
  return str.replace(/&#(\d+);/g, function($0, numberStr) {
    return String.fromCharCode(parseInt(numberStr, 10));
  });
};
var parseArrayValue = function(val, options) {
  if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) {
    return val.split(",");
  }
  return val;
};
var isoSentinel = "utf8=%26%2310003%3B";
var charsetSentinel = "utf8=%E2%9C%93";
var parseValues = function parseQueryStringValues(str, options) {
  var obj = { __proto__: null };
  var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
  var limit2 = options.parameterLimit === Infinity ? void 0 : options.parameterLimit;
  var parts = cleanStr.split(options.delimiter, limit2);
  var skipIndex = -1;
  var i2;
  var charset = options.charset;
  if (options.charsetSentinel) {
    for (i2 = 0; i2 < parts.length; ++i2) {
      if (parts[i2].indexOf("utf8=") === 0) {
        if (parts[i2] === charsetSentinel) {
          charset = "utf-8";
        } else if (parts[i2] === isoSentinel) {
          charset = "iso-8859-1";
        }
        skipIndex = i2;
        i2 = parts.length;
      }
    }
  }
  for (i2 = 0; i2 < parts.length; ++i2) {
    if (i2 === skipIndex) {
      continue;
    }
    var part = parts[i2];
    var bracketEqualsPos = part.indexOf("]=");
    var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
    var key, val;
    if (pos === -1) {
      key = options.decoder(part, defaults.decoder, charset, "key");
      val = options.strictNullHandling ? null : "";
    } else {
      key = options.decoder(part.slice(0, pos), defaults.decoder, charset, "key");
      val = utils.maybeMap(
        parseArrayValue(part.slice(pos + 1), options),
        function(encodedVal) {
          return options.decoder(encodedVal, defaults.decoder, charset, "value");
        }
      );
    }
    if (val && options.interpretNumericEntities && charset === "iso-8859-1") {
      val = interpretNumericEntities(val);
    }
    if (part.indexOf("[]=") > -1) {
      val = isArray$2(val) ? [val] : val;
    }
    var existing = has.call(obj, key);
    if (existing && options.duplicates === "combine") {
      obj[key] = utils.combine(obj[key], val);
    } else if (!existing || options.duplicates === "last") {
      obj[key] = val;
    }
  }
  return obj;
};
var parseObject = function(chain, val, options, valuesParsed) {
  var leaf = valuesParsed ? val : parseArrayValue(val, options);
  for (var i2 = chain.length - 1; i2 >= 0; --i2) {
    var obj;
    var root2 = chain[i2];
    if (root2 === "[]" && options.parseArrays) {
      obj = options.allowEmptyArrays && leaf === "" ? [] : [].concat(leaf);
    } else {
      obj = options.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
      var cleanRoot = root2.charAt(0) === "[" && root2.charAt(root2.length - 1) === "]" ? root2.slice(1, -1) : root2;
      var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, ".") : cleanRoot;
      var index = parseInt(decodedRoot, 10);
      if (!options.parseArrays && decodedRoot === "") {
        obj = { 0: leaf };
      } else if (!isNaN(index) && root2 !== decodedRoot && String(index) === decodedRoot && index >= 0 && (options.parseArrays && index <= options.arrayLimit)) {
        obj = [];
        obj[index] = leaf;
      } else if (decodedRoot !== "__proto__") {
        obj[decodedRoot] = leaf;
      }
    }
    leaf = obj;
  }
  return leaf;
};
var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
  if (!givenKey) {
    return;
  }
  var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
  var brackets2 = /(\[[^[\]]*])/;
  var child = /(\[[^[\]]*])/g;
  var segment = options.depth > 0 && brackets2.exec(key);
  var parent = segment ? key.slice(0, segment.index) : key;
  var keys2 = [];
  if (parent) {
    if (!options.plainObjects && has.call(Object.prototype, parent)) {
      if (!options.allowPrototypes) {
        return;
      }
    }
    keys2.push(parent);
  }
  var i2 = 0;
  while (options.depth > 0 && (segment = child.exec(key)) !== null && i2 < options.depth) {
    i2 += 1;
    if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
      if (!options.allowPrototypes) {
        return;
      }
    }
    keys2.push(segment[1]);
  }
  if (segment) {
    keys2.push("[" + key.slice(segment.index) + "]");
  }
  return parseObject(keys2, val, options, valuesParsed);
};
var normalizeParseOptions = function normalizeParseOptions2(opts) {
  if (!opts) {
    return defaults;
  }
  if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") {
    throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
  }
  if (typeof opts.decodeDotInKeys !== "undefined" && typeof opts.decodeDotInKeys !== "boolean") {
    throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
  }
  if (opts.decoder !== null && typeof opts.decoder !== "undefined" && typeof opts.decoder !== "function") {
    throw new TypeError("Decoder has to be a function.");
  }
  if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") {
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  }
  var charset = typeof opts.charset === "undefined" ? defaults.charset : opts.charset;
  var duplicates = typeof opts.duplicates === "undefined" ? defaults.duplicates : opts.duplicates;
  if (duplicates !== "combine" && duplicates !== "first" && duplicates !== "last") {
    throw new TypeError("The duplicates option must be either combine, first, or last");
  }
  var allowDots = typeof opts.allowDots === "undefined" ? opts.decodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;
  return {
    allowDots,
    allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
    allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : defaults.allowPrototypes,
    allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : defaults.allowSparse,
    arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : defaults.arrayLimit,
    charset,
    charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : defaults.charsetSentinel,
    comma: typeof opts.comma === "boolean" ? opts.comma : defaults.comma,
    decodeDotInKeys: typeof opts.decodeDotInKeys === "boolean" ? opts.decodeDotInKeys : defaults.decodeDotInKeys,
    decoder: typeof opts.decoder === "function" ? opts.decoder : defaults.decoder,
    delimiter: typeof opts.delimiter === "string" || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
    // eslint-disable-next-line no-implicit-coercion, no-extra-parens
    depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : defaults.depth,
    duplicates,
    ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
    interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
    parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : defaults.parameterLimit,
    parseArrays: opts.parseArrays !== false,
    plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : defaults.plainObjects,
    strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : defaults.strictNullHandling
  };
};
var parse$1 = function(str, opts) {
  var options = normalizeParseOptions(opts);
  if (str === "" || str === null || typeof str === "undefined") {
    return options.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  }
  var tempObj = typeof str === "string" ? parseValues(str, options) : str;
  var obj = options.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  var keys2 = Object.keys(tempObj);
  for (var i2 = 0; i2 < keys2.length; ++i2) {
    var key = keys2[i2];
    var newObj = parseKeys(key, tempObj[key], options, typeof str === "string");
    obj = utils.merge(obj, newObj, options);
  }
  if (options.allowSparse === true) {
    return obj;
  }
  return utils.compact(obj);
};
var stringify2 = stringify_1;
var parse = parse$1;
var formats = formats$3;
var lib = {
  formats,
  parse,
  stringify: stringify2
};
const qs = /* @__PURE__ */ getDefaultExportFromCjs$1(lib);
const parseURLParams = (queryString) => qs.parse(queryString, { arrayLimit: 50, ignoreQueryPrefix: true });
const cleanURLParams = (params) => {
  const keys2 = Object.keys(params);
  const newParams = keys2.reduce((result, key) => {
    const value = params[key];
    const newResult = {
      ...result
    };
    if (value) {
      newResult[key] = value;
    }
    return newResult;
  }, {});
  return newParams;
};
const stringifyURLParams = (params, opts = {}) => qs.stringify(cleanURLParams(params), { encodeValuesOnly: true, arrayFormat: "indices", ...opts });
const removeTrailingSlash = (url) => url.endsWith("/") ? url.slice(0, -1) : url;
const escapeRegExpChars = (string2) => string2.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
const concatenateWithAnd = (array) => {
  if (array.length === 0)
    return "";
  if (array.length === 1)
    return array[0];
  return `${array.slice(0, -1).join(", ")} and ${array.slice(-1)}`;
};
const reverseDirection = (reversableColumns = [], column = void 0, dir = void 0) => {
  if (!column || !dir)
    return void 0;
  if (reversableColumns.includes(column)) {
    return dir === "asc" ? "desc" : "asc";
  }
  return dir;
};
const addSchemeIfMissing = (url) => {
  if (!url)
    return "";
  return /(http(s?)):\/\//.test(url) ? url : `http://${url}`;
};
const urlWithRelaxedSchemeRegex = new RegExp(
  "^((?:(?:(?:https?|ftp):)?\\/\\/))?(?:\\S+(?::\\S*)?@)?(?:(?!(?:10|127)(?:\\.\\d{1,3}){3})(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z0-9\\u00a1-\\uffff][a-z0-9\\u00a1-\\uffff_-]{0,62})?[a-z0-9\\u00a1-\\uffff]\\.)+(?:[a-z\\u00a1-\\uffff]{2,}\\.?))(?::\\d{2,5})?(?:[/?#]\\S*)?$",
  "i"
);
const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const requiredField = (message2 = "This field is required") => (value) => {
  if (!value)
    return message2;
  if (Array.isArray(value) && value.length < 1)
    return message2;
  return void 0;
};
const emailText = (message2 = "This field must be a valid email") => (value) => {
  const expression = emailRegex.test(value);
  return expression ? void 0 : message2;
};
const nonEmptyText = (message2 = "This field requires at least one non-whitespace character") => (value) => {
  const expression = !value || value.trim().length > 0;
  return expression ? void 0 : message2;
};
const maxLengthText = (maxLength, message2 = "The maximum length possible is") => (value) => {
  const expression = !value || value.length <= maxLength;
  return expression ? void 0 : `${message2} ${maxLength}`;
};
const urlWithRelaxedSchemeText = (message2 = "This field must be a valid URL") => (value) => {
  const expression = !value || urlWithRelaxedSchemeRegex.test(value);
  return expression ? void 0 : message2;
};
const minLength = (minLengthParam, message2) => (value) => !value || value.length < minLengthParam ? message2 : void 0;
const numberWithinRange = (min, max2, message2) => (value) => {
  const expression = value && value > Number(0) && (Number(value) < min || Number(value) > max2);
  return expression ? message2 : void 0;
};
const commaInSearch = (message2 = "Please search for one item at a time") => (value) => {
  const lastValue = value[value.length - 1];
  if (lastValue && lastValue.label && lastValue.label.includes(","))
    return message2;
  return void 0;
};
const positiveIntegerRequired = (message2 = "Must be a positive number") => (value) => {
  const expression = value && Number(value) < Number(0);
  return expression ? message2 : void 0;
};
const nonZeroNumberRequired = (message2 = "Must be greater than zero") => (value) => {
  const expression = value && Number(value) === Number(0);
  return expression ? message2 : void 0;
};
const nonDecimalNumberRequired = (message2 = "Cannot be a decimal number") => (value) => {
  const expression = value && !Number.isInteger(Number(value));
  return expression ? message2 : void 0;
};
const styles$v = {
  avatar: css({
    margin: 0
  }),
  rounded: css({
    borderRadius: "50%"
  })
};
const avatarTheme = (theme) => css({
  backgroundColor: getSkeletonColors(theme)
});
const avatarSize = (size2) => {
  switch (size2) {
    case "small":
      return css({
        flex: "0 0 30px",
        width: 30,
        height: 30
      });
    case "medium":
      return css({
        flex: "0 0 60px",
        width: 60,
        height: 60
      });
    case "large":
      return css({
        flex: "0 0 90px",
        width: 90,
        height: 90
      });
    case "extraLarge":
      return css({
        flex: "0 0 125px",
        width: 125,
        height: 125
      });
    case "extraExtraLarge":
      return css({
        flex: "0 0 150px",
        width: 150,
        height: 150
      });
    default:
      return css({
        flex: "0 0 45px",
        width: 45,
        height: 45
      });
  }
};
const SkeletonAvatar = ({ theme, size: size2, round, className }) => /* @__PURE__ */ React.createElement("figure", { className: cx(styles$v.avatar, className, avatarTheme(theme), avatarSize(size2), round && styles$v.rounded) });
SkeletonAvatar.propTypes = {
  theme: PropTypes.oneOf(["", "light", "dark"]),
  size: PropTypes.oneOf(["", "small", "default", "medium", "large", "extraLarge", "extraExtraLarge"]),
  round: PropTypes.bool,
  className: PropTypes.string
};
SkeletonAvatar.defaultProps = {
  theme: "light",
  size: "default"
};
const styles$u = {
  card: css({
    boxSizing: "border-box",
    display: "flex",
    padding: spacing.default,
    borderRadius: borderRadius.default
  })
};
const boxTheme = (theme) => css({
  backgroundColor: getSkeletonColors(theme)
});
const SkeletonBox = ({ theme, className, children }) => /* @__PURE__ */ React.createElement("div", { className: cx(styles$u.card, className, boxTheme(theme)) }, children);
SkeletonBox.propTypes = {
  theme: PropTypes.oneOf(["", "light", "dark"]),
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
SkeletonBox.defaultProps = {
  theme: "light"
};
const styles$t = {
  button: css({
    border: "none",
    outline: "none",
    borderRadius: borderRadius.default,
    padding: 0,
    display: "inline-block"
  })
};
const buttonTheme = (theme) => css({
  backgroundColor: getSkeletonColors(theme)
});
const skeletonButtonSize = (size2) => {
  switch (size2) {
    case "small":
      return css({
        height: 30,
        minWidth: 90
      });
    case "medium":
      return css({
        height: 40,
        minWidth: 120
      });
    default:
      return css({
        height: 35,
        minWidth: 100
      });
  }
};
const SkeletonButton = ({ theme, size: size2, className }) => /* @__PURE__ */ React.createElement("div", { className: cx(styles$t.button, buttonTheme(theme), skeletonButtonSize(size2), className) });
SkeletonButton.propTypes = {
  theme: PropTypes.oneOf(["", "light", "dark"]),
  size: PropTypes.oneOf(["", "default", "small", "medium"]),
  className: PropTypes.string
};
SkeletonButton.defaultProps = {
  theme: "light",
  size: "default"
};
const styles$s = {
  card: css({
    boxSizing: "border-box",
    display: "flex",
    [mediaQueryHelper(breakpoint.tablet)]: {
      borderRadius: borderRadius.default
    }
  })
};
const cardTheme = (theme) => css({
  backgroundColor: getSkeletonColors(theme)
});
const SkeletonCard = ({ theme, className, children }) => /* @__PURE__ */ React.createElement("div", { className: cx(styles$s.card, className, cardTheme(theme)) }, children);
SkeletonCard.propTypes = {
  theme: PropTypes.oneOf(["", "light", "dark"]),
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
SkeletonCard.defaultProps = {
  theme: "light"
};
const styles$r = {
  wrapper: css({
    display: "inline-flex",
    alignItems: "center"
  }),
  text: css({
    display: "block"
  })
};
const wrapperSize = (size2) => {
  switch (size2) {
    case "extraSmall":
      return css({
        height: fontSize.extraSmall * 1.2
      });
    case "small":
      return css({
        height: fontSize.small * 1.2
      });
    case "medium":
      return css({
        height: fontSize.medium * 1.2
      });
    case "large":
      return css({
        height: fontSize.large * 1.2
      });
    default:
      return css({
        height: fontSize.default * 1.2
      });
  }
};
const textTheme = (theme) => css({
  backgroundColor: getSkeletonColors(theme)
});
const textSize = (size2, width) => {
  switch (size2) {
    case "extraSmall":
      return css({
        width,
        height: fontSize.extraSmall
      });
    case "small":
      return css({
        width,
        height: fontSize.small
      });
    case "medium":
      return css({
        width,
        height: fontSize.medium
      });
    case "large":
      return css({
        width,
        height: fontSize.large
      });
    default:
      return css({
        width,
        height: fontSize.default
      });
  }
};
const SkeletonText = ({ theme, size: size2, width, className }) => /* @__PURE__ */ React.createElement("span", { className: cx(styles$r.wrapper, className, wrapperSize(size2)) }, /* @__PURE__ */ React.createElement("span", { className: cx(styles$r.text, textTheme(theme), textSize(size2, width)) }));
SkeletonText.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  theme: PropTypes.oneOf(["", "light", "dark"]),
  size: PropTypes.oneOf(["", "default", "small", "extraSmall", "medium", "large"]),
  className: PropTypes.string
};
SkeletonText.defaultProps = {
  width: 220,
  theme: "light",
  size: "default"
};
const styles$q = {
  wrapper: css({
    display: "flex",
    alignItems: "center",
    "& > * + *": {
      marginLeft: spacing.default
    }
  }),
  checkbox: css({
    display: "block",
    width: 20,
    height: 20,
    borderRadius: borderRadius.default
  })
};
const checkboxTheme = (theme) => css({
  backgroundColor: getSkeletonColors(theme)
});
const SkeletonCheckbox = ({ className, theme, width }) => /* @__PURE__ */ React.createElement("div", { className: cx(styles$q.wrapper, className) }, /* @__PURE__ */ React.createElement("span", { className: cx(styles$q.checkbox, checkboxTheme(theme)) }), /* @__PURE__ */ React.createElement(SkeletonText, { theme, width }));
SkeletonCheckbox.propTypes = {
  width: PropTypes.number,
  theme: PropTypes.oneOf(["", "light", "dark"]),
  className: PropTypes.string
};
SkeletonCheckbox.defaultProps = {
  theme: "light",
  width: 80
};
const styles$p = {
  chip: css({
    display: "inline-flex",
    borderRadius: borderRadius.extraLarge
  })
};
const chipSize = (size2) => {
  switch (size2) {
    case "small":
      return css({
        height: 20,
        width: 80
      });
    default:
      return css({
        height: 26,
        width: 95
      });
  }
};
const chipTheme = (theme) => css({
  backgroundColor: getSkeletonColors(theme)
});
const SkeletonChip = ({ size: size2, theme, className }) => /* @__PURE__ */ React.createElement("div", { className: cx(styles$p.chip, chipSize(size2), chipTheme(theme), className) });
SkeletonChip.propTypes = {
  size: PropTypes.oneOf(["", "default", "small"]),
  theme: PropTypes.oneOf(["", "light", "dark"]),
  className: PropTypes.string
};
SkeletonChip.defaultProps = {
  size: "default",
  theme: "light"
};
const styles$o = {
  field: css({
    borderRadius: borderRadius.default,
    height: 40,
    width: 240
  })
};
const fieldTheme = (theme) => css({
  backgroundColor: getSkeletonColors(theme)
});
const SkeletonField = ({ theme, className }) => /* @__PURE__ */ React.createElement("div", { className: cx(styles$o.field, className, fieldTheme(theme)) });
SkeletonField.propTypes = {
  theme: PropTypes.oneOf(["", "light", "dark"]),
  className: PropTypes.string
};
SkeletonField.defaultProps = {
  theme: "light"
};
const styles$n = {
  icon: css({
    display: "inline-flex",
    borderRadius: "50%",
    flex: "0 0 auto"
  })
};
const iconTheme = (theme) => css({
  backgroundColor: getSkeletonColors(theme)
});
const iconSize = (size2) => {
  switch (size2) {
    case "extraSmall":
      return css({
        width: 16,
        height: 16
      });
    case "small":
      return css({
        width: 20,
        height: 20
      });
    case "medium":
      return css({
        width: 30,
        height: 30
      });
    default:
      return css({
        width: 24,
        height: 24
      });
  }
};
const SkeletonIcon = ({ theme, size: size2, className }) => /* @__PURE__ */ React.createElement("span", { className: cx(styles$n.icon, className, iconTheme(theme), iconSize(size2)) });
SkeletonIcon.propTypes = {
  theme: PropTypes.oneOf(["", "light", "dark"]),
  size: PropTypes.oneOf(["", "extraSmall", "small", "default", "medium"]),
  className: PropTypes.string
};
SkeletonIcon.defaultProps = {
  theme: "light",
  size: "default"
};
const styles$m = {
  wrapper: css({
    display: "flex",
    alignItems: "center",
    "& > * + *": {
      marginLeft: spacing.small
    }
  })
};
const SkeletonIconText = ({ size: size2, theme, width, className }) => /* @__PURE__ */ React.createElement("div", { className: cx(styles$m.wrapper, className) }, /* @__PURE__ */ React.createElement(SkeletonIcon, { size: size2, theme }), /* @__PURE__ */ React.createElement(SkeletonText, { size: size2, theme, width }));
SkeletonIconText.propTypes = {
  size: PropTypes.oneOf(["", "default", "small"]),
  theme: PropTypes.oneOf(["", "light", "dark"]),
  width: PropTypes.number,
  className: PropTypes.string
};
SkeletonIconText.defaultProps = {
  size: "default",
  theme: "light",
  width: 90
};
const styles$l = {
  animated: css({
    animation: `${flash} 2s infinite`
  })
};
const SpookySkeleton = ({ className, animated, children }) => /* @__PURE__ */ React.createElement("div", { className: cx(className, animated && styles$l.animated) }, children);
SpookySkeleton.defaultProps = {
  animated: true
};
SpookySkeleton.propTypes = {
  animated: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
const styles$k = {
  text: css({
    width: "100%",
    justifyContent: "flex-end",
    marginBottom: spacing.small
  })
};
const SkeletonItemCount = ({ className }) => /* @__PURE__ */ React.createElement(SpookySkeleton, { className, ariaLabel: "SkeletonItemCount", role: "presentation" }, /* @__PURE__ */ React.createElement(SkeletonText, { className: styles$k.text, size: "extraSmall", width: 100 }));
SkeletonItemCount.propTypes = {
  className: PropTypes.string
};
const styles$j = {
  table: css({
    width: "100%",
    tableLayout: "fixed",
    backgroundColor: colors.mystic,
    borderRadius: borderRadius.default,
    borderCollapse: "collapse",
    borderSpacing: 0
  })
};
const SkeletonTable = ({ children }) => /* @__PURE__ */ React.createElement("table", { className: styles$j.table, "aria-hidden": "true" }, children);
SkeletonTable.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
const SkeletonTableBody = ({ children }) => /* @__PURE__ */ React.createElement("tbody", null, children);
SkeletonTableBody.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
const styles$i = {
  header: css({
    backgroundColor: colors.geyser
  }),
  row: css({
    "& > th:first-child": {
      borderTopLeftRadius: borderRadius.default
    },
    "& > th:last-child": {
      borderTopRightRadius: borderRadius.default
    }
  }),
  cell: css({
    padding: spacing.default,
    textAlign: "left"
  })
};
const SkeletonTableHeader = ({ children }) => /* @__PURE__ */ React.createElement("thead", { className: styles$i.header }, /* @__PURE__ */ React.createElement("tr", { className: styles$i.row }, React.Children.map(children, (child) => {
  if (!child)
    return null;
  const width = child ? child.props.width : void 0;
  return /* @__PURE__ */ React.createElement("th", { className: styles$i.cell, width }, React.cloneElement(child, { width: void 0 }));
})));
SkeletonTableHeader.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
const styles$h = {
  row: css({
    borderTop: `1px solid ${colors.geyser}`
  }),
  cell: css({
    padding: spacing.default
  })
};
const SkeletonTableRow = ({ className, children }) => /* @__PURE__ */ React.createElement("tr", { className: styles$h.row }, React.Children.map(children, (child) => /* @__PURE__ */ React.createElement("td", { className: cx(styles$h.cell, className) }, child)));
SkeletonTableRow.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
const styles$g = {
  row: css({
    height: 14
  })
};
const SkeletonTableBasic = ({ rows = 5 }) => {
  const rowsArray = Array.from(Array(rows).keys());
  return /* @__PURE__ */ React.createElement(SpookySkeleton, null, /* @__PURE__ */ React.createElement(SkeletonTable, null, /* @__PURE__ */ React.createElement(SkeletonTableHeader, null, /* @__PURE__ */ React.createElement("div", { className: styles$g.row })), /* @__PURE__ */ React.createElement(SkeletonTableBody, null, rowsArray.map((row) => /* @__PURE__ */ React.createElement(SkeletonTableRow, { key: row }, /* @__PURE__ */ React.createElement("div", { className: styles$g.row }))))));
};
SkeletonTableBasic.propTypes = { rows: PropTypes.number };
const textStyles = {
  fontFamily: fontFamily.body,
  fontSize: fontSize.default,
  lineHeight: 1.2,
  fontWeight: fontWeight.regular,
  color: colors.jumbo
};
const styles$f = {
  wrapper: css(textStyles)
};
const Text = ({ className, children }) => /* @__PURE__ */ React.createElement("div", { className: cx(styles$f.wrapper, className) }, children);
Text.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string
};
const styles$e = {
  title: css({
    margin: 0,
    color: colors.oxfordBlue,
    fontFamily: fontFamily.heading,
    fontSize: fontSize.small,
    fontWeight: "inherit",
    lineHeight: 1.2
  })
};
const Title = ({ className, children }) => /* @__PURE__ */ React.createElement("h3", { className: cx(styles$e.title, className) }, children);
Title.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
const TooltipPopupTip = ({
  content,
  trigger,
  position = "top",
  breakpoint: breakpoint2 = "desktop",
  className,
  onOpen = () => {
  },
  useMediaQueryProp = useMediaQuery
}) => {
  const { isPhoneOrLarger, isTabletOrLarger, isDesktopOrLarger } = useMediaQueryProp();
  let matchesBreakpoint;
  switch (breakpoint2) {
    case "phone":
      matchesBreakpoint = isPhoneOrLarger;
      break;
    case "tablet":
      matchesBreakpoint = isTabletOrLarger;
      break;
    default:
      matchesBreakpoint = isDesktopOrLarger;
      break;
  }
  return matchesBreakpoint ? /* @__PURE__ */ React.createElement(Tooltip, { color: colors.grayChateau, trigger, position, className, onOpen }, content) : /* @__PURE__ */ React.createElement(PopupTip, { color: colors.grayChateau, trigger, className, onOpen }, content);
};
TooltipPopupTip.propTypes = {
  content: PropTypes.node.isRequired,
  trigger: PropTypes.func.isRequired,
  position: PropTypes.string,
  breakpoint: PropTypes.oneOf(["", "phone", "tablet", "desktop"]),
  className: PropTypes.string,
  onOpen: PropTypes.func,
  useMediaQueryProp: PropTypes.func
};
const styles$d = {
  tip: css({
    display: "inline-block",
    div: {
      fontStyle: "normal"
    }
  })
};
const CancelledEventTooltipPopupTip = ({ content, trigger, triggerClassName, onOpen, useMediaQueryProp, position }) => (
  // Prevents parent anchor from redirecting to it's `href`
  // eslint-disable-next-line jsx-a11y/no-static-element-interactions
  /* @__PURE__ */ React.createElement(
    "span",
    {
      onClick: (ev) => {
        ev.preventDefault();
      }
    },
    /* @__PURE__ */ React.createElement(
      TooltipPopupTip,
      {
        color: colors.grayChateau,
        className: cx(styles$d.tip, triggerClassName),
        trigger,
        content,
        onOpen,
        useMediaQueryProp,
        position
      }
    )
  )
);
CancelledEventTooltipPopupTip.propTypes = {
  content: PropTypes.node.isRequired,
  trigger: PropTypes.func.isRequired,
  triggerClassName: PropTypes.string,
  onOpen: PropTypes.func,
  useMediaQueryProp: PropTypes.func,
  position: PropTypes.string
};
/*! Copyright Twitter Inc. and other contributors. Licensed under MIT */
var twemoji = function() {
  var twemoji2 = { base: "https://cdn.jsdelivr.net/gh/jdecked/twemoji@15.1.0/assets/", ext: ".png", size: "72x72", className: "emoji", convert: { fromCodePoint, toCodePoint }, onerror: function onerror() {
    if (this.parentNode) {
      this.parentNode.replaceChild(createText(this.alt, false), this);
    }
  }, parse: parse2, replace: replace2, test: test2 }, escaper = { "&": "&amp;", "<": "&lt;", ">": "&gt;", "'": "&#39;", '"': "&quot;" }, re = /(?:\ud83d\udc68\ud83c\udffb\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udffc\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udffd\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udffe\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udfff\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffb\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffb\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffc\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffc\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffd\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffd\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffe\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffe\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udfff\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udfff\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83e\uddd1\ud83c\udffb\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83e\uddd1\ud83c[\udffc-\udfff]|\ud83e\uddd1\ud83c\udffc\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83e\uddd1\ud83c[\udffb\udffd-\udfff]|\ud83e\uddd1\ud83c\udffd\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83e\uddd1\ud83c[\udffb\udffc\udffe\udfff]|\ud83e\uddd1\ud83c\udffe\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83e\uddd1\ud83c[\udffb-\udffd\udfff]|\ud83e\uddd1\ud83c\udfff\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83e\uddd1\ud83c[\udffb-\udffe]|\ud83d\udc68\ud83c\udffb\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udffb\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffc-\udfff]|\ud83d\udc68\ud83c\udffc\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udffc\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb\udffd-\udfff]|\ud83d\udc68\ud83c\udffd\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udffd\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb\udffc\udffe\udfff]|\ud83d\udc68\ud83c\udffe\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udffe\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb-\udffd\udfff]|\ud83d\udc68\ud83c\udfff\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udfff\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb-\udffe]|\ud83d\udc69\ud83c\udffb\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffb\u200d\u2764\ufe0f\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffb\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffc-\udfff]|\ud83d\udc69\ud83c\udffb\u200d\ud83e\udd1d\u200d\ud83d\udc69\ud83c[\udffc-\udfff]|\ud83d\udc69\ud83c\udffc\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffc\u200d\u2764\ufe0f\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffc\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb\udffd-\udfff]|\ud83d\udc69\ud83c\udffc\u200d\ud83e\udd1d\u200d\ud83d\udc69\ud83c[\udffb\udffd-\udfff]|\ud83d\udc69\ud83c\udffd\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffd\u200d\u2764\ufe0f\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffd\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb\udffc\udffe\udfff]|\ud83d\udc69\ud83c\udffd\u200d\ud83e\udd1d\u200d\ud83d\udc69\ud83c[\udffb\udffc\udffe\udfff]|\ud83d\udc69\ud83c\udffe\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffe\u200d\u2764\ufe0f\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffe\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb-\udffd\udfff]|\ud83d\udc69\ud83c\udffe\u200d\ud83e\udd1d\u200d\ud83d\udc69\ud83c[\udffb-\udffd\udfff]|\ud83d\udc69\ud83c\udfff\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udfff\u200d\u2764\ufe0f\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udfff\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb-\udffe]|\ud83d\udc69\ud83c\udfff\u200d\ud83e\udd1d\u200d\ud83d\udc69\ud83c[\udffb-\udffe]|\ud83e\uddd1\ud83c\udffb\u200d\u2764\ufe0f\u200d\ud83e\uddd1\ud83c[\udffc-\udfff]|\ud83e\uddd1\ud83c\udffb\u200d\ud83e\udd1d\u200d\ud83e\uddd1\ud83c[\udffb-\udfff]|\ud83e\uddd1\ud83c\udffc\u200d\u2764\ufe0f\u200d\ud83e\uddd1\ud83c[\udffb\udffd-\udfff]|\ud83e\uddd1\ud83c\udffc\u200d\ud83e\udd1d\u200d\ud83e\uddd1\ud83c[\udffb-\udfff]|\ud83e\uddd1\ud83c\udffd\u200d\u2764\ufe0f\u200d\ud83e\uddd1\ud83c[\udffb\udffc\udffe\udfff]|\ud83e\uddd1\ud83c\udffd\u200d\ud83e\udd1d\u200d\ud83e\uddd1\ud83c[\udffb-\udfff]|\ud83e\uddd1\ud83c\udffe\u200d\u2764\ufe0f\u200d\ud83e\uddd1\ud83c[\udffb-\udffd\udfff]|\ud83e\uddd1\ud83c\udffe\u200d\ud83e\udd1d\u200d\ud83e\uddd1\ud83c[\udffb-\udfff]|\ud83e\uddd1\ud83c\udfff\u200d\u2764\ufe0f\u200d\ud83e\uddd1\ud83c[\udffb-\udffe]|\ud83e\uddd1\ud83c\udfff\u200d\ud83e\udd1d\u200d\ud83e\uddd1\ud83c[\udffb-\udfff]|\ud83d\udc68\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68|\ud83d\udc69\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d[\udc68\udc69]|\ud83e\udef1\ud83c\udffb\u200d\ud83e\udef2\ud83c[\udffc-\udfff]|\ud83e\udef1\ud83c\udffc\u200d\ud83e\udef2\ud83c[\udffb\udffd-\udfff]|\ud83e\udef1\ud83c\udffd\u200d\ud83e\udef2\ud83c[\udffb\udffc\udffe\udfff]|\ud83e\udef1\ud83c\udffe\u200d\ud83e\udef2\ud83c[\udffb-\udffd\udfff]|\ud83e\udef1\ud83c\udfff\u200d\ud83e\udef2\ud83c[\udffb-\udffe]|\ud83d\udc68\u200d\u2764\ufe0f\u200d\ud83d\udc68|\ud83d\udc69\u200d\u2764\ufe0f\u200d\ud83d[\udc68\udc69]|\ud83e\uddd1\u200d\ud83e\udd1d\u200d\ud83e\uddd1|\ud83d\udc6b\ud83c[\udffb-\udfff]|\ud83d\udc6c\ud83c[\udffb-\udfff]|\ud83d\udc6d\ud83c[\udffb-\udfff]|\ud83d\udc8f\ud83c[\udffb-\udfff]|\ud83d\udc91\ud83c[\udffb-\udfff]|\ud83e\udd1d\ud83c[\udffb-\udfff]|\ud83d[\udc6b-\udc6d\udc8f\udc91]|\ud83e\udd1d)|(?:\ud83d[\udc68\udc69]|\ud83e\uddd1)(?:\ud83c[\udffb-\udfff])?\u200d(?:\u2695\ufe0f|\u2696\ufe0f|\u2708\ufe0f|\ud83c[\udf3e\udf73\udf7c\udf84\udf93\udfa4\udfa8\udfeb\udfed]|\ud83d[\udcbb\udcbc\udd27\udd2c\ude80\ude92]|\ud83e[\uddaf-\uddb3\uddbc\uddbd])(?:\u200d\u27a1\ufe0f)?|(?:\ud83c[\udfcb\udfcc]|\ud83d[\udd74\udd75]|\u26f9)((?:\ud83c[\udffb-\udfff]|\ufe0f)\u200d[\u2640\u2642]\ufe0f(?:\u200d\u27a1\ufe0f)?)|(?:\ud83c[\udfc3\udfc4\udfca]|\ud83d[\udc6e\udc70\udc71\udc73\udc77\udc81\udc82\udc86\udc87\ude45-\ude47\ude4b\ude4d\ude4e\udea3\udeb4-\udeb6]|\ud83e[\udd26\udd35\udd37-\udd39\udd3d\udd3e\uddb8\uddb9\uddcd-\uddcf\uddd4\uddd6-\udddd])(?:\ud83c[\udffb-\udfff])?\u200d[\u2640\u2642]\ufe0f(?:\u200d\u27a1\ufe0f)?|(?:\ud83d\udc68\u200d\ud83d\udc68\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc68\u200d\ud83d\udc68\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\ud83d\udc69\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc68\u200d\ud83d\udc69\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\ud83d\udc69\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc69\u200d\ud83d\udc69\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83e\uddd1\u200d\ud83e\uddd1\u200d\ud83e\uddd2\u200d\ud83e\uddd2|\ud83d\udc68\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc68\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\ud83d\udc68\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\ud83d\udc69\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc69\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\ud83d\udc69\u200d\ud83d[\udc66\udc67]|\ud83e\uddd1\u200d\ud83e\uddd1\u200d\ud83e\uddd2|\ud83e\uddd1\u200d\ud83e\uddd2\u200d\ud83e\uddd2|\ud83c\udff3\ufe0f\u200d\u26a7\ufe0f|\ud83c\udff3\ufe0f\u200d\ud83c\udf08|\ud83d\ude36\u200d\ud83c\udf2b\ufe0f|\u26d3\ufe0f\u200d\ud83d\udca5|\u2764\ufe0f\u200d\ud83d\udd25|\u2764\ufe0f\u200d\ud83e\ude79|\ud83c\udf44\u200d\ud83d\udfeb|\ud83c\udf4b\u200d\ud83d\udfe9|\ud83c\udff4\u200d\u2620\ufe0f|\ud83d\udc15\u200d\ud83e\uddba|\ud83d\udc26\u200d\ud83d\udd25|\ud83d\udc3b\u200d\u2744\ufe0f|\ud83d\udc41\u200d\ud83d\udde8|\ud83d\udc68\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\ud83d[\udc66\udc67]|\ud83d\udc6f\u200d\u2640\ufe0f|\ud83d\udc6f\u200d\u2642\ufe0f|\ud83d\ude2e\u200d\ud83d\udca8|\ud83d\ude35\u200d\ud83d\udcab|\ud83d\ude42\u200d\u2194\ufe0f|\ud83d\ude42\u200d\u2195\ufe0f|\ud83e\udd3c\u200d\u2640\ufe0f|\ud83e\udd3c\u200d\u2642\ufe0f|\ud83e\uddd1\u200d\ud83e\uddd2|\ud83e\uddde\u200d\u2640\ufe0f|\ud83e\uddde\u200d\u2642\ufe0f|\ud83e\udddf\u200d\u2640\ufe0f|\ud83e\udddf\u200d\u2642\ufe0f|\ud83d\udc08\u200d\u2b1b|\ud83d\udc26\u200d\u2b1b)|[#*0-9]\ufe0f?\u20e3|(?:[©®\u2122\u265f]\ufe0f)|(?:\ud83c[\udc04\udd70\udd71\udd7e\udd7f\ude02\ude1a\ude2f\ude37\udf21\udf24-\udf2c\udf36\udf7d\udf96\udf97\udf99-\udf9b\udf9e\udf9f\udfcd\udfce\udfd4-\udfdf\udff3\udff5\udff7]|\ud83d[\udc3f\udc41\udcfd\udd49\udd4a\udd6f\udd70\udd73\udd76-\udd79\udd87\udd8a-\udd8d\udda5\udda8\uddb1\uddb2\uddbc\uddc2-\uddc4\uddd1-\uddd3\udddc-\uddde\udde1\udde3\udde8\uddef\uddf3\uddfa\udecb\udecd-\udecf\udee0-\udee5\udee9\udef0\udef3]|[\u203c\u2049\u2139\u2194-\u2199\u21a9\u21aa\u231a\u231b\u2328\u23cf\u23ed-\u23ef\u23f1\u23f2\u23f8-\u23fa\u24c2\u25aa\u25ab\u25b6\u25c0\u25fb-\u25fe\u2600-\u2604\u260e\u2611\u2614\u2615\u2618\u2620\u2622\u2623\u2626\u262a\u262e\u262f\u2638-\u263a\u2640\u2642\u2648-\u2653\u2660\u2663\u2665\u2666\u2668\u267b\u267f\u2692-\u2697\u2699\u269b\u269c\u26a0\u26a1\u26a7\u26aa\u26ab\u26b0\u26b1\u26bd\u26be\u26c4\u26c5\u26c8\u26cf\u26d1\u26d3\u26d4\u26e9\u26ea\u26f0-\u26f5\u26f8\u26fa\u26fd\u2702\u2708\u2709\u270f\u2712\u2714\u2716\u271d\u2721\u2733\u2734\u2744\u2747\u2757\u2763\u2764\u27a1\u2934\u2935\u2b05-\u2b07\u2b1b\u2b1c\u2b50\u2b55\u3030\u303d\u3297\u3299])(?:\ufe0f|(?!\ufe0e))|(?:(?:\ud83c[\udfcb\udfcc]|\ud83d[\udd74\udd75\udd90]|\ud83e\udef0|[\u261d\u26f7\u26f9\u270c\u270d])(?:\ufe0f|(?!\ufe0e))|(?:\ud83c\udfc3|\ud83d\udeb6|\ud83e\uddce)(?:\ud83c[\udffb-\udfff])?(?:\u200d\u27a1\ufe0f)?|(?:\ud83c[\udf85\udfc2\udfc4\udfc7\udfca]|\ud83d[\udc42\udc43\udc46-\udc50\udc66-\udc69\udc6e\udc70-\udc78\udc7c\udc81-\udc83\udc85-\udc87\udcaa\udd7a\udd95\udd96\ude45-\ude47\ude4b-\ude4f\udea3\udeb4\udeb5\udec0\udecc]|\ud83e[\udd0c\udd0f\udd18-\udd1c\udd1e\udd1f\udd26\udd30-\udd39\udd3d\udd3e\udd77\uddb5\uddb6\uddb8\uddb9\uddbb\uddcd\uddcf\uddd1-\udddd\udec3-\udec5\udef1-\udef8]|[\u270a\u270b]))(?:\ud83c[\udffb-\udfff])?|(?:\ud83c\udff4\udb40\udc67\udb40\udc62\udb40\udc65\udb40\udc6e\udb40\udc67\udb40\udc7f|\ud83c\udff4\udb40\udc67\udb40\udc62\udb40\udc73\udb40\udc63\udb40\udc74\udb40\udc7f|\ud83c\udff4\udb40\udc67\udb40\udc62\udb40\udc77\udb40\udc6c\udb40\udc73\udb40\udc7f|\ud83c\udde6\ud83c[\udde8-\uddec\uddee\uddf1\uddf2\uddf4\uddf6-\uddfa\uddfc\uddfd\uddff]|\ud83c\udde7\ud83c[\udde6\udde7\udde9-\uddef\uddf1-\uddf4\uddf6-\uddf9\uddfb\uddfc\uddfe\uddff]|\ud83c\udde8\ud83c[\udde6\udde8\udde9\uddeb-\uddee\uddf0-\uddf5\uddf7\uddfa-\uddff]|\ud83c\udde9\ud83c[\uddea\uddec\uddef\uddf0\uddf2\uddf4\uddff]|\ud83c\uddea\ud83c[\udde6\udde8\uddea\uddec\udded\uddf7-\uddfa]|\ud83c\uddeb\ud83c[\uddee-\uddf0\uddf2\uddf4\uddf7]|\ud83c\uddec\ud83c[\udde6\udde7\udde9-\uddee\uddf1-\uddf3\uddf5-\uddfa\uddfc\uddfe]|\ud83c\udded\ud83c[\uddf0\uddf2\uddf3\uddf7\uddf9\uddfa]|\ud83c\uddee\ud83c[\udde8-\uddea\uddf1-\uddf4\uddf6-\uddf9]|\ud83c\uddef\ud83c[\uddea\uddf2\uddf4\uddf5]|\ud83c\uddf0\ud83c[\uddea\uddec-\uddee\uddf2\uddf3\uddf5\uddf7\uddfc\uddfe\uddff]|\ud83c\uddf1\ud83c[\udde6-\udde8\uddee\uddf0\uddf7-\uddfb\uddfe]|\ud83c\uddf2\ud83c[\udde6\udde8-\udded\uddf0-\uddff]|\ud83c\uddf3\ud83c[\udde6\udde8\uddea-\uddec\uddee\uddf1\uddf4\uddf5\uddf7\uddfa\uddff]|\ud83c\uddf4\ud83c\uddf2|\ud83c\uddf5\ud83c[\udde6\uddea-\udded\uddf0-\uddf3\uddf7-\uddf9\uddfc\uddfe]|\ud83c\uddf6\ud83c\udde6|\ud83c\uddf7\ud83c[\uddea\uddf4\uddf8\uddfa\uddfc]|\ud83c\uddf8\ud83c[\udde6-\uddea\uddec-\uddf4\uddf7-\uddf9\uddfb\uddfd-\uddff]|\ud83c\uddf9\ud83c[\udde6\udde8\udde9\uddeb-\udded\uddef-\uddf4\uddf7\uddf9\uddfb\uddfc\uddff]|\ud83c\uddfa\ud83c[\udde6\uddec\uddf2\uddf3\uddf8\uddfe\uddff]|\ud83c\uddfb\ud83c[\udde6\udde8\uddea\uddec\uddee\uddf3\uddfa]|\ud83c\uddfc\ud83c[\uddeb\uddf8]|\ud83c\uddfd\ud83c\uddf0|\ud83c\uddfe\ud83c[\uddea\uddf9]|\ud83c\uddff\ud83c[\udde6\uddf2\uddfc]|\ud83c[\udccf\udd8e\udd91-\udd9a\udde6-\uddff\ude01\ude32-\ude36\ude38-\ude3a\ude50\ude51\udf00-\udf20\udf2d-\udf35\udf37-\udf7c\udf7e-\udf84\udf86-\udf93\udfa0-\udfc1\udfc5\udfc6\udfc8\udfc9\udfcf-\udfd3\udfe0-\udff0\udff4\udff8-\udfff]|\ud83d[\udc00-\udc3e\udc40\udc44\udc45\udc51-\udc65\udc6a\udc6f\udc79-\udc7b\udc7d-\udc80\udc84\udc88-\udc8e\udc90\udc92-\udca9\udcab-\udcfc\udcff-\udd3d\udd4b-\udd4e\udd50-\udd67\udda4\uddfb-\ude44\ude48-\ude4a\ude80-\udea2\udea4-\udeb3\udeb7-\udebf\udec1-\udec5\uded0-\uded2\uded5-\uded7\udedc-\udedf\udeeb\udeec\udef4-\udefc\udfe0-\udfeb\udff0]|\ud83e[\udd0d\udd0e\udd10-\udd17\udd20-\udd25\udd27-\udd2f\udd3a\udd3c\udd3f-\udd45\udd47-\udd76\udd78-\uddb4\uddb7\uddba\uddbc-\uddcc\uddd0\uddde-\uddff\ude70-\ude7c\ude80-\ude88\ude90-\udebd\udebf-\udec2\udece-\udedb\udee0-\udee8]|[\u23e9-\u23ec\u23f0\u23f3\u267e\u26ce\u2705\u2728\u274c\u274e\u2753-\u2755\u2795-\u2797\u27b0\u27bf\ue50a])|\ufe0f/g, UFE0Fg = /\uFE0F/g, U200D = String.fromCharCode(8205), rescaper = /[&<>'"]/g, shouldntBeParsed = /^(?:iframe|noframes|noscript|script|select|style|textarea)$/, fromCharCode = String.fromCharCode;
  return twemoji2;
  function createText(text, clean) {
    return document.createTextNode(clean ? text.replace(UFE0Fg, "") : text);
  }
  function escapeHTML(s2) {
    return s2.replace(rescaper, replacer);
  }
  function defaultImageSrcGenerator(icon, options) {
    return "".concat(options.base, options.size, "/", icon, options.ext);
  }
  function grabAllTextNodes(node2, allText) {
    var childNodes = node2.childNodes, length = childNodes.length, subnode, nodeType;
    while (length--) {
      subnode = childNodes[length];
      nodeType = subnode.nodeType;
      if (nodeType === 3) {
        allText.push(subnode);
      } else if (nodeType === 1 && !("ownerSVGElement" in subnode) && !shouldntBeParsed.test(subnode.nodeName.toLowerCase())) {
        grabAllTextNodes(subnode, allText);
      }
    }
    return allText;
  }
  function grabTheRightIcon(rawText) {
    return toCodePoint(rawText.indexOf(U200D) < 0 ? rawText.replace(UFE0Fg, "") : rawText);
  }
  function parseNode(node2, options) {
    var allText = grabAllTextNodes(node2, []), length = allText.length, attrib, attrname, modified, fragment, subnode, text, match2, i2, index, img, rawText, iconId, src;
    while (length--) {
      modified = false;
      fragment = document.createDocumentFragment();
      subnode = allText[length];
      text = subnode.nodeValue;
      i2 = 0;
      while (match2 = re.exec(text)) {
        index = match2.index;
        if (index !== i2) {
          fragment.appendChild(createText(text.slice(i2, index), true));
        }
        rawText = match2[0];
        iconId = grabTheRightIcon(rawText);
        i2 = index + rawText.length;
        src = options.callback(iconId, options);
        if (iconId && src) {
          img = new Image();
          img.onerror = options.onerror;
          img.setAttribute("draggable", "false");
          attrib = options.attributes(rawText, iconId);
          for (attrname in attrib) {
            if (attrib.hasOwnProperty(attrname) && attrname.indexOf("on") !== 0 && !img.hasAttribute(attrname)) {
              img.setAttribute(attrname, attrib[attrname]);
            }
          }
          img.className = options.className;
          img.alt = rawText;
          img.src = src;
          modified = true;
          fragment.appendChild(img);
        }
        if (!img)
          fragment.appendChild(createText(rawText, false));
        img = null;
      }
      if (modified) {
        if (i2 < text.length) {
          fragment.appendChild(createText(text.slice(i2), true));
        }
        subnode.parentNode.replaceChild(fragment, subnode);
      }
    }
    return node2;
  }
  function parseString(str, options) {
    return replace2(str, function(rawText) {
      var ret = rawText, iconId = grabTheRightIcon(rawText), src = options.callback(iconId, options), attrib, attrname;
      if (iconId && src) {
        ret = "<img ".concat('class="', options.className, '" ', 'draggable="false" ', 'alt="', rawText, '"', ' src="', src, '"');
        attrib = options.attributes(rawText, iconId);
        for (attrname in attrib) {
          if (attrib.hasOwnProperty(attrname) && attrname.indexOf("on") !== 0 && ret.indexOf(" " + attrname + "=") === -1) {
            ret = ret.concat(" ", attrname, '="', escapeHTML(attrib[attrname]), '"');
          }
        }
        ret = ret.concat("/>");
      }
      return ret;
    });
  }
  function replacer(m2) {
    return escaper[m2];
  }
  function returnNull() {
    return null;
  }
  function toSizeSquaredAsset(value) {
    return typeof value === "number" ? value + "x" + value : value;
  }
  function fromCodePoint(codepoint) {
    var code = typeof codepoint === "string" ? parseInt(codepoint, 16) : codepoint;
    if (code < 65536) {
      return fromCharCode(code);
    }
    code -= 65536;
    return fromCharCode(55296 + (code >> 10), 56320 + (code & 1023));
  }
  function parse2(what, how) {
    if (!how || typeof how === "function") {
      how = { callback: how };
    }
    return (typeof what === "string" ? parseString : parseNode)(what, { callback: how.callback || defaultImageSrcGenerator, attributes: typeof how.attributes === "function" ? how.attributes : returnNull, base: typeof how.base === "string" ? how.base : twemoji2.base, ext: how.ext || twemoji2.ext, size: how.folder || toSizeSquaredAsset(how.size || twemoji2.size), className: how.className || twemoji2.className, onerror: how.onerror || twemoji2.onerror });
  }
  function replace2(text, callback) {
    return String(text).replace(re, callback);
  }
  function test2(text) {
    re.lastIndex = 0;
    var result = re.test(text);
    re.lastIndex = 0;
    return result;
  }
  function toCodePoint(unicodeSurrogates, sep) {
    var r2 = [], c2 = 0, p = 0, i2 = 0;
    while (i2 < unicodeSurrogates.length) {
      c2 = unicodeSurrogates.charCodeAt(i2++);
      if (p) {
        r2.push((65536 + (p - 55296 << 10) + (c2 - 56320)).toString(16));
        p = 0;
      } else if (55296 <= c2 && c2 <= 56319) {
        p = c2;
      } else {
        r2.push(c2.toString(16));
      }
    }
    return r2.join(sep || "-");
  }
}();
const styles$c = {
  emoji: css({
    display: "inline-block",
    "& img": {
      fontSize: "inherit",
      width: "auto",
      height: "1em",
      verticalAlign: "-0.125em"
    }
  })
};
const countryToUnicode = (countryCode) => {
  if (!countryCode) {
    return "";
  }
  const upperCountryCode = countryCode.toUpperCase();
  if (!upperCountryCode.match(/[A-Z]{2}/)) {
    return "";
  }
  const unicodeRegionsStart = 127397;
  const codePoints = upperCountryCode.split("").map((char) => unicodeRegionsStart + char.charCodeAt());
  return String.fromCodePoint(...codePoints);
};
const Flag = ({ countryCode, className }) => {
  const emojiCodePoints = countryToUnicode(countryCode);
  if (emojiCodePoints === "")
    return "";
  return /* @__PURE__ */ React.createElement(
    "span",
    {
      "aria-hidden": true,
      className: cx(styles$c.emoji, className),
      dangerouslySetInnerHTML: {
        __html: twemoji.parse(emojiCodePoints, {
          ext: ".png"
        })
      }
    }
  );
};
Flag.propTypes = {
  countryCode: PropTypes.string,
  className: PropTypes.string
};
const CountryLegend = ({ countryCode, countryName }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Flag, { countryCode }), " ", countryName);
CountryLegend.propTypes = {
  countryCode: PropTypes.string,
  countryName: PropTypes.string
};
const c = ({
  title: e,
  titleId: o,
  ...r2
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...r2,
    children: [
      e ? /* @__PURE__ */ fr.jsx("title", { id: o, children: e }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m776.015 658.11 6.677 252.629c.405 14.997-14.421 25.685-28.523 20.587l-227.093-82.219a21.188 21.188 0 0 0-14.507 0l-227.072 82.219c-14.101 5.099-28.949-5.589-28.544-20.587l6.677-252.629a21.255 21.255 0 0 0-4.011-13.035L110.691 438.867c-8.576-11.883-2.837-28.693 11.2-32.875l232.171-69.248c4.864-1.472 9.067-4.629 11.797-8.896l136.043-211.413c8.405-13.013 27.435-13.013 35.84 0l136.043 211.413a21.403 21.403 0 0 0 11.819 8.896l232.171 69.248c14.037 4.181 19.755 20.992 11.179 32.875L780.026 645.075a21.398 21.398 0 0 0-4.011 13.035",
          clipRule: "evenodd"
        }
      )
    ]
  }
), s$2 = memo(c);
const i$6 = ({
  title: e,
  titleId: c2,
  ...o
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": c2,
    ...o,
    children: [
      e ? /* @__PURE__ */ fr.jsx("title", { id: c2, children: e }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M928.853 438.827c2.7-3.536 4.325-8.017 4.325-12.878 0-9.831-6.649-18.108-15.696-20.581l-.15-.035-231.68-68.693c-5.008-1.458-9.148-4.559-11.898-8.669l-.049-.077-135.893-211.413c-3.859-5.908-10.44-9.758-17.92-9.758s-14.061 3.85-17.87 9.677l-.05.082-136.107 211.413c-2.749 4.152-6.809 7.244-11.582 8.707l-.151.04-232.32 68.693c-8.816 2.753-15.103 10.844-15.103 20.403a21.24 21.24 0 0 0 4.052 12.512l-.043-.062 149.333 206.293c2.537 3.467 4.059 7.815 4.059 12.518 0 .174-.002.348-.006.521v-.026l-8.107 253.227a20.34 20.34 0 0 0-.039 1.285c0 11.782 9.551 21.333 21.333 21.333 2.617 0 5.123-.471 7.44-1.333l-.147.048 227.413-82.987c2.158-.805 4.651-1.271 7.253-1.271s5.095.466 7.401 1.319l-.148-.048 226.987 82.347c2.169.814 4.675 1.285 7.292 1.285 11.782 0 21.333-9.551 21.333-21.333 0-.452-.014-.901-.042-1.346l.003.061-6.613-252.587a21.237 21.237 0 0 1 3.885-13.08l-.045.067zM715.52 595.413c-13.333 17.899-21.346 40.447-21.346 64.866 0 .596.005 1.19.014 1.784l-.001-.09 4.267 163.413-142.72-51.627c-11.101-4.192-23.934-6.62-37.333-6.62s-26.232 2.427-38.083 6.866l.749-.246-142.933 51.627 5.973-164.053c.008-.487.012-1.062.012-1.638 0-24.647-8.007-47.424-21.562-65.872l.217.31-98.987-136.96 149.333-44.8c25.538-7.772 46.55-23.941 60.329-45.228l.258-.425 85.333-131.413 85.333 131.413c14.14 21.697 35.211 37.855 60.023 45.449l.777.205 149.333 44.8z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), t$2 = memo(i$6);
const styles$b = {
  button: css({
    boxSizing: "border-box",
    cursor: "pointer",
    backgroundColor: "transparent",
    border: `1px solid ${colors.amethyst}`,
    borderRadius: borderRadius.default,
    color: colors.amethyst,
    fontFamily: fontFamily.body,
    fontWeight: fontWeight.regular,
    fontSize: fontSize.small,
    lineHeight: 1.4,
    whiteSpace: "nowrap",
    height: 30,
    padding: shorthandHelper([spacing.small, spacing.default]),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: zIndex.level2,
    // so that the button is above positionSelect overlay
    minWidth: 105,
    // width of button with 'Unfavourite' as text
    "&:hover": {
      backgroundColor: colors.whiteLilac
    },
    "&:focus": {
      outline: "none"
    },
    "&:active": {
      backgroundColor: hexToRgba(colors.amethyst, 0.25)
    },
    "&[disabled]": {
      opacity: 0.3,
      pointerEvents: "none"
    }
  }),
  icon: css({
    marginRight: spacing.small
  })
};
const FavouriteButton = ({ label, hasFavourite, className, ...props }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  /* @__PURE__ */ React.createElement("button", { className: cx(styles$b.button, className), ...props, type: "button" }, /* @__PURE__ */ React.createElement(AccessibleIcon, { icon: hasFavourite ? s$2 : t$2, size: 12, color: colors.amethyst, className: styles$b.icon }), label)
);
FavouriteButton.propTypes = {
  label: PropTypes.string.isRequired,
  hasFavourite: PropTypes.bool,
  type: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string
};
FavouriteButton.defaultProps = {
  type: "button",
  hasFavourite: false
};
const s$1 = ({
  title: l,
  titleId: o,
  ...c2
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...c2,
    children: [
      l ? /* @__PURE__ */ fr.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M896 512c0-212.077-171.923-384-384-384S128 299.923 128 512s171.923 384 384 384 384-171.923 384-384m64 0c0 247.424-200.576 448-448 448S64 759.424 64 512 264.576 64 512 64s448 200.576 448 448m-428.817 55.305 2.91-31.612c80.74-13.056 146.933-52.226 146.933-138.816v-1.374c0-85.901-69.103-139.503-170.938-139.503-66.921 0-115.657 22.677-154.208 57.039-10.182 8.245-14.547 19.241-14.547 29.549 0 20.617 18.185 37.796 40.734 37.796 10.185 0 19.639-4.122 26.914-9.619 29.094-24.74 60.373-37.798 98.925-37.798 52.373 0 83.65 26.801 83.65 65.286v1.374c0 43.294-37.824 68.034-106.199 74.219-19.639 2.061-31.277 15.806-28.369 34.359l7.275 59.1c2.182 15.806 14.547 27.49 31.279 27.49h4.363c16.732 0 28.369-12.371 31.279-27.49zm-87.288 131.944c0 26.801 21.822 47.418 51.646 47.418 29.822 0 51.644-20.617 51.644-47.418v-6.871c0-26.801-21.822-47.418-51.644-47.418-29.824 0-51.646 20.617-51.646 47.418z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), r$4 = memo(s$1);
const popupTipIconSize = 16;
const styles$a = {
  wrapper: css({
    display: "inline-flex",
    alignItems: "center",
    marginTop: 0,
    position: "relative"
  }),
  tooltip: css({
    display: "flex",
    marginLeft: spacing.extraSmall,
    "> div": {
      maxWidth: 150,
      width: "max-content"
    }
  }),
  popupTip: css({
    display: "flex",
    position: "absolute",
    right: -popupTipIconSize - spacing.small,
    top: "50%",
    transform: "translateY(-50%)"
  }),
  popupTipIcon: css({
    padding: "4px"
  })
};
const timeZoneName = IANATimeZoneName();
const TimeRange = ({ startTime, endTime, tooltipBreakpoint, wrappingElement, className }) => {
  const WrappingElement = wrappingElement || "div";
  return /* @__PURE__ */ React.createElement(WrappingElement, { className: cx(styles$a.wrapper, className) }, format(startTime, "HH:mm"), /* @__PURE__ */ React.createElement(AccessibleText, { displayText: "–", accessibleText: "to" }), format(endTime, "HH:mm '('zzzz')'"), matchesMediaQuery(tooltipBreakpoint) ? /* @__PURE__ */ React.createElement(
    Tooltip,
    {
      icon: r$4,
      size: 16,
      color: colors.jumbo,
      trigger: AccessibleIcon,
      position: "top",
      className: styles$a.tooltip
    },
    timeZoneName
  ) : /* @__PURE__ */ React.createElement(
    PopupTip,
    {
      icon: r$4,
      size: 24,
      color: colors.jumbo,
      className: styles$a.popupTip,
      triggerClassName: styles$a.popupTipIcon,
      trigger: AccessibleIcon
    },
    timeZoneName
  ));
};
TimeRange.propTypes = {
  startTime: PropTypes.string,
  endTime: PropTypes.string,
  tooltipBreakpoint: PropTypes.number,
  wrappingElement: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  className: PropTypes.string
};
const styles$9 = {
  title: css({
    display: "flex",
    alignItems: "center",
    whiteSpace: "pre"
  }),
  icon: css({
    marginRight: spacing.small
  })
};
const PonyCollapsibleTitle = ({ title, subtitle, icon, iconColor: iconColor2, className }) => /* @__PURE__ */ React.createElement(Subheading, { className: cx(styles$9.title, className) }, Boolean(icon) && /* @__PURE__ */ React.createElement(AccessibleIcon, { icon, size: 20, color: iconColor2, className: styles$9.icon }), /* @__PURE__ */ React.createElement("strong", null, title), subtitle);
PonyCollapsibleTitle.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.shape({})]),
  iconColor: PropTypes.string,
  className: PropTypes.string
};
const styles$8 = {
  wrapper: css({
    flexDirection: "column",
    width: "100%"
  }),
  toggle: css({
    boxSizing: "border-box",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    userSelect: "none",
    "&:hover": {
      outline: "none",
      textDecoration: "underline",
      color: colors.grayChateau
    }
  }),
  title: css({
    display: "flex",
    alignItems: "center",
    whiteSpace: "pre",
    paddingRight: spacing.small,
    "& strong": {
      paddingLeft: spacing.small
    }
  }),
  caret: css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }),
  body: css({
    padding: `0 ${spacing.small}`
  })
};
const PonyCollapsible = ({
  children,
  isCollapsible = true,
  title,
  subtitle,
  icon,
  iconColor: iconColor2,
  open,
  onToggle,
  className,
  bodyClassName
}) => {
  const [isOpen, setIsOpen] = React.useState(open);
  useEffect(() => {
    if (open !== isOpen) {
      setIsOpen(open);
    }
  }, [open]);
  const toggleCollapsible = () => {
    const newIsOpen = !isOpen;
    setIsOpen(newIsOpen);
    if (onToggle) {
      onToggle(newIsOpen);
    }
  };
  return isCollapsible ? /* @__PURE__ */ React.createElement("div", { className: cx(styles$8.wrapper, className) }, /* @__PURE__ */ React.createElement(
    "a",
    {
      className: styles$8.toggle,
      tabIndex: "0",
      onClick: toggleCollapsible,
      onKeyDown: (ev) => {
        if (ev.key === "Enter" && !specialKeyPressed(ev)) {
          toggleCollapsible();
        }
      }
    },
    /* @__PURE__ */ React.createElement(PonyCollapsibleTitle, { title, subtitle, icon, iconColor: iconColor2 }),
    /* @__PURE__ */ React.createElement("div", { className: styles$8.caret }, /* @__PURE__ */ React.createElement(AccessibleIcon, { icon: isOpen ? m$f : m$e, size: 16, color: colors.grayChateau }))
  ), Boolean(isOpen) && /* @__PURE__ */ React.createElement("div", { className: cx(styles$8.body, bodyClassName) }, children)) : /* @__PURE__ */ React.createElement(PonyCollapsibleTitle, { title, subtitle, icon, iconColor: iconColor2, className: cx(className) });
};
const { string: string$1, func, bool, oneOfType, node, arrayOf } = PropTypes;
PonyCollapsible.propTypes = {
  title: string$1.isRequired,
  subtitle: string$1,
  onToggle: func,
  open: bool,
  isCollapsible: bool,
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.shape({})]),
  iconColor: string$1,
  className: string$1,
  bodyClassName: string$1,
  children: oneOfType([arrayOf(node), node])
};
PonyCollapsible.defaultProps = {
  open: false
};
const CANDIDATE_CARD_HIGHLIGHTS = `
  highlight {
    name
    location
    logLine
    workSkills
    summary
    summaryWhatNext
    roleExperience
    workHistory
    education
    quickMentionKeywords
    citizenshipCountry
    citizenshipDescription
  }
`;
const xxLarge = 40;
const styles$7 = {
  counter: css({
    borderRadius: borderRadius.default,
    backgroundColor: colors.porcelain,
    padding: shorthandHelper([spacing.small, spacing.default, spacing.default, spacing.default]),
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    fontWeight: fontWeight.semiBold,
    fontSize: fontSize.default
  }),
  count: css({
    fontSize: xxLarge,
    fontWeight: fontWeight.bold
  }),
  current: css({
    color: colors.cornflowerBlue
  }),
  empty: css({
    opacity: 0.5
  })
};
const currentTheme = (theme) => {
  const themed = getThemeColors(theme);
  return css({
    color: themed.base
  });
};
const PlacementItem = ({ className, heading, isCurrent, count, theme }) => /* @__PURE__ */ React.createElement("li", { className: cx(className, styles$7.counter) }, /* @__PURE__ */ React.createElement("span", { className: cx(isCurrent && currentTheme(theme), count === 0 && styles$7.empty, styles$7.count) }, count), heading);
PlacementItem.propTypes = {
  className: PropTypes.string,
  heading: PropTypes.string.isRequired,
  theme: PropTypes.string,
  count: PropTypes.number.isRequired,
  isCurrent: PropTypes.bool
};
const styles$6 = {
  card: css({
    height: 255,
    // height of the card when populated, rounded from 253px
    marginBottom: spacing.medium
  }),
  header: css({
    height: spacing.extraLarge,
    borderBottom: `1px solid ${colors.geyser}`,
    width: "100%"
  })
};
const SkeletonPlacementCard = () => /* @__PURE__ */ React.createElement(SpookySkeleton, null, /* @__PURE__ */ React.createElement(SkeletonCard, { className: styles$6.card }, /* @__PURE__ */ React.createElement(SkeletonBox, { className: styles$6.header })));
const styles$5 = {
  card: css({
    display: "flex",
    flexDirection: "column",
    marginBottom: spacing.medium,
    backgroundColor: colors.athensGray
  }),
  header: css({
    borderBottom: `1px solid ${colors.geyser}`,
    padding: shorthandHelper([spacing.default, spacing.medium]),
    fontSize: fontSize.default,
    fontWeight: fontWeight.semiBold,
    color: colors.oxfordBlue
  }),
  body: css({
    padding: spacing.medium,
    margin: 0,
    display: "grid",
    gridTemplateAreas: `
      'quarter quarter'
      'current_month last_month'
    `,
    gridGap: spacing.default
  }),
  quarter: css({
    gridArea: "quarter"
  }),
  currentMonth: css({
    gridArea: "current_month"
  }),
  lastMonth: css({
    gridArea: "last_month"
  })
};
const PlacementCard = ({ loading, header, theme = "primary", currentMonth, currentQuarter, lastMonth }) => loading ? /* @__PURE__ */ React.createElement(SkeletonPlacementCard, null) : /* @__PURE__ */ React.createElement(Card, { className: styles$5.card }, /* @__PURE__ */ React.createElement(Heading, { className: styles$5.header }, header), /* @__PURE__ */ React.createElement("ul", { className: styles$5.body }, /* @__PURE__ */ React.createElement(PlacementItem, { className: styles$5.quarter, heading: "This quarter", count: currentQuarter, isCurrent: true, theme }), /* @__PURE__ */ React.createElement(PlacementItem, { className: styles$5.currentMonth, heading: "This month", count: currentMonth }), /* @__PURE__ */ React.createElement(PlacementItem, { className: styles$5.lastMonth, heading: "Last month", count: lastMonth })));
PlacementCard.propTypes = {
  loading: PropTypes.bool.isRequired,
  header: PropTypes.string.isRequired,
  currentMonth: PropTypes.number,
  currentQuarter: PropTypes.number,
  lastMonth: PropTypes.number,
  theme: PropTypes.oneOf(["", "primary", "secondary"])
};
const phonePrefixMap = {
  AF: {
    name: "Afghanistan",
    prefix: "+93",
    code: "AF"
  },
  AX: {
    name: "Åland Islands",
    prefix: "+358",
    code: "AX"
  },
  AL: {
    name: "Albania",
    prefix: "+355",
    code: "AL"
  },
  DZ: {
    name: "Algeria",
    prefix: "+213",
    code: "DZ"
  },
  AS: {
    name: "American Samoa",
    prefix: "+1684",
    code: "AS"
  },
  AD: {
    name: "Andorra",
    prefix: "+376",
    code: "AD"
  },
  AO: {
    name: "Angola",
    prefix: "+244",
    code: "AO"
  },
  AI: {
    name: "Anguilla",
    prefix: "+1264",
    code: "AI"
  },
  AQ: {
    name: "Antarctica",
    prefix: "+672",
    code: "AQ"
  },
  AG: {
    name: "Antigua and Barbuda",
    prefix: "+1268",
    code: "AG"
  },
  AR: {
    name: "Argentina",
    prefix: "+54",
    code: "AR"
  },
  AM: {
    name: "Armenia",
    prefix: "+374",
    code: "AM"
  },
  AW: {
    name: "Aruba",
    prefix: "+297",
    code: "AW"
  },
  AU: {
    name: "Australia",
    prefix: "+61",
    code: "AU"
  },
  AT: {
    name: "Austria",
    prefix: "+43",
    code: "AT"
  },
  AZ: {
    name: "Azerbaijan",
    prefix: "+994",
    code: "AZ"
  },
  BS: {
    name: "Bahamas",
    prefix: "+1242",
    code: "BS"
  },
  BH: {
    name: "Bahrain",
    prefix: "+973",
    code: "BH"
  },
  BD: {
    name: "Bangladesh",
    prefix: "+880",
    code: "BD"
  },
  BB: {
    name: "Barbados",
    prefix: "+1246",
    code: "BB"
  },
  BY: {
    name: "Belarus",
    prefix: "+375",
    code: "BY"
  },
  BE: {
    name: "Belgium",
    prefix: "+32",
    code: "BE"
  },
  BZ: {
    name: "Belize",
    prefix: "+501",
    code: "BZ"
  },
  BJ: {
    name: "Benin",
    prefix: "+229",
    code: "BJ"
  },
  BM: {
    name: "Bermuda",
    prefix: "+1441",
    code: "BM"
  },
  BT: {
    name: "Bhutan",
    prefix: "+975",
    code: "BT"
  },
  BO: {
    name: "Bolivia, Plurinational State of Bolivia",
    prefix: "+591",
    code: "BO"
  },
  BA: {
    name: "Bosnia and Herzegovina",
    prefix: "+387",
    code: "BA"
  },
  BW: {
    name: "Botswana",
    prefix: "+267",
    code: "BW"
  },
  BV: {
    name: "Bouvet Island",
    prefix: "+47",
    code: "BV"
  },
  BR: {
    name: "Brazil",
    prefix: "+55",
    code: "BR"
  },
  IO: {
    name: "British Indian Ocean Territory",
    prefix: "+246",
    code: "IO"
  },
  BN: {
    name: "Brunei Darussalam",
    prefix: "+673",
    code: "BN"
  },
  BG: {
    name: "Bulgaria",
    prefix: "+359",
    code: "BG"
  },
  BF: {
    name: "Burkina Faso",
    prefix: "+226",
    code: "BF"
  },
  BI: {
    name: "Burundi",
    prefix: "+257",
    code: "BI"
  },
  KH: {
    name: "Cambodia",
    prefix: "+855",
    code: "KH"
  },
  CM: {
    name: "Cameroon",
    prefix: "+237",
    code: "CM"
  },
  CA: {
    name: "Canada",
    prefix: "+1",
    code: "CA"
  },
  CV: {
    name: "Cape Verde",
    prefix: "+238",
    code: "CV"
  },
  KY: {
    name: "Cayman Islands",
    prefix: "+ 345",
    code: "KY"
  },
  CF: {
    name: "Central African Republic",
    prefix: "+236",
    code: "CF"
  },
  TD: {
    name: "Chad",
    prefix: "+235",
    code: "TD"
  },
  CL: {
    name: "Chile",
    prefix: "+56",
    code: "CL"
  },
  CN: {
    name: "China",
    prefix: "+86",
    code: "CN"
  },
  CX: {
    name: "Christmas Island",
    prefix: "+61",
    code: "CX"
  },
  CC: {
    name: "Cocos (Keeling) Islands",
    prefix: "+61",
    code: "CC"
  },
  CO: {
    name: "Colombia",
    prefix: "+57",
    code: "CO"
  },
  KM: {
    name: "Comoros",
    prefix: "+269",
    code: "KM"
  },
  CG: {
    name: "Congo",
    prefix: "+242",
    code: "CG"
  },
  CD: {
    name: "Congo, The Democratic Republic of the Congo",
    prefix: "+243",
    code: "CD"
  },
  CK: {
    name: "Cook Islands",
    prefix: "+682",
    code: "CK"
  },
  CR: {
    name: "Costa Rica",
    prefix: "+506",
    code: "CR"
  },
  CI: {
    name: "Cote d'Ivoire",
    prefix: "+225",
    code: "CI"
  },
  HR: {
    name: "Croatia",
    prefix: "+385",
    code: "HR"
  },
  CU: {
    name: "Cuba",
    prefix: "+53",
    code: "CU"
  },
  CY: {
    name: "Cyprus",
    prefix: "+357",
    code: "CY"
  },
  CZ: {
    name: "Czech Republic",
    prefix: "+420",
    code: "CZ"
  },
  DK: {
    name: "Denmark",
    prefix: "+45",
    code: "DK"
  },
  DJ: {
    name: "Djibouti",
    prefix: "+253",
    code: "DJ"
  },
  DM: {
    name: "Dominica",
    prefix: "+1767",
    code: "DM"
  },
  DO: {
    name: "Dominican Republic",
    prefix: "+1849",
    code: "DO"
  },
  EC: {
    name: "Ecuador",
    prefix: "+593",
    code: "EC"
  },
  EG: {
    name: "Egypt",
    prefix: "+20",
    code: "EG"
  },
  SV: {
    name: "El Salvador",
    prefix: "+503",
    code: "SV"
  },
  GQ: {
    name: "Equatorial Guinea",
    prefix: "+240",
    code: "GQ"
  },
  ER: {
    name: "Eritrea",
    prefix: "+291",
    code: "ER"
  },
  EE: {
    name: "Estonia",
    prefix: "+372",
    code: "EE"
  },
  ET: {
    name: "Ethiopia",
    prefix: "+251",
    code: "ET"
  },
  FK: {
    name: "Falkland Islands (Malvinas)",
    prefix: "+500",
    code: "FK"
  },
  FO: {
    name: "Faroe Islands",
    prefix: "+298",
    code: "FO"
  },
  FJ: {
    name: "Fiji",
    prefix: "+679",
    code: "FJ"
  },
  FI: {
    name: "Finland",
    prefix: "+358",
    code: "FI"
  },
  FR: {
    name: "France",
    prefix: "+33",
    code: "FR"
  },
  GF: {
    name: "French Guiana",
    prefix: "+594",
    code: "GF"
  },
  PF: {
    name: "French Polynesia",
    prefix: "+689",
    code: "PF"
  },
  TF: {
    name: "French Southern Territories",
    prefix: "+262",
    code: "TF"
  },
  GA: {
    name: "Gabon",
    prefix: "+241",
    code: "GA"
  },
  GM: {
    name: "Gambia",
    prefix: "+220",
    code: "GM"
  },
  GE: {
    name: "Georgia",
    prefix: "+995",
    code: "GE"
  },
  DE: {
    name: "Germany",
    prefix: "+49",
    code: "DE",
    suggestedOption: true
  },
  GH: {
    name: "Ghana",
    prefix: "+233",
    code: "GH"
  },
  GI: {
    name: "Gibraltar",
    prefix: "+350",
    code: "GI"
  },
  GR: {
    name: "Greece",
    prefix: "+30",
    code: "GR"
  },
  GL: {
    name: "Greenland",
    prefix: "+299",
    code: "GL"
  },
  GD: {
    name: "Grenada",
    prefix: "+1473",
    code: "GD"
  },
  GP: {
    name: "Guadeloupe",
    prefix: "+590",
    code: "GP"
  },
  GU: {
    name: "Guam",
    prefix: "+1671",
    code: "GU"
  },
  GT: {
    name: "Guatemala",
    prefix: "+502",
    code: "GT"
  },
  GG: {
    name: "Guernsey",
    prefix: "+44",
    code: "GG"
  },
  GN: {
    name: "Guinea",
    prefix: "+224",
    code: "GN"
  },
  GW: {
    name: "Guinea-Bissau",
    prefix: "+245",
    code: "GW"
  },
  GY: {
    name: "Guyana",
    prefix: "+592",
    code: "GY"
  },
  HT: {
    name: "Haiti",
    prefix: "+509",
    code: "HT"
  },
  HM: {
    name: "Heard Island and Mcdonald Islands",
    prefix: "+0",
    code: "HM"
  },
  VA: {
    name: "Holy See (Vatican City State)",
    prefix: "+379",
    code: "VA"
  },
  HN: {
    name: "Honduras",
    prefix: "+504",
    code: "HN"
  },
  HK: {
    name: "Hong Kong",
    prefix: "+852",
    code: "HK"
  },
  HU: {
    name: "Hungary",
    prefix: "+36",
    code: "HU"
  },
  IS: {
    name: "Iceland",
    prefix: "+354",
    code: "IS"
  },
  IN: {
    name: "India",
    prefix: "+91",
    code: "IN"
  },
  ID: {
    name: "Indonesia",
    prefix: "+62",
    code: "ID"
  },
  IR: {
    name: "Iran, Islamic Republic of Persian Gulf",
    prefix: "+98",
    code: "IR"
  },
  IQ: {
    name: "Iraq",
    prefix: "+964",
    code: "IQ"
  },
  IE: {
    name: "Ireland",
    prefix: "+353",
    code: "IE"
  },
  IM: {
    name: "Isle of Man",
    prefix: "+44",
    code: "IM"
  },
  IL: {
    name: "Israel",
    prefix: "+972",
    code: "IL"
  },
  IT: {
    name: "Italy",
    prefix: "+39",
    code: "IT"
  },
  JM: {
    name: "Jamaica",
    prefix: "+1876",
    code: "JM"
  },
  JP: {
    name: "Japan",
    prefix: "+81",
    code: "JP"
  },
  JE: {
    name: "Jersey",
    prefix: "+44",
    code: "JE"
  },
  JO: {
    name: "Jordan",
    prefix: "+962",
    code: "JO"
  },
  KZ: {
    name: "Kazakhstan",
    prefix: "+7",
    code: "KZ"
  },
  KE: {
    name: "Kenya",
    prefix: "+254",
    code: "KE"
  },
  KI: {
    name: "Kiribati",
    prefix: "+686",
    code: "KI"
  },
  KP: {
    name: "Korea, Democratic People's Republic of Korea",
    prefix: "+850",
    code: "KP"
  },
  KR: {
    name: "Korea, Republic of South Korea",
    prefix: "+82",
    code: "KR"
  },
  XK: {
    name: "Kosovo",
    prefix: "+383",
    code: "XK"
  },
  KW: {
    name: "Kuwait",
    prefix: "+965",
    code: "KW"
  },
  KG: {
    name: "Kyrgyzstan",
    prefix: "+996",
    code: "KG"
  },
  LA: {
    name: "Laos",
    prefix: "+856",
    code: "LA"
  },
  LV: {
    name: "Latvia",
    prefix: "+371",
    code: "LV"
  },
  LB: {
    name: "Lebanon",
    prefix: "+961",
    code: "LB"
  },
  LS: {
    name: "Lesotho",
    prefix: "+266",
    code: "LS"
  },
  LR: {
    name: "Liberia",
    prefix: "+231",
    code: "LR"
  },
  LY: {
    name: "Libyan Arab Jamahiriya",
    prefix: "+218",
    code: "LY"
  },
  LI: {
    name: "Liechtenstein",
    prefix: "+423",
    code: "LI"
  },
  LT: {
    name: "Lithuania",
    prefix: "+370",
    code: "LT"
  },
  LU: {
    name: "Luxembourg",
    prefix: "+352",
    code: "LU"
  },
  MO: {
    name: "Macao",
    prefix: "+853",
    code: "MO"
  },
  MK: {
    name: "Macedonia",
    prefix: "+389",
    code: "MK"
  },
  MG: {
    name: "Madagascar",
    prefix: "+261",
    code: "MG"
  },
  MW: {
    name: "Malawi",
    prefix: "+265",
    code: "MW"
  },
  MY: {
    name: "Malaysia",
    prefix: "+60",
    code: "MY"
  },
  MV: {
    name: "Maldives",
    prefix: "+960",
    code: "MV"
  },
  ML: {
    name: "Mali",
    prefix: "+223",
    code: "ML"
  },
  MT: {
    name: "Malta",
    prefix: "+356",
    code: "MT"
  },
  MH: {
    name: "Marshall Islands",
    prefix: "+692",
    code: "MH"
  },
  MQ: {
    name: "Martinique",
    prefix: "+596",
    code: "MQ"
  },
  MR: {
    name: "Mauritania",
    prefix: "+222",
    code: "MR"
  },
  MU: {
    name: "Mauritius",
    prefix: "+230",
    code: "MU"
  },
  YT: {
    name: "Mayotte",
    prefix: "+262",
    code: "YT"
  },
  MX: {
    name: "Mexico",
    prefix: "+52",
    code: "MX"
  },
  FM: {
    name: "Micronesia, Federated States of Micronesia",
    prefix: "+691",
    code: "FM"
  },
  MD: {
    name: "Moldova",
    prefix: "+373",
    code: "MD"
  },
  MC: {
    name: "Monaco",
    prefix: "+377",
    code: "MC"
  },
  MN: {
    name: "Mongolia",
    prefix: "+976",
    code: "MN"
  },
  ME: {
    name: "Montenegro",
    prefix: "+382",
    code: "ME"
  },
  MS: {
    name: "Montserrat",
    prefix: "+1664",
    code: "MS"
  },
  MA: {
    name: "Morocco",
    prefix: "+212",
    code: "MA"
  },
  MZ: {
    name: "Mozambique",
    prefix: "+258",
    code: "MZ"
  },
  MM: {
    name: "Myanmar",
    prefix: "+95",
    code: "MM"
  },
  NA: {
    name: "Namibia",
    prefix: "+264",
    code: "NA"
  },
  NR: {
    name: "Nauru",
    prefix: "+674",
    code: "NR"
  },
  NP: {
    name: "Nepal",
    prefix: "+977",
    code: "NP"
  },
  NL: {
    name: "Netherlands",
    prefix: "+31",
    code: "NL",
    suggestedOption: true
  },
  AN: {
    name: "Netherlands Antilles",
    prefix: "+599",
    code: "AN"
  },
  NC: {
    name: "New Caledonia",
    prefix: "+687",
    code: "NC"
  },
  NZ: {
    name: "New Zealand",
    prefix: "+64",
    code: "NZ"
  },
  NI: {
    name: "Nicaragua",
    prefix: "+505",
    code: "NI"
  },
  NE: {
    name: "Niger",
    prefix: "+227",
    code: "NE"
  },
  NG: {
    name: "Nigeria",
    prefix: "+234",
    code: "NG"
  },
  NU: {
    name: "Niue",
    prefix: "+683",
    code: "NU"
  },
  NF: {
    name: "Norfolk Island",
    prefix: "+672",
    code: "NF"
  },
  MP: {
    name: "Northern Mariana Islands",
    prefix: "+1670",
    code: "MP"
  },
  NO: {
    name: "Norway",
    prefix: "+47",
    code: "NO"
  },
  OM: {
    name: "Oman",
    prefix: "+968",
    code: "OM"
  },
  PK: {
    name: "Pakistan",
    prefix: "+92",
    code: "PK"
  },
  PW: {
    name: "Palau",
    prefix: "+680",
    code: "PW"
  },
  PS: {
    name: "Palestinian Territory, Occupied",
    prefix: "+970",
    code: "PS"
  },
  PA: {
    name: "Panama",
    prefix: "+507",
    code: "PA"
  },
  PG: {
    name: "Papua New Guinea",
    prefix: "+675",
    code: "PG"
  },
  PY: {
    name: "Paraguay",
    prefix: "+595",
    code: "PY"
  },
  PE: {
    name: "Peru",
    prefix: "+51",
    code: "PE"
  },
  PH: {
    name: "Philippines",
    prefix: "+63",
    code: "PH"
  },
  PN: {
    name: "Pitcairn",
    prefix: "+64",
    code: "PN"
  },
  PL: {
    name: "Poland",
    prefix: "+48",
    code: "PL"
  },
  PT: {
    name: "Portugal",
    prefix: "+351",
    code: "PT"
  },
  PR: {
    name: "Puerto Rico",
    prefix: "+1939",
    code: "PR"
  },
  QA: {
    name: "Qatar",
    prefix: "+974",
    code: "QA"
  },
  RO: {
    name: "Romania",
    prefix: "+40",
    code: "RO"
  },
  RU: {
    name: "Russia",
    prefix: "+7",
    code: "RU"
  },
  RW: {
    name: "Rwanda",
    prefix: "+250",
    code: "RW"
  },
  RE: {
    name: "Reunion",
    prefix: "+262",
    code: "RE"
  },
  BL: {
    name: "Saint Barthelemy",
    prefix: "+590",
    code: "BL"
  },
  SH: {
    name: "Saint Helena, Ascension and Tristan Da Cunha",
    prefix: "+290",
    code: "SH"
  },
  KN: {
    name: "Saint Kitts and Nevis",
    prefix: "+1869",
    code: "KN"
  },
  LC: {
    name: "Saint Lucia",
    prefix: "+1758",
    code: "LC"
  },
  MF: {
    name: "Saint Martin",
    prefix: "+590",
    code: "MF"
  },
  PM: {
    name: "Saint Pierre and Miquelon",
    prefix: "+508",
    code: "PM"
  },
  VC: {
    name: "Saint Vincent and the Grenadines",
    prefix: "+1784",
    code: "VC"
  },
  WS: {
    name: "Samoa",
    prefix: "+685",
    code: "WS"
  },
  SM: {
    name: "San Marino",
    prefix: "+378",
    code: "SM"
  },
  ST: {
    name: "Sao Tome and Principe",
    prefix: "+239",
    code: "ST"
  },
  SA: {
    name: "Saudi Arabia",
    prefix: "+966",
    code: "SA"
  },
  SN: {
    name: "Senegal",
    prefix: "+221",
    code: "SN"
  },
  RS: {
    name: "Serbia",
    prefix: "+381",
    code: "RS"
  },
  SC: {
    name: "Seychelles",
    prefix: "+248",
    code: "SC"
  },
  SL: {
    name: "Sierra Leone",
    prefix: "+232",
    code: "SL"
  },
  SG: {
    name: "Singapore",
    prefix: "+65",
    code: "SG"
  },
  SK: {
    name: "Slovakia",
    prefix: "+421",
    code: "SK"
  },
  SI: {
    name: "Slovenia",
    prefix: "+386",
    code: "SI"
  },
  SB: {
    name: "Solomon Islands",
    prefix: "+677",
    code: "SB"
  },
  SO: {
    name: "Somalia",
    prefix: "+252",
    code: "SO"
  },
  ZA: {
    name: "South Africa",
    prefix: "+27",
    code: "ZA",
    suggestedOption: true
  },
  SS: {
    name: "South Sudan",
    prefix: "+211",
    code: "SS"
  },
  GS: {
    name: "South Georgia and the South Sandwich Islands",
    prefix: "+500",
    code: "GS"
  },
  ES: {
    name: "Spain",
    prefix: "+34",
    code: "ES"
  },
  LK: {
    name: "Sri Lanka",
    prefix: "+94",
    code: "LK"
  },
  SD: {
    name: "Sudan",
    prefix: "+249",
    code: "SD"
  },
  SR: {
    name: "Suriname",
    prefix: "+597",
    code: "SR"
  },
  SJ: {
    name: "Svalbard and Jan Mayen",
    prefix: "+47",
    code: "SJ"
  },
  SZ: {
    name: "Swaziland",
    prefix: "+268",
    code: "SZ"
  },
  SE: {
    name: "Sweden",
    prefix: "+46",
    code: "SE"
  },
  CH: {
    name: "Switzerland",
    prefix: "+41",
    code: "CH"
  },
  SY: {
    name: "Syrian Arab Republic",
    prefix: "+963",
    code: "SY"
  },
  TW: {
    name: "Taiwan",
    prefix: "+886",
    code: "TW"
  },
  TJ: {
    name: "Tajikistan",
    prefix: "+992",
    code: "TJ"
  },
  TZ: {
    name: "Tanzania, United Republic of Tanzania",
    prefix: "+255",
    code: "TZ"
  },
  TH: {
    name: "Thailand",
    prefix: "+66",
    code: "TH"
  },
  TL: {
    name: "Timor-Leste",
    prefix: "+670",
    code: "TL"
  },
  TG: {
    name: "Togo",
    prefix: "+228",
    code: "TG"
  },
  TK: {
    name: "Tokelau",
    prefix: "+690",
    code: "TK"
  },
  TO: {
    name: "Tonga",
    prefix: "+676",
    code: "TO"
  },
  TT: {
    name: "Trinidad and Tobago",
    prefix: "+1868",
    code: "TT"
  },
  TN: {
    name: "Tunisia",
    prefix: "+216",
    code: "TN"
  },
  TR: {
    name: "Turkey",
    prefix: "+90",
    code: "TR"
  },
  TM: {
    name: "Turkmenistan",
    prefix: "+993",
    code: "TM"
  },
  TC: {
    name: "Turks and Caicos Islands",
    prefix: "+1649",
    code: "TC"
  },
  TV: {
    name: "Tuvalu",
    prefix: "+688",
    code: "TV"
  },
  UG: {
    name: "Uganda",
    prefix: "+256",
    code: "UG"
  },
  UA: {
    name: "Ukraine",
    prefix: "+380",
    code: "UA"
  },
  AE: {
    name: "United Arab Emirates",
    prefix: "+971",
    code: "AE"
  },
  GB: {
    name: "United Kingdom",
    prefix: "+44",
    code: "GB"
  },
  US: {
    name: "United States",
    prefix: "+1",
    code: "US"
  },
  UY: {
    name: "Uruguay",
    prefix: "+598",
    code: "UY"
  },
  UZ: {
    name: "Uzbekistan",
    prefix: "+998",
    code: "UZ"
  },
  VU: {
    name: "Vanuatu",
    prefix: "+678",
    code: "VU"
  },
  VE: {
    name: "Venezuela, Bolivarian Republic of Venezuela",
    prefix: "+58",
    code: "VE"
  },
  VN: {
    name: "Vietnam",
    prefix: "+84",
    code: "VN"
  },
  VG: {
    name: "Virgin Islands, British",
    prefix: "+1284",
    code: "VG"
  },
  VI: {
    name: "Virgin Islands, U.S.",
    prefix: "+1340",
    code: "VI"
  },
  WF: {
    name: "Wallis and Futuna",
    prefix: "+681",
    code: "WF"
  },
  YE: {
    name: "Yemen",
    prefix: "+967",
    code: "YE"
  },
  ZM: {
    name: "Zambia",
    prefix: "+260",
    code: "ZM"
  },
  ZW: {
    name: "Zimbabwe",
    prefix: "+263",
    code: "ZW"
  }
};
const fieldWidth = 240;
const fieldHeight = 40;
const fieldBorderWidth = 1;
const fieldLineHeight = fieldHeight - fieldBorderWidth * 2;
const selectWidth = 106;
const caretWidth = 18;
const flagWidth = 16;
const styles$4 = {
  fieldset: css({
    legend: {
      marginBottom: spacing.small
    }
  }),
  wrapper: css({
    width: fieldWidth,
    maxWidth: "100%",
    height: fieldHeight,
    boxSizing: "border-box",
    borderRadius: borderRadius.default,
    border: `${fieldBorderWidth}px solid ${colors.mystic}`,
    padding: 0,
    margin: 0,
    display: "flex",
    position: "relative",
    fontFamily: fontFamily.body,
    "::before": {
      content: '""',
      position: "absolute",
      left: 0,
      top: 0,
      width: selectWidth,
      height: "100%",
      backgroundColor: colors.athensGray,
      borderRadius: shorthandHelper([borderRadius.default, 0, 0, borderRadius.default])
    }
  }),
  errorWrapper: css({
    borderColor: colors.mandy,
    ":focus-within": {
      borderColor: colors.mystic
    },
    "select:focus, input:focus": {
      borderColor: colors.mandy,
      boxShadow: `0 0 0 2px ${hexToRgba(colors.mandy, 0.25)}`
    }
  }),
  selectLabel: css(accessiblyHidden),
  select: css({
    width: selectWidth,
    minWidth: selectWidth,
    padding: shorthandHelper([0, spacing.default]),
    border: `${fieldBorderWidth}px solid transparent`,
    borderRightColor: colors.mystic,
    borderRadius: shorthandHelper([borderRadius.default, 0, 0, borderRadius.default]),
    appearance: "none",
    color: "transparent",
    zIndex: 0,
    backgroundColor: "transparent",
    cursor: "pointer",
    outline: "none",
    "option, optgroup": {
      color: colors.blackPearl
    }
  }),
  currentFlag: css({
    position: "absolute",
    left: spacing.default,
    top: 0,
    fontSize: fieldHeight - spacing.default * 2,
    lineHeight: `${fieldLineHeight}px`
  }),
  caret: {
    color: colors.grayChateau,
    width: caretWidth,
    styles: css({
      position: "absolute",
      left: spacing.default + flagWidth + spacing.extraSmall,
      top: 0,
      minHeight: "100%"
    })
  },
  currentPrefix: css({
    position: "absolute",
    left: spacing.default + flagWidth + spacing.extraSmall + caretWidth + spacing.extraSmall,
    top: 0,
    color: colors.jumbo,
    lineHeight: `${fieldLineHeight}px`,
    fontFamily: fontFamily.body,
    fontSize: fontSize.default
  }),
  inputLabel: css(accessiblyHidden),
  input: css({
    width: "100%",
    boxSizing: "border-box",
    border: `${fieldBorderWidth}px solid transparent`,
    borderRadius: shorthandHelper([0, borderRadius.default, borderRadius.default, 0]),
    padding: shorthandHelper([0, spacing.default]),
    color: colors.jumbo,
    fontSize: fontSize.default,
    fontFamily: fontFamily.body,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    outline: "none",
    appearance: "none"
  })
};
const wrapperTheme = (theme) => {
  const themed = getThemeColors(theme);
  return css({
    "input:focus, select:focus": {
      zIndex: 0,
      borderColor: themed.base,
      boxShadow: `0 0 0 2px ${hexToRgba(themed.base, 0.25)}`
    }
  });
};
const phonePrefixList = Object.keys(phonePrefixMap);
const suggestedPrefixList = Object.values(phonePrefixMap).filter((item) => item.suggestedOption).map((item) => item.code);
const getPrefix = (countryCode) => phonePrefixMap[countryCode] ? phonePrefixMap[countryCode].prefix : "";
const selectLabel = (prefix) => {
  const country = phonePrefixMap[prefix];
  return `${country.name} ${getPrefix(prefix)}`;
};
function escapedPrefix(regexString) {
  return getPrefix(regexString).replace(/\+/g, "\\$&");
}
const combineIntoString = (prefix, number2) => `${getPrefix(prefix)}${number2}`;
const separateFromString = (string2) => {
  let foundPrefix = phonePrefixList.find((prefix) => {
    const regex = new RegExp(String.raw`^${escapedPrefix(prefix)}`);
    return string2.search(regex) > -1;
  });
  foundPrefix = foundPrefix || "";
  return {
    prefix: foundPrefix,
    number: string2.slice(getPrefix(foundPrefix).length)
  };
};
const CountryCodePhoneInput = ({
  id,
  label = "Cellphone number",
  hideLabel = false,
  onChange,
  onBlur,
  value = {
    prefix: "",
    number: ""
  },
  errored = false,
  errorText = "Error",
  helpText,
  theme = "primary",
  className
}) => {
  let valueObject = value;
  if (typeof value === "string") {
    valueObject = separateFromString(value);
  }
  const [prefixValue, setPrefixValue] = useState(valueObject.prefix);
  const [numberValue, setNumberValue] = useState(valueObject.number);
  const onSelectChange = (ev) => {
    setPrefixValue(ev.target.value);
    const newNumberValue = numberValue.replace(/^0|[^\d]/g, "");
    setNumberValue(newNumberValue);
    if (onChange)
      onChange(combineIntoString(ev.target.value, newNumberValue));
  };
  const onInputChange = (ev) => {
    ev.preventDefault();
    const newValue = ev.target.value.replace(/[^\d]/g, "");
    setNumberValue(newValue);
    if (onChange)
      onChange(combineIntoString(prefixValue, newValue));
  };
  const onInputBlur = (ev) => {
    const newNumberValue = ev.target.value.replace(/^0/g, "");
    setNumberValue(newNumberValue);
    const newValue = combineIntoString(prefixValue, newNumberValue);
    if (onChange)
      onChange(newValue);
  };
  const emptyLabel = "- select a country code -";
  const onComponentBlur = (e) => {
    if (!e.currentTarget.contains(e.relatedTarget)) {
      if (onBlur)
        onBlur();
    }
  };
  return /* @__PURE__ */ React.createElement(FormFieldset, { legend: label, className: cx(styles$4.fieldset, className), hideLegend: hideLabel }, /* @__PURE__ */ React.createElement("div", { className: cx(styles$4.wrapper, wrapperTheme(theme), errored && styles$4.errorWrapper), onBlur: onComponentBlur }, /* @__PURE__ */ React.createElement(FormLabel, { label: "Country telephone prefix", htmlFor: `country-code-${id}`, className: styles$4.selectLabel }), /* @__PURE__ */ React.createElement("span", { "aria-hidden": "true", className: styles$4.currentFlag }, prefixValue ? /* @__PURE__ */ React.createElement(Flag, { countryCode: phonePrefixMap[prefixValue].code }) : /* @__PURE__ */ React.createElement(React.Fragment, null, "🌐")), /* @__PURE__ */ React.createElement(
    AccessibleIcon,
    {
      icon: m$e,
      size: styles$4.caret.width,
      color: styles$4.caret.color,
      ariaHidden: true,
      className: styles$4.caret.styles
    }
  ), /* @__PURE__ */ React.createElement("span", { "aria-hidden": "true", className: styles$4.currentPrefix }, prefixValue ? getPrefix(prefixValue) : "--"), /* @__PURE__ */ React.createElement("select", { id: `country-code-${id}`, className: styles$4.select, value: prefixValue, onChange: onSelectChange }, /* @__PURE__ */ React.createElement("option", { value: "", label: emptyLabel }), /* @__PURE__ */ React.createElement("optgroup", { label: "Suggested country codes" }, suggestedPrefixList.map((prefix) => /* @__PURE__ */ React.createElement("option", { key: prefix, value: prefix }, selectLabel(prefix)))), /* @__PURE__ */ React.createElement("optgroup", { label: "All country codes" }, phonePrefixList.map((prefix) => /* @__PURE__ */ React.createElement("option", { key: prefix, value: prefix }, selectLabel(prefix))))), /* @__PURE__ */ React.createElement(FormLabel, { label: "Telephone number", htmlFor: id, className: styles$4.inputLabel }), /* @__PURE__ */ React.createElement("input", { type: "tel", className: styles$4.input, id, value: numberValue || "", onChange: onInputChange, onBlur: onInputBlur })), Boolean(helpText && !errored) && /* @__PURE__ */ React.createElement(FormHelpText, { text: helpText }), Boolean(errored) && /* @__PURE__ */ React.createElement(FormErrorMessage, { text: errorText }));
};
CountryCodePhoneInput.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  hideLabel: PropTypes.bool,
  theme: PropTypes.oneOf(["", "primary", "secondary", "success", "warning", "error", "legacy", "dark", "tertiary", "info"]),
  className: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      prefix: PropTypes.string,
      number: PropTypes.number
    })
  ]),
  errored: PropTypes.bool,
  errorText: PropTypes.string,
  helpText: PropTypes.string
};
const countryPhonePrefixRequired = (message2 = "Select a country code") => (value) => !value || value.search(/^\+/) > -1 ? void 0 : message2;
const phoneMinLength = (message2 = "Your cellphone number must have at least 11 digits") => (value) => value ? minLength(11, message2)(value) : void 0;
const InputWithRedux = (InputComponent) => {
  const WrappedInputComponent = ({ input, meta, ...props }) => {
    const value = input.value || props.value;
    const onChangeHandler = input.onChange || props.onChange;
    const onBlurHandler = input.onBlur || props.onBlur;
    const { error, touched } = meta;
    const errored = touched && !!error;
    return /* @__PURE__ */ React.createElement(
      InputComponent,
      {
        onChange: onChangeHandler,
        onBlur: onBlurHandler,
        value,
        errored,
        errorText: error,
        ...props
      }
    );
  };
  WrappedInputComponent.propTypes = {
    inputComponent: PropTypes.node,
    meta: PropTypes.shape({
      touched: PropTypes.bool,
      error: PropTypes.string
    }),
    value: PropTypes.string,
    input: PropTypes.shape({
      onChange: PropTypes.func,
      onBlur: PropTypes.func,
      value: PropTypes.oneOfType([
        PropTypes.shape({
          value: PropTypes.string,
          name: PropTypes.string
        }),
        PropTypes.string
      ])
    }),
    onChange: PropTypes.func,
    onBlur: PropTypes.func
  };
  return WrappedInputComponent;
};
InputWithRedux.propTypes = {
  inputComponent: PropTypes.node
};
const i$5 = ({
  title: e,
  titleId: o,
  ...s2
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...s2,
    children: [
      e ? /* @__PURE__ */ fr.jsx("title", { id: o, children: e }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m811.503 478.91-1.856 6.827c-1.835 6.763-4.075 13.077-6.4 19.243l-2.667 6.699c-29.973 70.187-91.477 96.341-190.635 107.264 32.107 21.589 41.365 48.683 41.365 121.984 0 73.323-.917 83.285-.747 100.053.363 27.691 38.336 40.96 36.949 49.835-1.408 8.896-31.808 7.445-46.08 2.219-40.277-14.912-36.245-50.688-36.245-50.688l-1.28-98.133s2.731-52.715-15.595-52.715V852.01c0 34.901 23.061 45.419 23.061 58.411 0 22.08-41.92-2.048-54.827-16-19.563-21.035-17.408-65.621-16.939-100.885.469-34.091-.277-108.608-.277-108.608l-13.269.341s5.376 162.773-7.061 192.384c-16.192 38.037-64.96 51.243-64.96 33.835 0-11.691 12.053-8 18.688-34.112 5.611-22.208 3.776-188.181 3.776-188.181s-15.637 9.877-15.637 40.96c0 14.165-.32 95.509-.32 119.616 0 30.464-40.576 47.744-60.053 47.744-9.877 0-22.101-.533-22.101-6.08 0-14.059 36.992-22.315 36.992-51.605 0-25.344-.469-90.645-.469-90.645s-18.688 3.392-45.355 3.392c-67.115 0-88.32-45.632-98.453-71.211-13.163-33.344-30.251-48.939-48.32-61.547-11.179-7.659-13.653-16.661-.789-19.221 59.392-11.968 74.539 71.829 114.389 85.163 28.181 9.557 64.64 5.483 82.795-7.083 2.411-25.536 19.691-47.744 34.155-59.392-101.013-10.304-160.917-47.744-191.808-107.925l-3.392-6.677c-2.944-6.208-5.504-12.48-7.829-19.072l-2.304-6.784c-9.728-30.571-14.016-65.557-14.016-104.64 0-69.291 20.181-95.509 47.381-132.331-20.8-78.912 7.467-133.035 7.467-133.035s43.691-9.728 126.315 53.355c44.843-20.352 164.245-22.059 220.651-4.48 34.624-24.491 98.048-59.093 123.733-49.344 6.848 11.819 21.803 46.549 8.917 122.645 8.768 16.811 53.845 52.331 54.08 152.896-.747 37.163-4.395 68.459-11.029 95.019z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), n$5 = memo(i$5);
const r$3 = ({
  title: l,
  titleId: o,
  ...i2
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...i2,
    children: [
      l ? /* @__PURE__ */ fr.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M917.333 573.108v267.426H752.726V591.019c0-62.68-23.809-105.457-83.391-105.457-45.484 0-72.551 28.828-84.459 56.715-4.342 9.969-5.46 23.845-5.46 37.801v260.457H414.753s2.218-422.597 0-466.381H579.4v66.108c-.334.494-.768 1.028-1.082 1.507h1.082v-1.507c21.875-31.733 60.941-77.064 148.384-77.064 108.335-.002 189.55 66.658 189.55 209.912zM242.509 149.333c-56.331 0-93.176 34.8-93.176 80.564 0 44.766 35.779 80.623 90.99 80.623h1.1c57.422 0 93.133-35.85 93.133-80.623-1.082-45.764-35.711-80.564-92.047-80.564m-83.396 691.2h164.6V374.152h-164.6z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), m$4 = memo(r$3);
const i$4 = ({
  title: e,
  titleId: o,
  ...s2
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...s2,
    children: [
      e ? /* @__PURE__ */ fr.jsx("title", { id: o, children: e }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m742.17 656.779-19.584 115.413c0 54.421-94.891 98.539-211.947 98.539s-211.925-44.117-211.925-98.539l-20.672-121.728-.725-4.203c28.864 41.301 122.389 71.573 233.323 71.573 110.997 0 204.544-30.293 233.387-71.637l-1.856 10.581zm65.792-387.542c0-54.443-133.12-98.581-297.323-98.581s-297.301 44.139-297.301 98.581l54.464 320.853c23.339 44.8 123.2 78.485 242.837 78.485 120.256 0 220.288-34.069 242.965-79.189zM513.284 605.835c-53.76 0-97.365-43.093-97.365-96.256s43.605-96.256 97.365-96.256 97.344 43.093 97.344 96.256-43.584 96.256-97.344 96.256m-2.645-298.987c-108.971 0-197.312-18.944-197.312-42.304s88.341-42.325 197.312-42.325c108.971 0 197.333 18.965 197.333 42.325s-88.363 42.304-197.333 42.304m53.323 202.733c0 27.669-22.677 50.112-50.688 50.112-27.989 0-50.688-22.443-50.688-50.112s22.699-50.112 50.688-50.112c28.011 0 50.688 22.443 50.688 50.112",
          clipRule: "evenodd"
        }
      )
    ]
  }
), t$1 = memo(i$4);
const i$3 = ({
  title: l,
  titleId: o,
  ...c2
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...c2,
    children: [
      l ? /* @__PURE__ */ fr.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M152.971 544.215v147.456h134.272c24 0 42.667-3.243 56.021-9.749 24.235-11.989 36.352-35.029 36.352-69.035 0-28.779-11.776-48.533-35.221-59.307-13.141-5.995-31.552-9.109-55.296-9.365zm0-213.482v121.92h134.421c24.021 0 43.52-4.544 58.496-13.696 14.976-9.109 22.464-25.323 22.464-48.576 0-25.771-9.899-42.773-29.717-51.029-17.088-5.76-38.869-8.619-65.323-8.619zM453.28 293.57c16.917 23.531 25.387 51.648 25.387 84.416 0 33.792-8.555 60.907-25.621 81.429-9.557 11.499-23.595 22.016-42.176 31.509 28.224 10.261 49.515 26.539 63.872 48.789 14.379 22.272 21.568 49.28 21.568 81.045 0 32.768-8.213 62.165-24.64 88.192-10.432 17.237-23.509 31.744-39.147 43.52-17.664 13.504-38.507 22.741-62.507 27.755s-50.048 7.509-78.144 7.509H42.656V234.667h267.285c67.456 1.003 115.221 20.629 143.339 58.901zm240.358 185.843c-15.104 15.595-24.619 36.693-28.501 63.296h184.235c-1.941-28.373-11.435-49.92-28.48-64.619-17.045-14.677-38.187-22.059-63.424-22.059-27.456 0-48.725 7.808-63.829 23.381zm-85.141-160.32H875.27v-57.024H608.497zm245.12 67.947c28.523 12.779 52.075 32.939 70.677 60.501 16.747 24.299 27.584 52.48 32.576 84.544 2.88 18.795 4.032 45.867 3.52 81.173H662.513c1.664 41.024 15.936 69.781 42.773 86.293 16.341 10.261 35.968 15.403 58.965 15.403 24.363 0 44.139-6.251 59.392-18.773 8.277-6.763 15.616-16.128 21.995-28.16h109.163c-2.88 24.277-16.085 48.917-39.637 73.941-36.629 39.765-87.915 59.648-153.856 59.648-54.421 0-102.464-16.747-144.064-50.304s-62.421-88.128-62.421-163.755c0-70.827 18.795-125.163 56.363-162.965 37.547-37.803 86.293-56.725 146.24-56.725 35.584 0 67.648 6.4 96.192 19.179z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), r$2 = memo(i$3);
const i$2 = ({
  title: e,
  titleId: o,
  ...c2
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...c2,
    children: [
      e ? /* @__PURE__ */ fr.jsx("title", { id: o, children: e }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M682.477 552.397H364.781c-23.552 0-42.667-19.115-42.667-42.667s19.115-42.667 42.667-42.667h317.696c23.552 0 42.667 19.115 42.667 42.667s-19.115 42.667-42.667 42.667m-57.43 149.333H422.231c-23.573 0-42.667-19.093-42.667-42.667 0-23.552 19.093-42.667 42.667-42.667h202.816c23.552 0 42.667 19.115 42.667 42.667 0 23.573-19.115 42.667-42.667 42.667m-203.349-384h202.795c23.595 0 42.667 19.115 42.667 42.667s-19.072 42.667-42.667 42.667H421.698c-23.573 0-42.667-19.115-42.667-42.667s19.093-42.667 42.667-42.667m63.424-187.84c-178.795 17.515-323.477 162.048-341.269 340.8-6.037 60.587 2.155 118.613 21.568 171.2a21.378 21.378 0 0 1 .085 14.528c-31.019 86.421-48.107 134.144-57.557 160.469-5.376 14.955 6.891 30.272 22.656 28.395l169.301-20.053c4.928-.597 9.835.64 13.973 3.371 69.376 45.739 154.475 69.547 245.525 61.227 180.075-16.448 326.379-161.515 344.064-341.461 23.68-241.152-177.216-442.091-418.347-418.475z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), n$4 = memo(i$2);
const m$3 = ({
  title: l,
  titleId: o,
  ...c2
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...c2,
    children: [
      l ? /* @__PURE__ */ fr.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M512 42.668C253.215 42.668 42.668 253.184 42.668 512S253.217 981.332 512 981.332c258.785 0 469.332-210.516 469.332-469.332S770.783 42.668 512 42.668m308.978 221.61c53.451 66.254 86.043 150.459 87.673 241.845-17.928-3.589-93.214-17.623-183.498-17.623-29.008 0-59.643 1.632-90.281 5.221-2.609-6.201-5.214-12.73-7.821-18.931-7.822-18.603-16.621-37.206-25.422-55.484 138.519-57.769 205.332-137.081 219.349-155.032zM512 116.103c100.059 0 191.319 37.206 261.392 98.567-11.081 15.014-71.051 90.082-204.681 140.669-61.928-113.253-129.719-207.252-145.689-229.119a397.524 397.524 0 0 1 88.979-10.117zm-170.46 38.51c13.689 18.931 81.481 113.581 145.038 226.182-170.46 44.715-321.689 47.651-358.519 47.651h-3.911c26.728-121.087 108.208-221.61 217.392-273.833M115.349 512.652c0-3.265 0-6.529.328-9.79h10.43c49.214 0 220-4.244 396-56.465 10.758 20.887 20.86 42.102 30.311 63.318-4.562 1.304-8.8 2.612-13.038 3.916-198.489 64.298-307.349 234.014-323.97 261.756-62.251-70.171-100.06-161.885-100.06-262.736zM512 909.205c-90.932 0-174.698-30.681-241.838-82.573 11.408-22.195 93.54-170.37 310.608-246.09h.328c54.43 141.974 77.57 261.104 83.762 297.986-46.932 19.583-98.43 30.681-152.86 30.681zm224.562-69.847c-5.214-30.681-26.727-142.302-75.94-278.403 27.702-4.244 54.43-5.874 79.851-5.874 82.786 0 147.643 18.279 162.638 22.847-17.928 108.033-79.851 201.375-166.549 261.428z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), s = memo(m$3);
const n$3 = ({
  title: l,
  titleId: o,
  ...c2
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...c2,
    children: [
      l ? /* @__PURE__ */ fr.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M453.263 322.003c11.605-.021 21.227 11.797 17.515 23.36.896 2.176.725 4.48.725 6.763 0 49.643.277 99.264-.064 148.907-.256 32.917-12.971 60.629-36.843 83.093-1.259 1.152-2.453 2.389-3.669 3.584-12.395 9.579-25.792 17.109-40.981 21.269-6.464 1.771-13.035 2.795-19.627 3.755-5.077.768-8.384-2.091-10.283-6.741.021-14.293.021-28.565.064-42.859.235-4.203-1.451-8.683 1.899-12.416 1.643-1.835 3.52-3.072 6.059-3.733 7.403-1.877 14.912-3.392 21.653-7.445 12.437-7.488 20.181-18.304 23.595-32.384.533-2.219 1.045-4.459 1.557-6.677-29.824-.064-59.669-.107-89.493-.149-2.581 0-5.141-.107-7.659-.789-7.595-2.155-13.419-9.152-13.419-17.067-.064-45.525.021-91.093.064-136.619-.64-7.296 0-14.101 6.059-19.307 3.285-2.795 6.912-4.523 11.243-4.523h75.989c18.539 0 37.077 0 55.616-.021zm232.448 0c11.605-.021 21.248 11.797 17.515 23.36.875 2.176.725 4.48.725 6.763 0 49.707.021 99.435 0 149.141-.043 44.416-27.627 85.973-68.267 103.04-1.024.427-2.005 1.003-3.008 1.515.683.875 1.515 1.131 2.411 1.173-.896-.043-1.728-.32-2.411-1.173-.555.149-1.109.32-1.664.469-.32.171-.619.363-.96.555-8.469 2.411-17.067 4.416-25.813 5.739-6.656.981-11.733-2.816-11.819-9.621-.043-4.736-.064-9.515-.107-14.272.064-8.512.128-17.024.213-25.557-.043-1.877-.107-3.755-.107-5.589.021-6.549 2.517-9.323 10.581-11.179 10.197-2.347 19.819-5.696 27.755-13.141 9.579-8.939 14.379-20.117 16.576-32.725-27.563-.064-55.125-.107-82.688-.171-.981 0-1.984.021-2.987.021-2.005 0-3.989 0-5.995-.021-11.285-.192-18.987-8.043-18.965-19.477.021-44.971.064-89.941.107-134.933 0-.427-.043-.853-.085-1.28-.853-8.405 1.536-15.317 8.96-19.989 2.88-1.835 5.995-2.603 9.323-2.603h54.827c25.28 0 50.603 0 75.904-.021l-.021-.021zM477.498 63.998c-.427.96-1.195.939-1.941.896-.235-.021-.469-.021-.661-.021-12.821 1.152-25.579 2.624-38.208 5.035-92.373 17.685-168.256 63.467-226.987 137.429-48.299 60.821-74.901 130.603-80.64 208.384a398.716 398.716 0 0 0-1.067 28.032v1.216c.043 27.776 3.093 55.36 9.173 82.667 6.08 27.413 15.168 53.909 27.371 79.232 1.067 2.155 2.112 4.309 3.2 6.464 20.075 39.851 45.888 75.392 78.187 106.048 17.045 16.171 35.243 30.784 54.912 43.413 60.373 38.656 126.229 58.923 197.803 59.84 4.373.064 5.589 1.152 5.568 5.675-.213 38.656-.128 77.333-.107 115.989 0 1.515.128 3.008.213 4.864 1.216-.491 1.984-.789 2.731-1.152 71.957-34.112 138.005-77.227 196.907-131.264a558.805 558.805 0 0 0 33.707-33.728c4.629-5.013 9.216-10.155 13.824-15.147 7.147-7.701 13.333-16.341 20.096-24.469 7.765-9.344 14.741-19.328 21.653-29.355 15.232-22.144 28.843-45.269 40.277-69.675 5.781-12.331 11.307-24.789 16.171-37.504.149-.256.384-.448.469-.725 13.312-34.88 21.803-70.933 26.347-107.947 1.579-12.885 2.603-25.877 3.243-38.848.299-5.845.448-11.691.448-17.536v-1.259a363.76 363.76 0 0 0-5.845-64.299c-13.312-73.259-45.077-137.237-95.296-191.829-21.163-23.04-44.907-43.072-71.104-60.075-48.811-31.68-101.973-51.072-159.637-57.941-7.019-.853-14.144-.747-21.056-2.411H477.5z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), m$2 = memo(n$3);
const i$1 = ({
  title: l,
  titleId: o,
  ...s2
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...s2,
    children: [
      l ? /* @__PURE__ */ fr.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M114.484 64.074c-13.593-.707-25.491 3.652-35.405 12.999s-14.936 21.114-14.936 34.852v63.897c0 25.348 19.463 46.296 44.81 47.855 371.617 22.375 668.865 319.622 691.239 691.238 1.559 25.347 22.635 45.09 48.126 44.809h63.622c13.736 0 25.508-5.02 34.85-14.933 9.345-9.769 13.709-21.945 12.999-35.681C934.442 453.934 569.796 89.429 114.481 64.082zm1.382 281.306c-13.881-1.132-26.313 2.961-36.513 12.449s-15.216 21.387-15.216 35.405v63.899c0 24.785 18.644 45.308 43.428 47.573 217.816 20.535 391.334 193.772 411.867 411.588 2.267 24.784 22.792 43.703 47.574 43.703h63.899c14.02 0 25.917-5.294 35.405-15.49 9.345-10.196 13.582-22.632 12.449-36.513-24.927-299.247-263.504-537.693-562.895-562.615zm79.387 351.845c-72.478.096-131.171 58.906-131.111 131.389-.06 72.478 58.633 131.294 131.111 131.39a131.283 131.283 0 0 0 131.386-131.386 131.28 131.28 0 0 0-131.386-131.385z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), n$2 = memo(i$1);
const r$1 = ({
  title: o,
  titleId: l,
  ...i2
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": l,
    ...i2,
    children: [
      o ? /* @__PURE__ */ fr.jsx("title", { id: l, children: o }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M554.675 405.329v-85.333c0-23.552 19.115-42.667 42.667-42.667h42.667V170.662h-85.333c-70.699 0-128 57.301-128 128v106.667h-85.333v106.667h85.333v341.333h128V511.996h85.333l42.667-106.667h-128z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), m$1 = memo(r$1);
const t = ({
  title: l,
  titleId: o,
  ...i2
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...i2,
    children: [
      l ? /* @__PURE__ */ fr.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M926.699 250.261c-31.061 13.632-64.299 22.699-99.072 26.645 35.691-20.885 63.083-54.187 76.011-93.845-33.536 19.371-70.464 33.6-109.824 41.173-31.381-33.003-76.309-53.568-125.824-53.568-95.381 0-172.587 75.968-172.587 169.813 0 13.312 1.515 26.325 4.608 38.741-143.659-7.275-270.699-74.773-355.947-177.387-14.741 25.131-23.36 54.187-23.36 85.355 0 59.051 30.443 110.805 76.907 141.376-28.309-.917-54.763-8.491-78.144-21.184v2.112c0 82.325 59.371 150.741 138.432 166.485-14.443 3.947-29.824 6.037-45.525 6.037-11.072 0-21.845-1.195-32.619-3.008 21.867 67.499 85.845 116.544 161.216 118.059-59.072 45.397-133.525 72.64-214.443 72.64-13.824 0-27.669-.917-41.195-2.432 76.288 48.149 167.04 76.288 264.555 76.288 317.483 0 490.987-258.816 490.987-483.093 0-7.275-.32-14.848-.619-22.123a347.755 347.755 0 0 0 86.443-88.085z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), m = memo(t);
const i = ({
  title: l,
  titleId: o,
  ...c2
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...c2,
    children: [
      l ? /* @__PURE__ */ fr.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M705.355 544.335H323.062c-23.552 0-42.667-19.115-42.667-42.667s19.115-42.667 42.667-42.667h382.293c23.552 0 42.667 19.115 42.667 42.667s-19.115 42.667-42.667 42.667m-289.5 187.791H291.396c-125.397 0-227.392-102.016-227.392-227.413 0-125.376 101.995-227.371 227.392-227.371h123.627c23.552 0 42.667 19.093 42.667 42.667 0 23.552-19.115 42.667-42.667 42.667H291.396c-78.336 0-142.059 63.723-142.059 142.037 0 78.357 63.723 142.08 142.059 142.08h124.459c23.552 0 42.667 19.115 42.667 42.667s-19.115 42.667-42.667 42.667zm321.186 0H612.582c-23.552 0-42.667-19.115-42.667-42.667s19.115-42.667 42.667-42.667h124.459c78.336 0 142.059-63.723 142.059-142.08 0-78.315-63.723-142.037-142.059-142.037H613.414c-23.552 0-42.667-19.115-42.667-42.667 0-23.573 19.115-42.667 42.667-42.667h123.627c125.397 0 227.392 101.995 227.392 227.371 0 125.397-101.995 227.413-227.392 227.413z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), n$1 = memo(i);
const r = ({
  title: l,
  titleId: o,
  ...c2
}) => /* @__PURE__ */ fr.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...c2,
    children: [
      l ? /* @__PURE__ */ fr.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ fr.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M623.979 787.802c27.989-65.344 44.267-152.576 48.149-242.667h137.536c-15.125 109.419-87.467 200.597-185.685 242.667M195.285 545.135h137.557c3.861 90.091 20.139 177.323 48.128 242.667-98.219-42.069-170.56-133.248-185.685-242.667m185.686-328c-27.989 65.365-44.267 152.597-48.128 242.667H195.286c15.125-109.397 87.467-200.576 185.685-242.667m37.205 242.667c7.744-174.208 61.355-267.797 84.309-267.797s76.565 93.589 84.309 267.797H418.175zm84.309 353.152c-22.955 0-76.565-93.611-84.309-267.819h168.619c-7.744 174.208-61.355 267.819-84.309 267.819zm307.179-353.152H672.128c-3.883-90.069-20.16-177.301-48.149-242.667 98.219 42.091 170.56 133.269 185.685 242.667M502.485 106.671c-218.261 0-395.819 177.557-395.819 395.797s177.557 395.819 395.819 395.819c218.24 0 395.797-177.579 395.797-395.819S720.725 106.671 502.485 106.671",
          clipRule: "evenodd"
        }
      )
    ]
  }
), n = memo(r);
const styles$3 = {
  button: css({
    width: 36,
    height: 36,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: `1px solid ${colors.catskillWhite}`,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: colors.athensGray
    }
  })
};
const icons = [
  { name: "social-github", icon: n$5 },
  { name: "social-linkedin", icon: m$4 },
  { name: "social-bitBucket", icon: t$1 },
  { name: "social-behance", icon: r$2 },
  { name: "social-dribbble", icon: s },
  { name: "social-blog", icon: n$4 },
  { name: "social-hangouts", icon: m$2 },
  { name: "social-rss", icon: n$2 },
  { name: "social-facebook", icon: m$1 },
  { name: "social-twitter", icon: m },
  { name: "world", icon: n }
];
const OnlineProfileItem = ({ url, name: iconName }) => {
  const displayIcon = icons.filter((icon) => icon.name === iconName)[0] || { icon: n$1 };
  return /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("a", { href: url, target: "_blank", className: styles$3.button, rel: "noreferrer", "aria-label": iconName }, /* @__PURE__ */ React.createElement(AccessibleIcon, { icon: displayIcon.icon, color: colors.grayChateau, size: 18 })));
};
OnlineProfileItem.propTypes = {
  url: PropTypes.string,
  name: PropTypes.string
};
const styles$2 = {
  list: css({
    listStyle: "none",
    margin: 0,
    padding: 0,
    display: "flex",
    alignItems: "center",
    "& > * + *": {
      marginLeft: spacing.small
    }
  })
};
const OnlineProfileList = ({ children }) => /* @__PURE__ */ React.createElement("ul", { className: styles$2.list }, children);
OnlineProfileList.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
const styles$1 = {
  wrapper: css({
    display: "flex",
    flexDirection: "column",
    padding: spacing.medium
  }),
  details: css({
    display: "flex"
  }),
  description: css({
    flex: 1,
    marginLeft: spacing.default
  }),
  name: css({
    marginBottom: spacing.small,
    fontSize: fontSize.large
  }),
  experience: css({
    marginBottom: spacing.default
  }),
  salary: css({
    color: colors.oxfordBlue
  })
};
const DetailsCard = ({
  trackCard,
  profilePicture,
  name,
  overallYearsExperience,
  salary,
  netherlandsPreferredAnnualSalary,
  openToPermanentWork,
  onlineProfiles,
  children
}) => /* @__PURE__ */ React.createElement(Card, { className: styles$1.wrapper, onClick: trackCard }, /* @__PURE__ */ React.createElement("div", { className: styles$1.details }, /* @__PURE__ */ React.createElement(Avatar, { size: "large", theme: "primary", url: profilePicture }), /* @__PURE__ */ React.createElement("div", { className: styles$1.description }, /* @__PURE__ */ React.createElement(Heading, { className: styles$1.name }, /* @__PURE__ */ React.createElement("strong", null, name)), /* @__PURE__ */ React.createElement(Text, { className: styles$1.experience }, /* @__PURE__ */ React.createElement("strong", null, overallYearsExperience, " years exp ", Boolean(openToPermanentWork) && /* @__PURE__ */ React.createElement(React.Fragment, null, Boolean(salary) && /* @__PURE__ */ React.createElement(React.Fragment, null, "| Prefers ", /* @__PURE__ */ React.createElement("span", { className: styles$1.salary }, formatSalary("ZAR", salary, "month"))), salary && netherlandsPreferredAnnualSalary ? /* @__PURE__ */ React.createElement(React.Fragment, null, " or") : null, !salary && netherlandsPreferredAnnualSalary ? /* @__PURE__ */ React.createElement(React.Fragment, null, "|") : null, Boolean(netherlandsPreferredAnnualSalary) && /* @__PURE__ */ React.createElement(React.Fragment, null, " ", "Prefers ", /* @__PURE__ */ React.createElement("span", { className: styles$1.salary }, formatSalary("EUR", netherlandsPreferredAnnualSalary, "year")))))), Boolean(onlineProfiles.length > 0) && /* @__PURE__ */ React.createElement(OnlineProfileList, null, onlineProfiles.map((onlineProfile) => /* @__PURE__ */ React.createElement(OnlineProfileItem, { key: onlineProfile.name, url: onlineProfile.url, name: onlineProfile.name }))))), children);
const { string } = PropTypes;
DetailsCard.propTypes = {
  trackCard: PropTypes.func,
  profilePicture: string,
  name: string,
  overallYearsExperience: string,
  salary: string,
  netherlandsPreferredAnnualSalary: string,
  openToPermanentWork: PropTypes.bool,
  onlineProfiles: PropTypes.arrayOf(
    PropTypes.shape({
      type: string,
      url: string,
      name: string
      // icon name
    })
  ),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
const styles = {
  card: css({
    flexDirection: "column",
    fontSize: fontSize.medium
  }),
  header: css({
    display: "flex",
    alignItems: "center",
    borderBottom: `1px solid ${colors.mystic}`,
    padding: shorthandHelper([spacing.default, spacing.medium]),
    "& > * + *": {
      marginLeft: spacing.default,
      fontSize: fontSize.medium
    }
  }),
  body: css({
    padding: spacing.medium
  }),
  editButton: css({
    marginLeft: "auto"
  })
};
const SectionCard = ({ icon, title, className, onClick, onEdit, children }) => /* @__PURE__ */ React.createElement(Card, { className: styles.card, onClick }, /* @__PURE__ */ React.createElement(Subheading, { className: styles.header }, /* @__PURE__ */ React.createElement(Badge, { icon, theme: "light" }), /* @__PURE__ */ React.createElement("strong", null, title), Boolean(onEdit) && /* @__PURE__ */ React.createElement(BadgeButton, { className: styles.editButton, onClick: onEdit, icon: t$4, ariaLabel: `Edit ${title}` })), /* @__PURE__ */ React.createElement("div", { className: cx(styles.body, className) }, children));
SectionCard.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.shape({})]),
  title: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  onEdit: PropTypes.func,
  children: PropTypes.node
};
function differenceInCalendarMonths(dateLeft, dateRight) {
  const _dateLeft = toDate(dateLeft);
  const _dateRight = toDate(dateRight);
  const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
  const monthDiff = _dateLeft.getMonth() - _dateRight.getMonth();
  return yearDiff * 12 + monthDiff;
}
function endOfDay(date) {
  const _date = toDate(date);
  _date.setHours(23, 59, 59, 999);
  return _date;
}
function endOfMonth(date) {
  const _date = toDate(date);
  const month = _date.getMonth();
  _date.setFullYear(_date.getFullYear(), month + 1, 0);
  _date.setHours(23, 59, 59, 999);
  return _date;
}
function isLastDayOfMonth(date) {
  const _date = toDate(date);
  return +endOfDay(_date) === +endOfMonth(_date);
}
function differenceInMonths(dateLeft, dateRight) {
  const _dateLeft = toDate(dateLeft);
  const _dateRight = toDate(dateRight);
  const sign = compareAsc(_dateLeft, _dateRight);
  const difference = Math.abs(
    differenceInCalendarMonths(_dateLeft, _dateRight)
  );
  let result;
  if (difference < 1) {
    result = 0;
  } else {
    if (_dateLeft.getMonth() === 1 && _dateLeft.getDate() > 27) {
      _dateLeft.setDate(30);
    }
    _dateLeft.setMonth(_dateLeft.getMonth() - sign * difference);
    let isLastMonthNotFull = compareAsc(_dateLeft, _dateRight) === -sign;
    if (isLastDayOfMonth(toDate(dateLeft)) && difference === 1 && compareAsc(dateLeft, _dateRight) === 1) {
      isLastMonthNotFull = false;
    }
    result = sign * (difference - Number(isLastMonthNotFull));
  }
  return result === 0 ? 0 : result;
}
const formatWorkHistoryDuration = (start, end, stillThere) => {
  const workHistoryDurationData = {
    duration: "",
    durationInWords: ""
  };
  if (!start)
    return workHistoryDurationData;
  const endDate = stillThere ? /* @__PURE__ */ new Date() : end;
  const durationInMonths = differenceInMonths(endDate, start);
  const years = Math.floor(durationInMonths / 12);
  const months2 = durationInMonths % 12;
  let yearsText = "";
  if (years > 0)
    yearsText = `${years} yr`;
  if (years > 1)
    yearsText += "s";
  let monthsText = "";
  if (months2 > 0)
    monthsText = `${months2} mo`;
  if (months2 > 1)
    monthsText += "s";
  if (durationInMonths === 0)
    monthsText = "< 1 mo";
  const durationArray = [yearsText, monthsText].filter((text) => !!text);
  workHistoryDurationData.duration = durationArray.join(" ");
  workHistoryDurationData.durationInWords = durationArray.join(", ").replace(/yr/gi, "year").replace(/mo/gi, "month").replace(/</gi, "less than");
  return workHistoryDurationData;
};
const experienceYearRangeToPercent = (yearRange) => {
  switch (yearRange) {
    case "0-1":
      return 6;
    case "1-2":
      return 11;
    case "2-4":
      return 22;
    case "4-6":
      return 33;
    case "6-10":
      return 56;
    case "10-15":
      return 83;
    case "15+":
      return 100;
    default:
      return 0;
  }
};
const experienceYearRangeInWords = (yearRange) => {
  switch (yearRange) {
    case "0-1":
      return "0 to 1 years";
    case "1-2":
      return "1 to 2 years";
    case "2-4":
      return "2 to 4 years";
    case "4-6":
      return "4 to 6 years";
    case "6-10":
      return "6 to 10 years";
    case "10-15":
      return "10 to 15 years";
    case "15+":
      return "More than 15 years";
    default:
      return "";
  }
};
const candidateProfileRolesHelper = (rolesList, rolesFilters = [], yearsString = "years") => {
  if (!rolesList || !rolesList.length)
    return [];
  return rolesList.map(({ id, name, years, ...role }) => ({
    id,
    name,
    yearsExperience: `${years} ${yearsString}`,
    yearsExperienceInWords: experienceYearRangeInWords(years),
    percentOfBar: experienceYearRangeToPercent(years),
    matchesFilter: rolesFilters.includes(role.jobRoleId)
  }));
};
function createBaseFor$1(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}
var _createBaseFor = createBaseFor$1;
var createBaseFor = _createBaseFor;
var baseFor$1 = createBaseFor();
var _baseFor = baseFor$1;
var baseFor = _baseFor, keys = keys_1;
function baseForOwn$1(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}
var _baseForOwn = baseForOwn$1;
var isArrayLike$1 = isArrayLike_1;
function createBaseEach$1(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike$1(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
    while (fromRight ? index-- : ++index < length) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}
var _createBaseEach = createBaseEach$1;
var baseForOwn = _baseForOwn, createBaseEach = _createBaseEach;
var baseEach$1 = createBaseEach(baseForOwn);
var _baseEach = baseEach$1;
var baseEach = _baseEach, isArrayLike = isArrayLike_1;
function baseMap$1(collection, iteratee) {
  var index = -1, result = isArrayLike(collection) ? Array(collection.length) : [];
  baseEach(collection, function(value, key, collection2) {
    result[++index] = iteratee(value, key, collection2);
  });
  return result;
}
var _baseMap = baseMap$1;
function baseSortBy$1(array, comparer) {
  var length = array.length;
  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}
var _baseSortBy = baseSortBy$1;
var isSymbol = isSymbol_1;
function compareAscending$1(value, other) {
  if (value !== other) {
    var valIsDefined = value !== void 0, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
    var othIsDefined = other !== void 0, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
    if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
      return 1;
    }
    if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}
var _compareAscending = compareAscending$1;
var compareAscending = _compareAscending;
function compareMultiple$1(object, other, orders) {
  var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == "desc" ? -1 : 1);
    }
  }
  return object.index - other.index;
}
var _compareMultiple = compareMultiple$1;
var arrayMap = _arrayMap, baseGet = _baseGet, baseIteratee = _baseIteratee, baseMap = _baseMap, baseSortBy = _baseSortBy, baseUnary = _baseUnary, compareMultiple = _compareMultiple, identity = identity_1, isArray$1 = isArray_1;
function baseOrderBy$1(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap(iteratees, function(iteratee) {
      if (isArray$1(iteratee)) {
        return function(value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
      }
      return iteratee;
    });
  } else {
    iteratees = [identity];
  }
  var index = -1;
  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));
  var result = baseMap(collection, function(value, key, collection2) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { "criteria": criteria, "index": ++index, "value": value };
  });
  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}
var _baseOrderBy = baseOrderBy$1;
var baseOrderBy = _baseOrderBy, isArray = isArray_1;
function orderBy(collection, iteratees, orders, guard) {
  if (collection == null) {
    return [];
  }
  if (!isArray(iteratees)) {
    iteratees = iteratees == null ? [] : [iteratees];
  }
  orders = guard ? void 0 : orders;
  if (!isArray(orders)) {
    orders = orders == null ? [] : [orders];
  }
  return baseOrderBy(collection, iteratees, orders);
}
var orderBy_1 = orderBy;
const orderBy$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(orderBy_1);
const OPENING_TAG = '<mark data-src="jsKeyword">';
const CLOSING_TAG = "</mark>";
function matchAllPolyfill(sourceString, regexPattern) {
  const output = [];
  let match2;
  const regex = new RegExp(escapeRegExpChars(regexPattern), "gi");
  while (match2 = regex.exec(sourceString)) {
    const matchItem = [];
    matchItem.push(match2[0]);
    matchItem.index = match2.index;
    output.push(matchItem);
  }
  return output;
}
const removeOverlaps = (previousKeywords, keyword) => {
  const keywordRange = { start: keyword.index, end: keyword.index + keyword.keywordLength };
  const previousKeywordRanges = previousKeywords.map((p) => ({ start: p.index, end: p.index + p.keywordLength }));
  const overlaps = previousKeywordRanges.some(
    (range2) => keywordRange.start >= range2.start && keywordRange.start <= range2.end || keywordRange.end >= range2.start && keywordRange.end <= range2.end
  );
  if (overlaps)
    return previousKeywords;
  return previousKeywords.concat(keyword);
};
const stripOverlapMatches = (keywords) => {
  const noOverlaps = keywords.sort((a, b) => b.keywordLength - a.keywordLength).reduce(removeOverlaps, []).sort((a, b) => a.index > b.index ? 1 : -1);
  return noOverlaps;
};
const buildMatchKeywords = (keywords, string2) => {
  const allKeywordsMatches = keywords.map((currentKeyword) => matchAllPolyfill(string2, currentKeyword)).reduce((accumulator, current) => accumulator.concat(current), []);
  const matchedKeywordsMeta = allKeywordsMatches.map((match2) => ({
    keyword: match2[0],
    keywordLength: match2[0].length,
    index: match2.index
  }));
  return stripOverlapMatches(matchedKeywordsMeta);
};
const presentKeywordsAsHighlights = (string2, matchKeywords) => matchKeywords.reduce((accString, current, index) => {
  const offset = current.index + index * (OPENING_TAG.length + CLOSING_TAG.length);
  const highlightedKeyword = `${OPENING_TAG}${current.keyword}${CLOSING_TAG}`;
  return `${accString.slice(0, offset)}${highlightedKeyword}${accString.slice(offset + current.keywordLength)}`;
}, string2);
const formatStringWithKeywordHighlights = (string2, keywords) => {
  if (!keywords || keywords.length === 0)
    return string2;
  const matchKeywords = buildMatchKeywords(keywords, string2);
  return presentKeywordsAsHighlights(string2, matchKeywords);
};
const rolesVisible = 3;
const workHistoriesVisible = 2;
const workHistorySkillsVisible = 5;
const visibleOutOfTotal = (visibleLimit, total) => total > visibleLimit ? `(${visibleLimit} of ${total})` : "";
const yearsExperienceHelper = (yearRange) => {
  const yearsExperienceData = {
    yearsExperience: "",
    yearsExperienceInWords: ""
  };
  if (!yearRange)
    return yearsExperienceData;
  yearsExperienceData.yearsExperience = yearRange;
  yearsExperienceData.yearsExperienceInWords = `${experienceYearRangeInWords(yearRange)} experience`;
  return yearsExperienceData;
};
const candidateCardRolesHelper = (experienceList, experienceFilters) => {
  const rolesData = {
    roles: [],
    rolesCount: ""
  };
  if (!experienceList || !experienceList.length)
    return rolesData;
  const formattedRoles = candidateProfileRolesHelper(experienceList, experienceFilters, "yrs");
  rolesData.roles = orderBy$1(formattedRoles, ["matchesFilter"], ["desc"]).slice(0, rolesVisible);
  rolesData.rolesCount = visibleOutOfTotal(rolesVisible, experienceList.length);
  return rolesData;
};
const formatWorkHistoryItem = (workHistoryItem, workSkillsFilterIds, keywords) => {
  const { id, company, position, start, end, stillThere, skills } = workHistoryItem;
  const { duration, durationInWords } = formatWorkHistoryDuration(start, end, stillThere);
  const workHistoryData = {
    id,
    company: formatStringWithKeywordHighlights(company, keywords),
    position: formatStringWithKeywordHighlights(position, keywords),
    duration,
    durationInWords,
    skills,
    overflowSkills: "",
    overflowSkillsCount: 0
  };
  if (!skills || !skills.length)
    return workHistoryData;
  const formattedSkills = skills.map((skill) => ({
    name: skill.name,
    matchesFilter: workSkillsFilterIds.includes(skill.id)
  }));
  const orderedSkills = orderBy$1(formattedSkills, ["matchesFilter"], ["desc"]);
  const truncatedSkills = orderedSkills.slice(0, workHistorySkillsVisible);
  const overflowSkills = orderedSkills.slice(workHistorySkillsVisible).map((skill) => skill.name);
  workHistoryData.skills = truncatedSkills;
  workHistoryData.overflowSkills = overflowSkills.join(", ");
  workHistoryData.overflowSkillsCount = overflowSkills.length;
  return workHistoryData;
};
const matchingSkillsFromEarlierWorkHistory = (workHistories, workSkillsFilterIds) => {
  if (!workSkillsFilterIds.length)
    return [];
  const earlierWorkHistories = workHistories.slice(workHistoriesVisible);
  if (!earlierWorkHistories.length)
    return [];
  const matchingEarlierSkillsList = earlierWorkHistories.reduce((skillsAcc, historyItem) => {
    if (!historyItem.skills || !historyItem.skills.length)
      return skillsAcc;
    const matchingSkills = historyItem.skills.filter((skill) => workSkillsFilterIds.includes(skill.id));
    return [...skillsAcc, ...matchingSkills];
  }, []);
  const matchingEarlierSkillsMap = matchingEarlierSkillsList.reduce((skillsAcc, skill) => {
    skillsAcc[skill.id] = skill;
    return skillsAcc;
  }, {});
  return Object.values(matchingEarlierSkillsMap);
};
const workHistoriesHelper = (workHistories, workSkillsFilter, keywords) => {
  const workHistoriesData = {
    workHistories: [],
    workHistoriesCount: "",
    skillsInEarlierWorkHistory: []
  };
  if (!workHistories || !workHistories.length)
    return workHistoriesData;
  const workSkillsFilterIds = workSkillsFilter || [];
  const truncatedWorkHistories = workHistories.slice(0, workHistoriesVisible);
  const formattedWorkHistories = truncatedWorkHistories.map(
    (workHistoryItem) => formatWorkHistoryItem(workHistoryItem, workSkillsFilterIds, keywords)
  );
  workHistoriesData.workHistories = formattedWorkHistories;
  workHistoriesData.workHistoriesCount = visibleOutOfTotal(workHistoriesVisible, workHistories.length);
  workHistoriesData.skillsInEarlierWorkHistory = matchingSkillsFromEarlierWorkHistory(workHistories, workSkillsFilterIds);
  return workHistoriesData;
};
const DEFAULT_ERROR_MESSAGE = "Something went wrong. Please try again";
const NO_CONNECTION_ERROR_MESSAGE = "It seems you don't have an internet connection. Please ensure you're connected to the internet.";
const OPERA_DATA_SAVE_MESSAGE = "Something went wrong. You might be using Opera Mini or Opera Mobile with Data Saver option on. Please turn it off and try again.";
const ERROR_401_MESSAGE = "We can't process this action, you might be signed out. Please log in again.";
const ERROR_403_MESSAGE = "We can't process this action, you don't have the required permissions.";
const ERROR_422_MESSAGE = "Your session has expired. Please log in again.";
const isStatus = (code, response) => response && response.status === code;
const handleNonNetworkError = (err) => [false, err.message, -1];
const handleNoNetworkError = () => [false, NO_CONNECTION_ERROR_MESSAGE];
const handleGenericNetworkResponseError = (response, fallbackError) => {
  const message2 = response.data && response.data.error ? response.data.error : fallbackError;
  return [response.status, message2];
};
const handle401NetworkError = () => [false, ERROR_401_MESSAGE];
const handle403NetworkError = () => [false, ERROR_403_MESSAGE];
const handle422NetworkError = () => [false, ERROR_422_MESSAGE];
const handle404NetworkError = () => [false];
const isOperaMiniAgent = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  return userAgent.includes("opr") || userAgent.includes("opera");
};
const handleOperaMiniError = () => [OPERA_DATA_SAVE_MESSAGE];
const handleError = ({ error, errorClientCallback, defaultErrorMessage }) => {
  let status = null;
  let sendToErrorClient = true;
  let errorMessage = defaultErrorMessage || DEFAULT_ERROR_MESSAGE;
  if (!error.request && !error.response) {
    [sendToErrorClient, errorMessage, status] = handleNonNetworkError(error);
  }
  const { response, request } = error;
  if (request && !response) {
    [sendToErrorClient, errorMessage] = handleNoNetworkError();
  }
  if (response) {
    [status, errorMessage] = handleGenericNetworkResponseError(response, errorMessage);
  }
  if (isStatus(400, response) && isOperaMiniAgent()) {
    [errorMessage] = handleOperaMiniError();
  }
  if (isStatus(401, response)) {
    [sendToErrorClient, errorMessage] = handle401NetworkError();
  }
  if (isStatus(403, response)) {
    [sendToErrorClient, errorMessage] = handle403NetworkError();
  }
  if (isStatus(422, response)) {
    [sendToErrorClient, errorMessage] = handle422NetworkError();
  }
  if (isStatus(404, response)) {
    [sendToErrorClient] = handle404NetworkError();
  }
  if (errorClientCallback && sendToErrorClient) {
    errorClientCallback();
  }
  return { error: errorMessage, original: error, status };
};
function isWithinInterval(date, interval) {
  const time = +toDate(date);
  const [startTime, endTime] = [
    +toDate(interval.start),
    +toDate(interval.end)
  ].sort((a, b) => a - b);
  return time >= startTime && time <= endTime;
}
const shouldShowHiatusNotice = (interval) => isWithinInterval(/* @__PURE__ */ new Date(), { start: interval.start, end: interval.end });
const jobSearchStatusesMap = {
  started_interviewing: {
    id: "started_interviewing",
    label: "Actively looking and already interviewing",
    deprecated: true
  },
  open_not_looking: {
    id: "open_not_looking",
    label: "Not actively looking but open to new opportunities",
    deprecated: true
  },
  actively_looking: {
    id: "actively_looking",
    label: "Yes, I'm looking for a new job and ready to interview",
    deprecated: false
  },
  ready_to_interview: {
    id: "ready_to_interview",
    label: "Not actively looking, but I'm ready to interview for interesting positions",
    deprecated: false
  },
  unsure: {
    id: "unsure",
    label: "Not sure yet, I'm looking to learn more about my options",
    deprecated: false
  },
  not_looking: {
    id: "not_looking",
    label: "No, I’m not looking to start a job search right now",
    deprecated: false
  }
};
const jobSearchStatusesList = Object.values(jobSearchStatusesMap);
const jobSearchNoticePeriodMap = {
  "0 weeks": {
    value: "0 weeks",
    label: "0 weeks"
  },
  "2 weeks": {
    value: "2 weeks",
    label: "2 weeks"
  },
  "4 weeks": {
    value: "4 weeks",
    label: "4 weeks"
  },
  "8 weeks": {
    value: "8 weeks",
    label: "8 weeks"
  },
  longer_than_8_weeks: {
    value: "longer_than_8_weeks",
    label: "Longer than 8 weeks"
  }
};
const jobSearchNoticePeriodList = Object.values(jobSearchNoticePeriodMap);
const jobSearchNoticePeriodTypeMap = {
  calendar_month: {
    value: "calendar_month",
    label: "Beginning of calendar month"
  },
  date_of_notice: {
    value: "date_of_notice",
    label: "From date of notice"
  }
};
const jobSearchNoticePeriodTypeList = Object.values(jobSearchNoticePeriodTypeMap);
const jobSearchContractConditionsMap = {
  restraint_of_trade: {
    value: "restraint_of_trade",
    label: "Restraint of trade"
  },
  probation_period: {
    value: "probation_period",
    label: "Still in probation period"
  },
  bursary_owed: {
    value: "bursary_owed",
    label: "Bursary still owed"
  },
  training_owed: {
    value: "training_owed",
    label: "Training payback still owed"
  },
  retension_bonus_owed: {
    value: "retension_bonus_owed",
    label: "Retention bonus still owed"
  },
  other_payback_owed: {
    value: "other_payback_owed",
    label: "Other payback still owed"
  },
  other_conditions: {
    value: "other_conditions",
    label: "Other condition(s)"
  }
};
const jobSearchContractConditionsList = Object.values(jobSearchContractConditionsMap);
const jobSearchReasonsMap = {
  more_challenge: {
    value: "more_challenge",
    label: "More challenges, growth opportunities or responsibilities"
  },
  under_stimulated: {
    value: "under_stimulated",
    label: "Feel under-stimulated or bored"
  },
  work_life_balance: {
    value: "work_life_balance",
    label: "Better work-life balance"
  },
  culture: {
    value: "culture",
    label: "Unhappy with the culture"
  },
  expectations_not_met: {
    value: "expectations_not_met",
    label: "Company didn’t meet expectations"
  },
  change_industry_or_company_size: {
    value: "change_industry_or_company_size",
    label: "Want a different industry or company size"
  },
  better_remuneration: {
    value: "better_remuneration",
    label: "Better salary, benefits or perks"
  },
  retrenchment_or_company_finances: {
    value: "retrenchment_or_company_finances",
    label: "Company in financial difficulty or being retrenched"
  },
  not_currently_employed: {
    value: "not_currently_employed",
    label: "Unemployed or on a sabbatical"
  },
  currently_freelance: {
    value: "currently_freelance",
    label: "Contract is ending or freelancing"
  },
  relocation: {
    value: "relocation",
    label: "Relocating or looking to relocate"
  },
  graduation: {
    value: "graduation",
    label: "Graduating soon or recently graduated"
  },
  just_browsing: {
    value: "just_browsing",
    label: "Just browsing"
  },
  other: {
    value: "other",
    label: "Other"
  }
};
const jobSearchReasonsList = Object.values(jobSearchReasonsMap);
export {
  AccessibleFormLabel,
  AccessibleText,
  ActionsMenu,
  Attachment,
  Avatar,
  Badge,
  BadgeButton,
  BodyWithSidebar,
  Button,
  ButtonLink,
  ButtonLoader,
  CANDIDATE_CARD_HIGHLIGHTS,
  CancelledEventTooltipPopupTip,
  Card,
  CardList,
  CardListHeading,
  CardListItem,
  Checkbox,
  Chip,
  Collapsible,
  Container,
  ContentBox,
  Counter,
  CountryCodePhoneInput,
  CountryLegend,
  CurrencyInput,
  DetailsCard,
  EmailInput,
  FavouriteButton,
  FilterMenu,
  Flag,
  FormErrorMessage,
  FormErrorNotification,
  FormFieldset,
  FormHelpText,
  FormLabel,
  FormWarningMessage,
  Heading,
  HyperButton,
  Hyperlink,
  IANATimeZoneName,
  IconButtonLink,
  IconHyperlink,
  IconList,
  IconMenu,
  IconTabBar,
  IconTabItem,
  InfiniteScroll,
  InputWithRedux,
  LazyComponent,
  LazyImage,
  LockScroll,
  MatchingQueriesContext,
  MediaQueryProvider,
  MenuIcon,
  MenuOption,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalImageHeader,
  MultiOption,
  MultiSearch,
  MultiSelect,
  Navbar,
  Notification,
  Pagination,
  PhoneInput,
  PlacementCard,
  PonyCollapsible,
  Popup,
  PopupTip,
  RadioBoxGroup,
  RadioBoxOption,
  RadioInput,
  RadioInputGroup,
  SearchInput,
  SectionCard,
  SimpleItem,
  SingleOption,
  SingleSearch,
  SingleSelect,
  SingleSelectField,
  SingleSelectFilter,
  SkeletonAvatar,
  SkeletonBox,
  SkeletonButton,
  SkeletonCard,
  SkeletonCheckbox,
  SkeletonChip,
  SkeletonField,
  SkeletonIcon,
  SkeletonIconText,
  SkeletonItemCount,
  SkeletonPlacementCard,
  SkeletonTable,
  SkeletonTableBasic,
  SkeletonTableBody,
  SkeletonTableHeader,
  SkeletonTableRow,
  SkeletonText,
  SmallText,
  Spinner,
  SpookySkeleton,
  StructuredItem,
  Subheading,
  SubmitButton,
  SystemError,
  TabBar,
  TabItem,
  Table,
  TableBody,
  TableHeader,
  TableRow,
  Tag,
  Text,
  TextInput,
  Textarea,
  TimeRange,
  Title,
  Tooltip,
  TooltipPopupTip,
  accessiblyHidden,
  addSchemeIfMissing,
  borderRadius,
  breakpoint,
  buttonSize,
  buttonVariant,
  candidateCardRolesHelper,
  candidateProfileRolesHelper,
  colors,
  commaInSearch,
  concatenateWithAnd,
  countryPhonePrefixRequired,
  emailRegex,
  emailText,
  escapeRegExpChars,
  flash,
  fontFamily,
  fontSize,
  fontWeight,
  formatCurrencyEuro,
  formatCurrencyRand,
  formatDateWithShortMonth,
  formatDistanceInWords,
  formatRemuneration,
  formatSalary,
  formatSmartDate,
  formatSmartTimestamp,
  formatWorkHistoryDuration,
  getSkeletonColors,
  getThemeColors,
  handleError,
  handleMediaQuery,
  handleMention,
  hexToRgba,
  identifyUser,
  initializeAnalytics,
  jobSearchContractConditionsList,
  jobSearchContractConditionsMap,
  jobSearchNoticePeriodList,
  jobSearchNoticePeriodMap,
  jobSearchNoticePeriodTypeList,
  jobSearchReasonsList,
  jobSearchReasonsMap,
  jobSearchStatusesList,
  jobSearchStatusesMap,
  lineHeight,
  matchesMediaQuery,
  maxLengthText,
  mediaQueryHelper,
  minLength,
  navbarHeight,
  nonDecimalNumberRequired,
  nonEmptyText,
  nonZeroNumberRequired,
  numberWithinRange,
  pageLoad,
  parseURLParams,
  phoneMinLength,
  positiveIntegerRequired,
  removeTrailingSlash,
  requiredField,
  resizeTextarea,
  reverseDirection,
  scrollGradient,
  shorthandHelper,
  shouldShowHiatusNotice,
  size,
  spacing,
  specialKeyPressed,
  spin,
  stringifyURLParams,
  subheadingStyles,
  textStyles,
  trackEvent,
  urlWithRelaxedSchemeText,
  useMediaQuery,
  workHistoriesHelper,
  yearsExperienceHelper,
  zIndex
};
